(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define("wix", ["lodash"], factory);
	else if(typeof exports === 'object')
		exports["wix"] = factory(require("lodash"));
	else
		root["wix"] = factory(root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 221);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _RMI = new WeakMap();
var _appDefId = new WeakMap();
var _contextId = new WeakMap();
var _compId = new WeakMap();
var _compName = new WeakMap();
var _controllerId = new WeakMap();
var _emitter = new WeakMap();
var _role = new WeakMap();
var _styleInstance = new WeakMap();
var _type = new WeakMap();
var _wixSelector = new WeakMap();

exports._RMI = _RMI;
exports._appDefId = _appDefId;
exports._contextId = _contextId;
exports._compId = _compId;
exports._compName = _compName;
exports._controllerId = _controllerId;
exports._emitter = _emitter;
exports._role = _role;
exports._styleInstance = _styleInstance;
exports._type = _type;
exports._wixSelector = _wixSelector;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (receiver, supplier) {

    var propsNames = Object.getOwnPropertyNames(supplier);
    propsNames.forEach(function (property) {
        if (supplier.hasOwnProperty(property) && property !== 'constructor') {
            Object.defineProperty(receiver, property, Object.getOwnPropertyDescriptor(supplier, property));
        }
    });

    return receiver;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValueInRange = exports.validateArrayContainsItemsWithIds = exports.validateByType = exports.validateValueFromEnum = exports.validateMaximum = exports.validateMinimum = exports.validateRange = exports.validate = exports.TYPES = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _compSchemas = __webpack_require__(70);

var _errors = __webpack_require__(9);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _regexValidations = __webpack_require__(57);

var _regexValidations2 = _interopRequireDefault(_regexValidations);

var _urlUtils = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPES = {
    NUMBER: 'number',
    STRING: 'string',
    BOOLEAN: 'boolean',
    DATE: 'date',
    FUNCTION: 'function',
    ARRAY: 'array',
    OBJECT: 'object',
    URL: 'url',
    INTEGER: 'integer',
    UUID: 'uuid'
};

function validateArrayContainsItemsWithIds(_ref) {
    var items = _ref.items;

    var res = true;

    if (!_lodash2.default.isArray(items)) {
        return false;
    }

    var idCounts = _lodash2.default.countBy(items, '_id');

    _lodash2.default.forEach(items, function (item) {
        if (!item._id) {
            _reporter2.default.reportSdkError(_errors.generateError.error_mandatory_id());
            res = false;
        }

        if (idCounts[item._id] !== 1) {
            _reporter2.default.reportSdkWarning(_errors.generateError.warning_duplicate_item({ functionName: 'data', _id: item._id }));
        }
    });

    return res;
}

function reportHttpUrls(_ref2) {
    var value = _ref2.value,
        propertyName = _ref2.propertyName,
        functionName = _ref2.functionName;

    var isHttpSiteReg = /(http):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (isHttpSiteReg.test(value)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_http_format({
            propertyName: propertyName,
            functionName: functionName
        }));
    }
}

function validateByType(_ref3) {
    var value = _ref3.value,
        expectedType = _ref3.expectedType;

    switch (expectedType) {
        case TYPES.NUMBER:
            return _lodash2.default.isNumber(value) && !_lodash2.default.isNaN(value);
        case TYPES.STRING:
            return _lodash2.default.isString(value);
        case TYPES.BOOLEAN:
            return _lodash2.default.isBoolean(value);
        case TYPES.DATE:
            return _lodash2.default.isDate(value) && !_lodash2.default.isNaN(value.getTime());
        case TYPES.FUNCTION:
            return _lodash2.default.isFunction(value);
        case TYPES.ARRAY:
            return _lodash2.default.isArray(value);
        case TYPES.OBJECT:
            return _lodash2.default.isObject(value) && !_lodash2.default.isArray(value) && !_lodash2.default.isFunction(value);
        case TYPES.URL:
            return (0, _urlUtils.isExternalUrl)(value);
        case TYPES.INTEGER:
            return _lodash2.default.isInteger(value);
        case TYPES.UUID:
            return _regexValidations2.default.validateUUIDFormat(value);
        default:
            return true;
    }
}

function validateMandatoryFieldsAndReportIfNeeded(_ref4) {
    var compType = _ref4.compType,
        functionName = _ref4.functionName,
        dataToValidate = _ref4.dataToValidate,
        itemIndex = _ref4.itemIndex;

    var validationRes = { isValid: true };
    var expectedSchema = (0, _compSchemas.getSchemaOfComp)(compType);
    if (!expectedSchema) {
        return validationRes;
    }
    var mandatoryFields = _lodash2.default.pickBy(expectedSchema, { mandatory: true });
    _lodash2.default.forEach(mandatoryFields, function (v, k) {
        if (!_lodash2.default.has(dataToValidate, k)) {
            validationRes = { isValid: false, prop: k };
            return;
        }
    });

    if (!validationRes.isValid) {
        var error = !_lodash2.default.isNil(itemIndex) ? _errors.generateError.error_mandatory_val_with_index : _errors.generateError.error_mandatory_val;
        _reporter2.default.reportSdkError(error({
            propertyName: validationRes.prop,
            functionName: functionName,
            index: itemIndex
        }));
    }

    return validationRes.isValid;
}

function validateLength(_ref5) {
    var functionName = _ref5.functionName,
        propertyName = _ref5.propertyName,
        value = _ref5.value,
        minLength = _ref5.minLength,
        maxLength = _ref5.maxLength,
        itemIndex = _ref5.itemIndex,
        acceptNil = _ref5.acceptNil;

    var valid = isValueInRange({
        value: _lodash2.default.get(value, 'length'),
        minValue: minLength,
        maxValue: maxLength,
        acceptNil: acceptNil
    });
    if (!valid) {
        _reporter2.default.reportSdkError(getLengthError({ minLength: minLength, maxLength: maxLength, itemIndex: itemIndex })({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            minLength: minLength,
            maxLength: maxLength,
            acceptedLength: maxLength,
            index: itemIndex
        }));
    }
    return valid;
}

function getLengthError(_ref6) {
    var minLength = _ref6.minLength,
        maxLength = _ref6.maxLength,
        itemIndex = _ref6.itemIndex;

    var error = isActualNumber(itemIndex) ? _errors.generateError.error_length_in_range_with_index : _errors.generateError.error_length_in_range;
    if (!isActualNumber(minLength) || !isActualNumber(maxLength)) {
        return error;
    }

    if (minLength === maxLength) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_length_accept_single_value_with_index : _errors.generateError.error_length_accept_single_value;
    } else if (minLength === 0 && maxLength > 0) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_length_exceeds_with_index : _errors.generateError.error_length_exceeds;
    }
    return error;
}

function validateMinimum(_ref7) {
    var functionName = _ref7.functionName,
        propertyName = _ref7.propertyName,
        value = _ref7.value,
        minValue = _ref7.minValue,
        acceptNil = _ref7.acceptNil;

    if (acceptNil && _lodash2.default.isNil(value)) {
        return true;
    }
    if (!isActualNumber(value) || !isActualNumber(minValue) || value < minValue) {
        _reporter2.default.reportSdkError(_errors.generateError.error_larger_than({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            minValue: minValue
        }));
        return false;
    }
    return true;
}

function validateMaximum(_ref8) {
    var functionName = _ref8.functionName,
        propertyName = _ref8.propertyName,
        value = _ref8.value,
        maxValue = _ref8.maxValue,
        acceptNil = _ref8.acceptNil;

    if (acceptNil && _lodash2.default.isNil(value)) {
        return true;
    }
    if (!isActualNumber(value) || !isActualNumber(maxValue) || maxValue < value) {
        _reporter2.default.reportSdkError(_errors.generateError.error_less_than({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            maxValue: maxValue
        }));
        return false;
    }
    return true;
}

function validateRange(_ref9) {
    var functionName = _ref9.functionName,
        propertyName = _ref9.propertyName,
        value = _ref9.value,
        minValue = _ref9.minValue,
        maxValue = _ref9.maxValue,
        itemIndex = _ref9.itemIndex,
        acceptNil = _ref9.acceptNil;

    var valid = isValueInRange({ value: value, minValue: minValue, maxValue: maxValue, acceptNil: acceptNil });
    if (!valid) {
        _reporter2.default.reportSdkError(getRangeError({ minValue: minValue, maxValue: maxValue, itemIndex: itemIndex })({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            minValue: minValue,
            maxValue: maxValue,
            acceptedValue: minValue,
            index: itemIndex
        }));
    }
    return valid;
}

function isValueInRange(_ref10) {
    var value = _ref10.value,
        minValue = _ref10.minValue,
        maxValue = _ref10.maxValue,
        acceptNil = _ref10.acceptNil;

    if (acceptNil && _lodash2.default.isNil(value)) {
        return true;
    }
    if (!isActualNumber(maxValue) || !isActualNumber(value) || !isActualNumber(minValue) || maxValue < value || value < minValue) {
        return false;
    }
    return true;
}

function isActualNumber(value) {
    return _lodash2.default.isNumber(value) && !_lodash2.default.isNaN(value);
}

function getRangeError(_ref11) {
    var minValue = _ref11.minValue,
        maxValue = _ref11.maxValue,
        itemIndex = _ref11.itemIndex;

    var error = isActualNumber(itemIndex) ? _errors.generateError.error_range_with_index : _errors.generateError.error_range;
    if (!isActualNumber(minValue) || !isActualNumber(maxValue) || minValue < maxValue) {
        return error;
    } else if (minValue === maxValue) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_accept_single_value_with_index : _errors.generateError.error_accept_single_value;
    } else if (minValue > maxValue) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_empty_component_with_index : _errors.generateError.error_empty_component;
    }
    return error;
}

function getNullWarningTemplate(_ref12) {
    var itemIndex = _ref12.itemIndex,
        compName = _ref12.compName;

    if (!_lodash2.default.isNil(itemIndex)) {
        return _errors.generateError.warning_not_null_with_index;
    }

    if (compName) {
        return _errors.generateError.warning_not_null_for_comp_name;
    }

    return _errors.generateError.warning_not_null;
}

function validateType(_ref13) {
    var compType = _ref13.compType,
        functionName = _ref13.functionName,
        propertyName = _ref13.propertyName,
        value = _ref13.value,
        expectedTypes = _ref13.expectedTypes,
        warnIfNil = _ref13.warnIfNil,
        acceptNil = _ref13.acceptNil,
        shouldCheckMandatoryFields = _ref13.shouldCheckMandatoryFields,
        itemIndex = _ref13.itemIndex,
        compName = _ref13.compName;

    if (_lodash2.default.isNil(value)) {
        if (warnIfNil) {
            var error = getNullWarningTemplate({ itemIndex: itemIndex, compName: compName });
            _reporter2.default.reportSdkWarning(error({
                propertyName: propertyName,
                functionName: functionName,
                index: itemIndex,
                compName: compName,
                // convert null/undefined to string, since lodash templates ignore null/undefined values
                invalidValue: String(value)
            }));
        }
        if (acceptNil) {
            return true;
        }
    }

    var isValidByType = false;
    var actualType = void 0;
    expectedTypes.forEach(function (expectedType) {
        if (validateByType({
            value: value,
            expectedType: expectedType
        })) {
            isValidByType = true;
            actualType = expectedType;
        }
    });
    if (!isValidByType) {
        var _error = !_lodash2.default.isNil(itemIndex) ? _errors.generateError.error_type_with_index : _errors.generateError.error_type;
        _reporter2.default.reportSdkError(_error({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            expectedType: expectedTypes.join(','),
            index: itemIndex
        }));
        return false;
    }

    if (actualType === 'url' && _lodash2.default.includes(expectedTypes, 'url')) {
        reportHttpUrls({ value: value, propertyName: propertyName, functionName: functionName });
    }

    if (actualType === 'object' && _lodash2.default.includes(expectedTypes, 'object')) {
        var newObjType = _lodash2.default.isArray(compType) ? compType.concat([propertyName]) : [compType, propertyName];
        return validate({
            compType: newObjType,
            functionName: functionName,
            dataToValidate: value,
            shouldCheckMandatoryFields: shouldCheckMandatoryFields,
            itemIndex: itemIndex,
            compName: compName
        });
    }

    return true;
}

function validateValueFromEnum(_ref14) {
    var functionName = _ref14.functionName,
        propertyName = _ref14.propertyName,
        value = _ref14.value,
        enumValues = _ref14.enumValues,
        itemIndex = _ref14.itemIndex,
        acceptNil = _ref14.acceptNil;

    if (_lodash2.default.isNil(value) && acceptNil) {
        return true;
    }
    if (!_lodash2.default.includes(enumValues, value)) {
        var error = !_lodash2.default.isNil(itemIndex) ? _errors.generateError.error_type_with_index : _errors.generateError.error_type;
        _reporter2.default.reportSdkError(error({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            expectedType: 'from (' + enumValues.join(',') + ')',
            index: itemIndex
        }));
        return false;
    }
    return true;
}

function validateRegexForValue(_ref15) {
    var functionName = _ref15.functionName,
        propertyName = _ref15.propertyName,
        value = _ref15.value,
        validationExpressions = _ref15.validationExpressions;

    if (!_regexValidations2.default[validationExpressions](value)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_bad_format({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value
        }));
        return false;
    }
    return true;
}

function validateRegex(_ref16) {
    var functionName = _ref16.functionName,
        propertyName = _ref16.propertyName,
        value = _ref16.value,
        validationExpressions = _ref16.validationExpressions;

    if (_regexValidations2.default[validationExpressions]) {
        if (_lodash2.default.isArray(value)) {
            return _lodash2.default.forEach(value, function (val) {
                return validateRegexForValue({ functionName: functionName, propertyName: propertyName, value: val, validationExpressions: validationExpressions });
            });
        }
        return validateRegexForValue({ functionName: functionName, propertyName: propertyName, value: value, validationExpressions: validationExpressions });
    }
    return true;
}

function validate(_ref17) {
    var compType = _ref17.compType,
        functionName = _ref17.functionName,
        dataToValidate = _ref17.dataToValidate,
        shouldCheckMandatoryFields = _ref17.shouldCheckMandatoryFields,
        itemIndex = _ref17.itemIndex,
        compName = _ref17.compName;

    var res = true;
    var expectedSchema = (0, _compSchemas.getSchemaOfComp)(compType);
    if (!expectedSchema) {
        return true;
    }
    if (shouldCheckMandatoryFields) {
        if (!validateMandatoryFieldsAndReportIfNeeded({ compType: compType, functionName: functionName, dataToValidate: dataToValidate, itemIndex: itemIndex })) {
            return false;
        }
    }
    _lodash2.default.forEach(dataToValidate, function (value, propertyName) {
        if (!res) {
            return;
        }
        var expectedSchema = (0, _compSchemas.getSchemaOfComp)(compType)[propertyName];
        if (!expectedSchema) {
            res = true;
            return;
        }
        var validations = expectedSchema.validations || {};

        if (validations.type) {
            if (!validateType({
                compType: compType,
                functionName: functionName,
                propertyName: propertyName,
                value: value,
                expectedTypes: expectedSchema.schemaType,
                warnIfNil: expectedSchema.warnIfNil,
                acceptNil: expectedSchema.acceptNil,
                shouldCheckMandatoryFields: shouldCheckMandatoryFields,
                itemIndex: itemIndex,
                compName: compName
            })) {
                res = false;
                return;
            }
            if (expectedSchema.enum && !validateValueFromEnum({
                functionName: functionName,
                propertyName: propertyName,
                value: value,
                enumValues: expectedSchema.enum,
                itemIndex: itemIndex,
                acceptNil: expectedSchema.acceptNil
            })) {
                res = false;
                return;
            }
        }
        if (validations.range) {
            if (!validateRange({
                functionName: functionName,
                propertyName: propertyName,
                value: value,
                minValue: expectedSchema.minVal,
                maxValue: expectedSchema.maxVal,
                itemIndex: itemIndex,
                acceptNil: expectedSchema.acceptNil
            })) {
                res = false;
                return;
            }
        }
        if (validations.length) {
            if (!validateLength({
                functionName: functionName,
                propertyName: propertyName,
                value: value,
                minLength: expectedSchema.minLength,
                maxLength: expectedSchema.maxLength,
                itemIndex: itemIndex,
                acceptNil: expectedSchema.acceptNil
            })) {
                res = false;
                return;
            }
        }
        if (validations.regex) {
            if (!validateRegex({ functionName: functionName, propertyName: propertyName, value: value, validationExpressions: expectedSchema.validationExpressions })) {
                res = false;
                return;
            }
        }

        if (validations.minimum) {
            if (!validateMinimum({
                functionName: functionName,
                propertyName: propertyName,
                value: value,
                minValue: expectedSchema.minVal,
                acceptNil: expectedSchema.acceptNil
            })) {
                res = false;
                return;
            }
        }

        if (validations.maximum) {
            if (!validateMaximum({
                functionName: functionName,
                propertyName: propertyName,
                value: value,
                maxValue: expectedSchema.maxVal,
                acceptNil: expectedSchema.acceptNil
            })) {
                res = false;
                return;
            }
        }
    });
    return res;
}

exports.TYPES = TYPES;
exports.validate = validate;
exports.validateRange = validateRange;
exports.validateMinimum = validateMinimum;
exports.validateMaximum = validateMaximum;
exports.validateValueFromEnum = validateValueFromEnum;
exports.validateByType = validateByType;
exports.validateArrayContainsItemsWithIds = validateArrayContainsItemsWithIds;
exports.isValueInRange = isValueInRange;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HiddenMixin = __webpack_require__(74);

var _HiddenMixin2 = _interopRequireDefault(_HiddenMixin);

var _CollapsedMixin = __webpack_require__(73);

var _CollapsedMixin2 = _interopRequireDefault(_CollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin HiddenCollapsedMixin
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @mixes $w.HiddenMixin
 * @mixes $w.CollapsedMixin
 * @memberof $w
 */
var HiddenCollapsedMixin = function HiddenCollapsedMixin() {
  _classCallCheck(this, HiddenCollapsedMixin);
};

(0, _mixin2.default)(HiddenCollapsedMixin.prototype, _HiddenMixin2.default.prototype);
(0, _mixin2.default)(HiddenCollapsedMixin.prototype, _CollapsedMixin2.default.prototype);
exports.default = HiddenCollapsedMixin;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportWixCodeInteraction = exports.setType = exports.types = exports.capitalize = exports.isNilOrEmptyString = exports.isWorker = exports.getIndexOrUndefined = exports.nullIfNil = exports.emptyStringIfNil = exports.allPropertiesFor = exports.shallowCloneObject = exports.getInstanceValue = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _types = __webpack_require__(112);

var _types2 = _interopRequireDefault(_types);

var _typesData = __webpack_require__(113);

var _typesData2 = _interopRequireDefault(_typesData);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var types = new _types2.default(_typesData2.default);

function getDecodedInstance(queryParameters) {
    var instanceStr = _platformUtils2.default.getQueryParameter("instance", queryParameters);
    var encodedInstance = instanceStr.substring(instanceStr.indexOf(".") + 1);
    return JSON.parse(atob(encodedInstance));
}

function getInstanceValue(key, queryParameters) {
    var decodedInstance = getDecodedInstance(queryParameters);
    if (decodedInstance) {
        return decodedInstance[key] || null;
    }
    return null;
}

function shallowCloneObject(obj, ignoreKeys) {
    var newObj = {};
    for (var p in obj) {
        if (obj.hasOwnProperty(p) && ignoreKeys.indexOf(p) === -1) {
            newObj[p] = obj[p];
        }
    }
    return newObj;
}

function allPropertiesFor(obj) {
    var propNames = {};
    var objProto = obj;
    while (objProto !== Object.prototype) {
        Object.getOwnPropertyNames(objProto).forEach(function (prop) {
            propNames[prop] = true;
        });
        objProto = Object.getPrototypeOf(objProto);
    }
    delete propNames.constructor;
    return Object.keys(propNames);
}

function emptyStringIfNil(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}

function nullIfNil(value) {
    if (typeof value === 'undefined' || value === null) {
        return null;
    }
    return value;
}

function getIndexOrUndefined(collection, key, value) {
    var index = _lodash2.default.findIndex(collection, _defineProperty({}, key, value));
    return index !== -1 ? index : undefined;
}

function isWorker() {
    return typeof Window === 'undefined';
}

function isNilOrEmptyString(value) {
    return _lodash2.default.isNil(value) || value === '';
}

function capitalize(str) {
    if (!_lodash2.default.isString(str)) {
        return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function setType(viewerType, sdkType) {
    types.setType(viewerType, sdkType);
}

function reportWixCodeInteraction(_ref) {
    var controllerId = _ref.controllerId,
        appDefinitionId = _ref.appDefinitionId;

    var biReporter = _platformUtils2.default.getBIReporter();
    if (biReporter) {
        biReporter.reportWixCodeInteraction({ controllerId: controllerId, appDefinitionId: appDefinitionId });
    }
}

exports.getInstanceValue = getInstanceValue;
exports.shallowCloneObject = shallowCloneObject;
exports.allPropertiesFor = allPropertiesFor;
exports.emptyStringIfNil = emptyStringIfNil;
exports.nullIfNil = nullIfNil;
exports.getIndexOrUndefined = getIndexOrUndefined;
exports.isWorker = isWorker;
exports.isNilOrEmptyString = isNilOrEmptyString;
exports.capitalize = capitalize;
exports.types = types;
exports.setType = setType;
exports.reportWixCodeInteraction = reportWixCodeInteraction;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _errors = __webpack_require__(9);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

var _BIReporter = __webpack_require__(93);

var _BIReporter2 = _interopRequireDefault(_BIReporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlatformUtils = function PlatformUtils() {
    var _this = this;

    _classCallCheck(this, PlatformUtils);

    this.setExperiments = function (experiments) {
        return _this.experiments = experiments;
    };

    this.isExperimentOpen = function (name) {
        return _lodash2.default.includes(_this.experiments, name);
    };

    this.initGlobals = function (platformUtils) {
        _this.RGI = platformUtils.RGI;
    };

    this.init = function (platformUtils, onUpdateCallback) {
        platformUtils.RMI.setUpdateCallback(onUpdateCallback);
        _this.RMI = platformUtils.RMI;
        _this.componentsHooks = platformUtils.componentsHooks;
    };

    this.initUtilities = function (platformUtils) {
        _this.linkUtils = platformUtils.linkUtils;
        _this.backgroundUtils = platformUtils.backgroundUtils;
        _this.videoUrlsUtils = platformUtils.videoUrlsUtils;
        _this.repeaterUtils = platformUtils.repeaterUtils;
        _this.typeUtils = platformUtils.typeUtils;
        _this.uriUtils = platformUtils.uriUtils;
        _this.widgetUtils = platformUtils.widgetUtils;
        _this.richTextUtils = platformUtils.richTextUtils;
        _this.mediaSrcHandler = platformUtils.mediaSrcHandler;
        _this.pubSubService = platformUtils.pubSubService;
        _this.messageService = platformUtils.messageService;
    };

    this.addQueryParameters = function (params) {
        _lodash2.default.assign(_this.queryParametersMap, params);
    };

    this.setQueryParameters = function (params) {
        _this.queryParametersMap = params;
    };

    this.getQueryParameter = function (parameterName) {
        return _this.queryParametersMap[parameterName] || null;
    };

    this.initMonitoringServices = function (monitoringServices) {
        return _this.monitoringServices = monitoringServices;
    };

    this.getMonitoringServices = function () {
        return _this.monitoringServices;
    };

    this.setStaticEventHandlers = function (eventHandlers, contextId) {
        _this.staticEventHandlers = _lodash2.default.mapValues(eventHandlers, function (callback) {
            return {
                contextId: contextId,
                controllerId: contextId,
                callback: callback
            };
        });
    };

    this.throwIfMissing = function (param, apiName) {
        if (!param) {
            var errorMessage = apiName ? _errors.generateError.error_api_with_name_before_page_ready({ apiName: apiName }) : _errors.errors.ERROR_API_BEFORE_PAGE_READY;
            throw new _monitoring2.default.MonitoringErrorToIgnore(errorMessage);
        }
        return param;
    };

    this.getStaticEventHandler = function (name, onlyCallback) {
        var staticEventHandler = _this.staticEventHandlers[name]; // TODO - backward compatibility - remove after worker next release
        if (!staticEventHandler) {
            return null;
        } else if (onlyCallback) {
            return staticEventHandler.callback;
        }

        return staticEventHandler;
    };

    this.getRMI = function (apiName) {
        return _this.throwIfMissing(_this.RMI, apiName);
    };

    this.getRGI = function () {
        return _this.RGI;
    };

    this.getWixSelector = function (apiName) {
        return _this.throwIfMissing(_this.wixSelector, apiName);
    };

    this.setWixSelector = function (wixSelector) {
        _this.wixSelector = wixSelector;
    };

    this.getEmitter = function (apiName) {
        return _this.throwIfMissing(_this.emitter, apiName);
    };

    this.setEmitter = function (emitter) {
        _this.emitter = emitter;
    };

    this.getLinkUtils = function () {
        return _this.linkUtils;
    };

    this.getBackgroundUtils = function () {
        return _this.backgroundUtils;
    };

    this.getVideoUrlUtils = function () {
        return _this.videoUrlsUtils;
    };

    this.getRepeaterUtils = function () {
        return _this.repeaterUtils;
    };

    this.getTypeUtils = function () {
        return _this.typeUtils;
    };

    this.getComponentsHooks = function () {
        return _this.componentsHooks;
    };

    this.getUriUtils = function () {
        return _this.uriUtils;
    };

    this.getWidgetUtils = function () {
        return _this.widgetUtils;
    };

    this.getRichTextUtils = function () {
        return _this.richTextUtils;
    };

    this.getMediaSrcHandler = function () {
        return _this.mediaSrcHandler;
    };

    this.getPubSubService = function () {
        return _this.pubSubService;
    };

    this.setBiReporter = function (biServices) {
        var pageUrl = _this.RGI.getNavigationInfo().currentPageFullUrl;
        _this.biReporter = new _BIReporter2.default(biServices, pageUrl);
    };

    this.getBIReporter = function () {
        return _this.biReporter;
    };

    this.getMessageService = function () {
        return _this.messageService;
    };

    this.getEnv = function () {
        return _this.getQueryParameter("renderingEnv") || "browser";
    };

    this.wSpyLog = function () {
        if (self.wSpy) {
            var _self$wSpy;

            (_self$wSpy = self.wSpy).log.apply(_self$wSpy, arguments);
        }
    };

    this.staticEventHandlers = {};
    this.queryParametersMap = {};
} //eslint-disable-line no-return-assign

//eslint-disable-line no-return-assign

;

var platformUtils = new PlatformUtils();

exports.default = platformUtils;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportSdkError(errorMessage) {
    if (_lodash2.default.get(self, 'console.error')) {
        self.console.error('Wix code SDK error: ' + errorMessage);
    }
}

function reportSdkMsg(message) {
    if (_lodash2.default.get(self, 'console.error')) {
        self.console.log('Wix code SDK message: ' + message);
    }
}

function reportSdkWarning(message) {
    if (_lodash2.default.get(self, 'console.warn')) {
        self.console.warn('Wix code SDK Warning: ' + message);
    }
}

exports.default = {
    reportSdkError: reportSdkError,
    reportSdkMsg: reportSdkMsg,
    reportSdkWarning: reportSdkWarning
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = __webpack_require__(33);

var _Node3 = _interopRequireDefault(_Node2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _ViewportMixin = __webpack_require__(48);

var _ViewportMixin2 = _interopRequireDefault(_ViewportMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SLIDE_TYPES = new Set(['wysiwyg.viewer.components.BoxSlideShowSlide', 'wysiwyg.viewer.components.StripContainerSlideShowSlide', 'wysiwyg.viewer.components.StateBoxState', 'wysiwyg.viewer.components.StateStripState']);

/**
 * @mixin Element
 * @summary Provides basic functionality for elements.
 * @mixes $w.Node
 * @mixes $w.ViewportMixin
 * @memberof $w
 */

var Element = function (_Node) {
    _inherits(Element, _Node);

    function Element() {
        _classCallCheck(this, Element);

        return _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).apply(this, arguments));
    }

    _createClass(Element, [{
        key: 'onMouseIn',


        // METHODS:

        /**
         * @function onMouseIn
         * @syntax
         * function onMouseIn(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the mouse pointer is moved
         *  onto the element.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the mouse pointer is moved onto the
         *  element.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [Element-onMouseIn.es6=Get the mouse event info when the mouse enters an element]
         * @eventtype mouseenter
         * @memberof $w.Element
         * @eventhandler
         */
        value: function onMouseIn(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onMouseIn',
                dataToValidate: { onMouseIn: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().MOUSE_IN, controllerId, cb);
            return this;
        }

        /**
         * @function onMouseOut
         * @syntax
         * function onMouseOut(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the mouse pointer is moved
         *  off of the element.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the mouse pointer is moved off of
         *  the element.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [Element-onMouseOut.es6=Get the mouse event info when the mouse exits an element]
         * @eventtype mouseleave
         * @memberof $w.Element
         * @eventhandler
         */

    }, {
        key: 'onMouseOut',
        value: function onMouseOut(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onMouseOut',
                dataToValidate: { onMouseOut: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().MOUSE_OUT, controllerId, cb);
            return this;
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered;

            return { id: id, type: type, global: global, rendered: rendered };
        }
    }, {
        key: 'rendered',


        // PROPERTIES:

        /**
         * @member rendered
         * @label property
         * @syntax
         * get rendered(): boolean
         * @summary Indicates if an element is currently displayed.
         * @description
         *  If `rendered` is `true`, the element is in the current DOM structure and
         *  can be used.
         *
         *  If `rendered` is `false` the element is not in the current DOM structure.
         *
         *  An element might not be in the DOM if it is in a [slide]($w.Slide.html) or a [state]($w.State.html)
         *  which is not currently showing.
         * @snippet [Element-rendered.es6=Get an element's rendered status]
         * @type {external:Boolean}
         * @default false
         * @memberof $w.Element
         * @see [collapsed]($w.HiddenMixin.html#collapsed)
         * @see [hidden]($w.HiddenMixin.html#hidden)
         * @see [isVisible]($w.HiddenMixin.html#isVisible)
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            if (RMI.isGhostComponent(compId)) {
                return false;
            }

            var parentId = compId;
            while (parentId) {
                var parentType = _lodash2.default.get(RMI.getComp(parentId), 'type');
                if (SLIDE_TYPES.has(parentType)) {
                    var slideId = parentId;
                    var slideshowId = RMI.getParent(parentId);
                    var currentSlideIndex = _lodash2.default.get(RMI.getState(slideshowId), 'currentIndex');
                    var displayedSlideId = _lodash2.default.get(RMI.getChildren(slideshowId), currentSlideIndex);
                    return slideId === displayedSlideId;
                }
                parentId = RMI.getParent(parentId);
            }
            return RMI.getComp(compId).isDisplayed;
        }
    }]);

    return Element;
}(_Node3.default);

(0, _mixin2.default)(Element.prototype, _ViewportMixin2.default.prototype);

exports.default = Element;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatPlatformizedHttpError = exports.userErrors = exports.generateError = exports.errors = exports.extendGenerateError = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateError = {
    warning_not_null: _lodash2.default.template('The <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to null or undefined.'),
    warning_not_null_for_comp_name: _lodash2.default.template('The <%=propertyName%> parameter of "<%=compName%>" that is passed to the <%=functionName%> method cannot be set to null or undefined.'),
    warning_not_null_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to null or undefined.'),
    warning_invalid_option: _lodash2.default.template('The <%=propertyName%> parameter at index <%=index%> that is passed to the options function cannot be set to <%=wrongValue=>. Options must contain at least a non-null value or non-null label.'),
    warning_http_format: _lodash2.default.template('The <%=propertyName%> that  passed to the <%=functionName%> recommended format should be HTTPS and not HTTP'),
    warning_value_changed: _lodash2.default.template('The <%=propertyName%> of <%=compName%> was set to <%=newValue%>, which is less than <%=compName%>\'s <%=changedProperty%> value. <%=compName%> cannot have a <%=changedProperty%> value which is greater than its <%=propertyName%> value. The value of <%=changedProperty%> has therefore been set to <%=newValue%>.'),
    warning_duplicate_item: _lodash2.default.template('The data that was passed to <%=functionName%> contained at least two items with the same ID: <%=_id%>. Only the first item was accepted.'),
    warning_non_existing_item: _lodash2.default.template('The data that was passed to <%=functionName%> contained non existing item with the ID: <%=_id%> .'),
    warning_deprecated_effect_name: _lodash2.default.template('The "<%=functionName%>" function  called on "<%=compName%>" was called with the following deprecated effect: "<%=effectName%>". Read more about effects: "<%=infoLink%>"'),
    warning_deprecated_effect_with_options: _lodash2.default.template('The "<%=functionName%>" function  called on "<%=compName%>" was executed without the specified effect options because it was called with the following deprecated effect: "<%=effectName%>". Read more about effects: "<%=infoLink%>"'),
    warning_invalid_effect_name: _lodash2.default.template('The "<%=functionName%>" function called on "<%=compName%>" was executed without the "<%=effectName%>" effect because it is an invalid effectName value. Read more about effects: "<%=infoLink%>"'),
    warning_effect_options_not_set: _lodash2.default.template('The "<%=functionName%>" function called on "<%=compName%>" was executed without the specified effect options because it was called without an effect. Read more about effects: "<%=infoLink%>"'),
    warning_invalid_effect_options: _lodash2.default.template('The "<%=functionName%>" function called on "<%=compName%>" was executed without the "<%=effectName%>" effect because it was called with the following invalid effectOptions <%=wrongProperty%>: <%=wrongValue%>. Read more about the effectOptions object: "<%=infoLink%>"'),
    warning_invalid_type_effect_options: _lodash2.default.template('The "<%=functionName%>" function called on "<%=compName%>" was executed without the "<%=effectName%>" effect because the it was called with the following invalid effectOptions "<%=wrongValue%>". The effectOptions must be of type Object. Read more about the effectOptions object: "<%=infoLink%>"'),
    warning_color_casting_performed: _lodash2.default.template('The <%=propertyName%> property of <%=compName%> expects an rgbColor value, but was set to an rgbaColor value. The color value has been set, but the alpha (opacity) information has been ignored. Read more about rgbColor values: http://'),
    warning_at_least: _lodash2.default.template('The value of <%=propertyName%> property should not be set to the value <%=wrongValue%>. It should be at least <%=minValue%>.'),
    warning_at_most: _lodash2.default.template('The value of <%=propertyName%> property should not be set to the value <%=wrongValue%>. It should be at most <%=maxValue%>.'),
    warning_non_images_in_gallery: _lodash2.default.template('Gallery "<%=galleryId%>" cannot contain items that are not images. To also display video and text, choose a gallery that supports those types.'),
    error_namespace_already_exists: _lodash2.default.template('Can\'t register namespace <%=namespace%> since it already exists.'),
    error_component_already_exists: _lodash2.default.template('Can\'t register component <%=component%> since it already exists.'),
    error_compSchemaType_already_exists: _lodash2.default.template('Can\'t extend compSchemaType with type <%=type%> since it already exists.'),
    error_error_already_exists: _lodash2.default.template('Can\'t extend error with error <%=error%> since it already exists.'),
    error_mandatory_val: _lodash2.default.template('The <%=propertyName%> parameter is required for <%=functionName%> method.'),
    error_mandatory_val_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> is required for <%=functionName%> method.'),
    error_mandatory_id: _lodash2.default.template('Each item in the items array must have a member named `_id` which contains a unique value identifying the item.'),
    error_type: _lodash2.default.template('The <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be of type <%=expectedType%>.'),
    error_type_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be of type <%=expectedType%>.'),
    error_range: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be between <%=minValue%> and <%=maxValue%>.'),
    error_range_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be between <%=minValue%> and <%=maxValue%>.'),
    error_empty_component: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because the component is empty.'),
    error_empty_component_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because the component is empty.'),
    error_accept_single_value: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be <%=acceptedValue%>.'),
    error_accept_single_value_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be <%=acceptedValue%>.'),
    error_length_in_range: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be between <%=minLength%> and <%=maxLength%>.'),
    error_length_in_range_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be between <%=minLength%> and <%=maxLength%>.'),
    error_length_accept_single_value: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be <%=acceptedLength%>.'),
    error_length_accept_single_value_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be <%=acceptedLength%>.'),
    error_length_exceeds: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because its length exceeds <%=maxLength%>.'),
    error_length_exceeds_with_index: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because its length exceeds <%=maxLength%>.'),
    error_item_not_found: _lodash2.default.template('The <%=propertyName%> parameter with value <%=wrongValue%> that is passed to the <%=functionName%> method is not found'),
    error_larger_than: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be larger than <%=minValue%>.'),
    error_at_least: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be at least <%=minValue%>.'),
    error_less_than: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be less than <%=maxValue%>.'),
    error_at_most: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be at most <%=maxValue%>.'),
    error_bad_image_format: _lodash2.default.template('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", or "wix:image://".'),
    error_bad_image_format_with_index: _lodash2.default.template('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", or "wix:image://".'),
    error_bad_svg_format: _lodash2.default.template('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid SVG  XML string or an SVG source starting with "http://", "https://", or "wix:vector://v1/".'),
    error_bad_svg_format_with_index: _lodash2.default.template('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". It must be a valid SVG XML string or an SVG source starting with "http://", "https://", or "wix:vector://v1/".'),
    error_bad_menu_item_format: _lodash2.default.template('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", "image://", "wix:image://v1" or "wix:vector://v1/svgshape.v2".'),
    error_bad_menu_item_format_with_index: _lodash2.default.template('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", "image://", "wix:image://v1" or "wix:vector://v1/svgshape.v2".'),
    error_bad_item_id_format: _lodash2.default.template('Error setting the data property of <%=repeaterId%>. The data array contains the invalid ID "<%=wrongValue%>" at index <%=index%>. IDs must be composed of only alphanumeric characters and dashes.'),
    error_bad_format: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. Bad format'),
    error_bad_format_with_index: _lodash2.default.template('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". Bad format'),
    error_bad_format_with_hint: _lodash2.default.template('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. Bad format, must be <%=hint%> format.'),
    error_only_getter: _lodash2.default.template('Cannot set property <%=propertyName%> of <%=compType%> which has only a getter'),
    error_menu_can_have_two_levels: _lodash2.default.template('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot contains items as well - currently  we support menus with two levels only'),
    error_bad_link: _lodash2.default.template('Failed to create link because <%=error%>'),
    error_post_message: _lodash2.default.template('Failed to post message because <%=error%>'),
    error_app_does_not_exist: _lodash2.default.template('App with appDefinitionId <%=appDefId%> does not exist on the site'),
    error_unsupported_link: _lodash2.default.template('The link property that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported link type.'),
    error_unsupported_link_with_index: _lodash2.default.template('The link property of the item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported link type.'),
    error_unsupported_target: _lodash2.default.template('The target property that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported target. It must be one of the following supported values: <%=supportedValues=>.'),
    error_unsupported_target_with_index: _lodash2.default.template('The target property of the item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported target. It must be one of the following supported values: <%=supportedValues=>.'),
    error_bad_background_format: _lodash2.default.template('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid image URL starting with "http://", "https://" or "wix:image://", or a valid video URL starting with "wix:video://".'),
    error_api_with_name_before_page_ready: _lodash2.default.template('<%=apiName%> cannot be used before the page is ready.'),
    error_function_throws_error: _lodash2.default.template('The "<%=functionName%>" function of "<%=compName%>" threw the following error: <%=errorMessage%>'),
    error_slide_input: _lodash2.default.template('The "<%=propertyName%>" parameter that is passed to the "<%=functionName%>" method cannot be set to the value <%=wrongValue%>. It must be a slide from the "<%=slideshowID%>" slideshow or an index between <%=minValue%> and <%=maxValue%>'),
    error_state_input: _lodash2.default.template('The "<%=propertyName%>" parameter that is passed to the "<%=functionName%>" method cannot be set to the value <%=wrongValue%>. It must be a state or a state ID from the "<%=stateboxID%>" state box'),
    error_ghost_slide_input: _lodash2.default.template('The "<%=propertyName%>" parameter that is passed to the "<%=functionName%>" method cannot be set to the value <%=wrongValue%>. The slideshow no longer exists.'),
    error_invalid_css_value: _lodash2.default.template('The "<%=propertyName%>" property of "<%=compName%>" was set to an invalid "<%=cssProperty%>" value. The value is expected in the following format:"<%=exampleFormat%>". Read more about "<%=cssProperty%>" values: "<%=infoLink%>"'),
    error_invalid_css_value_multiple_expected_formats: _lodash2.default.template('The "<%=propertyName%>" property of "<%=compName%>" was set to an invalid "<%=cssProperty%>" value. The value is expected in one of the following formats:"<%=exampleFormats%>". Read more about "<%=cssProperty%>" values: "<%=infoLink%>"'),
    error_type_with_url: _lodash2.default.template('The <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be of type <%=expectedType%>. For more information, please visit <%=infoLink%>.'),
    error_ghost_function: _lodash2.default.template('The <%=functionName%> method has not been executed for <%=compType%>.'),
    error_compId_does_not_exist_for_app: _lodash2.default.template('Component with compId <%=compId%> that is passed to the <%=functionName%> method does not exist for app with appDefinitionId <%=appDefId%>'),
    error_navigating_to_external_url: _lodash2.default.template('The "navigateTo" method has not been executed for linkData with url: <%=externalUrl%>. You can get the external url value by using the "getExternalUrl" method.'),
    error_function_exist_only_in_preview: _lodash2.default.template('Error - <%=functionName%> is available only on preview mode')
};

var errors = {
    ERROR_API_BEFORE_PAGE_READY: 'Some APIs cannot be used before the page is ready.',
    ERROR_SELECTOR_TYPE_STRING: 'The value passed to the element selector function (usually $w), must be of type string',
    ERROR_SELECTOR_BEFORE_ON_READY: 'The element selector function (usually $w) cannot be used before the page is ready',
    ERROR_STORAGE_MAX_SIZE: 'QuotaExceededError - app storage limit is 50kb'
};

var userErrors = {
    CLOSE_DIALOG: 'The user closed the login dialog',
    NO_LOGGED_IN: 'No user is currently logged in',
    AWAITING_APPROVAL: 'Member login request has been sent and is awaiting approval'
};

var formatPlatformizedHttpError = function formatPlatformizedHttpError(rawXhrError) {
    var status = rawXhrError.status,
        responseText = rawXhrError.responseText;

    if (!status && !responseText) {
        return rawXhrError;
    }
    var errorMessage = void 0;
    try {
        errorMessage = JSON.parse(responseText).message;
    } catch (e) {/*do nothing */}
    return (errorMessage || 'unknown failure') + ' (' + (status || 0) + ')';
};

function extendGenerateError(errorName, error) {
    if (generateError[errorName]) {
        _reporter2.default.reportSdkError(generateError.error_error_already_exists({ error: errorName }));
        return false;
    }

    _lodash2.default.set(generateError, errorName, error);
    return true;
}

exports.extendGenerateError = extendGenerateError;
exports.errors = errors;
exports.generateError = generateError;
exports.userErrors = userErrors;
exports.formatPlatformizedHttpError = formatPlatformizedHttpError;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ClickableMixin
 * @description Provides functionality for elements that can be clicked.
 * @memberof $w
 */
var ClickableMixin = function () {
    function ClickableMixin() {
        _classCallCheck(this, ClickableMixin);
    }

    _createClass(ClickableMixin, [{
        key: 'onClick',


        /**
         * @function onClick
         * @syntax
         * function onClick(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the element is clicked.
         * @description
         *  An element receives a `click` event when a user clicks on the element
         *  and releases.
         *
         *  When a user double-clicks an element, two `click` events are fired
         *  before a `doubleClick` event is also fired.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the element is clicked.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [ClickableMixin-onClick.es6=Get the ID of the element that was clicked]
         * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
         * @eventtype click
         * @see [onDblClick( )](#onDblClick)
         * @memberof $w.ClickableMixin
         * @eventhandler
         */
        value: function onClick(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onClick',
                dataToValidate: { onClick: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CLICK, controllerId, cb);
            return this;
        }

        /**
         * @function onDblClick
         * @syntax
         * function onDblClick(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the element is double-clicked.
         * @description
         *  An element receives a `dblClick` event when a user double-clicks on the element
         *  and releases.
         *
         *  When a user double-clicks an element, two `click` events are fired
         *  before a `doubleClick` event is also fired.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the element is clicked.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [ClickableMixin-onDblClick.es6=Get the ID of the element that was double-clicked]
         * @see [onClick( )](#onClick)
         * @memberof $w.ClickableMixin
         * @eventtype dblClick
         * @eventhandler
         */

    }, {
        key: 'onDblClick',
        value: function onDblClick(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onDblClick',
                dataToValidate: { onDblClick: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().DBL_CLICK, controllerId, cb);
            return this;
        }
    }]);

    return ClickableMixin;
}();

exports.default = ClickableMixin;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extendValueMethodToInputType = exports.clearValidations = exports.getValidationMessage = exports.runValidationsAndSyncAfterChange = exports.runValidationsAfterChange = exports.hideValidityIndication = exports.showValidityIndication = exports.isValid = exports.getValidity = exports.runValidationsAndSync = exports.runValidations = exports.onCustomValidation = exports.initValidationsService = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _validationsServiceState = __webpack_require__(118);

var _valueValidation = __webpack_require__(68);

var _checkboxGroupUtils = __webpack_require__(53);

var _errors = __webpack_require__(9);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var customValidations = {};

var initValidationsService = function initValidationsService() {
    customValidations = {};
    (0, _validationsServiceState.initValidationsServiceState)();
};

var getValueMethodToInputType = {
    CheckboxInput: function CheckboxInput(RMI, compId) {
        return RMI.getData(compId).checked;
    },
    CheckboxGroup: function CheckboxGroup(RMI, compId) {
        return (0, _checkboxGroupUtils.getCheckedValues)(RMI.getData(compId).options);
    },
    DatePicker: function DatePicker(RMI, compId) {
        return RMI.getState(compId).selectedDate;
    },
    FileUploader: function FileUploader(RMI, compId) {
        return RMI.getState(compId).value;
    }
};

function extendValueMethodToInputType(type, getValueMethod) {
    if (getValueMethodToInputType[type]) {
        _reporter2.default.reportSdkError(_errors.generateError.error_component_already_exists({ component: type }));
        return false;
    }

    _lodash2.default.set(getValueMethodToInputType, type, getValueMethod);
    return true;
}

var getValueByInputType = function getValueByInputType(RMI, compId) {
    var compData = RMI.getData(compId);
    var getValueMethod = getValueMethodToInputType[compData.type];

    if (getValueMethod) {
        return getValueMethod(RMI, compId);
    }

    return compData.value;
};

var onCustomValidation = function onCustomValidation(RMI, compId, validator) {
    customValidations[compId] = validator;

    runValidations(RMI, compId);
};

var checkCustomValidity = function checkCustomValidity(compId, value) {
    var customValidator = customValidations[compId];
    var customValidity = '';

    var reject = function reject(message) {
        customValidity = message;
    };

    if (customValidator) {
        customValidator(value, reject);
    }

    return customValidity;
};

var updateValidityIndication = function updateValidityIndication(RMI, compId, indicationValue) {
    var state = RMI.getState(compId);
    var shouldShowValidationIndication = _lodash2.default.get(state, 'shouldShowValidationIndication', false);

    if (shouldShowValidationIndication !== indicationValue) {
        RMI.updateModel(_defineProperty({}, compId, {
            state: {
                shouldShowValidationIndication: indicationValue
            }
        }));

        RMI.executeCompBehavior(compId, 'updateValidityIndication', { value: indicationValue, requiresDom: null });
    }
};

var showValidityIndication = function showValidityIndication(RMI, compId) {
    return updateValidityIndication(RMI, compId, true);
};
var hideValidityIndication = function hideValidityIndication(RMI, compId) {
    return updateValidityIndication(RMI, compId, false);
};

var runValidations = function runValidations(RMI, compId, value) {
    value = !_lodash2.default.isUndefined(value) ? value : getValueByInputType(RMI, compId);
    var validationState = (0, _validationsServiceState.getCompValidationState)(compId);
    var prevCustomValidity = (0, _valueValidation.getCustomValidity)(validationState);
    var compData = RMI.getFullDataWithOverrides(compId);
    var compProps = RMI.getProps(compId);
    var compState = RMI.getState(compId);

    var validateData = (0, _valueValidation.validateValue)(value, compData, compProps, compState);
    var customValidity = checkCustomValidity(compId, value);

    if (customValidity) {
        validateData = (0, _valueValidation.addCustomValidityToValidateData)(validateData, customValidity);
    }

    (0, _validationsServiceState.setCompValidationState)(compId, validateData);

    if (customValidity !== prevCustomValidity) {
        RMI.executeCompBehavior(compId, RMI.getEventTypes().SET_CUSTOM_VALIDITY, { customValidity: customValidity, requiresDom: null });
    }
};

var clearValidations = function clearValidations(RMI, compId) {
    (0, _validationsServiceState.unsetCompValidationState)(compId);
};

var runValidationsAfterChange = function runValidationsAfterChange(RMI, compId, value) {
    runValidations(RMI, compId, value);
    showValidityIndication(RMI, compId);
};

var runValidationsAndSync = function runValidationsAndSync(RMI, compId, value) {
    value = !_lodash2.default.isUndefined(value) ? value : getValueByInputType(RMI, compId);
    var compData = RMI.getFullDataWithOverrides(compId);
    var compProps = RMI.getProps(compId);
    var compState = RMI.getState(compId);

    var validateData = (0, _valueValidation.validateValue)(value, compData, compProps, compState);
    var customValidity = checkCustomValidity(compId, value);

    if (customValidity) {
        validateData = (0, _valueValidation.addCustomValidityToValidateData)(validateData, customValidity);
    }

    (0, _validationsServiceState.setCompValidationState)(compId, validateData);

    RMI.executeCompBehavior(compId, RMI.getEventTypes().SYNC_VALIDATION_DATA, { validateData: validateData, requiresDom: null });
};

var runValidationsAndSyncAfterChange = function runValidationsAndSyncAfterChange(RMI, compId, value) {
    runValidationsAndSync(RMI, compId, value);
    showValidityIndication(RMI, compId);
};

var getValidity = function getValidity(compId) {
    return _lodash2.default.get((0, _validationsServiceState.getCompValidationState)(compId), 'validity');
};

var isValid = function isValid(compId) {
    return _lodash2.default.get((0, _validationsServiceState.getCompValidationState)(compId), 'validity.valid', true);
};

var getValidationMessage = function getValidationMessage(compId) {
    return _lodash2.default.get((0, _validationsServiceState.getCompValidationState)(compId), 'validationMessage', '');
};

exports.initValidationsService = initValidationsService;
exports.onCustomValidation = onCustomValidation;
exports.runValidations = runValidations;
exports.runValidationsAndSync = runValidationsAndSync;
exports.getValidity = getValidity;
exports.isValid = isValid;
exports.showValidityIndication = showValidityIndication;
exports.hideValidityIndication = hideValidityIndication;
exports.runValidationsAfterChange = runValidationsAfterChange;
exports.runValidationsAndSyncAfterChange = runValidationsAndSyncAfterChange;
exports.getValidationMessage = getValidationMessage;
exports.clearValidations = clearValidations;
exports.extendValueMethodToInputType = extendValueMethodToInputType;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentsBatchFunctions = __webpack_require__(39);

var _componentsBatchFunctions2 = _interopRequireDefault(_componentsBatchFunctions);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ContainableMixin
 * @summary Provides functionality for elements that can contain other elements.
 *  Some elements, such as pages, headers, footers, and boxes, can contain
 *  other elements. This occurs when you drag an element onto a container
 *  element and <a href="https://www.wix.com/support/html5/article/attaching-elements-to-a-box" target="_blank">attach it</a>.
 *  These attached elements are considered the parent element's children. Some
 *  actions performed on the parent, such as [`hiding`]($w.HiddenMixin.html#hide),
 *  affect the element's children as well.
 * @memberof $w
 */
var ContainableMixin = function () {
    function ContainableMixin() {
        _classCallCheck(this, ContainableMixin);
    }

    _createClass(ContainableMixin, [{
        key: 'children',


        /**
         * @member children
         * @label property
         * @syntax
         * get children(): Element[]
         * @summary Gets an array of the elements that are contained within the element.
         * @description
         *  Some elements, such as pages, headers, footers, and boxes, can contain
         *  other elements. This occurs when you drag an element onto a container
         *  element and <a href="https://www.wix.com/support/html5/article/attaching-elements-to-a-box" target="_blank">attach it</a>.
         *  These attached elements are considered the parent element's children.
         * @type {$w.Element[]}
         * @default An empty array
         * @snippet [Containable-children.es6=Get an element's children]
         * @see [parent]($w.Node.html#parent)
         * @memberof $w.ContainableMixin
         * @readonly
         */
        get: function get() {
            var compId = members._compId.get(this);
            if (compId === 'default') {
                return;
            }
            var childElements = [];
            var RMI = members._RMI.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);
            var childrenIds = RMI.getChildren(compId);
            var children = childrenIds.map(RMI.getComp.bind(RMI));

            children.forEach(function (child, index) {
                childElements.push(wixSelector.getInstance(RMI, child.type, childrenIds[index], controllerId));
            }, this);
            return _componentsBatchFunctions2.default.expose(childElements);
        }
    }]);

    return ContainableMixin;
}();

exports.default = ContainableMixin;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var wrappedClasses = {};
var raven = void 0;
var JS_WIXCODE_SDK_SENTRY_DSN = 'https://d83ddb9b6f0643068176ec3ed0a94686@sentry.io/271739';

function dataCallback(data) {
    var exceptionFrames = _lodash2.default.get(data, ['exception', 'values', 0, 'stacktrace', 'frames'], []);
    if (exceptionFrames.length) {
        _lodash2.default.set(data, ['exception', 'values', 0, 'stacktrace', 'frames'], _lodash2.default.map(exceptionFrames, function (frame) {
            if (frame && _lodash2.default.isString(frame.filename)) {
                frame.abs_path = frame.filename;
                frame.filename = _lodash2.default.last(_lodash2.default.split(frame.filename, '/'));
            }
            return frame;
        }));
        var lastFrame = _lodash2.default.last(exceptionFrames);
        data.fingerprint = _lodash2.default.concat(data.fingerprint || [], [lastFrame.filename, lastFrame.lineno, lastFrame.colno]);
    }

    return data;
}

function setUserContext() {
    raven.setUserContext({
        id: _lodash2.default.get(self, ['wix-users', 'currentUser', 'id']),
        baseUrl: _lodash2.default.get(self, ['wix-location', 'baseUrl'])
    });
}

function initRaven() {
    var monitoring = _platformUtils2.default.getMonitoringServices();
    raven = monitoring.createMonitor(JS_WIXCODE_SDK_SENTRY_DSN, dataCallback);
}

function tryToCreateNewInstance(Class) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        try {
            _platformUtils2.default.wSpyLog('createInstance', [Class].concat(args));
            return new (Function.prototype.bind.apply(Class, [null].concat(args)))();
        } catch (error) {
            raven.setExtraContext(args);
            raven.captureException(error);
            throw error;
        }
    };
}

function tryToRunMethod(method, getRavenContext, descriptor) {
    return function () {
        try {
            var logName = descriptor === 'get' ? 'get' : 'runMethod';

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            _platformUtils2.default.wSpyLog(logName, [descriptor || method.name, this].concat(args));
            if ((0, _livePreview.isStageUnfriendly)(method) && _platformUtils2.default.getRGI().getLivePreviewMode && _platformUtils2.default.getRGI().getLivePreviewMode()) {
                _platformUtils2.default.wSpyLog(logName, [descriptor || method.name, 'blocked for livepreview']);
                return;
            }
            return method.apply(this, args);
        } catch (error) {
            var originalError = error.originalError;

            if (error instanceof MonitoringErrorToIgnore) {
                throw originalError;
            }
            var context = _lodash2.default.isFunction(getRavenContext) ? getRavenContext.call(this) : {};
            raven.setExtraContext(context);
            raven.captureException(error);
            throw error;
        }
    };
}

// Note: this function travels from the given class until Object and wrapped all super classes.
// This function saves the wrapped classes and returns a given class(or super class) if a class with the same name was already wrapped
function monitorClassIncludingSuperClasses(Class, getRavenContext) {
    if (!Class instanceof Object || !Class.prototype) {
        return Class;
    }

    var className = _lodash2.default.get(Class.prototype, 'constructor.name');

    if (!className) {
        return Class;
    }

    var wrappedClass = wrappedClasses[className];

    if (wrappedClass) {
        return wrappedClass;
    }

    var superClass = Object.getPrototypeOf(Class);
    monitorClassIncludingSuperClasses(superClass, getRavenContext);

    wrappedClass = exportObj.monitorClass(Class, getRavenContext);
    wrappedClasses[className] = wrappedClass;

    return wrappedClass;
}

function monitorClass(Class, getRavenContext) {
    if (!Class instanceof Object || !Class.prototype) {
        return Class;
    }

    var compDescriptors = Object.getOwnPropertyDescriptors(Class.prototype);
    for (var descriptor in compDescriptors) {
        //eslint-disable-line guard-for-in
        var compDescriptor = compDescriptors[descriptor];
        if (descriptor === 'constructor') {
            // do nothing
        } else if (compDescriptor.set || compDescriptor.get) {
            var getWrapper = void 0;
            var setWrapper = void 0;
            if (compDescriptor.set) {
                setWrapper = tryToRunMethod(compDescriptor.set, getRavenContext, descriptor);
            }
            if (compDescriptor.get) {
                getWrapper = tryToRunMethod(compDescriptor.get, getRavenContext, descriptor);
            }
            Object.defineProperty(Class.prototype, descriptor, { configurable: true, get: getWrapper, set: setWrapper });
        } else if (_lodash2.default.isFunction(compDescriptor.value)) {
            Object.defineProperty(Class.prototype, descriptor, {
                configurable: true,
                value: tryToRunMethod(compDescriptor.value, getRavenContext, descriptor)
            });
        }
    }

    return tryToCreateNewInstance(Class);
}

function getRavenContextForComponent() {
    var RMI = members._RMI.get(this);
    var contextId = members._contextId.get(this);
    var compId = members._compId.get(this);
    var role = members._role.get(this);
    var controllerId = members._controllerId.get(this);
    var type = members._type.get(this);

    return { compId: compId, type: type, contextId: contextId, role: role, controllerId: controllerId, RMI: RMI };
}

function monitorComponent(Class) {
    return monitorClassIncludingSuperClasses(Class, exportObj.getRavenContextForComponent);
}

function getRavenContextForNamespace() {
    var appDefId = members._appDefId.get(this);

    return { appDefId: appDefId };
}

function monitorNamespace(Class) {
    return exportObj.monitorClass(Class, exportObj.getRavenContextForNamespace);
}

function reportError(e) {
    if (raven) {
        raven.captureException(e);
    }
}

var MonitoringErrorToIgnore = function () {
    function MonitoringErrorToIgnore(originalError) {
        _classCallCheck(this, MonitoringErrorToIgnore);

        this.error = originalError;
    }

    _createClass(MonitoringErrorToIgnore, [{
        key: 'originalError',
        get: function get() {
            return this.error;
        }
    }]);

    return MonitoringErrorToIgnore;
}();

var exportObj = {
    initRaven: initRaven,
    monitorClass: monitorClass,
    monitorComponent: monitorComponent,
    monitorNamespace: monitorNamespace,
    reportError: reportError,
    getRavenContextForComponent: getRavenContextForComponent,
    getRavenContextForNamespace: getRavenContextForNamespace,
    setUserContext: setUserContext,
    MonitoringErrorToIgnore: MonitoringErrorToIgnore
};

exports.default = exportObj;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _multiMixin = __webpack_require__(108);

var _multiMixin2 = _interopRequireDefault(_multiMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _BackgroundColorMixin = __webpack_require__(78);

var _BackgroundColorMixin2 = _interopRequireDefault(_BackgroundColorMixin);

var _BorderWidthMixin = __webpack_require__(81);

var _BorderWidthMixin2 = _interopRequireDefault(_BorderWidthMixin);

var _BorderColorMixin = __webpack_require__(79);

var _BorderColorMixin2 = _interopRequireDefault(_BorderColorMixin);

var _BorderRadiusMixin = __webpack_require__(80);

var _BorderRadiusMixin2 = _interopRequireDefault(_BorderRadiusMixin);

var _TextColorMixin = __webpack_require__(83);

var _TextColorMixin2 = _interopRequireDefault(_TextColorMixin);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

var _ForegroundColorMixin = __webpack_require__(82);

var _ForegroundColorMixin2 = _interopRequireDefault(_ForegroundColorMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SUPPORTED_STYLES = {
    Button: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    Box: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype],
    Checkbox: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype],
    UploadButton: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    TextInput: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    TextBox: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    Shape: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype],
    RadioButtonGroup: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    CheckboxGroup: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    Header: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype],
    Footer: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype],
    Dropdown: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    ProgressBar: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _ForegroundColorMixin2.default.prototype]
};

function getRavenContextForStyle() {
    var RMI = members._RMI.get(this);
    var compId = members._compId.get(this);
    var type = members._type.get(this);
    var compNickname = members._compName.get(this);

    return { compId: compId, type: type, compNickname: compNickname, RMI: RMI };
}

var styleClasses = _lodash2.default.transform(SUPPORTED_STYLES, function (result, styleMixins, compType) {

    /**
     * @class Style
     * @memberOf $w
     * @summary An object representing an element's styles.
     * 
     * Elements that expose a style property can be styled programmatically.
     * You cannot programmatically style elements that do not expose a style property.
     *  
     * The following elements expose the style property:
     * 
     *  + [`Box`]($w.Box.html)
     *  + [`Button`]($w.Button.html)
     *  + [`Checkbox`]($w.Checkbox.html)
     *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`Footer`]($w.Footer.html)
     *  + [`Header`]($w.Header.html) 
     *  + [`QuickActionBar`]($w.QuickActionBar.html)
     *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html) 
     *  + [`UploadButton`]($w.UploadButton.html)
     */

    var Style = function Style(RMI, compId, type, compNickname) {
        _classCallCheck(this, Style);

        members._RMI.set(this, RMI);
        members._compId.set(this, compId);
        members._type.set(this, type);
        members._compName.set(this, compNickname);
    };

    (0, _multiMixin2.default)(Style.prototype, styleMixins);

    result[compType] = _monitoring2.default.monitorClass(Style, getRavenContextForStyle);
}, {});

/**
 * @class StyleMixin
 * @summary Provides functionality for elements that can be styled.
 * @classdesc
 *  Elements that expose a [`style`](#style) property can be styled programmatically.
 *  You cannot programmatically style elements that do not expose a [`style`](#style) property.
 *  
 *  The following elements expose the [`style`](#style) property:
 * 
 *  + [`Box`]($w.Box.html)
 *  + [`Button`]($w.Button.html)
 *  + [`Checkbox`]($w.Checkbox.html)
 *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
 *  + [`Dropdown`]($w.Dropdown.html)
 *  + [`Footer`]($w.Footer.html)
 *  + [`Header`]($w.Header.html) 
 *  + [`QuickActionBar`]($w.QuickActionBar.html)
 *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
 *  + [`TextBox`]($w.TextBox.html)
 *  + [`TextInput`]($w.TextInput.html) 
 *  + [`UploadButton`]($w.UploadButton.html)
 * 
 * @memberof $w
 * @tagname styleMixin
 */

var StyleMixin = function () {
    function StyleMixin() {
        _classCallCheck(this, StyleMixin);
    }

    _createClass(StyleMixin, [{
        key: 'style',

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the element's styles.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.StyleMixin
         * @readonly
         */
        get: function get() {
            var styleInstance = members._styleInstance.get(this);
            if (styleInstance) {
                return styleInstance;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var type = members._type.get(this);
            var StyleClass = styleClasses[type.compType];
            var compName = this.id;

            styleInstance = new StyleClass(RMI, compId, type, compName);
            members._styleInstance.set(this, styleInstance);
            return styleInstance;
        }
    }]);

    return StyleMixin;
}();

exports.default = StyleMixin;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unregisterEventListener = exports.registerEventListener = exports.onMessage = exports.callEventListeners = exports.Intent = exports.MessageTypes = exports.sendMessageToHost = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(5);

var utils = _interopRequireWildcard(_utils);

var _appStudioUtils = __webpack_require__(43);

var _appStudioUtils2 = _interopRequireDefault(_appStudioUtils);

var _eventService = __webpack_require__(103);

var _eventService2 = _interopRequireDefault(_eventService);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _nativeComponentUtils = __webpack_require__(67);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intent = {
    WIX_CODE_SITE_API: 'WIX_CODE_SITE_API',
    WIX_CODE_APP_API: 'WIX_CODE_APP_API',
    WIX_CODE_RESPONSE: 'WIX_CODE_RESPONSE',
    WIX_CODE: 'WIX_CODE',
    WIX_CODE_WARMUP: 'WIX_CODE_WARMUP',
    BROWSER_API: 'BROWSER_API'
};

var MessageTypes = {
    NAVIGATE_TO: 'navigateTo',
    SITE_INFO: 'siteInfo',
    SM_CURRENT_USER_EMAIL: 'smCurrentUserEmail',
    SM_CURRENT_USER_SLUG: 'smCurrentUserSlug',
    SM_REQUEST_LOGIN: 'smRequestLogin',
    SM_LOGOUT: 'smLogout',
    SM_FORGOT_PASSWORD: 'smForgotPassword',
    SM_REGISTER_USER: 'smRegisterUser',
    SM_APPLY_SESSION_TOKEN: 'smApplySessionToken',
    ML_SET_LANGUAGECODE: 'mlSetLanguageCode',
    WINDOW_BOUNDING_RECT: 'windowBoundingRect',
    SCROLL_TO: 'scrollTo',
    SCROLL_TO_COMP: 'scrollToComponent',
    SCROLL_BY: 'scrollBy',
    GET_APP_API: 'getAppAPI',
    INVOKE_APP_FN: 'invokeAppFn',
    INVOKE_APP_ON: 'invokeAppOn',
    SET_TO_STORAGE: 'setToStorage',
    STORAGE_UPDATE: 'storageWasUpdated',
    POST_HTML_MESSAGE: 'postHtmlMessage',
    OPEN_LIGHTBOX: 'openLightbox',
    CLOSE_LIGHTBOX: 'closeLightbox',
    START_UPLOAD: 'startFileUpload',
    GET_ROUTERS_SITEMAP: 'getRoutersSiteMap',
    GET_CURRENT_GEOLOCATION: 'getCurrentGeolocation',
    SET_WARMUP_DATA: 'setWarmupData',
    GOOGLE_ANALYTICS: 'googleAnalytics',
    TRACK_EVENT: 'trackEvent',
    OPEN_MODAL: 'openModal',
    SEND_MESSAGE_TO_PARENT: 'sendMessageToParent',
    OPEN_MESSAGE_CHANNEL: 'openMessageChannel',
    OPEN_POPUP: 'openPopup',
    OPEN_PERSISTENT_POPUP: 'openPersistentPopup',
    GET_SECTION_URL: 'getSectionUrl',
    SET_PAGE_METADATA: 'setPageMetadata',
    GET_COMPONENT_VIEWPORT_STATE: 'getComponentViewportState',
    SET_TPA_NATIVE_COMPONENT_PROPS: 'setTPANativeComponentProps',
    NOTIFY_EVENT_TO_EDITOR_APP: 'notifyEventToEditorApp'
};

var callbackId = 1;

var registeredEventListeners = {};

var callbacks = {};

function postMessage(message, ports) {
    _platformUtils2.default.getMessageService().sendMessage(message, ports);
}

var msgSenders = {
    WIX_CODE_WARMUP: sendWarmupCommandMessage,
    WIX_CODE: sendCompCommandMessage,
    BROWSER_API: sendBrowserCommandMessage,
    WIX_CODE_SITE_API: sendGeneralViewerCommandMessage,
    WIX_CODE_APP_API: sendGeneralViewerCommandMessage
};

var EventsCallbacks = {};

//BI note - each message that comes from a component should include controllerId, appDefinitionId is not needed
//BI note - each message that comes from a namespace should include appDefinitionId, controllerId is not needed
function sendMessageToHost(intent, _ref) {
    var command = _ref.command,
        data = _ref.data,
        contextId = _ref.contextId,
        appDefinitionId = _ref.appDefinitionId,
        controllerId = _ref.controllerId,
        compId = _ref.compId,
        callback = _ref.callback,
        ports = _ref.ports;

    utils.reportWixCodeInteraction({ controllerId: controllerId, appDefinitionId: appDefinitionId });
    (msgSenders[intent] || sendGeneralViewerCommandMessage)(intent, { command: command, compId: compId, contextId: contextId, data: data, callback: callback, ports: ports });
}

function sendBrowserCommandMessage(intent, _ref2) {
    var command = _ref2.command,
        data = _ref2.data;

    if (!command) {
        return;
    }

    postMessage({
        intent: intent,
        type: command,
        data: data
    });
}

function sendGeneralViewerCommandMessage(intent, _ref3) {
    var command = _ref3.command,
        data = _ref3.data,
        callback = _ref3.callback,
        ports = _ref3.ports;

    if (!command) {
        return;
    }

    var callbackId = getCallbackId();
    if (callback) {
        callbacks[callbackId] = callback;
    }

    var message = {
        callbackId: callbackId,
        intent: intent,
        type: command,
        contextId: _platformUtils2.default.getRGI().getContextId(),
        deviceType: _platformUtils2.default.getRGI().getDeviceType() || 'desktop',
        data: data
    };

    if (_lodash2.default.get(data, 'compId')) {
        message.compId = data.compId;
    }

    postMessage(message, ports);
}

function sendWarmupCommandMessage(intent, _ref4) {
    var command = _ref4.command,
        data = _ref4.data;

    intent = 'WIX_CODE';
    try {
        postMessage({
            intent: intent,
            type: 'wix_code_warmup_data',
            deviceType: _platformUtils2.default.getRGI().getDeviceType() || 'desktop',
            data: data,
            command: command
        });
    } catch (error) {
        _reporter2.default.reportSdkError(_errors.generateError.error_post_message({ error: error }));
    }
}

function sendCompCommandMessage(intent, _ref5) {
    var command = _ref5.command,
        compId = _ref5.compId,
        contextId = _ref5.contextId,
        data = _ref5.data,
        callback = _ref5.callback;

    //validations
    var callbackId = getCallbackId();
    if (callback) {
        callbacks[callbackId] = callback;
    }

    postMessage({
        callbackId: callbackId,
        intent: intent,
        type: 'wix_code_iframe_command',
        deviceType: _platformUtils2.default.getRGI().getDeviceType() || 'desktop',
        data: data,
        compId: compId,
        contextId: contextId,
        command: command
    });
}

function onMessage(event) {
    if (!event || !event.data) {
        return;
    }

    var data = {};
    try {
        if (_lodash2.default.isString(event.data)) {
            data = JSON.parse(event.data);
        } else if (_lodash2.default.isObject(event.data)) {
            data = event.data;
        }
    } catch (e) {
        return;
    }
    switch (data.intent) {
        case 'TPA_NATIVE_EVENT':
            (0, _nativeComponentUtils.handleNativeEvent)(_platformUtils2.default.getRMI(), data);
            break;
        case 'WIX_CODE_RESPONSE':
            var callback = data.callbackId && callbacks[data.callbackId];
            if (callback) {
                if (!_lodash2.default.isNil(data.result)) {
                    var dataToPassToCallback = data.result;
                    if (data.type === MessageTypes.INVOKE_APP_ON) {
                        dataToPassToCallback = (0, _eventService2.default)(data.result);
                    } else if (data.result.command === 'propsChanged') {
                        dataToPassToCallback = undefined;
                    }
                    callback.call(this, dataToPassToCallback, null, event.ports);
                } else {
                    callback(data.result, data.error, event.ports);
                }

                if (data.type !== MessageTypes.INVOKE_APP_ON) {
                    delete callbacks[data.callbackId];
                }
            }
            break;

        case 'addEventListener':
            callEventListeners(data);
            break;

        case 'WIX_CODE':
            var RGI = _platformUtils2.default.getRGI();

            if (data.type === 'update_site_member') {
                RGI.addSiteMemberData(data.updates);
                break;
            }

            if (data.type === 'update_apps_data') {
                RGI.addAppsData(data.updates);
                break;
            }

            if (data.type === 'update_navigation') {
                RGI.addNavigation(data.updates);
                break;
            }

            if (data.type === 'update_session_info') {
                RGI.addSessionInfoProp(data.updates);
                break;
            }

            var RMI = void 0;
            try {
                RMI = _platformUtils2.default.getRMI();
            } catch (e) {
                return; //Ignore events before we have a model in here.
            }

            if (data.type === 'trigger_app_studio_widget_on_props_changed') {
                _appStudioUtils2.default.addAppStudioWidgetPropsToSelector(data.newProps);
                RGI.triggerWidgetPropsChanged(data.oldProps, data.newProps);
                RMI.updateWidgetProperties(data.newProps);
                break;
            }

            if (data.type === 'update') {
                RMI.updateModel(data.updates);
                break;
            }

            // TODO: should have a check for data.type
            var funcRef = data.callbackId;
            var compId = data.compId;
            var dynamicCallback = RMI.getCallbackById(funcRef, true);
            var staticCallback = _platformUtils2.default.getStaticEventHandler(funcRef);
            if (dynamicCallback || staticCallback) {
                addContextToEventData(data, RMI, compId);
            }

            if (dynamicCallback) {
                var selector = _platformUtils2.default.getWixSelector().getScopedSelector(compId, dynamicCallback.contextId, dynamicCallback.controllerId);
                dynamicCallback.callback.call(this, (0, _eventService2.default)(data, dynamicCallback.controllerId), selector);
            }
            if (staticCallback) {
                var _selector = _platformUtils2.default.getWixSelector().getScopedSelector(compId, staticCallback.contextId, staticCallback.controllerId);
                staticCallback.callback.call(this, (0, _eventService2.default)(data, staticCallback.controllerId), _selector);
            }

            break;
    }

    if (registeredEventListeners[data.type]) {
        registeredEventListeners[data.type](data);
    }
}

function addContextToEventData(data, RMI, compId) {
    var context = RMI.getScopeByCompId(compId);

    if (_lodash2.default.get(context, 'additionalData.itemId')) {
        context.itemId = context.additionalData.itemId;
    }

    _lodash2.default.set(data, 'event.context', context);
}

function registerEventListener(msgType, listener) {
    registeredEventListeners[msgType] = listener;
}

function unregisterEventListener(msgType) {
    delete registeredEventListeners[msgType];
}

function callEventListeners(data, typeOfCall) {
    if (EventsCallbacks[data.eventType]) {
        EventsCallbacks[data.eventType].forEach(function (callbackHandler) {
            callbackHandler.callback.call(this, data.params, typeOfCall);
        });
    }
}

function getCallbackId() {
    return callbackId++;
}

exports.sendMessageToHost = sendMessageToHost;
exports.MessageTypes = MessageTypes;
exports.Intent = Intent;
exports.callEventListeners = callEventListeners;
exports.onMessage = onMessage;
exports.registerEventListener = registerEventListener;
exports.unregisterEventListener = unregisterEventListener;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _ValidatableMixin = __webpack_require__(76);

var _ValidatableMixin2 = _interopRequireDefault(_ValidatableMixin);

var _ValueMixin = __webpack_require__(77);

var _ValueMixin2 = _interopRequireDefault(_ValueMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @mixin FormElement
 * @summary Provides functionality related to user input elements.
 * @mixes $w.Element
 * @mixes $w.ValidatableMixin
 * @mixes $w.ValueMixin
 * @memberof $w
 */
var FormElement = function (_Element) {
  _inherits(FormElement, _Element);

  function FormElement() {
    _classCallCheck(this, FormElement);

    return _possibleConstructorReturn(this, (FormElement.__proto__ || Object.getPrototypeOf(FormElement)).apply(this, arguments));
  }

  return FormElement;
}(_Element3.default);

(0, _mixin2.default)(FormElement.prototype, _ValidatableMixin2.default.prototype);
(0, _mixin2.default)(FormElement.prototype, _ValueMixin2.default.prototype);

exports.default = FormElement;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEvents = exports.onEvent = exports.getFullDataWithOverrides = exports.getData = exports.setDataWithoutUpdate = exports.setData = exports.getProp = exports.setProp = exports.getRMI = undefined;

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getRMI(instance) {
    return members._RMI.get(instance);
}

function getCompId(instance) {
    return members._compId.get(instance);
}

function getControllerId(instance) {
    return members._controllerId.get(instance);
}

function getContextId(instance) {
    return members._contextId.get(instance);
}

function setProp(instance, value) {
    getRMI(instance).setProps(getCompId(instance), value);
}

function getProp(instance, valueName) {
    return getRMI(instance).getProps(getCompId(instance))[valueName];
}

function setData(instance, value) {
    getRMI(instance).setData(getCompId(instance), value);
}

function setDataWithoutUpdate(instance, value) {
    getRMI(instance).setDataWithoutUpdate(getCompId(instance), value);
}

function getData(instance, valueName) {
    return getRMI(instance).getData(getCompId(instance))[valueName];
}

function getFullDataWithOverrides(instance, valueName) {
    return getRMI(instance).getFullDataWithOverrides(getCompId(instance))[valueName];
}

function onEvent(instance, eventName, cb) {
    getRMI(instance).registerEvent(getContextId(instance), getCompId(instance), eventName, getControllerId(instance), cb);
    return instance;
}

function getEvents(instance) {
    return getRMI(instance).getEvents(getCompId(instance));
}

exports.getRMI = getRMI;
exports.setProp = setProp;
exports.getProp = getProp;
exports.setData = setData;
exports.setDataWithoutUpdate = setDataWithoutUpdate;
exports.getData = getData;
exports.getFullDataWithOverrides = getFullDataWithOverrides;
exports.onEvent = onEvent;
exports.getEvents = getEvents;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _asyncDecorator = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin DisabledMixin
 * @description Provides functionality for elements that can be disabled.
 * @memberof $w
 */
var DisabledMixin = function () {
    function DisabledMixin() {
        _classCallCheck(this, DisabledMixin);
    }

    _createClass(DisabledMixin, [{
        key: 'disable',


        /**
         * @function disable
         * @syntax
         * function disable(): Promise<void>
         * @summary Disables the element and sets its `enabled` property to `false`.
         * @description
         *  The `disable()` function returns a Promise that is resolved when the
         *  element's [`enabled`](#enabled) property has been set to `false`.
         *
         *  To learn about the behavior of a disabled element,
         *  see the [`enabled`](#enabled) property.
         * @returns {Promise}
         * @fulfill {void} When the element's `enabled` property has been set to `false`.
         * @snippet [DisabledMixin-disable.es6=Disable an element]
         * @snippet [DisabledMixin-disable_then.es6=Disable an element and log a message when done]
         * @snippet [DisabledMixin_toggle_enabled.es6=Toggle an element's enabled state]
         * @see [enable( )](#enable)
         * @see [enabled](#enabled)
         * @memberof $w.DisabledMixin
         */
        value: function disable() {
            var _this = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this);
                var compId = members._compId.get(_this);

                RMI.setProps(compId, {
                    isDisabled: true
                }, resolve);
            });
        }

        /**
         * @function enable
         * @syntax
         * function enable(): Promise<void>
         * @summary Enables the element and sets its `enabled` property to `true`.
         * @description
         *  The `enable()` function returns a Promise that is resolved when the
         *  element's [`enabled`](#enabled) property has been set to `true`.
         *
         *  To learn about the behavior of an enabled element,
         *  see the [`enabled`](#enabled) property.
         * @returns {Promise}
         * @fulfill {void} When the element's `enabled` property has been set to `true`.
         * @snippet [DisabledMixin-enable.es6=Enable an element]
         * @snippet [DisabledMixin-enable_then.es6=Enable an element and log a message when done]
         * @snippet [DisabledMixin_toggle_enabled.es6=Toggle an element's enabled state]
         * @see [disable( )](#disable)
         * @see [enabled](#enabled)
         * @memberof $w.DisabledMixin
         */

    }, {
        key: 'enable',
        value: function enable() {
            var _this2 = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this2);
                var compId = members._compId.get(_this2);

                RMI.setProps(compId, {
                    isDisabled: false
                }, resolve);
            });
        }

        /**
         * @member enabled
         * @label property
         * @syntax
         * get enabled(): boolean
         * @summary Indicates if the element is enabled or disabled.
         * @description
         *  If `enabled` is `true`, users can interact with the element.
         *
         *  If `enabled` is `false`, users cannot interact with the element.
         *
         *  When an element is disabled:
         *
         *  + Its color is faded or grayed out.
         *  + Animations that the element normally exhibits when being interacting
         *    with do not occur.
         *  + Actions that the element has been configured to perform, such as
         *    opening a link, do not occur.
         *  + Event handlers that have been bound to the element, such as with
         *    [`onMouseIn`]($w.Element.onMouseIn), do not run.
         *  + If the element is an input element, such as a dropdown or text box,
         *    users cannot interact with it.
         *
         *
         *  To set the `enabled` property of an element, use the element's
         *  [`enable()`](#enable) or [`disable()`](#disable) functions.
         *
         *  The `enabled` property can also be set in the Editor using the Properties panel.
         * @snippet [DisabledMixin-enabled.es6=Get an element's enabled status]
         * @snippet [DisabledMixin_toggle_enabled.es6=Toggle an element's enabled state]
         * @type {external:Boolean}
         * @default true
         * @see [disable( )](#disable)
         * @see [enable( )](#enable)
         * @memberof $w.DisabledMixin
         * @attr {external:Boolean} enabled
         * @readonly
         */

    }, {
        key: 'enabled',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var props = RMI.getProps(compId);
            return !props.isDisabled || props.isDisabled === false;
        }
    }]);

    return DisabledMixin;
}();

(0, _asyncDecorator.setAsyncFunctions)(['disable', 'enable']);

exports.default = DisabledMixin;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WixBaseEvent2 = __webpack_require__(66);

var _WixBaseEvent3 = _interopRequireDefault(_WixBaseEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.EventHandler
 * @description Handles events.
 * @param {$w.Event} event The event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class Event
 * @summary Events are fired when certain actions occur to elements.
 * @description
 *  Events can be caused by user interactions, such as clicking the mouse or
 *  pressing a key, or generated programmatically, such as hiding or showing an
 *  element using the [hide()]($w.HiddenMixin.html#hide) and
 *  [show()]($w.HiddenMixin.html#hide) functions.
 * @memberof $w
 */
var WixEvent = function (_WixBaseEvent) {
  _inherits(WixEvent, _WixBaseEvent);

  function WixEvent(target, event) {
    _classCallCheck(this, WixEvent);

    var _this = _possibleConstructorReturn(this, (WixEvent.__proto__ || Object.getPrototypeOf(WixEvent)).call(this, event));

    _this.target = target;
    _this.syntheticEvent = event;
    return _this;
  }

  /**
   * @member {$w.Element} target
   * @label property
   * @syntax
   * get target(): string
   * @summary Gets the element that the event was fired on.
   * @snippet [Event-target.es6=Get the ID of the target element]
   * @memberof $w.Event
   * @readonly
   */

  /**
   * @member {external:String} type
   * @label property
   * @syntax
   * get type(): string
   * @summary Gets the type of event that was fired.
   * @snippet [Event-type.es6=Get the type of the event]
   * @memberof $w.Event
   * @readonly
   */

  /**
   * @typedef {external:Object} $w.Event~EventContext
   * @summary An object that contains information about the context in which an event was fired.
   * @property {external:String} type `"GLOBAL_SCOPE"` for events fired outside
   *  of repeaters, or `"COMPONENT_SCOPE"` for events fired from repeaters.
   * @property {external:String} itemId ID of the repeater item where the
   *  event was fired from.
   * @snippet [Event-context.es6=Get the context of the event]
   * @see [context](#context)
   * @memberof $w.Event
   */

  /**
   * @member {$w.Event~EventContext} context
   * @member {external:Object} context
   * @label property
   * @syntax
   * get context(): Object
   * @summary Gets the context in which an event was fired.
   * @summary Gets the context of the event on a repeated element.
   * @description
   *  An event's `context` contains information about the circumstances
   *  surrounding the firing of the event.
   *  The context property only appears in events on repeated elements.
   *
   *  You can use the event context with [$w.at()]($w.html#at) to get a
   *  selector function which selects items from a specific repeater item.
   *  It contains an object with one key:value pair. The key is "itemId" and
   *  the value is the ID of the repeated item on which the event occurred.
   * @snippet [Event-context.es6=Get the context of the event]
   * @memberof $w.Event
   * @readonly
   */

  return WixEvent;
}(_WixBaseEvent3.default);

exports.default = WixEvent;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.valueValidatableClearance = exports.valueValidatableInitialize = undefined;

var _validationsService = __webpack_require__(11);

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.value;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
    };
};

var updateValidationState = function updateValidationState(RMI, compId) {
    return (0, _validationsService.runValidations)(RMI, compId);
};

var valueValidatableInitialize = function valueValidatableInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

var valueValidatableClearance = function valueValidatableClearance(RMI, contextId, compId) {
    return (0, _validationsService.clearValidations)(compId);
};

exports.valueValidatableInitialize = valueValidatableInitialize;
exports.valueValidatableClearance = valueValidatableClearance;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _backgroundMediaUtils = __webpack_require__(44);

var _backgroundMediaUtils2 = _interopRequireDefault(_backgroundMediaUtils);

var _validation = __webpack_require__(3);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

var _utils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function mergedCompDesign(compDesign, mediaData) {
    return _lodash2.default.assign({}, compDesign, {
        type: 'MediaContainerDesignData',
        background: _lodash2.default.assign({}, compDesign.background, {
            mediaRef: mediaData,
            type: 'BackgroundMedia'
        })
    });
}

/**
 * @class Background
 * @summary Provides functionality for background images in certain elements.
 * @memberof $w
 */

var Background = function (_Element) {
    _inherits(Background, _Element);

    function Background() {
        _classCallCheck(this, Background);

        return _possibleConstructorReturn(this, (Background.__proto__ || Object.getPrototypeOf(Background)).apply(this, arguments));
    }

    _createClass(Background, [{
        key: 'background',


        /**
         * @typedef $w.Background~BackgroundOptions
         * @summary An object used by the `background` property that contains the background options.
         * @description
         *  Setting the `src` property of the `BackgroundOptions` object changes the
         *  displayed image or video to the image or video found at the new `src` value.
         *
         *  Getting the `src` property of the `BackgroundOptions` object returns the
         *  location of the current image or video file.
         *
         *  Images can either be from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
         *  or an external image from any web location. Videos must come from the
         *  <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>.
         *
         *  The URL formats supported are:
         *
         *  + Images from the Media Manager:
         *    `wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
         *  + Videos from the Media Manager:
         *    `wix:video://v1/<video_uri>/<filename>#posterUri=<poster_uri>&posterWidth=<width>&posterHeight=<height>`
         *  + Images from the web:
         *    `http(s)://<image url>`
         * @property {external:String} src The file location of the background image or video.
         * @snippet [Background-background_get.es6=Get the background information]
         * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
         * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
         * @see [background](#background)
         */

        /**
         * @member background
         * @label property
         * @syntax
         * get background(): BackgroundOptions
         * @summary Gets an object containing information about the element's background.
         * @snippet [Background-background_get.es6=Get the background information]
         * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
         * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
         * @type {$w.Background~BackgroundOptions}
         * @memberof $w.Background
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var type = members._type.get(this);
            return new WrappedBackgroundOptions(RMI, compId, type);
        }
    }]);

    return Background;
}(_Element3.default);

exports.default = Background;

var BackgroundOptions = function () {
    function BackgroundOptions(RMI, compId, type) {
        _classCallCheck(this, BackgroundOptions);

        members._RMI.set(this, RMI);
        members._compId.set(this, compId);
        members._type.set(this, type);
    }

    _createClass(BackgroundOptions, [{
        key: 'src',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var mediaRef = _lodash2.default.get(RMI.getDesign(compId), 'background.mediaRef') || {};

            return _backgroundMediaUtils2.default.buildFullUrlFromMediaRef(mediaRef);
        },
        set: function set(value) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'src',
                dataToValidate: { src: value },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compDesign = RMI.getDesign(compId) || {};

            if ((0, _utils.isNilOrEmptyString)(value)) {
                RMI.setDesign(compId, mergedCompDesign(compDesign, null));
                return;
            }

            var currentMediaRef = _lodash2.default.get(compDesign, 'background.mediaRef');
            var mediaData = _backgroundMediaUtils2.default.getMediaDataFromSrc(value);
            if (!mediaData) {
                return;
            }
            if (currentMediaRef && currentMediaRef.opacity) {
                _lodash2.default.assign(mediaData, { opacity: currentMediaRef.opacity });
            }

            _backgroundMediaUtils2.default.getFullMediaData(mediaData, function (fullMediaRefData) {
                if (!fullMediaRefData) {
                    return;
                }
                /*setDesignAsync with all media data*/
                var updatedCompDesign = RMI.getDesign(compId) || {};
                _lodash2.default.assign(updatedCompDesign.background.mediaRef, fullMediaRefData);
                RMI.setDesign(compId, updatedCompDesign);
            });
            RMI.setDesign(compId, mergedCompDesign(compDesign, mediaData));
        }
    }]);

    return BackgroundOptions;
}();

var WrappedBackgroundOptions = _monitoring2.default.monitorClass(BackgroundOptions, _monitoring2.default.getRavenContextForComponent);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin FocusMixin
 * @summary Provides functionality for elements that can set and lose focus.
 *
 *  The element on the page that is currently active is the element in focus.
 *  Only one element on the page can have focus at any given moment.
 *  Typically, an element exhibits a visual cue, such as a subtle outline,
 *  indicating that it is in focus. The element in focus receives keystroke
 *  events if the user causes any.
 *
 *  An element receives focus and loses focus (blurs) through user actions,
 *  such as clicking and tabbing, or programmatically, using the
 *  [focus( )](#focus) and [blur( )](#blur) functions.
 * @memberof $w
 */
var FocusMixin = function () {
    function FocusMixin() {
        _classCallCheck(this, FocusMixin);
    }

    _createClass(FocusMixin, [{
        key: 'focus',


        /**
         * @function focus
         * @syntax
         * function focus(): void
         * @summary Places focus on the element.
         * @description
         *  The `focus()` function places focus on the element and fires a `focus`
         *  event.
         *
         *  The `focus` event handlers set on this element by the [onFocus( )](#onFocus)
         *  function or in the Editor are called.
         *
         *  Receiving focus through a call to this function is equivalent to
         *  a user clicking on or tabbing to the element manually.
         * @snippet [FocusMixin-focus.es6=Place focus on an element]
         * @see [onFocus( )](#onFocus)
         * @see [blur( )](#blur)
         * @see [onBlur( )](#onBlur)
         * @memberof $w.FocusMixin
         */
        value: function focus() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.executeCompBehavior(compId, 'focus', { requiresDom: { compId: compId, requiresFullRender: true } }, function () {});
        }

        /**
         * @function blur
         * @syntax
         * function blur(): void
         * @summary Removes focus from the element.
         * @description
         *  The `blur()` function removes focus from the element and fires a `blur`
         *  event.
         *
         *  The `blur` event handlers set on this element by the [onBlur( )](#onBlur)
         *  function or in the Editor are called.
         *
         *  Removing focus through a call to this function is equivalent to a user
         *  clicking on another element or tabbing out of the element manually.
         *
         *  If blur() is called on an element that is not in focus, it has no effect.
         *  The element in focus remains in focus and the `onBlur` event handlers
         *  are not called.
         * @snippet [FocusMixin-blur.es6=Remove focus from an element]
         * @see [onBlur( )](#onBlur)
         * @see [focus( )](#focus)
         * @see [onFocus( )](#onFocus)
         * @memberof $w.FocusMixin
         */

    }, {
        key: 'blur',
        value: function blur() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.executeCompBehavior(compId, 'blur', { requiresDom: { compId: compId, requiresFullRender: true } }, function () {});
        }

        /**
         * @function onFocus
         * @syntax
         * function onFocus(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the element receives focus.
         * @description
         *  An element receives focus through user actions,
         *  such as clicking and tabbing, or programmatically, using the
         *  [focus( )](#focus) function.
         *
         * @note
         *  `onFocus()` has no effect when applied to [RadioButtonGroup]($w.RadioButtonGroup.html) elements.
         *
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element receives focus.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [FocusMixin-onFocus.es6=Get the ID of the element that has received focus]
         * @see [focus( )](#focus)
         * @see [onBlur( )](#onBlur)
         * @see [blur( )](#blur)
         * @memberof $w.FocusMixin
         * @eventtype focus
         * @eventhandler
         */

    }, {
        key: 'onFocus',
        value: function onFocus(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onFocus',
                dataToValidate: { onFocus: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().FOCUS, controllerId, cb);
            return this;
        }

        /**
         * @function onBlur
         * @syntax
         * function onBlur(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the element loses focus.
         * @description
         *  An element loses focus (blurs) through user actions,
         *  such as clicking and tabbing, or programmatically, using the
         *  [blur( )](#blur) function.
         *
         * @note
         * `onBlur()` has no effect when applied to [RadioButtonGroup]($w.RadioButtonGroup.html) elements.
         *
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element losed focus.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [FocusMixin-onBlur.es6=Get the ID of the element that has lost focus]
         * @see [blur( )](#blur)
         * @see [onFocus( )](#onFocus)
         * @see [focus( )](#focus)
         * @memberof $w.FocusMixin
         * @eventtype blur
         * @eventhandler
         */

    }, {
        key: 'onBlur',
        value: function onBlur(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onBlur',
                dataToValidate: { onBlur: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().BLUR, controllerId, cb);
            return this;
        }
    }]);

    return FocusMixin;
}();

exports.default = FocusMixin;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _validation = __webpack_require__(3);

var _validationsService = __webpack_require__(11);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin RequiredMixin
 * @summary Provides functionality for input elements can be required to have a value.
 * @memberof $w
 */
var RequiredMixin = function () {
    function RequiredMixin() {
        _classCallCheck(this, RequiredMixin);
    }

    _createClass(RequiredMixin, [{
        key: 'required',


        /**
         * @member required
         * @label property
         * @syntax
         * get required(): boolean
         * set required(value: boolean): void
         * @summary Sets or gets whether an input element is required to have a value.
         * @description
         *  Setting the `required` property to `true` causes the
         *  element to be [invalid]($w.ValidatableMixin.html#.validity) if it
         *  doesn't contain a value. Setting it to false allows the element to be
         *  valid even if it doesn't contain a value. The validity of the element
         *  can be checked using its [`validity`]($w.ValidatableMixin.html#.validity)
         *  property.
         *
         *  Getting the value of the `required` property returns whether the element
         *  is required.
         *
         *  You can also set an input element to be required
         *  by using the element's Settings pane in the Editor.
         * @snippet [RequiredMixin-required_set.es6=Set an element to be required]
         * @snippet [RequiredMixin-required_get.es6=Get whether an element is required]
         * @type {external:Boolean}
         * @see [validity]($w.ValidatableMixin.html#validity)
         * @memberof $w.RequiredMixin
         * @attr {external:Boolean}
         */
        get: function get() {
            return Utils.getProp(this, 'required') || false;
        }

        /**
         * @member required
         * @memberof $w.RequiredMixin
         * @param {external:Boolean} required
         */
        ,
        set: function set(required) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'required',
                dataToValidate: { required: required },
                compName: this.id
            })) {
                return;
            }
            Utils.setProp(this, { required: required });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId);
        }
    }]);

    return RequiredMixin;
}();

exports.default = RequiredMixin;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _linkGenerator = __webpack_require__(34);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _validation = __webpack_require__(3);

var _constants = __webpack_require__(27);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidImage(src) {
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    return mediaSrcHandler.isValidMediaSrc(src, mediaSrcHandler.types.IMAGE);
}

function extractModelDataFromSrc(src) {
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();

    var _mediaSrcHandler$pars = mediaSrcHandler.parseMediaSrc(src, mediaSrcHandler.types.IMAGE),
        error = _mediaSrcHandler$pars.error,
        title = _mediaSrcHandler$pars.title,
        uri = _mediaSrcHandler$pars.mediaId,
        width = _mediaSrcHandler$pars.width,
        height = _mediaSrcHandler$pars.height;

    if (error) {
        return null;
    }

    return { uri: uri, width: width, height: height, title: title, name: title };
}

function buildFullUrlFromMediaRef(mediaRef) {
    return buildFullUrlFromUri(mediaRef.uri, mediaRef.width, mediaRef.height, mediaRef.title);
}

function convertImageToModelFormatAndReportIfError(src, propertyName, functionName, index) {
    var imageData = extractModelDataFromSrc(src);
    _lodash2.default.assign(imageData, { type: 'Image' });
    if (!imageData) {
        var error = !_lodash2.default.isNil(index) ? _errors.generateError.error_bad_image_format_with_index : _errors.generateError.error_bad_image_format;
        _reporter2.default.reportSdkError(error({
            propertyName: propertyName,
            functionName: functionName,
            index: index,
            wrongValue: src
        }));
        return null;
    }
    return imageData;
}

function buildFullUrlFromUri(uri, width, height, title) {
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    var mediaItemUri = mediaSrcHandler.createMediaSrc({ mediaId: uri, type: mediaSrcHandler.types.IMAGE, width: width, height: height, title: title });
    if (mediaItemUri.error) {
        return '';
    }
    return mediaItemUri.item;
}

function convertModelToUserFormat(imageData) {
    var height = _lodash2.default.isUndefined(imageData.height) ? imageData.height : Number(imageData.height);
    var width = _lodash2.default.isUndefined(imageData.width) ? imageData.width : Number(imageData.width);
    var title = imageData.title;
    var src = buildFullUrlFromUri(imageData.uri || imageData.src, width, height, title);
    var result = _lodash2.default.omitBy({
        type: imageData.type,
        description: imageData.description,
        alt: imageData.alt,
        title: title,
        height: height,
        width: width,
        link: _linkGenerator2.default.convertLinkToUrlAndReportIfError(imageData.link, imageData.target, 'items'),
        target: _lodash2.default.get(imageData, 'link.target')
    }, _lodash2.default.isUndefined);

    result.src = src;

    return result;
}

function convertUserToModelFormat(imageData, imageIndex) {
    var uri = imageData.uri || imageData.src;
    var dataFromSrc = {};

    if ((0, _utils.isNilOrEmptyString)(uri)) {
        dataFromSrc.uri = '';
    } else {
        dataFromSrc = convertImageToModelFormatAndReportIfError(uri, 'src', 'items', imageIndex);
        if (!dataFromSrc) {
            return;
        }
    }

    var result = _lodash2.default.omitBy(_lodash2.default.defaults({
        type: _constants.GALLERY_ITEM_TYPES.image,
        description: imageData.description,
        title: imageData.title,
        alt: imageData.alt,
        id: imageData.id,
        link: _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(imageData.link, imageData.target, 'items', imageIndex),
        width: imageData.width,
        height: imageData.height
    }, dataFromSrc), _lodash2.default.isUndefined);

    result.uri = dataFromSrc.uri;

    return result;
}

function checkImageValidation(_ref) {
    var imageData = _ref.imageData,
        imageIndex = _ref.imageIndex,
        elementID = _ref.elementID;

    var imageType = 'Image';
    return (0, _validation.validate)({
        compType: imageType,
        functionName: 'items',
        dataToValidate: imageData,
        shouldCheckMandatoryFields: true,
        itemIndex: imageIndex,
        elementID: elementID
    });
}

function filterImageItems(items) {
    return _lodash2.default.filter(items, function (item) {
        return _lodash2.default.isUndefined(item.type) || _lodash2.default.toLower(item.type) === _lodash2.default.toLower(_constants.GALLERY_ITEM_TYPES.image);
    });
}

exports.default = {
    isValidImage: isValidImage,
    buildFullUrlFromMediaRef: buildFullUrlFromMediaRef,
    extractModelDataFromSrc: extractModelDataFromSrc,
    buildFullUrlFromUri: buildFullUrlFromUri,
    filterImageItems: filterImageItems,
    checkImageValidation: checkImageValidation,
    convertImageToModelFormatAndReportIfError: convertImageToModelFormatAndReportIfError,
    dataFormat: {
        toUser: convertModelToUserFormat,
        toModel: convertUserToModelFormat
    }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isStageUnfriendly = exports.setStageUnfriendlyFunctions = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIVEPREVIEW_BLACK_LIST_ACTIONS = new Set();
var setStageUnfriendlyFunctions = function setStageUnfriendlyFunctions(clz, methodNames) {
    if (!methodNames) {
        return;
    }
    var nameArr = _lodash2.default.isArray(methodNames) ? methodNames : [methodNames];
    return _lodash2.default.forEach(nameArr, function (methodName) {
        var method = _lodash2.default.get(clz, 'prototype.' + methodName);
        LIVEPREVIEW_BLACK_LIST_ACTIONS.add(method);
    });
};

function isStageUnfriendly(method) {
    return LIVEPREVIEW_BLACK_LIST_ACTIONS.has(method);
}

exports.setStageUnfriendlyFunctions = setStageUnfriendlyFunctions;
exports.isStageUnfriendly = isStageUnfriendly;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setStyle(styleParam, value) {
    var RMI = members._RMI.get(this);
    var compId = members._compId.get(this);
    var viewerType = members._type.get(this).viewerType;

    var style = RMI.getStyle(compId);
    var param = _platformUtils2.default.getWidgetUtils().convertStyleParamForViewerType(viewerType, styleParam);

    var updateStyle = _lodash2.default.set(style, 'style.properties.' + param, value);
    return RMI.setStyle(compId, updateStyle);
}

function getStyleParamValue(styleParam) {
    var RMI = members._RMI.get(this);
    var compId = members._compId.get(this);
    var compStyle = RMI.getStyle(compId);
    var viewerType = members._type.get(this).viewerType;
    var param = _platformUtils2.default.getWidgetUtils().convertStyleParamForViewerType(viewerType, styleParam);
    return _lodash2.default.get(compStyle, 'style.properties.' + param);
}

exports.default = {
    setStyle: setStyle, getStyleParamValue: getStyleParamValue
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HE_URL = exports.EFFECTS = exports.GALLERY_ITEM_TYPES = exports.GALLERY_CLICK_ACTIONS = exports.IMAGE_CLICK_ACTIONS = exports.WIX_CODE_REFERENCE_BASE_URL = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WIX_CODE_REFERENCE_BASE_URL = 'https://www.wix.com/code/reference/';

var HE_URL = 'https://static.parastorage.com/unpkg/he@1.2.0/he.js';

var GALLERY_CLICK_ACTIONS = {
    none: 'disabled',
    expand: 'zoomMode',
    link: 'goToLink'
};

var IMAGE_CLICK_ACTIONS = _lodash2.default.merge({ magnified: 'zoomAndPanMode' }, GALLERY_CLICK_ACTIONS);

var GALLERY_ITEM_TYPES = {
    image: 'Image',
    video: 'Video',
    text: 'Text'
};

var EFFECTS = {
    //TODO WEED-8265
    // CURRENT_EDITOR_EFFECT: {
    //     name: 'currentEditorEffect'
    // },
    HIDE: {
        suffix: 'Out',
        noSuffixPresets: ['conceal'],
        deprecatedValues: ['ArcOut', 'BounceOut', 'CollapseOut', 'Conceal', 'FadeOut', 'FlipOut', 'FloatOut', 'FlyOut', 'FoldOut', 'GlideOut', 'PopOut', 'SlideOut', 'SpinOut', 'TurnOut']
    },
    SHOW: {
        suffix: 'In',
        noSuffixPresets: ['reveal'],
        deprecatedValues: ['ArcIn', 'BounceIn', 'DropIn', 'ExpandIn', 'FadeIn', 'FlipIn', 'FloatIn', 'FlyIn', 'FoldIn', 'GlideIn', 'Reveal', 'SlideIn', 'SpinIn', 'TurnIn']
    }
};

exports.WIX_CODE_REFERENCE_BASE_URL = WIX_CODE_REFERENCE_BASE_URL;
exports.IMAGE_CLICK_ACTIONS = IMAGE_CLICK_ACTIONS;
exports.GALLERY_CLICK_ACTIONS = GALLERY_CLICK_ACTIONS;
exports.GALLERY_ITEM_TYPES = GALLERY_ITEM_TYPES;
exports.EFFECTS = EFFECTS;
exports.HE_URL = HE_URL;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var StyleProperties = {
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    BORDER_COLOR: 'borderColor',
    BACKGROUND_COLOR: 'backgroundColor',
    FOREGROUND_COLOR: 'foregroundColor',
    COLOR: 'color',
    COLOR_SCHEME: 'colorScheme'
};

exports.default = StyleProperties;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAsyncFunction = exports.setAsyncFunctions = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ASYNC_FUNCTIONS = new Set();
var setAsyncFunctions = function setAsyncFunctions(funcs) {
    if (_lodash2.default.isArray(funcs)) {
        return _lodash2.default.forEach(funcs, function (func) {
            return ASYNC_FUNCTIONS.add(func);
        });
    }
    return ASYNC_FUNCTIONS.add(funcs);
};

var isAsyncFunction = function isAsyncFunction(func) {
    return ASYNC_FUNCTIONS.has(func);
};
exports.setAsyncFunctions = setAsyncFunctions;
exports.isAsyncFunction = isAsyncFunction;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* TURNED OFF JSDOC FOR THIS BLOCK; I DON'T THINK THIS IS BEING USED IN THE SDK:
 * @typedef $w.Link
 * @summary An object that describes the link set on linkable items.
 * @description In the Wix Platform, a link can be a link to a site page, a document, an email, or an external web page.
 * @property {$w.LinkType} type The type of link
 * @property {external:String} [pageId] The ID of the page to link to if the `LinkType` is `PAGE`
 * @property {external:String} [url] The URL to link to if the `LinkType` is `EXTERNAL`
 * @property {external:String} [target] The target of the link, either `_blank` or `_self`
 * @property {external:String} [emailAddress] The email address to open if the `LinkType` is `EMAIL`
 * @property {external:String} [emailSubject] The subject of the email if the `LinkType` is `EMAIL`
 * @property {external:String} [documentUrl] The URL of the document to link to if the `LinkType` is `DOCUMENT`. The document must be hosted on Wix.
 */

var Link = function () {
    function _formatLinkItem(linkItem) {
        var linkUtils = _platformUtils2.default.getLinkUtils();
        var formattedLinkItem = _lodash2.default.clone(linkItem);
        if (formattedLinkItem.anchorDataId) {
            formattedLinkItem.anchorDataId = linkUtils.getAnchorDataId(formattedLinkItem);
        }
        if (formattedLinkItem.pageId) {
            formattedLinkItem.pageId = linkUtils.getPageId(formattedLinkItem);
        }
        return formattedLinkItem;
    }

    function _extractAnchorName(linkItem) {
        var formattedLinkItem = _lodash2.default.clone(linkItem);
        if (_lodash2.default.isPlainObject(linkItem.anchorDataId)) {
            var RMI = _platformUtils2.default.getRMI('Link');
            var anchorCompId = linkItem.anchorDataId.compId;
            var anchorComp = RMI.getComp(anchorCompId);
            formattedLinkItem.anchorDataId = anchorComp ? anchorComp.id : linkItem.anchorDataId.id;
        }
        return formattedLinkItem;
    }

    function LinkFromString(value, target) {
        var siteStructure = _platformUtils2.default.getRMI().getSiteStructure();
        this._linkObject = _platformUtils2.default.getLinkUtils().convertUrlToLinkObject(siteStructure.prefixes, value, target, siteStructure.pages);
        this._link = value;
    }

    function LinkFromItem(linkItem) {
        if (linkItem.pageId && _lodash2.default.isPlainObject(linkItem.pageId)) {
            linkItem.pageId = '#' + linkItem.pageId.id;
        }
        var linkUtils = _platformUtils2.default.getLinkUtils();
        var updatedLinkItem = _extractAnchorName(linkItem);
        var siteStructure = _platformUtils2.default.getRMI().getSiteStructure();
        this._link = linkUtils.convertLinkObjectToUrl(siteStructure.prefixes, updatedLinkItem, siteStructure.pages);
        this._linkObject = _formatLinkItem(updatedLinkItem);
    }

    function Link(value, target) {
        switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
            case 'string':
                LinkFromString.call(this, value, target);
                break;
            case 'object':
                LinkFromItem.call(this, value, target);
                break;
        }
    }

    Link.prototype.getValue = function getValue() {
        return this._link;
    };

    Link.prototype.getData = function getData() {
        return this._linkObject;
    };

    return Link;
}();

exports.default = Link;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validatePixel = exports.validateColorAndPerformCastingIfNecessary = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _colorKeywords = __webpack_require__(116);

var _colorKeywords2 = _interopRequireDefault(_colorKeywords);

var _constants = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colorTypes = {
    RGBA: {
        type: 'rgbaColor',
        isValid: isValidRgbOrRgba,
        exampleFormats: '"red", "#FF0000", "#FF000000", "rgb(225, 0, 0)" or "rgba(225, 0, 0, 0)"'
    },
    RGB: {
        type: 'rgbColor',
        isValid: isValidRgb,
        exampleFormats: '"red", "#FF0000", or "rgb(225, 0, 0)"'
    }
};

var HexadecimalLengths = {
    HEXA: { LONG: 9, SHORT: 5 },
    HEX: { LONG: 7, SHORT: 4 }
};

var STYLE_REFERENCE_BASE_URL = _constants.WIX_CODE_REFERENCE_BASE_URL + '$w.Style.html#';

function extractNumericalValues(string) {
    return string.replace(/[^\d,]/g, '').split(',');
}

function isHexColor(colorToValidate) {
    var validHexColor = /^#(([0-9|a-f|A-F]){3}){1,2}$/;
    return validHexColor.test(colorToValidate);
}

function isHexaColor(colorToValidate) {
    var validHexaColor = /^#([a-f0-9]{8}|[a-f0-9]{4})\b$/gi;
    return validHexaColor.test(colorToValidate);
}

function isRgbaColor(colorToValidate) {
    /*from : https://eddyerburgh.me/validate-rgb-or-rgba-value-in-javascript*/
    var rxValidRgba = /\b([R][G][B][A][(]\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])(\s*,\s*((0\.[0-9]{1})|(1\.0)|(1)|(0)))?[)])/i;
    return rxValidRgba.test(colorToValidate);
}

function isRgbColor(colorToValidate) {
    var rxValidRgb = /\b([R][G][B][(]\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])(\s*)[)])/i;
    return rxValidRgb.test(colorToValidate);
}

function isKeyword(colorToValidate) {
    return _lodash2.default.get(_colorKeywords2.default, colorToValidate);
}

function isValidRgbOrRgba(colorToValidate) {
    return isValidRgba(colorToValidate) || isValidRgb(colorToValidate);
}

function isValidRgba(colorToValidate) {
    return isRgbaColor(colorToValidate) || isHexaColor(colorToValidate);
}

function isValidRgb(colorToValidate) {
    return isRgbColor(colorToValidate) || isHexColor(colorToValidate) || isKeyword(colorToValidate);
}

function rgbaToRgbCast(color) {
    if (isHexaColor(color)) {
        if (color.length === HexadecimalLengths.HEXA.LONG) {
            return color.slice(0, HexadecimalLengths.HEX.LONG);
        }

        if (color.length === HexadecimalLengths.HEXA.SHORT) {
            return color.slice(0, HexadecimalLengths.HEX.SHORT);
        }
    }

    if (isRgbaColor(color)) {
        var _extractNumericalValu = extractNumericalValues(color),
            _extractNumericalValu2 = _slicedToArray(_extractNumericalValu, 3),
            red = _extractNumericalValu2[0],
            green = _extractNumericalValu2[1],
            blue = _extractNumericalValu2[2];

        return 'rgb(' + red + ', ' + green + ', ' + blue + ')';
    }
}

function validateColorAndPerformCastingIfNecessary(colorToValidate, opacitySupport, propertyName, compName) {
    var colorType = opacitySupport ? colorTypes.RGBA : colorTypes.RGB;
    if (colorType.isValid(colorToValidate)) {
        return colorToValidate;
    }

    if (!opacitySupport && isValidRgba(colorToValidate)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_color_casting_performed({
            propertyName: propertyName,
            compName: compName
        }));
        return rgbaToRgbCast(colorToValidate);
    }

    _reporter2.default.reportSdkError(_errors.generateError.error_invalid_css_value_multiple_expected_formats({
        propertyName: propertyName,
        compName: compName,
        cssProperty: colorType.type,
        exampleFormats: colorType.exampleFormats,
        infoLink: STYLE_REFERENCE_BASE_URL + propertyName
    }));
    return false;
}

function validatePixel(value, propertyName, compName, cssProperty) {
    var res = false;

    if (_lodash2.default.isString(value)) {
        var endsWithPx = _lodash2.default.endsWith(value, 'px');
        var integerToValidate = value.slice(0, value.length - 2);
        var containsOnlyNumbers = /^\d*$/.test(integerToValidate);
        res = endsWithPx && containsOnlyNumbers && _lodash2.default.parseInt(integerToValidate);
    }

    if (res === false) {
        _reporter2.default.reportSdkError(_errors.generateError.error_invalid_css_value({
            propertyName: propertyName,
            compName: compName,
            cssProperty: cssProperty,
            exampleFormat: '1px',
            infoLink: STYLE_REFERENCE_BASE_URL + propertyName
        }));
    }

    return res;
}

exports.validateColorAndPerformCastingIfNecessary = validateColorAndPerformCastingIfNecessary;
exports.validatePixel = validatePixel;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ELEMENT_TYPES$TEXT_I, _ELEMENT_TYPE_TO_SANI;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SANITIZE_TYPES = {
    'TEXT_INPUT_TEXT': 'TEXT_INPUT_TEXT',
    'TEXT_INPUT_PASSWORD': 'TEXT_INPUT_PASSWORD',
    'TEXT_INPUT_NUMBER': 'TEXT_INPUT_NUMBER',
    'TEXT_INPUT_EMAIL': 'TEXT_INPUT_EMAIL',
    'TEXT_INPUT_URL': 'TEXT_INPUT_URL',
    'TEXT_INPUT_TEL': 'TEXT_INPUT_TEL',
    'TEXT_AREA': 'TEXT_AREA',
    'SELECT_INPUT': 'SELECT_INPUT',
    'RADIO_GROUP': 'RADIO_GROUP',
    'CHECKBOX_GROUP': 'CHECKBOX_GROUP',
    'CHECKBOX': 'CHECKBOX'
};
var ELEMENT_TYPES = {
    TEXT_INPUT: 'TextInput',
    TEXT_AREA: 'TextAreaInput',
    SELECT_INPUT: 'SelectableList',
    RADIO_GROUP: 'RadioGroup',
    CHECKBOX_GROUP: 'CheckboxGroup',
    CHECKBOX: 'CheckboxInput'
};
var TEXT_INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password',
    NUMBER: 'number',
    EMAIL: 'email',
    URL: 'url',
    TEL: 'tel'
};
var ELEMENT_TYPE_TO_SANITIZE_TYPE = (_ELEMENT_TYPE_TO_SANI = {}, _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.TEXT_INPUT, (_ELEMENT_TYPES$TEXT_I = {}, _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEXT, SANITIZE_TYPES.TEXT_INPUT_TEXT), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.PASSWORD, SANITIZE_TYPES.TEXT_INPUT_PASSWORD), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.NUMBER, SANITIZE_TYPES.TEXT_INPUT_NUMBER), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.EMAIL, SANITIZE_TYPES.TEXT_INPUT_EMAIL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.URL, SANITIZE_TYPES.TEXT_INPUT_URL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEL, SANITIZE_TYPES.TEXT_INPUT_TEL), _ELEMENT_TYPES$TEXT_I)), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.TEXT_AREA, SANITIZE_TYPES.TEXT_AREA), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.SELECT_INPUT, SANITIZE_TYPES.SELECT_INPUT), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.RADIO_GROUP, SANITIZE_TYPES.RADIO_GROUP), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.CHECKBOX_GROUP, SANITIZE_TYPES.CHECKBOX_GROUP), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.CHECKBOX, SANITIZE_TYPES.CHECKBOX), _ELEMENT_TYPE_TO_SANI);

var validFloatingPointNumberRegExp = /^-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?$/;

var numberToString = function numberToString(value) {
    return _lodash2.default.isFinite(value) ? value.toString() : value;
};
var emptyStringIfNotString = function emptyStringIfNotString(value) {
    return _lodash2.default.isString(value) ? value : '';
};
var removeLineBreaks = function removeLineBreaks(value) {
    return value.replace(/(\r\n|\n|\r)/gm, "");
};
var removeLeadingAndTrailingWhitespace = function removeLeadingAndTrailingWhitespace(value) {
    return value.trim();
};
var validFloatingPointNumber = function validFloatingPointNumber(value) {
    return validFloatingPointNumberRegExp.test(value) ? value : '';
};
var forceMaxLength = function forceMaxLength(compData) {
    return function (value) {
        var maxLength = _lodash2.default.get(compData, 'maxLength', null);

        return maxLength ? value.substr(0, maxLength) : value;
    };
};

var sanitizeForArray = function sanitizeForArray(sanitizes) {
    return _lodash2.default.flow(_lodash2.default.map(sanitizes, function (sanitize) {
        return function (arrValue) {
            return _lodash2.default.map(arrValue, sanitize);
        };
    }));
};

var getSanitizerByType = function getSanitizerByType(sanitizeType, compData) {
    switch (sanitizeType) {
        case SANITIZE_TYPES.TEXT_INPUT_TEXT:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString, removeLineBreaks, forceMaxLength(compData)]);
        case SANITIZE_TYPES.TEXT_INPUT_PASSWORD:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString, removeLineBreaks, forceMaxLength(compData)]);
        case SANITIZE_TYPES.TEXT_INPUT_NUMBER:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString, validFloatingPointNumber]);
        case SANITIZE_TYPES.TEXT_INPUT_EMAIL:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString, removeLineBreaks, removeLeadingAndTrailingWhitespace]);
        case SANITIZE_TYPES.TEXT_INPUT_URL:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString, removeLineBreaks, removeLeadingAndTrailingWhitespace]);
        case SANITIZE_TYPES.TEXT_INPUT_TEL:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString, removeLineBreaks]);
        case SANITIZE_TYPES.TEXT_AREA:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString, forceMaxLength(compData)]);
        case SANITIZE_TYPES.SELECT_INPUT:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.RADIO_GROUP:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.CHECKBOX_GROUP:
            return sanitizeForArray([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.CHECKBOX:
            return _lodash2.default.flow([numberToString, emptyStringIfNotString]);
        default:
            return function (value) {
                return value;
            };
    }
};

var getSanitizer = function getSanitizer(compData) {
    var elementType = compData.type;

    if (elementType === ELEMENT_TYPES.TEXT_INPUT) {
        elementType += '.' + compData.textType;
    }

    var sanitizeType = _lodash2.default.get(ELEMENT_TYPE_TO_SANITIZE_TYPE, elementType);

    return getSanitizerByType(sanitizeType, compData);
};

var valueSanitzationAlgorithm = function valueSanitzationAlgorithm(compData, value) {
    var sanitizer = getSanitizer(compData);

    return sanitizer(value);
};

exports.default = valueSanitzationAlgorithm;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(5);

var _asyncDecorator = __webpack_require__(29);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin Node
 * @summary Provides basic functionality for all Wix objects, including objects
 *  that are not [elements]($w.Element.html).
 * @memberof $w
 */

var Node = function () {
    function Node(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Node);

        members._RMI.set(this, RMI);
        members._contextId.set(this, contextId);
        members._compId.set(this, compId);
        members._role.set(this, role);
        members._controllerId.set(this, controllerId);
        members._wixSelector.set(this, wixSelector);
        members._type.set(this, type);
    }

    /**
     * @member id
     * @label property
     * @syntax
     * get id(): string
     * @summary Gets the element's ID.
     * @description
     *  The ID is the element's unique identifier. It is used when selecting
     *  elements using the [`$w()`]($w.html#w) function.
     *
     *  An element's `id` is set in the Editor using the <a href="https://support.wix.com/en/article/how-do-i-use-the-properties-panel" target="_blank">Properties panel</a>.
     * @snippet [Node-id.es6=Get the ID]
     * @type {external:String}
     * @memberof $w.Node
     * @readonly
     */


    _createClass(Node, [{
        key: 'scrollTo',


        /**
         * @function scrollTo
         * @syntax
         * function scrollTo(): Promise<void>
         * @summary Scrolls the page to the element using an animation.
         * @description
         *  The `scrollTo()` function returns a Promise that is resolved when the
         *  animated scroll is complete and the element is now in view.
         *
         *  To scroll to a specific location on the page, see the `wix-window`
         *  [`scrollTo()`](wix-window.html#scrollTo) function.
         *
         *  Calling the `scrollTo()` function on an element in a repeated item that
         *  is selected from the [global scope]($w.Repeater.html#global-scope) causes
         *  an error.
         * @snippet [Node-scrollTo.es6=Scroll the page to an element]
         * @snippet [Node-scrollTo_then.es6=Scroll the page to an element and log message when done]
         * @returns {Promise}
         * @fulfill {void} When the scroll is complete.
         * @memberof $w.Node
         */
        value: function scrollTo() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                var compId = members._compId.get(_this);
                var RMI = members._RMI.get(_this);
                var rendered = RMI.getComp(compId).isDisplayed;
                if (rendered) {
                    var callback = function callback(data, error) {
                        return error ? reject(error) : resolve(data);
                    };
                    postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                        command: postMessage.MessageTypes.SCROLL_TO_COMP,
                        data: { compId: compId, requiresDom: { compId: compId } },
                        controllerId: members._controllerId.get(_this),
                        callback: callback
                    });
                } else {
                    reject({ error: 'component is not rendered thus can\'t be scrollTo' });
                }
            });
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global;

            return { id: id, type: type, global: global };
        }
    }, {
        key: 'id',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getId(compId);
        }

        /*
         * --- THIS METHOD IS INTENTIONALLY UNDOCUMENTED ---
         * @member connectionConfig
         * @label property
         * @syntax
         * let controllerConfig = $w("#myController").connectionConfig;
         * @summary Gets the controller's config.
         * @attr {external:String}
         * @config {external:String}
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'connectionConfig',
        get: function get() {
            var compId = members._compId.get(this);
            var role = members._role.get(this);
            var RMI = members._RMI.get(this);
            return RMI.getConfig(compId, role);
        }
    }, {
        key: 'uniqueId',
        get: function get() {
            return members._compId.get(this);
        }

        /**
         * @member parent
         * @label property
         * @syntax
         * get parent(): Node
         * @summary Gets the element's parent element.
         * @description
         *  Some elements can contain other elements. This occurs when you drag
         *  an element onto a container element. The container is the `parent` of
         *  all the elements it contains.
         *
         *  [`Page`]($w.Page.html), [`Header`]($w.Header.html), and
         *  [`Footer`]($w.Footer.html) are top-level elements and have no parent.
         * @snippet [Node-parent.es6=Get the parent element and the parent's ID]
         * @type {$w.Node}
         * @default null
         * @see [children]($w.ContainableMixin.html#children)
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'parent',
        get: function get() {
            var RMI = members._RMI.get(this);
            var wixSelector = members._wixSelector.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);

            if (_lodash2.default.isUndefined(compId) || compId === 'default') {
                return;
            }

            var parentId = RMI.getParent(compId);
            var parent = RMI.getComp(parentId);
            if (_lodash2.default.isUndefined(parent) || _lodash2.default.isNull(parent)) {
                return;
            }

            var appDefId = RMI.getAppDefinitionId();
            var connectedCompIds = RMI.getAllCompIdsInScope();
            if (_lodash2.default.isUndefined(appDefId) || appDefId === 'dataBinding' || _lodash2.default.includes(connectedCompIds, parentId)) {
                return wixSelector.getInstance(RMI, parent.type, parentId, controllerId);
            }
            return;
        }

        /**
         * @member global
         * @label property
         * @syntax
         * get global(): boolean
         * @summary Indicates if an element appears on all pages or only on the current page.
         * @description
         *  If `global` is `true`, the element appears on all pages.
         *
         *  If `global` is `false`, the element only appears on the current page.
         * @snippet [Node-global_get.es6=Get whether an element is displayed on all pages]
         * @type {external:Boolean}
         * @default false
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'global',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var MASTER_PAGE_ID = "masterPage";
            var rootId = null;
            var parentId = compId;

            do {
                parentId = RMI.getParent(parentId);
                rootId = parentId || rootId;
            } while (parentId);

            return !rootId || rootId === MASTER_PAGE_ID;
        }

        /**
         * @member type
         * @label property
         * @syntax
         * get type(): string
         * @summary Gets the element's type.
         * @snippet [Node-type.es6=Get the element's type]
         * @type {external:String}
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'type',
        get: function get() {
            var type = members._type.get(this);
            if (_lodash2.default.isObject(type)) {
                var compType = type.compType && type.compType !== _utils.types.getDefaultSdkType() ? type.compType : _lodash2.default.last(type.viewerType.split('.'));
                return '$w.' + compType;
            }
            return '$w.' + type;
        }
    }]);

    return Node;
}();

(0, _asyncDecorator.setAsyncFunctions)('scrollTo');
(0, _livePreview.setStageUnfriendlyFunctions)(Node, 'scrollTo');

exports.default = Node;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Link = __webpack_require__(30);

var _Link2 = _interopRequireDefault(_Link);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEmptyString(value) {
    return value === '';
}

function convertLinkToModelFormatAndReportIfError(link, target, functionName, index) {
    var convertedLink = convertLinkToObjectAndReportIfError(link, target, functionName, index);
    if (isEmptyString(convertedLink)) {
        return convertedLink;
    }

    if (_lodash2.default.isError(convertedLink) || _lodash2.default.isNil(convertedLink)) {
        return;
    }

    return convertedLink.getData();
}

function convertLinkToUrlAndReportIfError(link, target, functionName, index) {
    var convertedLink = convertLinkToObjectAndReportIfError(link, target, functionName, index);
    if (isEmptyString(convertedLink)) {
        return convertedLink;
    }

    if (_lodash2.default.isError(convertedLink) || _lodash2.default.isNil(convertedLink)) {
        return;
    }

    return convertedLink.getValue();
}

function convertLinkToObjectAndReportIfError(link, target, functionName, index) {
    if (!link) {
        return link;
    }

    try {
        return new _Link2.default(link, target);
    } catch (e) {
        var ERROR_TYPE = {
            UnsupportedLinkTypeError: 'error_unsupported_link',
            UnsupportedTargetValueError: 'error_unsupported_target'
        };

        var error = !_lodash2.default.isNil(index) ? _lodash2.default.get(_errors.generateError, ERROR_TYPE[e.name] + '_with_index') : _lodash2.default.get(_errors.generateError, ERROR_TYPE[e.name]);
        _reporter2.default.reportSdkError(error({
            functionName: functionName,
            index: index,
            wrongValue: link,
            supportedTargets: e.supportedTargets
        }));
        return e;
    }
}

exports.default = {
    convertLinkToModelFormatAndReportIfError: convertLinkToModelFormatAndReportIfError,
    convertLinkToUrlAndReportIfError: convertLinkToUrlAndReportIfError
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationsService = __webpack_require__(11);

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.value;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, value);
    };
};

var updateValidationState = function updateValidationState(RMI, contextId, compId) {
    return (0, _validationsService.runValidationsAndSync)(RMI, compId);
};

var validatableWithSyncInitialize = function validatableWithSyncInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, contextId, compId);
};

exports.default = validatableWithSyncInitialize;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Link = __webpack_require__(30);

var _Link2 = _interopRequireDefault(_Link);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _pagesDataManipulation = __webpack_require__(111);

var pagesDataManipulation = _interopRequireWildcard(_pagesDataManipulation);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _linkGenerator = __webpack_require__(34);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _utils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin LinkableMixin
 * @summary Provides functionality for elements that can acts as links.
 * @memberof $w
 */
var LinkableMixin = function () {
    function LinkableMixin() {
        _classCallCheck(this, LinkableMixin);
    }

    _createClass(LinkableMixin, [{
        key: 'link',


        /**
         * @member link
         * @label property
         * @syntax
         * get link(): string
         * set link(value: string): void
         * @summary Sets or gets the element's link.
         * @description
         *  When the element is clicked, the browser navigates to the `link` location.
         *
         *  The different types of links you can use are:
         *
         *  + `/localPageURL`: another page on your site
         *  + `/`: your site's home page
         *  + `http(s)://<url>`: an external web address
         *  + `wix:document://<location>`: a document stored in the Media Manager
         *  + `mailto:<email-address>?subject=<subject>`: an email
         *  + `tel:<phone number>`: a phone number
         *
         *
         *  The `link` property attempts to properly encode the URL value that
         *  you set. For example, `.../some page` is encoded to `.../some%20page`.
         *  However, some URLs do not have one unambiguous encoding. In those cases
         *  it is up to you to encode the URL to reflect your intentions. Because of
         *  these situations, it is a best practice to always encode URLs before you
         *  set them as the value of the `link` property. Regardless of how you set
         *  the `link` property, when you get its value, it returns an encoded URL.
         *
         *  Note that Wix URLs do not contain spaces. A page which has spaces in its
         *  name has its spaces replaced with dashes (`-`). Similarly,
         *  a <a href="https://support.wix.com/en/article/wix-code-about-setting-up-dynamic-page-urls" target="_black">dynamic page URL</a> which 
         *  contains the value of a field in your collection with spaces
         *  has its spaces replaced with dashes (`-`).
         * @type {external:String}
         * @default An empty string
         * @snippet [LinkableMixin-link_get.es6=Get the link URL from an element]
         * @snippet [LinkableMixin-link_set_local.es6=Set an element to open a local link]
         * @snippet [LinkableMixin-link_set_weblink.es6=Set an element to open an external web link]
         * @snippet [LinkableMixin-link_set_weblink_new_page.es6=Set an element to open an external web link in a new browser page when clicked]
         * @snippet [LinkableMixin-link_set_mailto.es6=Set an element to open a new email window when clicked]
         * @snippet [LinkableMixin-link_set_document.es6=Set an element to open a document]
         * @snippet [LinkableMixin-link_set_telephone.es6=Set an element to make a phone call when clicked]
         * @see [target](#target)
         * @memberof $w.LinkableMixin
         * @attr {external:String}
         * @attr {external:String} target
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var link = RMI.getData(compId).link;
            return (0, _utils.emptyStringIfNil)(link && (link.link || new _Link2.default(link).getValue()));
        }

        /**
         * @member link
         * @param {external:String} value
         * @memberof $w.LinkableMixin
         */
        ,
        set: function set(value) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'link',
                dataToValidate: { link: value },
                compName: this.id
            });
            if (!isValid) {
                return;
            }

            if (!(0, _utils.isNilOrEmptyString)(value)) {
                var linkObject = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(value, this.target, 'link');

                if (!linkObject) {
                    return;
                }

                if (linkObject && linkObject.pageId === '#masterPage' && linkObject.queryParams) {
                    _reporter2.default.reportSdkWarning('Same page Anchor link can not accept query Params');
                    delete linkObject.queryParams;
                }
                RMI.setData(compId, {
                    link: linkObject
                });
            } else {
                RMI.setData(compId, { link: null });
            }
        }

        /**
         * @member target
         * @label property
         * @syntax
         * get target(): string
         * set target(value: TargetType): void
         * type TargetType = "_blank" | "_self"
         * @summary Sets or gets the target of the element's link.
         * @description
         *  An element's `target` determines where its [link](#link) opens. The
         *  target can be set so the [link](#link) opens in the current page or
         *  in a new page.
         *
         *  Supported values are:
         *
         *  + `"_blank"`: The link opens in a new tab or window.
         *  + `"_self"`: The link opens in the tab or window.
         *
         * @note
         *  Link targets are only supported for external web links
         *  (e.g. `http://www.wix.com`).
         * @type {external:String}
         * @default "_blank"
         * @snippet [LinkableMixin-target_get.es6=Get the link target from an element]
         * @snippet [LinkableMixin-target_set.es6=Set the link target for an element]
         * @snippet [LinkableMixin-link_set_weblink_new_page.es6=Set an element to open an external web link in a new browser page when clicked]
         * @see [link](#link)
         * @memberof $w.LinkableMixin
         * @attr {external:String} target
         */

    }, {
        key: 'target',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var link = RMI.getData(compId).link;

            return link && link.target ? link.target : '_blank';
        }

        /**
         * @member target
         * @memberof $w.LinkableMixin
         * @param {external:String} target
         */
        ,
        set: function set(target) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'target',
                dataToValidate: { target: target },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var RGI = _platformUtils2.default.getRGI();
            var compId = members._compId.get(this);
            var link = RMI.getData(compId).link;

            if (!link) {
                var siteStructure = RMI.getSiteStructure() || {};
                var navigation = RGI.getNavigationInfo();
                var pageData = RMI.getPageData();
                var currentPageSiteStructureData = _lodash2.default.find(siteStructure.pages, { id: navigation.currentPageId });
                var currentPageUri = pagesDataManipulation.getPageURI(currentPageSiteStructureData, pageData.currentNavigationInfo);

                link = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(currentPageUri, this.target, 'target');
                if (!link) {
                    return;
                }
            }
            link.target = target;
            RMI.setData(compId, { link: link });
        }
    }]);

    return LinkableMixin;
}();

exports.default = LinkableMixin;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _componentAPISupport = __webpack_require__(54);

var _componentAPISupport2 = _interopRequireDefault(_componentAPISupport);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _validation = __webpack_require__(3);

var _asyncDecorator = __webpack_require__(29);

var _livePreview = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin PlayableMixin
 * @summary Provides functionality for elements that can be played.
 * @memberof $w
 */
var autoPlayOverrides = {
    '$w.Slideshow': 'autoPlay'
};

function reportUnsupportedAPI(api, type) {
    _reporter2.default.reportSdkWarning('\'' + api + '\' is not supported for an element of type: ' + type + '.');
}

function executeApiIfSupported(comp, apiName, apiToInvoke) {
    var viewerType = members._type.get(comp).viewerType;
    if ((0, _componentAPISupport2.default)(viewerType, apiName)) {
        return apiToInvoke();
    }
    reportUnsupportedAPI(apiName, viewerType); //todo Shimi_Liderman 21/05/2017 18:53 Seems very strange to print out the viewer type!
}

function setAutoplay(comp, autoplay) {
    var compType = members._type.get(comp).compType;
    if ((0, _validation.validate)({
        compType: compType,
        functionName: 'autoplay',
        dataToValidate: { autoplay: autoplay },
        compName: comp.id
    })) {
        var RMI = members._RMI.get(comp);
        var compId = members._compId.get(comp);
        var obj = {};
        obj[autoPlayOverrides[comp.type] ? autoPlayOverrides[comp.type] : 'autoplay'] = autoplay;
        RMI.setProps(compId, obj);
    }
}

var PlayableMixin = function () {
    function PlayableMixin() {
        _classCallCheck(this, PlayableMixin);
    }

    _createClass(PlayableMixin, [{
        key: 'onPause',


        // METHODS:

        /**
         * @function onPause
         * @syntax
         * function onPause(handler: EventHandler): Gallery | Slideshow
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when playback is paused.
         * @description
         *  An element can be paused by a user clicking the gallery or slideshow's
         *  pause button or by calling its [`pause()`](#pause) function
         *
         * @note
         *  When using `onPause()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `onPause()`, your code may longer function correctly.
         *
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @snippet [PlayableMixin-onPause.es6=Get the ID of the element that has been paused]
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element is paused.
         * @returns {$w.Gallery|$w.Slideshow} The gallery or slideshow that triggered the event.
         * @see [pause( )](#pause)
         * @memberof $w.PlayableMixin
         * @eventtype autoplayOff
         * @eventhandler
         */
        value: function onPause(cb) {
            var _this = this;

            executeApiIfSupported(this, 'onPause', function () {
                var compType = members._type.get(_this).compType;
                if ((0, _validation.validate)({
                    compType: compType,
                    functionName: 'onPause',
                    dataToValidate: { onPause: cb },
                    compName: _this.id
                })) {
                    var RMI = members._RMI.get(_this);
                    var contextId = members._contextId.get(_this);
                    var controllerId = members._controllerId.get(_this);
                    var compId = members._compId.get(_this);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().AUTOPLAY_OFF, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @function onPlay
         * @syntax
         * function onPlay(handler: EventHandler): Gallery | Slideshow
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when playback is started or restarted.
         * @description
         *  An element can be played by a user clicking the gallery or slideshow's
         *  play button or by calling its [`play()`](#play) function.
         * @note
         *  When using `onPlay()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `onPlay()`, your code may longer function correctly.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @snippet [PlayableMixin-onPlay.es6=Get the ID of the element that is playing]
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element is played.
         * @returns {$w.Gallery|$w.Slideshow} The gallery or slideshow that triggered the event.
         * @see [play( )](#play)
         * @memberof $w.PlayableMixin
         * @eventtype autoplayOn
         * @eventhandler
         */

    }, {
        key: 'onPlay',
        value: function onPlay(cb) {
            var _this2 = this;

            executeApiIfSupported(this, 'onPlay', function () {
                var compType = members._type.get(_this2).compType;
                if ((0, _validation.validate)({
                    compType: compType,
                    functionName: 'onPlay',
                    dataToValidate: { onPlay: cb },
                    compName: _this2.id
                })) {
                    var RMI = members._RMI.get(_this2);
                    var contextId = members._contextId.get(_this2);
                    var controllerId = members._controllerId.get(_this2);
                    var compId = members._compId.get(_this2);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().AUTOPLAY_ON, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @function pause
         * @syntax
         * function pause(): void;
         * @summary Pauses playback.
         * @description
         *  The `pause()` function pauses a slideshow or playable gallery and fires a `pause` event.
         *
         *  The `pause` event handlers set on this element by the [onPause( )](#onPause)
         *  function or in the Editor are called.
         *
         * @note
         *  When using `pause()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `pause()`, your code may longer function correctly.
         * @snippet [PlayableMixin-pause.es6=Pauses playback]
         * @snippet [PlayableMixin_toggle_isPlaying.es6=Toggle an element's current playing state]
         * @see [play( )](#play)
         * @see [onPause( )](#onPause)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'pause',
        value: function pause() {
            var _this3 = this;

            executeApiIfSupported(this, 'pause', function () {
                setAutoplay(_this3, false);
            });
            return this;
        }

        /**
         * @function play
         * @syntax
         * function play(): void;
         * @summary Begins or resumes playback.
         * @description
         *  The `play()` function plays a slideshow or playable gallery and fires a `play` event.
         *
         *  The `play` event handlers set on this element by the [onPlay( )](#onPlay)
         *  function or in the Editor are called.
         *
         * @note
         *  When using `play()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `play()`, your code may longer function correctly.
         * @snippet [PlayableMixin-play.es6=Begins or resumes playback]
         * @snippet [PlayableMixin_toggle_isPlaying.es6=Toggle an element's current playing state]
         * @see [pause( )](#pause)
         * @see [onPlay( )](#onPlay)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'play',
        value: function play() {
            var _this4 = this;

            executeApiIfSupported(this, 'play', function () {
                setAutoplay(_this4, true);
            });
            return this;
        }

        /**
         * @function next
         * @syntax
         * function next(): Promise<Element>
         * @summary Moves to the next item.
         * @description
         *  The `next()` function returns a Promise that is resolved when the next
         *  item is completely rendered. Calling `next()` when on the last item
         *  moves to the first item.
         *
         * @note
         *  When using `next()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `next()`, your code may longer function correctly.
         * @snippet [PlayableMixin-next.es6=Move to the next item]
         * @snippet [PlayableMixin-next_then.es6=Move to the next item and log a message when done]
         * @returns {external:Promise}
         * @fulfill {$w.Element} The newly displayed image or slide.
         * @see [previous( )](#previous)
         * @see [play( )](#play)
         * @see [pause( )](#pause)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'next',
        value: function next() {
            var _this5 = this;

            var viewerType = members._type.get(this).viewerType;
            return executeApiIfSupported(this, 'next', function () {
                return new Promise(function (resolve) {
                    var RMI = members._RMI.get(_this5);
                    var compId = members._compId.get(_this5);
                    RMI.executeCompBehavior(compId, 'nextSlide', {}, function () {
                        resolve();
                    });
                });
            }) || Promise.reject('Next is not supported for an element of type: ' + viewerType + '.');
        }

        /**
         * @function previous
         * @syntax
         * function previous(): Promise<Element>
         * @summary Moves to the previous image or slide.
         * @description
         *  The `previous()` function returns a Promise that is resolved when the previous
         *  image or slide is completely rendered. Calling `previous()` when on the first item
         *  moves to the last item.
         *
         * @note
         *  When using `previous()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `previous()`, your code may longer function correctly.
         * @snippet [PlayableMixin-previous.es6=Move to the previous item]
         * @snippet [PlayableMixin-previous_then.es6=Move to the previous item and log a message when done]
         * @returns {external:Promise}
         * @fulfill {$w.Element} The newly displayed image or slide.
         * @see [next( )](#next)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'previous',
        value: function previous() {
            var _this6 = this;

            var viewerType = members._type.get(this).viewerType;
            return executeApiIfSupported(this, 'previous', function () {
                return new Promise(function (resolve) {
                    var RMI = members._RMI.get(_this6);
                    var compId = members._compId.get(_this6);
                    RMI.executeCompBehavior(compId, 'prevSlide', {}, function () {
                        resolve();
                    });
                });
            }) || Promise.reject('Previous is not supported for an element of type: ' + viewerType + '.');
        }
    }, {
        key: 'isPlaying',


        // PROPERTIES:

        /**
         * @member isPlaying
         * @label property
         * @syntax
         * get isPlaying(): boolean
         * @summary Indicates if the element is currently playing.
         * @description
         *  To set the `isPlaying` property on an element, use the element's
         *  [`play()`](#play) and [`pause()`](#pause) functions.
         *
         *  If you select **Autoplays on loading** in the element's Settings panel
         *  in the Editor, the `isPlaying` property is set to `true` when the page loads.
         * @snippet [PlayableMixin-isPlaying.es6=Get an element's current playing status]
         * @snippet [PlayableMixin_toggle_isPlaying.es6=Toggle an element's current playing state]
         * @type {external:Boolean}
         * @see [play( )](#play)
         * @see [pause( )](#pause)
         * @memberof $w.PlayableMixin
         * @readonly
         */
        get: function get() {
            var _this7 = this;

            return executeApiIfSupported(this, 'isPlaying', function () {
                var RMI = members._RMI.get(_this7);
                var compId = members._compId.get(_this7);
                return RMI.getState(compId).isPlaying;
            });
        }
    }]);

    return PlayableMixin;
}();

(0, _asyncDecorator.setAsyncFunctions)(['next', 'previous']);
(0, _livePreview.setStageUnfriendlyFunctions)(PlayableMixin, 'play');

exports.default = PlayableMixin;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _validation = __webpack_require__(3);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ReadOnlyMixin
 * @summary Provides functionality for input elements which support readonly mode.
 * @memberof $w
 */
var ReadOnlyMixin = function () {
    function ReadOnlyMixin() {
        _classCallCheck(this, ReadOnlyMixin);
    }

    _createClass(ReadOnlyMixin, [{
        key: 'readOnly',


        /**
         * @member readOnly
         * @label property
         * @syntax
         * let isElementReadOnly = $w("#myFormElement").readOnly;
         * $w("#myFormElement").readOnly = isElementReadOnly;
         * @summary Sets or gets if a user can modify the value of the input element.
         * @description
         *  Setting the value of the `readOnly` property to `true` prevents users
         *  from changing the element's value. However, it does not limit your
         *  ability to change the value programmatically. Setting it to `false`
         *  allows users to change the element's value.
         *
         *  Getting the value of the `readonly` property returns whether a user
         *  can modify the value of the input element.
         *
         *  You can also set an element's `readonly` property in the Editor using the Settings pane:
         *  ![Input Settings pane](images/input_settings-read_only.png)
         * @snippet [ReadOnlyMixin-readonly_get.es6=Get whether the element is readOnly]
         * @snippet [ReadOnlyMixin-readonly_set.es6=Set an element to be readOnly]
         * @type {external:Boolean}
         * @memberof $w.ReadOnlyMixin
         */
        get: function get() {
            return Utils.getProp(this, 'readOnly') || false;
        }

        /**
         * @member readOnly
         * @memberof $w.ReadOnlyMixin
         * @param {external:Boolean} readonly `true` if read-only.
         */
        ,
        set: function set(readonly) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'readonly',
                dataToValidate: { readonly: readonly },
                compName: this.id
            })) {
                return;
            }
            Utils.setProp(this, { readOnly: readonly });
        }
    }]);

    return ReadOnlyMixin;
}();

exports.default = ReadOnlyMixin;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var singleCompFunction = {
    'scrollTo': true
};

function isPropertyFunction(object, property) {
    var descriptor = getDescriptorRecursively(object, property);

    return _lodash2.default.isFunction(descriptor.value);
}

function getDescriptorRecursively(object, property) {
    if (_lodash2.default.isUndefined(object)) {
        return undefined;
    }
    var descriptor = Object.getOwnPropertyDescriptor(object, property);

    return descriptor ? descriptor : getDescriptorRecursively(Object.getPrototypeOf(object), property);
}

function getBatchedResultsFor(batch, property, argumentsForProperty) {
    if (_lodash2.default.get(singleCompFunction, property)) {
        var _$first;

        return (_$first = _lodash2.default.first(batch))[property].apply(_$first, _toConsumableArray(argumentsForProperty));
    }

    return _lodash2.default.map(batch, function (batchItem) {
        return batchItem[property].apply(batchItem, _toConsumableArray(argumentsForProperty));
    });
}

function setterFunctionFor(batch, property) {
    return function (value) {
        batch.forEach(function (batchItem) {
            batchItem[property] = value;
        });
    };
}

function getterFunctionFor(batch, property) {
    if (property === 'style') {
        var batchForDeepProperty = _lodash2.default.without(_lodash2.default.map(batch, function (component) {
            return _lodash2.default.get(component, property);
        }), undefined);
        exposeBatch(batchForDeepProperty);

        return function () {
            return batchForDeepProperty;
        };
    }

    return function () {
        return _lodash2.default.first(batch)[property];
    };
}

function defineGetterSetterFor(batch, property, descriptor) {
    var desc = {};

    if (descriptor.get) {
        desc.get = getterFunctionFor(batch, property);
    }

    if (descriptor.set) {
        desc.set = setterFunctionFor(batch, property);
    }

    Object.defineProperty(batch, property, desc);
}

function defineGetterSetter(batch, batchItem, property) {
    var descriptor = getDescriptorRecursively(batchItem, property);

    if (descriptor) {
        defineGetterSetterFor(batch, property, descriptor);
    }
}

function defineBatchFunction(batch, property) {
    batch[property] = function batchFunction() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _lodash2.default.first(getBatchedResultsFor(batch, property, args));
    };
}

function defineBatchFunctionWithMultipleResults(batch, property) {
    batch[property] = function batchFunction() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return getBatchedResultsFor(batch, property, args);
    };
}

function exposeBatchAPI(batch, batchItem, prop) {
    if (prop === 'toJSON') {
        defineBatchFunctionWithMultipleResults(batch, prop);
    } else if (isPropertyFunction(batchItem, prop)) {
        defineBatchFunction(batch, prop);
    } else {
        defineGetterSetter(batch, batchItem, prop);
    }
}

function exposeBatch(batch) {
    var componentTypes = _lodash2.default.uniqBy(batch, 'type');
    var properties = void 0;
    if (componentTypes.length > 1) {
        var propertiesPerType = [];
        componentTypes.forEach(function (compType) {
            var propertiesForType = (0, _utils.allPropertiesFor)(compType);
            propertiesPerType.push(propertiesForType);
        });
        properties = _lodash2.default.intersection.apply(_lodash2.default, propertiesPerType);
    } else {
        properties = (0, _utils.allPropertiesFor)(_lodash2.default.first(batch));
    }
    properties.forEach(exposeBatchAPI.bind(null, batch, _lodash2.default.first(batch)));
}

function expose(components) {
    if (_lodash2.default.isEmpty(components)) {
        return components;
    }

    exposeBatch(components);
    return components;
}

exports.default = {
    expose: expose
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Link = __webpack_require__(30);

var _Link2 = _interopRequireDefault(_Link);

var _errors = __webpack_require__(9);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _validation = __webpack_require__(3);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _vectorImageUtils = __webpack_require__(45);

var _vectorImageUtils2 = _interopRequireDefault(_vectorImageUtils);

var _linkGenerator = __webpack_require__(34);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _LinkType = __webpack_require__(104);

var _LinkType2 = _interopRequireDefault(_LinkType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataItemToUserFormatPropsMap = {
    label: 'label',
    items: 'items',
    link: 'link',
    isVisible: 'visibleOnDesktop',
    isVisibleMobile: 'visibleOnMobile',
    icon: 'iconRef',
    displayCount: 'displayCount'
};

var BasicMenuItemType = 'BasicMenuItem';
var compiled = _lodash2.default.template('<%= menuItemIndex %>,<%= subItemIndex %>');

function convertIconToModelFormat(icon, functionName, menuItemIndex) {
    var isValidImage = _imageUtils2.default.isValidImage(icon);
    if (isValidImage) {
        var model = _imageUtils2.default.extractModelDataFromSrc(icon);
        return _lodash2.default.assign(model, { type: 'Image' });
    }

    var isValidSvg = _vectorImageUtils2.default.isValidInternalVectorImage(icon); // this is a hack until WEED-13787 would be solved
    if (isValidSvg) {
        var _model = _vectorImageUtils2.default.extractModelDataFromSrc(icon);
        return _lodash2.default.assign(_model, { type: 'VectorImage' });
    }

    var error = !_lodash2.default.isNil(menuItemIndex) ? _errors.generateError.error_bad_menu_item_format_with_index : _errors.generateError.error_bad_menu_item_format;
    _reporter2.default.reportSdkError(error({
        propertyName: 'icon',
        functionName: functionName,
        index: menuItemIndex,
        wrongValue: icon
    }));

    return null;
}

function convertIconRefToUserFormat(iconRef) {
    if (iconRef.svgId) {
        return _vectorImageUtils2.default.buildFullUrlFromSvgId(iconRef.svgId, iconRef.title);
    }
    return _imageUtils2.default.buildFullUrlFromUri(iconRef.uri, iconRef.width, iconRef.height, iconRef.title);
}

function convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, functionName, labelOptional) {
    var menuItemModelFormat = {};
    var originalLink = menuItem.link;
    var link = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(menuItem.link, null, functionName, menuItemIndex);
    if (link) {
        menuItemModelFormat.link = link;
    }
    if (!_lodash2.default.isNil(menuItem.label) && (0, _validation.validateByType)({
        value: menuItem.label,
        expectedType: _validation.TYPES.STRING
    })) {
        menuItemModelFormat.label = menuItem.label;
    }
    if (!_lodash2.default.isNil(menuItem.visibleOnDesktop) && (0, _validation.validateByType)({
        value: menuItem.visibleOnDesktop,
        expectedType: _validation.TYPES.BOOLEAN
    })) {
        menuItemModelFormat.isVisible = menuItem.visibleOnDesktop;
    }
    if (!_lodash2.default.isNil(menuItem.visibleOnMobile) && (0, _validation.validateByType)({
        value: menuItem.visibleOnMobile,
        expectedType: _validation.TYPES.BOOLEAN
    })) {
        menuItemModelFormat.isVisibleMobile = menuItem.visibleOnMobile;
    }
    if (!_lodash2.default.isNil(menuItem.items) && (0, _validation.validateByType)({
        value: menuItem.items,
        expectedType: _validation.TYPES.ARRAY
    })) {
        if (!_lodash2.default.isEmpty(menuItem.items)) {
            menuItemModelFormat.items = _lodash2.default.map(menuItem.items, function (subItem, subItemIndex) {
                return convertMenuItemToModelFormat(RMI, subItem, compiled({
                    menuItemIndex: menuItemIndex,
                    subItemIndex: subItemIndex
                }), functionName);
            });
        } else {
            menuItemModelFormat.items = menuItem.items;
        }
    }
    if (!_lodash2.default.isNil(menuItem.icon)) {
        var iconData = convertIconToModelFormat(menuItem.icon, functionName, menuItemIndex);
        if (iconData) {
            menuItemModelFormat.iconRef = iconData;
        }
    }
    if (_lodash2.default.has(menuItem, 'displayCount') && (_lodash2.default.isNil(menuItem.displayCount) || (0, _validation.validateByType)({
        value: menuItem.displayCount,
        expectedType: _validation.TYPES.NUMBER
    }))) {
        menuItemModelFormat.displayCount = menuItem.displayCount;
    }
    if (!_lodash2.default.isNil(menuItem.label) && (0, _validation.validateByType)({
        value: menuItem.label,
        expectedType: _validation.TYPES.STRING
    })) {
        menuItemModelFormat.label = menuItem.label;
    }
    if (!labelOptional && menuItemModelFormat.link && menuItemModelFormat.link.type === _LinkType2.default.PAGE && !menuItemModelFormat.label) {
        var siteStructure = RMI.getSiteStructure() || {};
        var item = _lodash2.default.find(siteStructure.pages, { url: originalLink });
        menuItemModelFormat.label = item.name;
    }
    if (!labelOptional && !menuItemModelFormat.label) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_not_null_with_index({
            propertyName: 'label',
            functionName: functionName,
            index: menuItemIndex
        }));
    }
    _lodash2.default.defaults(menuItemModelFormat, {
        type: BasicMenuItemType,
        isVisible: true,
        isVisibleMobile: true,
        items: []
    });
    return menuItemModelFormat;
}

function convertMenuItemToUserFormat(menuItem) {
    return _lodash2.default.reduce(menuItem, function (res, val, key) {
        if (_lodash2.default.isNil(val)) {
            return res;
        }
        var prop = dataItemToUserFormatPropsMap[key];
        if (prop) {
            res[prop] = val;
        }
        if (key === 'link') {
            var link = new _Link2.default(val);
            res.link = link ? link.getValue() : null;
        }
        if (key === 'iconRef' && !_lodash2.default.isEmpty(val)) {
            res.icon = convertIconRefToUserFormat(val);
        }
        if (key === 'items' && !_lodash2.default.isEmpty(val)) {
            res.items = _lodash2.default.map(val, convertMenuItemToUserFormat);
        }
        return res;
    }, {});
}

function removeUnsupportedProps(navItem, additionalUnsupportedProps) {
    return _lodash2.default.omit(navItem, ['items', 'type'].concat(additionalUnsupportedProps || []));
}

function convertNavItemToUserFormat(navItem, unsupportedProps) {
    var userFormatNavItem = convertMenuItemToUserFormat(navItem);
    return removeUnsupportedProps(userFormatNavItem, unsupportedProps);
}

function removeNonValidMenuLevelsAndReport(menuItem, menuItemIndex, functionName) {
    if (_lodash2.default.isEmpty(menuItem.items)) {
        return true;
    }
    var hasMoreThanTwoLevels = false;
    var index = void 0;

    _lodash2.default.forEach(menuItem.items, function (subItem, subItemIndex) {
        if (_lodash2.default.isEmpty(subItem.items)) {
            return true;
        }
        hasMoreThanTwoLevels = true;
        index = compiled({ menuItemIndex: menuItemIndex, subItemIndex: subItemIndex });
        delete subItem.items;
    });

    if (hasMoreThanTwoLevels) {
        _reporter2.default.reportSdkError(_errors.generateError.error_menu_can_have_two_levels({
            propertyName: 'label',
            functionName: functionName,
            index: index
        }));
    }
}

function checkMenuItemValidation(_ref) {
    var menuItem = _ref.menuItem,
        menuItemIndex = _ref.menuItemIndex,
        functionName = _ref.functionName,
        elementID = _ref.elementID;

    var isValid = (0, _validation.validate)({
        compType: BasicMenuItemType,
        functionName: functionName,
        dataToValidate: menuItem,
        shouldCheckMandatoryFields: true,
        itemIndex: menuItemIndex,
        elementID: elementID
    });
    removeNonValidMenuLevelsAndReport(menuItem, menuItemIndex, functionName);

    return isValid;
}

function checkMenuItemsValidation(_ref2) {
    var menuItems = _ref2.menuItems,
        functionName = _ref2.functionName,
        elementID = _ref2.elementID;

    _lodash2.default.forEach(menuItems, function (menuItem, menuItemIndex) {
        delete menuItem.icon; //TODO : remove once the add the icon support
        checkMenuItemValidation({ menuItem: menuItem, menuItemIndex: menuItemIndex, functionName: functionName, elementID: elementID });
        _lodash2.default.forEach(menuItem.items, function (subItem, subItemIndex) {
            delete subItem.icon; //TODO : remove once the add the icon support
            checkMenuItemValidation({
                menuItem: subItem,
                menuItemIndex: compiled({ menuItemIndex: menuItemIndex, subItemIndex: subItemIndex }),
                functionName: functionName,
                elementID: elementID
            });
        });
    });
}

function checkUserProfileItemsValidation(_ref3) {
    var navItems = _ref3.navItems,
        functionName = _ref3.functionName,
        additionalUnsupportedProps = _ref3.additionalUnsupportedProps,
        elementID = _ref3.elementID;

    return _lodash2.default.reduce(navItems, function (res, navItem, navItemIndex) {
        var navItemWithSupportedProps = removeUnsupportedProps(navItem, additionalUnsupportedProps);
        checkMenuItemValidation({
            menuItem: navItemWithSupportedProps,
            menuItemIndex: navItemIndex,
            functionName: functionName,
            elementID: elementID
        });
        res.push(navItemWithSupportedProps);
        return res;
    }, []);
}

function checkUserProfileNavBarItemsValidation(_ref4) {
    var navItems = _ref4.navItems,
        functionName = _ref4.functionName,
        elementID = _ref4.elementID;

    return checkUserProfileItemsValidation({
        navItems: navItems,
        functionName: functionName,
        additionalUnsupportedProps: ['label'],
        elementID: elementID
    });
}

function checkUserProfileTinyMenuNavBarItemsValidation(_ref5) {
    var navItems = _ref5.navItems,
        functionName = _ref5.functionName,
        elementID = _ref5.elementID;

    return checkUserProfileItemsValidation({
        navItems: navItems,
        functionName: functionName,
        additionalUnsupportedProps: ['visibleOnDesktop'],
        elementID: elementID
    });
}

function checkUserProfileTinyMenuItemsValidation(_ref6) {
    var navItems = _ref6.navItems,
        functionName = _ref6.functionName,
        elementID = _ref6.elementID;

    return checkUserProfileItemsValidation({
        navItems: navItems,
        functionName: functionName,
        additionalUnsupportedProps: ['icon', 'visibleOnDesktop'],
        elementID: elementID
    });
}

function checkUserProfileMenuItemsValidation(_ref7) {
    var navItems = _ref7.navItems,
        functionName = _ref7.functionName,
        elementID = _ref7.elementID;

    return checkUserProfileItemsValidation({
        navItems: navItems,
        functionName: functionName,
        additionalUnsupportedProps: ['icon'],
        elementID: elementID
    });
}

exports.default = {
    convertMenuItemToModelFormat: convertMenuItemToModelFormat,
    convertMenuItemToUserFormat: convertMenuItemToUserFormat,
    convertNavItemToUserFormat: convertNavItemToUserFormat,
    checkMenuItemsValidation: checkMenuItemsValidation,
    checkUserProfileMenuItemsValidation: checkUserProfileMenuItemsValidation,
    checkUserProfileTinyMenuItemsValidation: checkUserProfileTinyMenuItemsValidation,
    checkUserProfileNavBarItemsValidation: checkUserProfileNavBarItemsValidation,
    checkUserProfileTinyMenuNavBarItemsValidation: checkUserProfileTinyMenuNavBarItemsValidation
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateOption = exports.optionsToDisplay = exports.emptyStringIfNotInOptions = exports.getOptionsFromFullWithChecked = exports.getOptionsFromFull = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _errors = __webpack_require__(9);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _utils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PERMITTED_KEYS = ['label', 'value'];

function getOptionsFromFull() {
    return Utils.getFullDataWithOverrides(this, 'options').map(function (option) {
        return {
            label: option.label,
            value: option.value
        };
    });
}

function getOptionsFromFullWithChecked() {
    return Utils.getFullDataWithOverrides(this, 'options').map(function (option) {
        return {
            label: option.label,
            value: option.value,
            checked: !!option.checked
        };
    });
}

var emptyStringIfNotInOptions = function emptyStringIfNotInOptions(options, value) {
    return _lodash2.default.some(options, { value: value }) ? value : '';
};

var isValidOption = function isValidOption(option) {
    var optionPermittedKeys = _lodash2.default.pick(option, PERMITTED_KEYS);
    var optionProperties = _lodash2.default.values(optionPermittedKeys);
    var everyPropertyIsNilOrEmpty = _lodash2.default.every(optionProperties, function (prop) {
        return (0, _utils.isNilOrEmptyString)(prop);
    });
    var isValidEmptyOption = _lodash2.default.every(PERMITTED_KEYS, function (key) {
        return optionPermittedKeys[key] === '';
    });

    return !_lodash2.default.isEmpty(optionPermittedKeys) && !everyPropertyIsNilOrEmpty || isValidEmptyOption;
};

var optionsToDisplay = function optionsToDisplay(options) {
    return _lodash2.default.filter(options, function (option) {
        return isValidOption(option);
    });
};

var validateOption = function validateOption(option, index, propertyName) {
    if (!isValidOption(option)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_option({
            propertyName: propertyName,
            index: index,
            wrongValue: option
        }));
    }
    return true;
};

exports.getOptionsFromFull = getOptionsFromFull;
exports.getOptionsFromFullWithChecked = getOptionsFromFullWithChecked;
exports.emptyStringIfNotInOptions = emptyStringIfNotInOptions;
exports.optionsToDisplay = optionsToDisplay;
exports.validateOption = validateOption;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _PlayableMixin = __webpack_require__(37);

var _PlayableMixin2 = _interopRequireDefault(_PlayableMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _componentAPISupport = __webpack_require__(54);

var _componentAPISupport2 = _interopRequireDefault(_componentAPISupport);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _validation = __webpack_require__(3);

var _constants = __webpack_require__(27);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function reportUnsupportedAPI(api, type) {
    _reporter2.default.reportSdkWarning('\'' + api + '\' is not supported for an element of type: ' + type + '.');
}

function getShowANavigationButtonsPropertyName(viewerType) {
    if (_lodash2.default.includes(['tpa.viewer.components.StripShowcase', 'tpa.viewer.components.Thumbnails'], viewerType)) {
        return 'arrowMode';
    }

    return 'showNavigation';
}

function executeApiIfSupported(comp, apiName, apiImplementation) {
    var viewerType = members._type.get(comp).viewerType;
    if ((0, _componentAPISupport2.default)(viewerType, apiName)) {
        return apiImplementation();
    }
    reportUnsupportedAPI(apiName, viewerType); //todo Shimi_Liderman 21/05/2017 18:53 Seems very strange to print out the viewer type!
}

/**
 * @typedef {external:Object} $w.Gallery~GalleryCapabilities
 * @summary An object used by the `galleryCapabilities` property that contains the capabilities of a gallery.
 * @property {external:Boolean} isPlayable Indicates if the gallery supports play operations.
 * @property {external:Boolean} hasCurrentItem Indicates if the gallery supports the notion of a current item.
 * @property {external:Boolean} hasNavigationButtons Indicates if the gallery supports navigation buttons.
 * @snippet [Gallery-galleryCapabilities_get.es6=Get the gallery's capabilities]
 * @see [galleryCapabilities](#galleryCapabilities)
 */

/**
 * @typedef {external:Object} $w.Gallery~VideoItem
 * @summary An object used by the Gallery properties `items` and `currentItem` to represent a single gallery video.
 * @property {external:String} type Item type. Value is `"video"`.
 * @property {external:String} src Video source URL.
 * @property {external:String} slug Item slug.
 * @property {external:String} [title] Video title.
 * @property {external:String} [description] Video description. Descriptions over 100 characters are truncated.
 * @property {external:String} [link] URL of the video's clickable link. See [here]($w.LinkableMixin.html#link) for more information about links.
 * @property {external:String} [thumbnail] Video thumbnail URL.
 * @description
 *  A `VideoItem` can be used as an item in a Pro Gallery.
 *
 *  To determine if your gallery is a Pro Gallery or a standard gallery, hover
 *  over the gallery while it is not selected. The gallery type appears above
 *  the upper left corner of the gallery. If the type is "Wix Pro Gallery", then
 *  your gallery is a Pro Gallery. If the type is anything other than "Wix Pro
 *  Gallery", your gallery gallery is a standard gallery.
 *
 *  The video source format is:
 *  `wix:video://v1/<video_uri>/<filename>#posterUri=<poster_uri>&posterWidth=<width>&posterHeight=<height>`
 * @snippet [Gallery-items_set.es6=Set the list of items for a gallery]
 * @see [items](#items)
 * @see [currentItem](#currentItem)
 */

/**
 * @typedef {external:Object} $w.Gallery~ImageItem
 * @summary An object used by the Gallery properties `items` and `currentItem` to represent a single gallery image.
 * @property {external:String} type Item type. Value is `"image"`.
 * @property {external:String} src Image source URL.
 * @property {external:String} slug Item slug.
 * @property {external:String} [title] Image title.
 * @property {external:String} [description] Image description. Descriptions over 100 characters are truncated.
 * @property {external:String} [link] URL of the image's clickable link. See [here]($w.LinkableMixin.html#link) for more information about links.
 * @description
 *  The `src` property of a `ImageItem` can be:
 *
 *  + An image from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>.
 *  + An external image from any web location (some galleries do not support external images).
 *
 *  The image source format for Media Manager images is:
 *  `wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
 * @snippet [Gallery-items_set.es6=Set the list of items for a gallery]
 * @see [items](#items)
 * @see [currentItem](#currentItem)
 */

/**
 * @class Gallery
 * @summary A gallery for displaying multiple items.
 * @classdesc
 *  There are many different types and styles of galleries, some of which do not
 *  support all of the properties and functions described below. To determine
 *  what functionality a specific gallery supports, use its
 *  [`galleryCapabilities`](#galleryCapabilities) property to identify its
 *  capabilities. Then use the list below to determine what functionality is
 *  supported by the gallery.
 *
 *  + All galleries
 *    + [`clickAction`](#clickAction)
 *    + [`collapsed`](#collapsed)
 *    + [`galleryCapabilities`](#galleryCapabilities)
 *    + [`global`](#global)
 *    + [`hidden`](#hidden)
 *    + [`id`](#id)
 *    + [`items`](#items)
 *    + [`isVisible`](#isVisible)
 *    + [`parent`](#parent)
 *    + [`rendered`](#rendered)
 *    + [`type`](#type)
 *    + [`collapse()`](#collapse)
 *    + [`expand()`](#expand)
 *    + [`hide()`](#hide)
 *    + [`onClick()`](#onClick)
 *    + [`onDblClick()`](#onDblClick)
 *    + [`onItemClicked()`](#onItemClicked)
 *    + [`onMouseIn()`](#onMouseIn)
 *    + [`onMouseOut()`](#onMouseOut)
 *    + [`onViewportEnter()`](#onViewportEnter)
 *    + [`onViewportLeave()`](#onViewportLeave)
 *    + [`scrollTo()`](#scrollTo)
 *    + [`show()`](#show)
 *  + Galleries where `hasCurrentItem` is `true`
 *    + [`currentIndex`](#currentIndex)
 *    + [`currentItem`](#currentItem)
 *    + [`onCurrentItemChanged()`](#onCurrentItemChanged)
 *  + Galleries where `isPlayable` is `true`
 *    + [`isPlaying`](#isPlaying)
 *    + [`next()`](#next)
 *    + [`onPause()`](#onPause)
 *    + [`onPlay()`](#onPlay)
 *    + [`pause()`](#pause)
 *    + [`play()`](#play)
 *    + [`previous()`](#previous)
 *  + Galleries where `hasNavigationButtons` is `true`
 *    + [`showNavigationButtons`](#showNavigationButtons)
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.PlayableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.SlideShowGallery
 * @viewername wysiwyg.viewer.components.SliderGallery
 * @viewername wysiwyg.viewer.components.MatrixGallery
 * @viewername wysiwyg.viewer.components.PaginatedGridGallery
 * @viewername tpa.viewer.components.Thumbnails
 * @viewername tpa.viewer.components.StripShowcase
 * @viewername tpa.viewer.components.StripSlideshow
 * @viewername tpa.viewer.components.Collage
 * @viewername tpa.viewer.components.Masonry
 * @viewername tpa.viewer.components.Honeycomb
 * @viewername tpa.viewer.components.Accordion
 * @viewername wysiwyg.viewer.components.tpapps.TPA3DCarousel
 * @viewername wysiwyg.viewer.components.tpapps.TPA3DGallery
 * @viewername tpa.viewer.components.Impress
 * @viewername tpa.viewer.components.Freestyle
 * @definitionId wysiwyg.viewer.components.SlideShowGallery
 * @definitionId wysiwyg.viewer.components.SliderGallery
 * @definitionId wysiwyg.viewer.components.MatrixGallery
 * @definitionId wysiwyg.viewer.components.PaginatedGridGallery
 * @definitionId tpa.viewer.components.Thumbnails
 * @definitionId tpa.viewer.components.StripShowcase
 * @definitionId tpa.viewer.components.StripSlideshow
 * @definitionId tpa.viewer.components.Collage
 * @definitionId tpa.viewer.components.Masonry
 * @definitionId tpa.viewer.components.Honeycomb
 * @definitionId tpa.viewer.components.Accordion
 * @definitionId wysiwyg.viewer.components.tpapps.TPA3DCarousel
 * @definitionId wysiwyg.viewer.components.tpapps.TPA3DGallery
 * @definitionId tpa.viewer.components.Impress
 * @definitionId tpa.viewer.components.Freestyle
 * @tagname gallery
 */

var Gallery = function (_Element) {
    _inherits(Gallery, _Element);

    function Gallery() {
        _classCallCheck(this, Gallery);

        return _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).apply(this, arguments));
    }

    _createClass(Gallery, [{
        key: 'onCurrentItemChanged',


        /**
         * @function onCurrentItemChanged
         * @syntax
         * function onCurrentItemChanged(handler: GalleryChangeEventHandler): Gallery
         * callback GalleryChangeEventHandler(event: GalleryItemChangedEvent, $w: Function): void
         * @summary Adds an event handler that runs when a gallery's current item changes.
         * @description
         *  A gallery's current item changes through playing or certain user
         *  interactions.
         *
         * @note
         *  The `onCurrentItemChanged()` function is supported by galleries where
         *  the `hasCurrentItem` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `hasCurrentItem` and you try to use it, your
         *  code may no longer function correctly.
         *
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.GalleryItemChangedEventHandler} handler The name of the
         *  function or the function expression to run when the gallery's current
         *  item changes.
         * @returns {$w.Gallery} The gallery that triggered the event.
         * @snippet [Gallery-onCurrentItemChanged.es6=Get the information of the item that changed]
         * @memberof $w.Gallery
         * @eventtype imageChanged
         * @eventhandler
         */
        value: function onCurrentItemChanged(cb) {
            var _this2 = this;

            executeApiIfSupported(this, 'onCurrentItemChanged', function () {
                var compType = members._type.get(_this2).compType;
                if ((0, _validation.validate)({
                    compType: compType,
                    functionName: 'onCurrentItemChanged',
                    dataToValidate: { onChange: cb },
                    compName: _this2.id
                })) {
                    var RMI = members._RMI.get(_this2);
                    var contextId = members._contextId.get(_this2);
                    var controllerId = members._controllerId.get(_this2);
                    var compId = members._compId.get(_this2);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().IMAGE_CHANGED, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @function onItemClicked
         * @syntax
         * function onItemClicked(handler: GalleryItemClickedEventHandler): Gallery
         * callback GalleryItemClickedEventHandler(event: GalleryItemClickedEvent, $w: Function): void
         * @summary Adds an event handler that runs when an item in a gallery is
         *  clicked.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.GalleryItemClickedEventHandler} handler The name of the
         *  function or the function expression to run when a gallery item is
         *  clicked.
         * @returns {$w.Gallery} The gallery that triggered the event.
         * @snippet [Gallery-onItemClicked.es6=Get the information of the item that was clicked]
         * @see [clickAction](#clickAction)
         * @memberof $w.Gallery
         * @eventtype itemClicked
         * @eventhandler
         */

    }, {
        key: 'onItemClicked',
        value: function onItemClicked(cb) {
            var _this3 = this;

            executeApiIfSupported(this, 'onItemClicked', function () {
                var compType = members._type.get(_this3).compType;
                if ((0, _validation.validate)({
                    compType: compType,
                    functionName: 'onItemClicked',
                    dataToValidate: { onItemClicked: cb },
                    compName: _this3.id
                })) {
                    var RMI = members._RMI.get(_this3);
                    var contextId = members._contextId.get(_this3);
                    var controllerId = members._controllerId.get(_this3);
                    var compId = members._compId.get(_this3);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().ITEM_CLICKED, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @member showNavigationButtons
         * @label property
         * @syntax
         * get showNavigationButtons(): boolean
         * set showNavigationButtons(value: boolean): void
         * @summary Determines if a gallery's navigation arrows are shown.
         * @description
         *  A gallery's navigation arrows allow a user to click through the items in
         *  the gallery.
         * @note
         *  The `showNavigationButtons` property is supported by galleries where
         *  the `hasNavigationButtons` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `hasNavigationButtons` and you try to use
         *  it, your code may no longer function correctly.
         * @snippet [Gallery-showNavigationButtons_get.es6=Get whether navigation buttons are shown]
         * @snippet [Gallery-showNavigationButtons_set.es6=Set navigation buttons to be hidden]
         * @snippet [Gallery-showNavigationButtons_toggle.es6=Toggle whether navigation buttons are shown]
         * @type {external:Boolean}
         * @memberof $w.Gallery
         * @instance
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            var viewerType = members._type.get(this).viewerType;
            var possibleProperties = {
                clickAction: (0, _componentAPISupport2.default)(viewerType, 'clickAction') ? this.clickAction : null,
                currentIndex: (0, _componentAPISupport2.default)(viewerType, 'currentIndex') ? this.currentIndex : null,
                currentItem: (0, _componentAPISupport2.default)(viewerType, 'currentItem') ? this.currentItem : null,
                showNavigationButtons: (0, _componentAPISupport2.default)(viewerType, 'showNavigationButtons') ? this.showNavigationButtons : null,
                items: (0, _componentAPISupport2.default)(viewerType, 'items') ? this.items : null
            };
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered;

            var result = _lodash2.default.assign({
                id: id,
                type: type,
                global: global,
                rendered: rendered
            }, possibleProperties);

            return _lodash2.default.omitBy(result, _lodash2.default.isNull);
        }
    }, {
        key: 'clickAction',


        /**
         * @member clickAction
         * @label property
         * @syntax
         * get clickAction(): string
         * set clickAction(value: ClickActionType): void
         * type ClickActionType = "expand" | "link" | "none"
         * @summary Sets or gets the action that occurs when an item in the gallery is clicked.
         * @description
         *  Setting the `clickAction` property sets what happens when
         *  an item in the gallery is clicked.
         *
         *  The value can be set to:
         *
         *  + `"none"`: Nothing happens.
         *  + `"expand"`: The item opens in a popup window.
         *  + `"link"`: The item's link opens.
         *
         *
         *  Getting the `clickAction` property returns what happens when
         *  an item in the gallery is clicked.
         * @snippet [Gallery-clickAction_get.es6=Get the action that occurs when an item in the gallery is clicked]
         * @snippet [Gallery-clickAction_set.es6=Set the action that occurs when an item in the gallery is clicked]
         * @type {external:string}
         * @memberof $w.Gallery
         * @instance
         */
        get: function get() {
            var _this4 = this;

            return executeApiIfSupported(this, 'clickAction', function () {
                var RMI = members._RMI.get(_this4);
                var compId = members._compId.get(_this4);
                var galleryImageClickAction = RMI.getProps(compId).galleryImageOnClickAction;
                return _lodash2.default.findKey(_constants.GALLERY_CLICK_ACTIONS, function (v) {
                    return v === galleryImageClickAction;
                });
            });
        }

        /**
         * @member clickAction
         * @memberof $w.Gallery
         * @param {external:string} action The action that occurs when an item in the gallery is clicked.
         */
        ,
        set: function set(action) {
            var _this5 = this;

            return executeApiIfSupported(this, 'clickAction', function () {
                var compType = members._type.get(_this5).compType;
                if ((0, _validation.validate)({
                    compType: compType,
                    functionName: 'clickAction',
                    dataToValidate: { galleryImageOnClickAction: action },
                    compName: _this5.id
                })) {
                    var galleryImageClickAction = _lodash2.default.isNil(action) ? _constants.GALLERY_CLICK_ACTIONS.none : _constants.GALLERY_CLICK_ACTIONS[action];
                    var RMI = members._RMI.get(_this5);
                    var compId = members._compId.get(_this5);
                    RMI.setProps(compId, { galleryImageOnClickAction: galleryImageClickAction });
                }
            });
        }

        /**
         * @member currentIndex
         * @label property
         * @syntax
         * get currentIndex(): Number
         * @summary Gets the index of the gallery's current item.
         * @description
         *  The indices of the items in a gallery are zero-based. For example, if
         *  the third item is currently being displayed, then `currentIndex`
         *  returns `2`.
         *
         * @note
         *  The `currentIndex` property is supported by galleries where the
         *  `hasCurrentItem` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `currentIndex` and you try to use it, your code may no longer function correctly.
         * @snippet [Gallery-currentIndex_get.es6=Get the index of the gallery's current item]
         * @type {external:Number}
         * @memberof $w.Gallery
         * @instance
         * @readonly
         */

    }, {
        key: 'currentIndex',
        get: function get() {
            var _this6 = this;

            return executeApiIfSupported(this, 'currentIndex', function () {
                var RMI = members._RMI.get(_this6);
                var compId = members._compId.get(_this6);
                var compState = RMI.getState(compId);
                return compState.currentIndex;
            });
        }

        /**
         * @member items
         * @label property
         * @syntax
         * get items(): (ImageItem | VideoItem)[]
         * set items(value: (ImageItem | VideoItem)[]): void
         * @summary Sets or gets the items in a gallery.
         * @description
         *  Setting the `items` property sets the gallery items that make up the gallery.
         *
         *  Set `items` to an empty array (`[]`) to remove the current gallery items.
         *
         *  Getting the `items` property returns the current list of gallery items
         *  that make up the gallery.
         *
         *  You cannot modify the gallery item array in-place. To add, change, or
         *  remove individual gallery items:
         *
         *    1. Store the value of the `items` property in a variable.
         *    1. Make changes to the gallery items array.
         *    1. Reset the `items` property with the modified array.
         *
         *
         * @note You can only get the items of a Pro Gallery using the `items` property
         *  if you set its items using the `items` property or connect the gallery
         *  to a dataset first. If you set the gallery's items in the Editor, you
         *  are not be able to retrieve them with the `items` property. This limitation
         *  does not apply to standard galleries.
         *
         *  To determine if your gallery is a Pro Gallery, hover over the gallery while
         *  it is not selected. The gallery type appears above the upper left corner
         *  of the gallery. If the type is "Wix Pro Gallery", then your gallery is a
         *  Pro Gallery. If the type is anything other than "Wix Pro Gallery", the
         *  limitation described above does not apply to your gallery.
         * @snippet [Gallery-items_get.es6=Get the list of items and the first item's information]
         * @snippet [Gallery-items_set.es6=Set the list of items for a gallery]
         * @snippet [Gallery-add.es6=Add an item to a gallery]
         *  This example retrieves the items of a gallery, adds a new
         *  item, and then overwrites the old items.
         * @type {($w.Gallery~ImageItem[]|$w.Gallery~VideoItem[])}
         * @memberof $w.Gallery
         * @instance
         */

    }, {
        key: 'items',
        get: function get() {
            var _this7 = this;

            return executeApiIfSupported(this, 'items', function () {
                var RMI = members._RMI.get(_this7);
                var compId = members._compId.get(_this7);
                var data = RMI.getData(compId);
                var imageItems = _imageUtils2.default.filterImageItems(data.items);
                return _lodash2.default.map(data.items, function (item, index) {
                    if (_lodash2.default.includes(imageItems, item)) {
                        return _imageUtils2.default.dataFormat.toUser(item, index);
                    }
                    return item;
                });
            });
        }

        /**
         * @member items
         * @memberof $w.Gallery
         * @param {($w.Gallery~ImageItem[]|$w.Gallery~VideoItem[])} items
         */
        ,
        set: function set(items) {
            var _this8 = this;

            return executeApiIfSupported(this, 'items', function () {
                var compType = members._type.get(_this8).compType;
                if (!(0, _validation.validate)({
                    compType: compType,
                    functionName: 'items',
                    dataToValidate: { items: items },
                    compName: _this8.id
                })) {
                    return _this8;
                }
                var imageItems = _imageUtils2.default.filterImageItems(items);
                if (_lodash2.default.size(imageItems) !== _lodash2.default.size(items)) {
                    _reporter2.default.reportSdkWarning(_errors.generateError.warning_non_images_in_gallery({
                        galleryId: _this8.id
                    }));
                }
                var isImagesDataValid = _lodash2.default.every(imageItems, function (imageData, imageIndex) {
                    return _imageUtils2.default.checkImageValidation({ imageData: imageData, imageIndex: imageIndex, compName: _this8.id });
                });

                if (!isImagesDataValid) {
                    return;
                }

                var newImageItems = _lodash2.default.map(imageItems, _imageUtils2.default.dataFormat.toModel);

                if (!_lodash2.default.every(newImageItems)) {
                    return;
                }

                var RMI = members._RMI.get(_this8);
                RMI.setData(members._compId.get(_this8), { items: newImageItems });
            });
        }
    }, {
        key: 'showNavigationButtons',
        get: function get() {
            var _this9 = this;

            return executeApiIfSupported(this, 'showNavigationButtons', function () {
                var RMI = members._RMI.get(_this9);
                var compId = members._compId.get(_this9);
                var props = RMI.getProps(compId);
                var viewerType = members._type.get(_this9).viewerType;
                var navButtonsPropName = getShowANavigationButtonsPropertyName(viewerType);
                return props[navButtonsPropName];
            });
        }

        /**
         * @member showNavigationButtons
         * @memberof $w.Gallery
         * @param {external:Boolean} value
         */
        ,
        set: function set(value) {
            var _this10 = this;

            return executeApiIfSupported(this, 'showNavigationButtons', function () {
                var compType = members._type.get(_this10).compType;
                var viewerType = members._type.get(_this10).viewerType;
                var navButtonsPropName = getShowANavigationButtonsPropertyName(viewerType);
                if ((0, _validation.validate)({
                    compType: compType,
                    functionName: 'showNavigationButtons',
                    dataToValidate: _defineProperty({}, navButtonsPropName, value),
                    compName: _this10.id
                })) {
                    var RMI = members._RMI.get(_this10);
                    var compId = members._compId.get(_this10);
                    RMI.setProps(compId, _defineProperty({}, navButtonsPropName, value));
                }
            });
        }

        /**
         * @member currentItem
         * @label property
         * @syntax
         * get currentItem(): ImageItem | VideoItem
         * @summary Gets an object containing information about the current item.
         * @snippet [Gallery-currentItem_get.es6=Get the current gallery item]
         * @note
         *  The `currentItem` property is supported by galleries where the
         *  `hasCurrentItem` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `hasCurrentItem` and you try to use
         *  it, your code may no longer function correctly.
         * @type {$w.Gallery~ImageItem|$w.Gallery~VideoItem}
         * @memberof $w.Gallery
         * @instance
         * @readonly
         */

    }, {
        key: 'currentItem',
        get: function get() {
            var _this11 = this;

            return executeApiIfSupported(this, 'currentItem', function () {
                var RMI = members._RMI.get(_this11);
                var compId = members._compId.get(_this11);
                var compState = RMI.getState(compId);
                var currentIndex = compState.currentIndex;
                var items = _lodash2.default.get(RMI.getData(compId), 'items');
                if (_lodash2.default.isUndefined(items) || _lodash2.default.isUndefined(currentIndex) || _lodash2.default.size(items) === 0) {
                    return undefined;
                }
                var image = _imageUtils2.default.dataFormat.toUser(items[currentIndex]);
                return _lodash2.default.omit(image, 'id');
            });
        }

        /**
         * @member galleryCapabilities
         * @label property
         * @syntax
         * get galleryCapabilities(): GalleryCapabilities
         * @summary Gets an object containing information about the gallery's capabilities.
         * @snippet [Gallery-galleryCapabilities_get.es6=Get the gallery's capabilities]
         * @type {$w.Gallery~GalleryCapabilities}
         * @memberof $w.Gallery
         * @instance
         * @readonly
         */

    }, {
        key: 'galleryCapabilities',
        get: function get() {
            var viewerType = members._type.get(this).viewerType;
            return Object.freeze({
                isPlayable: (0, _componentAPISupport2.default)(viewerType, 'play'),
                hasCurrentItem: (0, _componentAPISupport2.default)(viewerType, 'currentItem'),
                hasNavigationButtons: (0, _componentAPISupport2.default)(viewerType, 'showNavigationButtons'),
                supportsAllMediaTypes: false
            });
        }
    }]);

    return Gallery;
}(_Element3.default);

(0, _mixin2.default)(Gallery.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Gallery.prototype, _PlayableMixin2.default.prototype);
(0, _mixin2.default)(Gallery.prototype, _ClickableMixin2.default.prototype);

exports.default = Gallery;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addAppStudioWidgetPropsToSelector(props) {
    if (!self.$widget) {
        return;
    }
    self.$widget.props = {};
    _lodash2.default.forEach(props, function (val, key) {
        Object.defineProperty(self.$widget.props, key, {
            writable: false,
            value: val
        });
    });
}

function addAppStudioGlobalsIfNeeded() {
    var RGI = _platformUtils2.default.getRGI();
    if (RGI.getIsApplicationStudio()) {
        self.$widget = {};
        self.$widget.fireEvent = function (eventName) {
            console.log('Event Fired: ' + eventName);
        };
        self.$widget.onPropsChanged = function (callback) {
            RGI.addOnWidgetPropsChangedCallback(function (oldProps, newProps) {
                callback(oldProps, newProps);
            });
        };
    }
}

exports.default = {
    addAppStudioWidgetPropsToSelector: addAppStudioWidgetPropsToSelector,
    addAppStudioGlobalsIfNeeded: addAppStudioGlobalsIfNeeded
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _videoUtils = __webpack_require__(69);

var _videoUtils2 = _interopRequireDefault(_videoUtils);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMediaDataFromSrc(value) {
    var mediaData = void 0;
    if (_videoUtils2.default.isVideoUrl(value)) {
        mediaData = _videoUtils2.default.extractModelDataFromSrc(value);
        if (mediaData) {
            _lodash2.default.assign(mediaData, { type: 'WixVideo' });
        }
    } else {
        mediaData = _imageUtils2.default.extractModelDataFromSrc(value);
        if (mediaData) {
            _lodash2.default.assign(mediaData, { type: 'Image' });
        }
    }
    if (!_lodash2.default.isNil(value) && !mediaData) {
        _reporter2.default.reportSdkError(_errors.generateError.error_bad_background_format({
            propertyName: 'src',
            functionName: 'background',
            wrongValue: value
        }));
        return null;
    }
    return mediaData || {};
}

function getFullMediaData(mediaData, callback) {
    if (mediaData.videoId) {
        _videoUtils2.default.getFullVideoData(mediaData.videoId, callback);
        return;
    }
    callback();
}

function buildFullUrlFromMediaRef(mediaData) {
    if (mediaData.videoId) {
        return _videoUtils2.default.buildFullUrlFromMediaRef(mediaData);
    }
    return _imageUtils2.default.buildFullUrlFromMediaRef(mediaData);
}

exports.default = {
    buildFullUrlFromMediaRef: buildFullUrlFromMediaRef,
    getMediaDataFromSrc: getMediaDataFromSrc,
    getFullMediaData: getFullMediaData
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VECTOR_MEDIA_SRC_REGEX = /^wix:vector:\/\/v1\/([^\/]+)\/([^\/]+)?$/; // this is a hack until WEED-13787 would be solved

var isValidInternalVectorImage = function isValidInternalVectorImage(src) {
    return VECTOR_MEDIA_SRC_REGEX.test(src);
}; // this is a hack until WEED-13787 would be solved

function isValidVectorImage(src) {
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    return mediaSrcHandler.isValidMediaSrc(src, mediaSrcHandler.types.VECTOR);
}

function extractModelDataFromSrc(src) {
    // this is a hack until WEED-13787 would be solved
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    var parseMediaItem = mediaSrcHandler.parseMediaSrc(src, mediaSrcHandler.types.VECTOR);
    if (parseMediaItem.error) {
        return null;
    }

    if (!VECTOR_MEDIA_SRC_REGEX.test(src)) {
        return null;
    }

    return { svgId: parseMediaItem.mediaId, title: parseMediaItem.title };
}

function convertToModelFormatAndReportIfError(src, propertyName, functionName, index) {
    // this is a hack until WEED-13787 would be solved
    var svgData = extractModelDataFromSrc(src);
    if (!svgData) {
        var error = !_lodash2.default.isNil(index) ? _errors.generateError.error_bad_svg_format_with_index : _errors.generateError.error_bad_svg_format;
        _reporter2.default.reportSdkError(error({
            propertyName: propertyName,
            functionName: functionName,
            index: index,
            wrongValue: src
        }));
        return null;
    }
    return svgData;
}

function convertToMediaSrcAndReportIfError(src, propertyName, functionName, index) {
    if ((0, _utils.isNilOrEmptyString)(src)) {
        return { value: src, isValid: false };
    }

    var isValid = _lodash2.default.isString(src) && isValidVectorImage(src);
    if (!isValid) {
        var error = !_lodash2.default.isNil(index) ? _errors.generateError.error_bad_svg_format_with_index : _errors.generateError.error_bad_svg_format;
        _reporter2.default.reportSdkError(error({
            propertyName: propertyName,
            functionName: functionName,
            index: index,
            wrongValue: src
        }));
    }
    return { value: src, isValid: isValid };
}

function buildFullUrlFromSvgId(svgId, title) {
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    var mediaItemUri = mediaSrcHandler.createMediaSrc({ mediaId: svgId, type: mediaSrcHandler.types.VECTOR, title: title });
    if (mediaItemUri.error) {
        return svgId;
    }
    return mediaItemUri.item;
}

exports.default = {
    isValidInternalVectorImage: isValidInternalVectorImage,
    convertToMediaSrcAndReportIfError: convertToMediaSrcAndReportIfError,
    extractModelDataFromSrc: extractModelDataFromSrc,
    convertToModelFormatAndReportIfError: convertToModelFormatAndReportIfError,
    buildFullUrlFromSvgId: buildFullUrlFromSvgId
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _AccountNavBar = __webpack_require__(120);

var _AccountNavBar2 = _interopRequireDefault(_AccountNavBar);

var _Anchor = __webpack_require__(121);

var _Anchor2 = _interopRequireDefault(_Anchor);

var _AppController = __webpack_require__(58);

var _AppController2 = _interopRequireDefault(_AppController);

var _AppWidget = __webpack_require__(122);

var _AppWidget2 = _interopRequireDefault(_AppWidget);

var _Background = __webpack_require__(21);

var _Background2 = _interopRequireDefault(_Background);

var _Box = __webpack_require__(123);

var _Box2 = _interopRequireDefault(_Box);

var _Button = __webpack_require__(71);

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = __webpack_require__(124);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _CheckboxGroup = __webpack_require__(125);

var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);

var _Column = __webpack_require__(126);

var _Column2 = _interopRequireDefault(_Column);

var _ColumnStrip = __webpack_require__(127);

var _ColumnStrip2 = _interopRequireDefault(_ColumnStrip);

var _Container = __webpack_require__(128);

var _Container2 = _interopRequireDefault(_Container);

var _DatePicker = __webpack_require__(129);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _DropDown = __webpack_require__(130);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _Element = __webpack_require__(8);

var _Element2 = _interopRequireDefault(_Element);

var _Footer = __webpack_require__(131);

var _Footer2 = _interopRequireDefault(_Footer);

var _FormElement = __webpack_require__(16);

var _FormElement2 = _interopRequireDefault(_FormElement);

var _Gallery = __webpack_require__(132);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _GoogleMap = __webpack_require__(133);

var _GoogleMap2 = _interopRequireDefault(_GoogleMap);

var _Header = __webpack_require__(134);

var _Header2 = _interopRequireDefault(_Header);

var _HiddenCollapsedElement = __webpack_require__(59);

var _HiddenCollapsedElement2 = _interopRequireDefault(_HiddenCollapsedElement);

var _HoverBox = __webpack_require__(135);

var _HoverBox2 = _interopRequireDefault(_HoverBox);

var _Popover = __webpack_require__(144);

var _Popover2 = _interopRequireDefault(_Popover);

var _HtmlComponent = __webpack_require__(136);

var _HtmlComponent2 = _interopRequireDefault(_HtmlComponent);

var _IFrame = __webpack_require__(60);

var _IFrame2 = _interopRequireDefault(_IFrame);

var _Image = __webpack_require__(137);

var _Image2 = _interopRequireDefault(_Image);

var _Link = __webpack_require__(30);

var _Link2 = _interopRequireDefault(_Link);

var _MobileMenu = __webpack_require__(140);

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _Node = __webpack_require__(33);

var _Node2 = _interopRequireDefault(_Node);

var _Native = __webpack_require__(142);

var _Native2 = _interopRequireDefault(_Native);

var _Page = __webpack_require__(143);

var _Page2 = _interopRequireDefault(_Page);

var _QuickActionBar = __webpack_require__(146);

var _QuickActionBar2 = _interopRequireDefault(_QuickActionBar);

var _RadioButtonGroup = __webpack_require__(147);

var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);

var _Repeater = __webpack_require__(148);

var _Repeater2 = _interopRequireDefault(_Repeater);

var _Slide = __webpack_require__(61);

var _Slide2 = _interopRequireDefault(_Slide);

var _Slideshow = __webpack_require__(62);

var _Slideshow2 = _interopRequireDefault(_Slideshow);

var _State = __webpack_require__(63);

var _State2 = _interopRequireDefault(_State);

var _MultiStateBox = __webpack_require__(141);

var _MultiStateBox2 = _interopRequireDefault(_MultiStateBox);

var _Table = __webpack_require__(149);

var _Table2 = _interopRequireDefault(_Table);

var _Text = __webpack_require__(150);

var _Text2 = _interopRequireDefault(_Text);

var _TextBox = __webpack_require__(151);

var _TextBox2 = _interopRequireDefault(_TextBox);

var _TextInput = __webpack_require__(152);

var _TextInput2 = _interopRequireDefault(_TextInput);

var _UploadButton = __webpack_require__(64);

var _UploadButton2 = _interopRequireDefault(_UploadButton);

var _VectorImage = __webpack_require__(154);

var _VectorImage2 = _interopRequireDefault(_VectorImage);

var _VerticalMenu = __webpack_require__(155);

var _VerticalMenu2 = _interopRequireDefault(_VerticalMenu);

var _Video = __webpack_require__(156);

var _Video2 = _interopRequireDefault(_Video);

var _MenuContainer = __webpack_require__(139);

var _MenuContainer2 = _interopRequireDefault(_MenuContainer);

var _MediaBox = __webpack_require__(138);

var _MediaBox2 = _interopRequireDefault(_MediaBox);

var _Types = __webpack_require__(153);

var _Types2 = _interopRequireDefault(_Types);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classes = {
    AccountNavBar: _AccountNavBar2.default,
    Anchor: _Anchor2.default,
    AppController: _AppController2.default,
    AppWidget: _AppWidget2.default,
    Background: _Background2.default,
    Box: _Box2.default,
    Button: _Button2.default,
    Checkbox: _Checkbox2.default,
    CheckboxGroup: _CheckboxGroup2.default,
    Column: _Column2.default,
    ColumnStrip: _ColumnStrip2.default,
    Container: _Container2.default,
    DatePicker: _DatePicker2.default,
    Dropdown: _DropDown2.default,
    Element: _Element2.default,
    Footer: _Footer2.default,
    FormElement: _FormElement2.default,
    Gallery: _Gallery2.default,
    GoogleMap: _GoogleMap2.default,
    Header: _Header2.default,
    HiddenCollapsedElement: _HiddenCollapsedElement2.default,
    HoverBox: _HoverBox2.default,
    HtmlComponent: _HtmlComponent2.default,
    IFrame: _IFrame2.default,
    Image: _Image2.default,
    Link: _Link2.default,
    MobileMenu: _MobileMenu2.default,
    Node: _Node2.default,
    Native: _Native2.default,
    Page: _Page2.default,
    QuickActionBar: _QuickActionBar2.default,
    RadioButtonGroup: _RadioButtonGroup2.default,
    Repeater: _Repeater2.default,
    Slide: _Slide2.default,
    Slideshow: _Slideshow2.default,
    State: _State2.default,
    MultiStateBox: _MultiStateBox2.default,
    Table: _Table2.default,
    Text: _Text2.default,
    TextBox: _TextBox2.default,
    TextInput: _TextInput2.default,
    UploadButton: _UploadButton2.default,
    VectorImage: _VectorImage2.default,
    VerticalMenu: _VerticalMenu2.default,
    Video: _Video2.default,
    Popover: _Popover2.default,
    MenuContainer: _MenuContainer2.default,
    MediaBox: _MediaBox2.default
};

var ui = _lodash2.default.assign(_lodash2.default.mapValues(classes, function (clazz) {
    return _monitoring2.default.monitorComponent(clazz);
}), { getTypes: _Types2.default });

ui.registerComponent = function (sdkType, module) {
    if (ui[sdkType]) {
        return false;
    }
    ui[sdkType] = _monitoring2.default.monitorComponent(module);
    return true;
};

exports.default = ui;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(5);

var _validation = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin TextInputMixin
 * @summary Provides functionality for elements that accept text as input.
 * @memberof $w
 */
var TextInputMixin = function () {
    function TextInputMixin() {
        _classCallCheck(this, TextInputMixin);
    }

    _createClass(TextInputMixin, [{
        key: 'onKeyPress',


        /**
         * @function onKeyPress
         * @syntax
         * function onKeyPress(handler: KeyboardEventHandler): Element
         * callback KeyboardEventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the cursor is inside the
         *  input element and a key is pressed.
         * @description
         *  A text input receives a `keyPress` event when a user presses a key on
         *  the keyboard while the cursor is inside the input element. A `keyPress`
         *  event is fired for printable and non-printable characters.
         * @note
         *  Some browsers do not issue a key press event for certain keys,
         *  such as arrow keys or the shift key.
         * 
         *  When you retrieve the `value` from the `target` property of a [`KeyboardEvent`]($w.KeyboardEvent.html),
         *  you get the value of the target element before the key was pressed.  
         * 
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.KeyboardEventHandler} eventHandler The name of the function or
         *  the function expression to run when a key is pressed.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [TextInputElement-onKeyPress.es6=Get the key that was pressed]
         * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
         * @memberof $w.TextInputMixin
         * @eventtype keyPress
         * @eventhandler
         */
        value: function onKeyPress(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onKeyPress',
                dataToValidate: { onKeyPress: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().KEY_PRESS, controllerId, cb);
            return this;
        }
    }, {
        key: 'placeholder',

        /**
         * @member placeholder
         * @label property
         * @syntax
         * get placeholder(): string
         * set placeholder(value: string): void
         * @summary Sets or gets the element's placeholder text.
         * @description
         *  Placeholder text is typically used to provide a
         *  hint to the user of what to enter into a input element that accepts
         *  text. When the user begins to enter text, the placeholder text disappears.
         * @snippet [TextInputElement-placeholder_get.es6=Get an element's placeholder text]
         * @snippet [TextInputElement-placeholder_set.es6=Set an element's placeholder text]
         * @type {external:String}
         * @memberof $w.TextInputMixin
         * @attr {external:String}
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compProps = RMI.getProps(compId);
            var compData = RMI.getData(compId);

            return _lodash2.default.get(compData, 'placeholder') || _lodash2.default.get(compProps, 'placeholder');
        }

        /**
         * @member placeholder
         * @memberof $w.TextInputMixin
         * @param {external:String} newPlaceholder
         */
        ,
        set: function set(newPlaceholder) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'placeholder',
                dataToValidate: { placeholder: newPlaceholder },
                compName: this.id
            });
            if (newPlaceholder && !isValid) {
                return;
            }
            newPlaceholder = (0, _utils.emptyStringIfNil)(newPlaceholder);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.setData(compId, {
                placeholder: newPlaceholder
            });
            RMI.setProps(compId, {
                placeholder: newPlaceholder
            });
        }

        /**
         * @member maxLength
         * @label property
         * @syntax
         * get maxLength(): Number
         * set maxLength(value: Number): void
         * @summary Sets or gets the maximum number of characters that can be entered.
         * @description
         *  Setting the `maxLength` property of an input element to a
         *  positive number restricts user input, by manual entry or pasting, to
         *  text that does not exceed the `maxLength`. However, it does not limit
         *  your ability to change the element's value to one that exceeds
         *  `maxLength` programmatically.
         *
         *  To remove the maximum length restriction that has been set on the input
         *  element, set `maxLength` to `0`.
         *
         *  Getting the `maxLength` property returns the element's
         *  current `maxLength` setting.
         *
         *  The number of characters is calculated by <a href="https://en.wikipedia.org/wiki/Code_point"
         *  target="_blank">Unicode code points</a>.
         * @snippet [TextInputMixin-maxlength_get.es6=Get an element's maximum length]
         * @snippet [TextInputMixin-maxlength_set.es6=Set an element's maximum length]
         * @snippet [TextInputMixin-maxlength_reset.es6=Remove an element's maximum length restriction]
         * @type {external:Number}
         * @memberof $w.TextInputMixin
         */

    }, {
        key: 'maxLength',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            return compData && compData.maxLength;
        }

        /**
         * @member maxLength
         * @memberof $w.TextInputMixin
         * @param {external:Number} len
         */
        ,
        set: function set(len) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'maxlength',
                dataToValidate: { maxlength: len },
                compName: this.id
            });
            if (!_lodash2.default.isNil(len) && !isValid) {
                return;
            }
            len = (0, _utils.nullIfNil)(len);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.setData(compId, {
                maxLength: len
            });
        }
    }]);

    return TextInputMixin;
}();

exports.default = TextInputMixin;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ViewportMixin
 * @summary Provides functionality for elements that can be scrolled into and out
 *  of view.
 * @memberof $w
 */
var ViewportMixin = function () {
    function ViewportMixin() {
        _classCallCheck(this, ViewportMixin);
    }

    _createClass(ViewportMixin, [{
        key: 'onViewportEnter',


        /**
         * @function onViewportEnter
         * @syntax
         * function onViewportEnter(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when an element is displayed
         *  in the viewable part of the current window.
         * @description
         *  An element enters the viewport when the page is scrolled to show any
         *  part of the element. An element also enters the viewport if it was
         *  [hidden]($w.HiddenMixin.html#hidden) or [collapsed]($w.CollapsedMixin.html#collapsed)
         *  and is then shown or expanded in the viewable part of the current window.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element enters the viewport.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [ViewportMixin-onViewportEnter.es6=Get the ID of the element that has entered the viewport]
         * @see [onViewportLeave( )](#onViewportLeave)
         * @memberof $w.ViewportMixin
         * @eventtype viewportEnter
         * @eventhandler
         */
        value: function onViewportEnter(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onViewportEnter',
                dataToValidate: { onViewportEnter: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().VIEWPORT_ENTER, controllerId, cb);
            return this;
        }

        /**
         * @function onViewportLeave
         * @syntax
         * function onViewportLeave(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when an element is no longer
         *  displayed in the viewable part of the current window.
         * @description
         *  An element leaves the viewport when the page is scrolled so that the
         *  elements is completely out of view. An element also leaves the viewport
         *  if it was shown or expanded and is then [hidden]($w.HiddenMixin.html#hidden)
         *  or [collapsed]($w.CollapsedMixin.html#collapsed) from the viewable part
         *  of the current window.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element leaves the viewport.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [ViewportMixin-onViewportLeave.es6=Get the ID of the element that has entered the viewport]
         * @see [onViewportEnter( )](#onViewportEnter)
         * @memberof $w.ViewportMixin
         * @eventtype viewportLeave
         * @eventhandler
         */

    }, {
        key: 'onViewportLeave',
        value: function onViewportLeave(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onViewportLeave',
                dataToValidate: { onViewportLeave: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().VIEWPORT_LEAVE, controllerId, cb);
            return this;
        }
    }]);

    return ViewportMixin;
}();

exports.default = ViewportMixin;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {

    FieldType: Object.freeze({
        STRING: 'string',
        DATE: 'date',
        NUMBER: 'number',
        IMAGE: 'image',
        BOOLEAN: 'bool',
        RICH_TEXT: 'richText'
    }),

    SortDirection: Object.freeze({
        ASC: 'asc',
        DESC: 'desc',
        NONE: 'none'
    }),

    UserSelectionType: Object.freeze({
        NONE: 'none',
        CELL: 'cell',
        ROW: 'row'
    }),

    LinkTargetType: Object.freeze({
        SELF: '_self',
        BLANK: '_blank'
    }),

    DataSourceType: Object.freeze({
        DYNAMIC: 'dynamic',
        STATIC: 'static'
    }),

    PaginationType: Object.freeze({
        NONE: 'normal',
        PAGES: 'pagination',
        SCROLL: 'virtual'
    }),

    HeightLayout: Object.freeze({
        MANUAL: 'manual',
        AUTO: 'auto'
    }),

    ColumnLayout: Object.freeze({
        EQUAL: 'equal',
        FIT_CONTENT: 'fitContent',
        MANUAL: 'manual'
    }),

    HorizontalAlignment: Object.freeze({
        LEFT: 'left',
        CENTER: 'center',
        RIGHT: 'right'
    }),

    RowModification: Object.freeze({
        UPDATE: 'update',
        ADD: 'add',
        REMOVE: 'remove'
    }),

    filtering: {
        NumericOperator: Object.freeze({
            EQUALS: 'EQUALS',
            NOT_EQUALS: 'NOT_EQUALS',
            LESS_THAN: 'LESS_THAN',
            LESS_OR_EQUALS: 'LESS_OR_EQUALS',
            GREATER_THAN: 'GREATER_THAN',
            GREATER_OR_EQUALS: 'GREATER_OR_EQUALS'
        }),

        StringOperator: Object.freeze({
            EQUALS: 'EQUALS',
            NOT_EQUALS: 'NOT_EQUALS',
            CONTAINS: 'CONTAINS',
            STARTS_WITH: 'STARTS_WITH',
            ENDS_WITH: 'ENDS_WITH'
        }),

        DateOperator: Object.freeze({
            LAST_X_DAYS: 'LAST_X_DAYS',
            LAST_X_WEEKS: 'LAST_X_WEEKS',
            LAST_X_MONTHS: 'LAST_X_MONTHS'
        })
    }
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _textInputInitialize = __webpack_require__(101);

var _comboBoxInputInitialize = __webpack_require__(97);

var _textAreaInputInitialize = __webpack_require__(100);

var _booleanInputInitialize = __webpack_require__(95);

var _radioGroupInitialize = __webpack_require__(99);

var _checkboxGroupInitialize = __webpack_require__(96);

var _datePickerInitialize = __webpack_require__(98);

var _uploadButtonInitialize = __webpack_require__(102);

var _errors = __webpack_require__(9);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compTypeToInitializeMethod = {
    'wysiwyg.viewer.components.inputs.TextInput': _textInputInitialize.textInputInitialize,
    'wysiwyg.viewer.components.inputs.ComboBoxInput': _comboBoxInputInitialize.comboBoxInputInitialize,
    'wysiwyg.viewer.components.inputs.TextAreaInput': _textAreaInputInitialize.textAreaInputInitialize,
    'wysiwyg.viewer.components.inputs.Checkbox': _booleanInputInitialize.booleanInputInitialize,
    'wysiwyg.viewer.components.inputs.RadioGroup': _radioGroupInitialize.radioGroupInitialize,
    'wysiwyg.viewer.components.inputs.CheckboxGroup': _checkboxGroupInitialize.checkboxGroupInitialize,
    'wysiwyg.viewer.components.inputs.DatePicker': _datePickerInitialize.datePickerInitialize,
    'wysiwyg.viewer.components.inputs.FileUploader': _uploadButtonInitialize.uploadButtonInitialize
};

var compTypeToRemovalMethod = {
    'wysiwyg.viewer.components.inputs.TextInput': _textInputInitialize.textInputClearance,
    'wysiwyg.viewer.components.inputs.ComboBoxInput': _comboBoxInputInitialize.comboBoxInputClearance,
    'wysiwyg.viewer.components.inputs.TextAreaInput': _textAreaInputInitialize.textAreaInputClearance,
    'wysiwyg.viewer.components.inputs.Checkbox': _booleanInputInitialize.booleanInputClearance,
    'wysiwyg.viewer.components.inputs.RadioGroup': _radioGroupInitialize.radioGroupClearance,
    'wysiwyg.viewer.components.inputs.CheckboxGroup': _checkboxGroupInitialize.checkboxGroupClearance,
    'wysiwyg.viewer.components.inputs.DatePicker': _datePickerInitialize.datePickerClearance,
    'wysiwyg.viewer.components.inputs.FileUploader': _uploadButtonInitialize.uploadButtonClearance
};

var componentsInitialize = function componentsInitialize(RMI, contextId, components) {
    _lodash2.default.forEach(components, function (comp, compId) {
        var initializeMethod = compTypeToInitializeMethod[comp.type];

        if (initializeMethod) {
            initializeMethod(RMI, contextId, compId);
        }
    });
};

var componentsRemoval = function componentsRemoval(RMI, contextId, components) {
    _lodash2.default.forEach(components, function (comp, compId) {
        var removalMethod = compTypeToRemovalMethod[comp.type];

        if (removalMethod) {
            removalMethod(RMI, contextId, compId);
        }
    });
};

function extendComponentsInitialize(viewerType, initializeMethod) {
    if (compTypeToInitializeMethod[viewerType]) {
        _reporter2.default.reportSdkError(_errors.generateError.error_component_already_exists({ component: viewerType }));
        return false;
    }

    compTypeToInitializeMethod[viewerType] = initializeMethod;

    return true;
}

function extendComponentsRemoval(viewerType, removalMethod) {
    if (compTypeToRemovalMethod[viewerType]) {
        _reporter2.default.reportSdkError(_errors.generateError.error_component_already_exists({ component: viewerType }));
        return false;
    }

    compTypeToRemovalMethod[viewerType] = removalMethod;

    return true;
}

exports.default = {
    componentsInitialize: componentsInitialize,
    componentsRemoval: componentsRemoval,
    extendComponentsInitialize: extendComponentsInitialize,
    extendComponentsRemoval: extendComponentsRemoval
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onReady = onReady;
exports.triggerOnReady = triggerOnReady;
exports.onRender = onRender;
exports.triggerOnRender = triggerOnRender;
exports.clearReadyManager = clearReadyManager;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _postMessage = __webpack_require__(15);

var pm = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _appStudioUtils = __webpack_require__(43);

var _appStudioUtils2 = _interopRequireDefault(_appStudioUtils);

var _errors = __webpack_require__(9);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onReadyCallbacks = [];
var onRenderCallbacks = [];
var ready = new Set();

function wrapCallbackWithTimer(callback, id) {
    return function () {
        var startTime = Date.now();
        var result = callback();
        if (result instanceof Promise) {
            result.then(function () {
                console.log(id + ' was delayed by ' + (Date.now() - startTime) + 'ms due to code');
            });
        }
        return result;
    };
}

function safeRun(callback) {
    try {
        return callback();
    } catch (e) {
        console.error(e);
        return;
    }
}

function on(callback, callbacksArr, log, type) {
    _platformUtils2.default.wSpyLog('readyManager', ['on-' + type, callback, callbacksArr]);
    if (!_lodash2.default.isFunction(callback)) {
        var functionName = 'on' + _lodash2.default.capitalize(type);
        throw new _monitoring2.default.MonitoringErrorToIgnore(_errors.generateError.error_type({
            functionName: functionName,
            propertyName: functionName + 'Handler',
            wrongValue: callback,
            expectedType: 'function'
        }));
    }

    var actualCallback = log ? wrapCallbackWithTimer(callback, log) : callback;
    if (ready.has(type)) {
        _lodash2.default.defer(function () {
            return safeRun(actualCallback);
        });
    }

    callbacksArr.push(actualCallback);
}

function trigger(success, callbacksArr, type) {
    _platformUtils2.default.wSpyLog('readyManager', ['trigger-' + type + '-activate', callbacksArr, success]);
    var allReady = Promise.all(callbacksArr.map(function (cb) {
        return safeRun(cb);
    })).then(function (res) {
        var items = _lodash2.default.remove(res, function (item) {
            return !(_lodash2.default.isUndefined(item) || _lodash2.default.has(item, 'controllerId'));
        });
        _platformUtils2.default.wSpyLog('readyManager', ['trigger-' + type + '-after-all-ready', items]);
        _lodash2.default.forEach(items, function (data) {
            return pm.sendMessageToHost(pm.Intent.WIX_CODE_WARMUP, {
                command: pm.MessageTypes.SET_WARMUP_DATA,
                data: {
                    controllerId: 'wix-code',
                    data: data
                }
            });
        });
    }).catch(function (reason) {
        _platformUtils2.default.wSpyLog('readyManager', ['trigger-' + type + '-error', reason]);
        console.error(reason);
    });
    if (success) {
        allReady.then(function () {
            return success();
        });
    }

    callbacksArr.length = 0;
}

function onReady(callback, log) {
    on(callback, onReadyCallbacks, log, 'ready');
}

function triggerOnReady(success) {

    ready.add('ready');
    var RMI = _platformUtils2.default.getRMI();
    var props = RMI.getWidgetProperties();
    _appStudioUtils2.default.addAppStudioWidgetPropsToSelector(props);
    onReadyCallbacks.push(function () {
        _platformUtils2.default.addQueryParameters({ renderCycle: NaN });
    });
    trigger(success, onReadyCallbacks, 'onReady');
}

function onRender(callback, log) {
    on(callback, onRenderCallbacks, log, 'render');
}

function triggerOnRender(success) {
    ready.add('render');
    trigger(success, onRenderCallbacks, 'render');
}

function clearReadyManager() {
    onReadyCallbacks.splice(0);
    onRenderCallbacks.splice(0);
    ready.clear();
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function getProtocol(url) {
    if (!url) {
        return '';
    }
    var urlRe = /((https?)\:\/\/)?([^\?\:\/#]+)(\:([0-9]+))?(\/[^\?\#]*)?(\?([^#]*))?(#.*)?/i;
    var match = url.match(urlRe);
    return match[2] || 'http:';
}

function isExternalUrl(url) {
    return (/^(?:(?:https?:)\/\/)(?:(?:[\u0400-\uA69F\w][\u0400-\uA69F\w-]*)?[\u0400-\uA69F\w]\.)+(?:[\u0400-\uA69Fa-z]+|\d{1,3})(?::[\d]{1,5})?(?:[/?#].*)?$/i.test(url)
    );
}

function isValidProtocol(url, RGI) {
    var protocol = getProtocol(url);
    var siteUrl = RGI.getFullUrl();
    var siteProtocol = getProtocol(siteUrl);

    if (protocol === 'http' && siteProtocol === 'https') {
        return false;
    }
    return true;
}

exports.isExternalUrl = isExternalUrl;
exports.isValidProtocol = isValidProtocol;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCheckedIndices = exports.getCheckedValues = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCheckedValues = function getCheckedValues(options) {
    var checkedOptions = _lodash2.default.filter(options, function (option) {
        return option.checked;
    });
    return _lodash2.default.map(checkedOptions, function (option) {
        return option.value;
    });
};

var getCheckedIndices = function getCheckedIndices(options) {
    return _lodash2.default.filter(_lodash2.default.map(options, function (option, index) {
        return option.checked ? index : -1;
    }), function (index) {
        return index >= 0;
    });
};

exports.getCheckedValues = getCheckedValues;
exports.getCheckedIndices = getCheckedIndices;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAllowedComponentAPI = function isAllowedComponentAPI(type, api) {
    var apis = _utils.types.supportedComponentAPIs[type] || [];
    return _lodash2.default.includes(apis, api);
};

exports.default = isAllowedComponentAPI;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ldquo': '\u201C',
  'lsquo': '\u2018',
  'rsquo': '\u2019',
  'laquo': '\xAB',
  'raquo': '\xBB',
  'lsaquo': '\u2039',
  'rsaquo': '\u203A',
  'lt': '<',
  'gt': '>',
  'amp': '&',
  'bull': '\u2022',
  'deg': '\xB0',
  'hellip': '\u2026',
  'trade': '\u2122',
  'copy': '\xA9',
  'reg': '\xAE',
  'mdash': '\u2014',
  'ndash': '\u2013',
  'nbsp': '\xA0',
  'emsp': '\u2003',
  'ensp': '\u2002',
  'sup2': '\xB2',
  'sup3': '\xB3',
  'frac14': '\xBC',
  'frac12': '\xBD',
  'frac34': '\xBE'
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Link = __webpack_require__(30);

var _Link2 = _interopRequireDefault(_Link);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLOR_SCHEME_REGEX = /^(brand|grey|black)(\sinv)?$/;
var INVERT_COLOR_SCHEME_STYLE_PROPERTY_PART = ' inv';

var getColorSchemeParts = function getColorSchemeParts(colorSchemeStyleProperty) {
    var _COLOR_SCHEME_REGEX$e = COLOR_SCHEME_REGEX.exec(colorSchemeStyleProperty.trim()),
        _COLOR_SCHEME_REGEX$e2 = _slicedToArray(_COLOR_SCHEME_REGEX$e, 3),
        colorScheme = _COLOR_SCHEME_REGEX$e2[1],
        invertColorScheme = _COLOR_SCHEME_REGEX$e2[2];

    return {
        colorScheme: colorScheme,
        invertColorScheme: (0, _utils.emptyStringIfNil)(invertColorScheme)
    };
};

var getColorSchemeStyleProperty = function getColorSchemeStyleProperty(colorScheme, invertColors) {
    return colorScheme.concat(invertColors ? INVERT_COLOR_SCHEME_STYLE_PROPERTY_PART : '');
};

var convertToUserFormat = function convertToUserFormat(actionItem) {
    var link = actionItem.link;
    return {
        itemType: actionItem.itemType,
        label: actionItem.text,
        link: (0, _utils.emptyStringIfNil)(link && (link.link || new _Link2.default(link).getValue()))
    };
};

exports.default = {
    getColorSchemeParts: getColorSchemeParts,
    getColorSchemeStyleProperty: getColorSchemeStyleProperty,
    convertToUserFormat: convertToUserFormat
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationExpressions = __webpack_require__(117);

var _validationExpressions2 = _interopRequireDefault(_validationExpressions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateVideoUrlFormats(val) {
    return _validationExpressions2.default.validYouTubeLongUrlReg.test(val) || _validationExpressions2.default.validYouTubeShortUrlReg.test(val) || _validationExpressions2.default.validVimeoUrlReg.test(val) || _validationExpressions2.default.validDailymotionUrlReg.test(val) || _validationExpressions2.default.validFacebookUrlReg.test(val);
}

function validateRepeaterItemIdFormat(val) {
    return _validationExpressions2.default.validRepeaterItemId.test(val);
}

function validateUUIDFormat(val) {
    return _validationExpressions2.default.validUUID.test(val);
}

exports.default = {
    validateVideoUrlFormats: validateVideoUrlFormats,
    validateRepeaterItemIdFormat: validateRepeaterItemIdFormat,
    validateUUIDFormat: validateUUIDFormat
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _Node2 = __webpack_require__(33);

var _Node3 = _interopRequireDefault(_Node2);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* DISABLING JSDOC FOR THIS CLASS UNTIL FURTHER NOTICE:
 * @class AppController
 * @summary Provides functionality for the Wix Application Controller.
 * @mixes $w.Node
 * @memberof $w
 * @tagname AppController
 * @viewername platform.components.AppController
 */
var AppController = function (_Node) {
  _inherits(AppController, _Node);

  function AppController(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    _classCallCheck(this, AppController);

    var _this = _possibleConstructorReturn(this, (AppController.__proto__ || Object.getPrototypeOf(AppController)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

    members._emitter.set(_this, _platformUtils2.default.getEmitter().createScopedEmitter(compId));

    var publicAPI = RMI.getPublicAPI(compId);
    if (_lodash2.default.isFunction(publicAPI)) {
      var controllerData = RMI.getData(compId);
      var publicApiExports = publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id));
      (0, _mixin2.default)(_this, publicApiExports);
    } else if (publicAPI) {
      (0, _mixin2.default)(_this, publicAPI);
    }
    return _this;
  }

  /* DISABLING JSDOC FOR THIS PROPERTY UNTIL FURTHER NOTICE:
   * @member type
   * @label property
   * @syntax
     * let controllerType = $w("#myController").type;
   * @summary Gets the controller's type.
   * @type {external:String}
   * @see [Types](wix.html#Types)
   * @memberof $w.AppControllerit('should inherit base event methods', () => {
        const iconMouseEvent = new IconMouseInEvent(element, syntheticEvent);
        expect(iconMouseEvent.target).toBe(element);
        expect(iconMouseEvent.type).toBe('iconMouseIn');
    });
  });
   * @attr {external:String}
   * @readonly
   */


  _createClass(AppController, [{
    key: 'on',
    value: function on(event, callback, context) {
      var emitter = members._emitter.get(this);
      emitter.on(event, callback, context);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      var emitter = members._emitter.get(this);
      emitter.off(event, callback);
    }
  }, {
    key: 'once',
    value: function once(event, callback, context) {
      var emitter = members._emitter.get(this);
      emitter.once(event, callback, context);
    }
  }, {
    key: 'type',
    get: function get() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      return RMI.getData(compId).controllerType;
    }
  }]);

  return AppController;
}(_Node3.default);

exports.default = AppController;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @mixin HiddenCollapsedElement
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 */
var HiddenCollapsedElement = function (_Element) {
  _inherits(HiddenCollapsedElement, _Element);

  function HiddenCollapsedElement() {
    _classCallCheck(this, HiddenCollapsedElement);

    return _possibleConstructorReturn(this, (HiddenCollapsedElement.__proto__ || Object.getPrototypeOf(HiddenCollapsedElement)).apply(this, arguments));
  }

  return HiddenCollapsedElement;
}(_Element3.default);

(0, _mixin2.default)(HiddenCollapsedElement.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = HiddenCollapsedElement;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @mixin IFrame
 * @summary Provides functionality for iframe-based elements, such as `HtmlComponent`.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @tagname IFrame
 */
var IFrame = function (_Element) {
    _inherits(IFrame, _Element);

    function IFrame(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, IFrame);

        var _this = _possibleConstructorReturn(this, (IFrame.__proto__ || Object.getPrototypeOf(IFrame)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        var publicAPI = RMI.getPublicAPI(compId);
        if (_lodash2.default.isFunction(publicAPI)) {
            var controllerData = RMI.getData(compId);
            _lodash2.default.assign(_this, publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id)));
        } else if (publicAPI) {
            _lodash2.default.assign(_this, publicAPI);
        }
        return _this;
    }

    return IFrame;
}(_Element3.default);

(0, _mixin2.default)(IFrame.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = IFrame;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Background2 = __webpack_require__(21);

var _Background3 = _interopRequireDefault(_Background2);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Slide
 * @summary A `Slide` from a `Slideshow` that can contain other elements.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.BoxSlideShowSlide
 * @definitionId wysiwyg.viewer.components.BoxSlideShowSlide
 * @definitionId wysiwyg.viewer.components.StripContainerSlideShowSlide
 */
var Slide = function (_Background) {
    _inherits(Slide, _Background);

    function Slide() {
        _classCallCheck(this, Slide);

        return _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).apply(this, arguments));
    }

    _createClass(Slide, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                background = this.background,
                rendered = this.rendered,
                name = this.name;

            return { id: id, type: type, global: global, background: background.src, rendered: rendered, name: name };
        }
    }, {
        key: 'name',

        /**
         * @member name
         * @label property
         * @syntax
         * get name(): string
         * @summary Gets the name of the slide.
         * @description
         *  A slide's `name` is used as a label for the slide.
         *
         *  A slide's `name` is set in the Editor using the <a href="https://support.wix.com/en/article/manage-slides" target="_blank">Manage Slides panel</a>.
         *  ![Manage Slides](images/manage_slides.png "Manage Slides")
         * @snippet [Slide-name.es6=Get a slide's name]
         * @type {external:String}
         * @memberof $w.Slide
         * @readonly
         * @instance
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).title;
        }
    }]);

    return Slide;
}(_Background3.default);

(0, _mixin2.default)(Slide.prototype, _ContainableMixin2.default.prototype);

exports.default = Slide;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _Slide = __webpack_require__(61);

var _Slide2 = _interopRequireDefault(_Slide);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _PlayableMixin = __webpack_require__(37);

var _PlayableMixin2 = _interopRequireDefault(_PlayableMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateSlideInfo = function validateSlideInfo(compType, slideInfo, slidesCount, slideIndex, slideshowID) {
    if (!(0, _validation.validate)({
        compType: compType,
        functionName: 'changeSlide',
        dataToValidate: _lodash2.default.isNil(slideInfo) ? {} : { slideInfo: slideInfo },
        shouldCheckMandatoryFields: true,
        compName: slideshowID
    })) {
        return false;
    }
    if (_lodash2.default.isObject(slideInfo) && !(slideInfo instanceof _Slide2.default)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_type({
            functionName: 'changeSlide',
            propertyName: 'slideInfo',
            wrongValue: slideInfo,
            expectedType: 'slide,integer'
        }));
        return false;
    }

    if (slideIndex < 0 || slideIndex >= slidesCount) {
        if (slideInfo instanceof _Slide2.default) {
            _reporter2.default.reportSdkError(_errors.generateError.error_slide_input({
                propertyName: 'slideInfo',
                functionName: 'changeSlide',
                minValue: 0,
                maxValue: slidesCount - 1,
                slideshowID: slideshowID,
                wrongValue: slideInfo.id }));
        } else {
            _reporter2.default.reportSdkError(_errors.generateError.error_slide_input({
                propertyName: 'slideInfo',
                functionName: 'changeSlide',
                minValue: 0,
                maxValue: slidesCount - 1,
                slideshowID: slideshowID,
                wrongValue: slideIndex
            }));
        }
        return false;
    }

    return true;
};

var computeSlideIndex = function computeSlideIndex(RMI, compId, slideInfo) {
    var slideIndex = -1;
    if (slideInfo instanceof _Slide2.default) {
        var slideCompId = members._compId.get(slideInfo);

        slideIndex = RMI.getChildren(compId).indexOf(slideCompId);
    } else {
        slideIndex = slideInfo;
    }

    return slideIndex;
};

var getSlidesCount = function getSlidesCount(RMI, compId) {
    return RMI.getChildren(compId).length;
};

/**
 * @class Slideshow
 * @summary Slideshows are playable containers for slides.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.PlayableMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.BoxSlideShow
 * @viewername wysiwyg.viewer.components.StripContainerSlideShow
 * @definitionId wysiwyg.viewer.components.BoxSlideShow
 * @definitionId wysiwyg.viewer.components.StripContainerSlideShow
 * @tagname box-slideshow
 */

var Slideshow = function (_Element) {
    _inherits(Slideshow, _Element);

    function Slideshow() {
        _classCallCheck(this, Slideshow);

        return _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).apply(this, arguments));
    }

    _createClass(Slideshow, [{
        key: 'onChange',


        /**
         * @function onChange
         * @syntax
         * function onChange(handler: EventHandler): Slideshow
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the slideshow moves to a new slide.
         * @description
         *  A slideshow moves to a new slide through user actions, such as clicking
         *  on navigation or slide buttons, or programmatically, using functions
         *  such as [play()](#play), [previous( )](#previous), and [next( )](#next).
         *
         *  The event handler set by the `onChange` function is run immediately before
         *  the slideshow moves to the new slide. Therefore, reading the slideshow's
         *  [`currentIndex`](#currentIndex) or [`currentSlide`](#currentSlide) within
         *  the event handler function returns the index or slide that the slideshow
         *  is moving away from.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} eventHandler The name of the function or
         *  the function expression to run when the slideshow moves to a new slide.
         * @returns {$w.Slideshow} The slideshow on which the event is now registered.
         * @snippet [Slideshow-onChange.es6=Get the index of the slide that the slideshow is moving away from]
         * @see [changeSlide( )](#changeSlide)
         * @see [previous( )](#previous)
         * @see [next( )](#next)
         * @see [autoplay](#autoplay)
         * @memberof $w.Slideshow
         * @eventtype change
         * @eventhandler
         */
        value: function onChange(callback) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onChange',
                dataToValidate: { onChange: callback },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, controllerId, callback);
            return this;
        }

        /**
         * @member currentSlide
         * @label property
         * @syntax
         * get currentSlide(): Slide
         * @summary Gets the slideshow's current slide.
         * @snippet [Slideshow-currentSlide.es6=Get the current slide and its name]
         * @type {$w.Slide}
         * @see [currentIndex](#currentindex)
         * @memberof $w.Slideshow
         * @instance
         * @readonly
         */

    }, {
        key: 'changeSlide',


        /**
         * @function changeSlide
         * @syntax
         * function changeSlide(slideReference: Number | Slide): Promise<Slide>
         * @summary Change the slideshow's current slide to a specific slide or index.
         * @description
         *  The `changeSlide()` function returns a Promise that is resolved when
         *  the slideshow finishes moving from the current slide to the slide
         *  referred to by `slideReference`.
         *
         *  You can retrieve [`Slide`]($w.Slide.html) objects to pass to the
         *  `slideReference` parameter from your slideshow using the
         *  [`currentSlide`](#currentSlide) or [`slides`](#slides) properties.
         *
         *  If passing a number, note that slide indices in a slideshow are zero-based,
         *  even though they are numbered starting from 1 in the Editor.
         * @snippet [Slideshow-changeSlide-index.es6=Move to a new slide using an index]
         *  This example moves to the third slide in the slideshow.
         * @snippet [Slideshow-changeSlide-object.es6=Move to a new slide using a [`Slide`]($w.Slide.html) object]
         *  This example moves to the slide that is stored in the `slide` variable.
         * @snippet [Slideshow-changeSlide-done.es6=Moves to a new slide and logs a message when the move is finished]
         * @param {external:Number|$w.Slide} slideReference The slide to move to. Either the index of the slide or a [`Slide`](#w.Slide.html) from the slideshow.
         * @returns {external:Promise}
         * @fulfill {$w.Slide} The slide that the slideshow changed to.
         * @throws {external:Error} If no argument was provided or the argument is not a number or an existing slide.
         * @memberof $w.Slideshow
         */

        value: function changeSlide(slideInfo) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var compType = members._type.get(_this2).compType;
                var RMI = members._RMI.get(_this2);
                var compId = members._compId.get(_this2);
                var wixSelector = members._wixSelector.get(_this2);
                var controllerId = members._controllerId.get(_this2);

                var slideIndex = computeSlideIndex(RMI, compId, slideInfo);
                if (!validateSlideInfo(compType, slideInfo, getSlidesCount(RMI, compId), slideIndex, _this2.id)) {
                    return reject(_errors.generateError.error_slide_input({
                        propertyName: 'slideInfo',
                        functionName: 'changeSlide',
                        minValue: 0,
                        maxValue: getSlidesCount(RMI, compId) - 1,
                        slideshowID: _this2.id,
                        wrongValue: slideInfo
                    }));
                }

                RMI.executeCompBehavior(compId, 'moveToSlide', { slide: slideIndex }, function () {
                    var childrenIds = RMI.getChildren(compId);
                    var slideCompId = childrenIds[slideIndex];
                    var slide = RMI.getComp(slideCompId);
                    resolve(RMI, wixSelector.getInstance(RMI, slide.type, slideCompId, controllerId));
                });
            });
        }

        /**
         * @member slides
         * @label property
         * @syntax
           * get slides(): Slide[]
         * @summary Gets a list of all the slides contained in the slideshow.
         * @description
         *  Note that the slide indices in a slideshow are zero-based, even though
         *  they are numbered starting from 1 in the Editor.
         * @snippet [Slideshow-slides.es6=Get a slidshow's slides]
         * @snippet [Slideshow-slides_plus.es6=Get the slides, number of slides, and name of the first slide from a slideshow]
         * @type {$w.Slide[]}
         * @memberof $w.Slideshow
         * @instance
         * @readonly
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                currentIndex = this.currentIndex,
                showNavigationButtons = this.showNavigationButtons,
                showSlideButtons = this.showSlideButtons;

            return { id: id, type: type, global: global, rendered: rendered, currentIndex: currentIndex, showNavigationButtons: showNavigationButtons, showSlideButtons: showSlideButtons };
        }
    }, {
        key: 'currentSlide',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);

            var currentSlideIndex = RMI.getState(compId).currentIndex;
            var currentSlideCompId = RMI.getChildren(compId)[currentSlideIndex];
            var currentSlideType = RMI.getType(currentSlideCompId);

            return wixSelector.getInstance(RMI, currentSlideType, currentSlideCompId, controllerId);
        }
    }, {
        key: 'slides',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);

            return RMI.getChildren(compId).map(function (id) {
                return wixSelector.getInstance(RMI, RMI.getComp(id).type, id, controllerId);
            });
        }

        /**
         * @member currentIndex
         * @label property
         * @syntax
           * get currentIndex(): Number
         * @summary Gets the index of the slideshow's current slide.
         * @description
         *  Note that the slide indices in a slideshow are zero-based, even though
         *  they are numbered starting from 1 in the Editor.
         * @snippet [Slideshow-currentIndex.es6=Get the name of the current slide's index]
         * @type {external:Number}
         * @see [currentSlide](#currentSlide)
         * @memberof $w.Slideshow
         * @instance
         * @readonly
         */

    }, {
        key: 'currentIndex',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getState(compId).currentIndex;
        }

        /**
         * @member showNavigationButtons
         * @label property
         * @syntax
         * get showNavigationButtons(): boolean
         * set showNavigationButtons(value: boolean): void
         * @summary Sets or gets whether a slideshow's navigation buttons are shown.
         * @description
         *  Setting the `showNavigationButtons` property to `true` shows
         *  the slideshow's [navigation buttons](https://support.wix.com/en/article/slideshow-layouts).
         *  Setting it to `false` hides the slideshow's [navigation buttons](https://support.wix.com/en/article/slideshow-layouts).
         *
         *  Getting the `showNavigationButtons` property returns
         *  whether a slideshow's [navigation buttons](https://support.wix.com/en/article/slideshow-layouts)
         *  are shown or hidden.
         * @snippet [Slideshow-showNavigationButtons_get.es6=Get whether navigation buttons are shown]
         * @snippet [Slideshow-showNavigationButtons_set.es6=Set navigation buttons to be hidden]
         * @snippet [Slideshow-showNavigationButtons_toggle.es6=Toggle whether navigation buttons are shown]
         * @type {external:Boolean}
         * @memberof $w.Slideshow
         * @instance
         */

    }, {
        key: 'showNavigationButtons',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getProps(compId).showNavigationButton;
        }

        /**
         * @member showNavigationButtons
         * @memberof $w.Slideshow
         * @param {external:Boolean} show
         */
        ,
        set: function set(show) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'showNavigationButtons',
                dataToValidate: { showNavigationButtons: show },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, {
                showNavigationButton: show
            });
        }

        /**
         * @member showSlideButtons
         * @label property
         * @syntax
         * get showSlideButtons(): boolean
         * set showSlideButtons(value: boolean): void
         * @summary Set or returns whether a slideshow's slide buttons are shown.
         * @description
         *  Setting the `showSlideButtons` property to `true` shows
         *  the slideshow's [slide buttons](https://support.wix.com/en/article/slideshow-layouts).
         *  Setting it to `false` hides the slideshow's [slide buttons](https://support.wix.com/en/article/slideshow-layouts).
         *
         *  Getting the `showSlideButtons` property returns
         *  whether a slideshow's [slide buttons](https://support.wix.com/en/article/slideshow-layouts)
         *  are shown or hidden.
         * @snippet [Slideshow-showSlideButtons_get.es6=Get whether slide buttons are shown]
         * @snippet [Slideshow-showSlideButtons_set.es6=Set slide buttons to be hidden]
         * @snippet [Slideshow-showSlideButtons_toggle.es6=Toggle whether slide buttons are shown]
         * @type {external:Boolean}
         * @memberof $w.Slideshow
         * @instance
         */

    }, {
        key: 'showSlideButtons',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getProps(compId).showNavigationDots;
        }

        /**
         * @member showSlideButtons
         * @memberof $w.Slideshow
         * @param {external:Boolean} show
         */
        ,
        set: function set(show) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'showSlideButtons',
                dataToValidate: { showSlideButtons: show },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, {
                showNavigationDots: show
            });
        }
    }]);

    return Slideshow;
}(_Element3.default);

(0, _mixin2.default)(Slideshow.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Slideshow.prototype, _PlayableMixin2.default.prototype);
(0, _mixin2.default)(Slideshow.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Slideshow.prototype, _ContainableMixin2.default.prototype);

exports.default = Slideshow;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Background2 = __webpack_require__(21);

var _Background3 = _interopRequireDefault(_Background2);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class State
 * @summary A `State` from a `MultiStateBox` that can contain other elements.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.StateBoxState
 * @definitionId wysiwyg.viewer.components.StateBoxState
 * @definitionId wysiwyg.viewer.components.StateStripState
 */
var State = function (_Background) {
  _inherits(State, _Background);

  function State() {
    _classCallCheck(this, State);

    return _possibleConstructorReturn(this, (State.__proto__ || Object.getPrototypeOf(State)).apply(this, arguments));
  }

  return State;
}(_Background3.default);

(0, _mixin2.default)(State.prototype, _ContainableMixin2.default.prototype);

exports.default = State;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _validation = __webpack_require__(3);

var _utils = __webpack_require__(5);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _validationsService = __webpack_require__(11);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef {external:Object} $w.UploadButton~File
 * @summary The object used by the `value` property that represents
 *  files ready for upload.
 * @property {external:String} name The file's name.
 * @property {external:String} size The file's size in bytes.
 * @snippet [UploadButton-value.es6=Get the files pending upload]
 * @see [value](#value)
 */

/**
 * @typedef {external:Object} $w.UploadButton~UploadedFile
 * @summary The object returned by the `startUpload()` function's
 *  Promise that contains the URL of the successfully uploaded file.
 * @property {external:String} url The Wix URL of the uploaded file.
 * @snippet [UploadButton-startUpload.es6=Get uploaded file information]
 * @see [startUpload](#startUpload)
 */

/**
 * @typedef {external:Object} $w.UploadButton~UploadError
 * @summary The object returned by the `startUpload()` function's
 *  Promise when an upload fails.
 * @property {external:String} errorCode Numeric The error's code.
 * @property {external:String} errorDescription The error's description.
 * @snippet [UploadButton-startUpload.es6=Get upload error information]
 * @see [startUpload](#startUpload)
 */

/**
 * @class UploadButton
 * @summary An upload button enables users to upload files to your site.
 * @description
 *  <h3 id="typical-scenario">Typical File Upload Scenario</h3>
 *  <p>In a typical scenario, the page from which files are uploaded contains
 *  an upload button and another element, such as a regular button. The user chooses
 *  which file to upload by clicking the upload button and selecting the
 *  file in a native file chooser dialog. At that point the file is stored in
 *  the upload button's [`value`](#value) property as a [`File`](#File) object. Then
 *  the user triggers an event, such as a button click, on the other element.
 *  That element's event handler calls the [`startUpload()`](#startUpload)
 *  function to perform the actual upload. The upload either succeeds and
 *  gives you an [`UploadedFile`](#UploadedFile) object, or fails and gives you
 *  an [`UploadError`](#UploadError) object.</p>
 * @snippet [UploadButton-startUpload_scenario.es6=Typical file upload scenario]
 *  This example uploads a file when the user clicks on a button. First it
 *  checks to see if the user has chosen a file. If a file was chosen, it
 *  triggers the upload and logs the status of the upload when it completes
 *  successfully or with an error.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.FileUploader
 * @definitionId wysiwyg.viewer.components.inputs.FileUploader
 * @tagname fileuploader
 */
var UploadButton = function (_FormElement) {
    _inherits(UploadButton, _FormElement);

    function UploadButton() {
        _classCallCheck(this, UploadButton);

        return _possibleConstructorReturn(this, (UploadButton.__proto__ || Object.getPrototypeOf(UploadButton)).apply(this, arguments));
    }

    _createClass(UploadButton, [{
        key: 'startUpload',


        /**
         * @function startUpload
         * @syntax
         * function startUpload(): Promise<UploadedFile>
         * @summary Uploads the files that the user has chosen.
         * @description
         *  The `startUpload()` function triggers the upload of the files in the
         *  upload button's [value](#value) property.
         *
         *  See how `startUpload()` is used in a
         *  [typical file upload scenario](#typical-scenario).
         *
         *  The upload button does not accept files that are larger than 25MB.
         * @returns {Promise}
         * @fulfill {$w.UploadButton~UploadedFile} Resolves when the file upload is completed.
         * @reject {$w.UploadButton~UploadError} Rejects if the file upload fails.
         * @snippet [UploadButton-startUpload.es6=Start a file upload]
         * @snippet [UploadButton-startUpload_scenario.es6=Full file upload scenario]
         *  This example uploads a file when the user clicks on a button. First it
         *  checks to see if the user has chosen a file. If a file was chosen, it
         *  triggers the upload and logs the status of the upload when it completes
         *  successfully or with an error.
         * @memberof $w.UploadButton
         */
        value: function startUpload() {
            var _this2 = this;

            var compId = members._compId.get(this);
            return new Promise(function (resolve, reject) {
                var callback = function callback(data, err) {
                    if (err) {
                        reject(err);
                    } else {
                        var uriUtils = _platformUtils2.default.getUriUtils();
                        if (data.media_type === 'picture') {
                            resolve({ url: uriUtils.generateWixCodeImageUri(data) });
                            return;
                        } else if (data.media_type === 'document') {
                            resolve({ url: uriUtils.generateWixCodeDocumentUri(data) });
                            return;
                        } else if (data.media_type === 'video') {
                            resolve({ url: uriUtils.generateWixCodeVideoUri(data) });
                            return;
                        }
                        resolve(data);
                    }
                };
                postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                    command: postMessage.MessageTypes.START_UPLOAD,
                    data: { compId: compId },
                    controllerId: members._controllerId.get(_this2),
                    callback: callback
                });
            });
        }

        /**
         * @function reset
         * @syntax
         * function reset(): void
         * @summary Clears the files that are pending upload.
         * @description
         *  The `value` of the upload button contains a list of files that have been
         *  selected to upload. The `reset()` function clears these files.
         * @snippet [UploadButton-reset.es6=Clears the files pending upload]
         * @memberof $w.UploadButton
         */

    }, {
        key: 'reset',
        value: function reset() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var value = [];
            var newState = _lodash2.default.defaults({ value: value, uploadStatus: 'NOT_STARTED', serverMessage: '' }, RMI.getState(compId));

            RMI.updateModel(_defineProperty({}, compId, { state: newState }));
            RMI.executeCompBehavior(compId, 'reset');
            (0, _validationsService.runValidationsAndSync)(RMI, compId, value); // must run validations after executing rest behavior so that viewer validations will be correct
            (0, _validationsService.hideValidityIndication)(RMI, compId);
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                buttonLabel = this.buttonLabel,
                fileType = this.fileType,
                startUpload = this.startUpload,
                reset = this.reset;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, buttonLabel: buttonLabel, fileType: fileType, startUpload: startUpload, reset: reset };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the upload button's styles.
         * @description
         *  The following styles can be used with upload buttons:
         *
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting an upload button's styles, gets or sets the styles of the
         *  upload button's regular state. It does not set the styles of the upload button's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.UploadButton
         * @readonly
         * @override
         */

    }, {
        key: 'buttonLabel',


        // PROPERTIES:

        /**
         * @member buttonLabel
         * @label property
         * @syntax
         * get buttonLabel(): string
         * set buttonLabel(value: string): void
         * @summary Sets or gets the label on the upload button.
         * @type {external:String}
         * @snippet [UploadButton-buttonLabel_get.es6=Get an upload button's label]
         * @snippet [UploadButton-buttonLabel_set.es6=Set an upload button's label]
         * @memberof $w.UploadButton
         * @instance
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);

            return compData && compData.buttonLabel;
        }

        /**
         * @member buttonLabel
         * @memberof $w.UploadButton
         * @param {external:String} label
         */
        ,
        set: function set(label) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'buttonLabel',
                dataToValidate: { buttonLabel: label },
                compName: this.id
            })) {
                return;
            }
            RMI.setData(compId, {
                buttonLabel: (0, _utils.emptyStringIfNil)(label)
            });
        }

        /**
         * @member fileType
         * @label property
         * @syntax
         * get fileType(): FileType
         * set fileType(value: FileType): void
         * type FileType = "Image" | "Document" | "Video"
         * @summary Sets or gets the type of file that a user can upload.
         * @description
         *  Setting the `fileType` property sets the type of file that
         *  a user can upload. The value of `fileType` can be set to either
         *  `"Image"`, `"Document"`, or `"Video"`.
         *
         *  Getting the `fileType` property returns the current type of
         *  file that a user can upload.
         *
         *  The file types of the images and documents that can be uploaded are
         *  listed [here](https://support.wix.com/en/article/supported-media-file-types-and-file-sizes).
         * @snippet [UploadButton-fileType_get.es6=Get an upload button's type]
         * @snippet [UploadButton-fileType_set.es6=Set an upload button's type]
         * @type {external:String}
         * @memberof $w.UploadButton
         */

    }, {
        key: 'fileType',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compProps = RMI.getProps(compId);

            return compProps && compProps.filesType;
        }

        /**
         * @member fileType
         * @memberof $w.UploadButton
         * @param {external:String} type
         */
        ,
        set: function set(type) {
            type = _lodash2.default.isString(type) ? _lodash2.default.startCase(type) : type;
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'fileType',
                dataToValidate: { filesType: type },
                shouldCheckMandatoryFields: true,
                compName: this.id
            })) {
                return;
            }
            RMI.setProps(compId, {
                filesType: type
            });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): File[]
         * @summary Returns a list of files that are pending upload.
         * @description
         *  Returns a list of [File](#File) objects that a user has selected to
         *  upload after pressing the upload button.
         *
         *  See how `value` is used in a
         *  [typical file upload scenario](#typical-scenario).
         * @snippet [UploadButton-value.es6=Get the files pending upload]
         * @snippet [UploadButton-startUpload_scenario.es6=Full file upload scenario]
         *  This example uploads a file when the user clicks on a button. First it
         *  checks to see if the user has chosen a file. If a file was chosen, it
         *  triggers the upload and logs the status of the upload when it completes
         *  successfully or with an error.
         * @type {$w.UploadButton~File[]}
         * @memberof $w.UploadButton
         * @readonly
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compState = RMI.getState(compId);

            return _lodash2.default.get(compState, 'value');
        }

        /**
         * @member value
         * @memberof $w.UploadButton
         * @param {$w.UploadButton~File[]} value
         * @override
         */
        ,
        set: function set(val) {
            // eslint-disable-line no-unused-vars
            var compType = members._type.get(this).compType;
            _reporter2.default.reportSdkError(_errors.generateError.error_only_getter({
                propertyName: 'value',
                compType: compType
            }));
        }
    }]);

    return UploadButton;
}(_FormElement3.default);

(0, _mixin2.default)(UploadButton.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(UploadButton.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(UploadButton.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(UploadButton.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(UploadButton.prototype, _RequiredMixin2.default.prototype);

(0, _livePreview.setStageUnfriendlyFunctions)(UploadButton, 'startUpload');
exports.default = UploadButton;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getImageData(event) {
    var image = void 0;

    try {
        if (_lodash2.default.get(event, 'item')) {
            image = _imageUtils2.default.dataFormat.toUser(event.item);
        }
    } catch (e) {/*do nothing*/
    }

    return image;
}

/**
 * @callback $w.GalleryItemChangedEventHandler
 * @summary Handles events fired when a gallery moves to a new image.
 * @param {$w.GalleryItemChangedEvent} event The event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class GalleryItemChangedEvent
 * @summary Event that is fired when a gallery moves to a new image.
 * @memberof $w
 * @mixes $w.Event
 */

var GalleryItemChangedEvent = function (_WixEvent) {
    _inherits(GalleryItemChangedEvent, _WixEvent);

    function GalleryItemChangedEvent(target, event) {
        _classCallCheck(this, GalleryItemChangedEvent);

        var _this = _possibleConstructorReturn(this, (GalleryItemChangedEvent.__proto__ || Object.getPrototypeOf(GalleryItemChangedEvent)).call(this, target, event));

        _this.item = getImageData(event);
        _this.itemIndex = event.imageIndex;

        return _this;
    }

    /**
     * @member item
     * @label property
     * @syntax
     * get item(): ImageItem | VideoItem
     * @summary Gets the gallery item.
     * @snippet [GalleryEvent-item.es6=Get the event's item]
     * @type {$w.Gallery~ImageItem|$w.Gallery~VideoItem}
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */

    /**
     * @member itemIndex
     * @label property
     * @syntax
     * get itemIndex(): Number
     * @summary Gets the gallery item's index.
     * @type {external:Number}
     * @snippet [GalleryEvent-itemIndex.es6=Get the event's item index]
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */


    return GalleryItemChangedEvent;
}(_WixEvent3.default);

exports.default = GalleryItemChangedEvent;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixBaseEvent = function WixBaseEvent(event) {
    _classCallCheck(this, WixBaseEvent);

    this.type = _lodash2.default.get(event, 'action') || _lodash2.default.get(event, 'type');
    this.context = _lodash2.default.get(event, 'context');
};

exports.default = WixBaseEvent;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateControllerData = updateControllerData;
exports.handleNativeEvent = handleNativeEvent;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _postMessage = __webpack_require__(15);

var pm = _interopRequireWildcard(_postMessage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var extractSerializable = function extractSerializable(obj) {
    return _lodash2.default.omitBy(obj, function (e) {
        return _lodash2.default.isFunction(e);
    });
};
var extractEvents = function extractEvents(obj) {
    return _lodash2.default.pickBy(obj, function (e) {
        return _lodash2.default.isFunction(e);
    });
};

function setComponentProps(_ref) {
    var controllerId = _ref.controllerId,
        appDefinitionId = _ref.appDefinitionId,
        props = _ref.props;

    pm.sendMessageToHost(pm.Intent.WIX_CODE_SITE_API, {
        command: pm.MessageTypes.SET_TPA_NATIVE_COMPONENT_PROPS,
        appDefinitionId: appDefinitionId,
        data: {
            props: props,
            controllerId: controllerId
        }
    });
}

function dataPartition(obj) {
    // first level
    var events = extractEvents(obj);
    var serialized = extractSerializable(obj);
    // second level
    _lodash2.default.forEach(serialized, function (val, key) {
        if (_lodash2.default.isObject(val) && !_lodash2.default.isArray(val)) {
            _lodash2.default.assign(events, _lodash2.default.mapKeys(extractEvents(val), function (v, k) {
                return key + "." + k;
            }));
            _lodash2.default.assign(serialized, _defineProperty({}, key, extractSerializable(val)));
        } else {
            _lodash2.default.assign(serialized, _defineProperty({}, key, val));
        }
    });
    return { serializedData: serialized, events: events };
}

function updateControllerData(contextId, currentRMI, controllerDataQuery, data) {
    var scopedRMI = currentRMI.getScopedRMI(controllerDataQuery);
    var controllerId = scopedRMI.getCompIdByDataQuery(controllerDataQuery);

    var _dataPartition = dataPartition(data),
        serializedData = _dataPartition.serializedData,
        events = _dataPartition.events;

    var eventsInfo = _lodash2.default.mapValues(events, function (callback, eventName) {
        var callbackId = scopedRMI.registerEventCallback({
            callback: callback,
            overrideCallbackId: controllerId + "-" + eventName
        });
        return { callbackId: callbackId, contextId: contextId };
    });
    setComponentProps({
        controllerId: controllerId,
        appDefinitionId: scopedRMI.getAppDefinitionId(),
        props: {
            wixCodeProps: serializedData,
            events: eventsInfo
        }
    });
}

function handleNativeEvent(RMI, _ref2) {
    var callbackId = _ref2.callbackId,
        eventArgs = _ref2.eventArgs;

    var eventHandler = RMI.getCallbackById(callbackId);
    if (_lodash2.default.isFunction(eventHandler)) {
        eventHandler.apply(undefined, _toConsumableArray(eventArgs));
    }
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VALIDITY_KEYS = exports.addErrorToValidateDataAndKeepMessage = exports.validators = exports.extendGetValidatorByType = exports.addCustomValidityToValidateData = exports.validateValue = exports.getCustomValidity = undefined;

var _validity, _INVALID_MESSAGES, _ELEMENT_TYPES$TEXT_I, _ELEMENT_TYPE_TO_VALI, _validatorByType;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VALIDITY_KEYS = {
    BAD_INPUT: 'badInput',
    CUSTOM_ERROR: 'customError',
    FILE_NOT_UPLOADED: 'fileNotUploaded',
    PATTERN_MISMATCH: 'patternMismatch',
    RANGE_OVERFLOW: 'rangeOverflow',
    RANGE_UNDERFLOW: 'rangeUnderflow',
    STEP_MISMATCH: 'stepMismatch',
    TOO_LONG: 'tooLong',
    TOO_SHORT: 'tooShort',
    TYPE_MISMATCH: 'typeMismatch',
    VALID: 'valid',
    VALUE_MISSING: 'valueMissing'
};
var INITIAL_VALIDATE_DATA = {
    validity: (_validity = {}, _defineProperty(_validity, VALIDITY_KEYS.BAD_INPUT, false), _defineProperty(_validity, VALIDITY_KEYS.CUSTOM_ERROR, false), _defineProperty(_validity, VALIDITY_KEYS.FILE_NOT_UPLOADED, false), _defineProperty(_validity, VALIDITY_KEYS.PATTERN_MISMATCH, false), _defineProperty(_validity, VALIDITY_KEYS.RANGE_OVERFLOW, false), _defineProperty(_validity, VALIDITY_KEYS.RANGE_UNDERFLOW, false), _defineProperty(_validity, VALIDITY_KEYS.STEP_MISMATCH, false), _defineProperty(_validity, VALIDITY_KEYS.TOO_LONG, false), _defineProperty(_validity, VALIDITY_KEYS.TOO_SHORT, false), _defineProperty(_validity, VALIDITY_KEYS.TYPE_MISMATCH, false), _defineProperty(_validity, VALIDITY_KEYS.VALID, true), _defineProperty(_validity, VALIDITY_KEYS.VALUE_MISSING, false), _validity),
    validationMessage: ''
};
var INVALID_MESSAGES = (_INVALID_MESSAGES = {}, _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.VALUE_MISSING, 'value missing'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.PATTERN_MISMATCH, 'pattern mismatch'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.RANGE_OVERFLOW, 'range overflow'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.RANGE_UNDERFLOW, 'range underflow'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.STEP_MISMATCH, 'step mismatch'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.TYPE_MISMATCH, 'type mismatch'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.FILE_NOT_UPLOADED, 'file not uploaded'), _INVALID_MESSAGES);
var VALIDATORS_TYPES = {
    'TEXT_INPUT_TEXT': 'TEXT_INPUT_TEXT',
    'TEXT_INPUT_PASSWORD': 'TEXT_INPUT_PASSWORD',
    'TEXT_INPUT_NUMBER': 'TEXT_INPUT_NUMBER',
    'TEXT_INPUT_EMAIL': 'TEXT_INPUT_EMAIL',
    'TEXT_INPUT_URL': 'TEXT_INPUT_URL',
    'TEXT_INPUT_TEL': 'TEXT_INPUT_TEL',
    'TEXT_AREA': 'TEXT_AREA',
    'SELECT_INPUT': 'SELECT_INPUT',
    'RADIO_GROUP': 'RADIO_GROUP',
    'CHECKBOX_GROUP': 'CHECKBOX_GROUP',
    'CHECKBOX': 'CHECKBOX',
    'DATE_PICKER': 'DATE_PICKER',
    'FILE_UPLOADER': 'FILE_UPLOADER'
};
var ELEMENT_TYPES = {
    TEXT_INPUT: 'TextInput',
    TEXT_AREA: 'TextAreaInput',
    SELECT_INPUT: 'SelectableList',
    RADIO_GROUP: 'RadioGroup',
    CHECKBOX_GROUP: 'CheckboxGroup',
    CHECKBOX: 'CheckboxInput',
    DATE_PICKER: 'DatePicker',
    FILE_UPLOADER: 'FileUploader'
};
var TEXT_INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password',
    NUMBER: 'number',
    EMAIL: 'email',
    URL: 'url',
    TEL: 'tel'
};
var ELEMENT_TYPE_TO_VALIDATOR_TYPE = (_ELEMENT_TYPE_TO_VALI = {}, _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.TEXT_INPUT, (_ELEMENT_TYPES$TEXT_I = {}, _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEXT, VALIDATORS_TYPES.TEXT_INPUT_TEXT), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.PASSWORD, VALIDATORS_TYPES.TEXT_INPUT_PASSWORD), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.NUMBER, VALIDATORS_TYPES.TEXT_INPUT_NUMBER), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.EMAIL, VALIDATORS_TYPES.TEXT_INPUT_EMAIL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.URL, VALIDATORS_TYPES.TEXT_INPUT_URL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEL, VALIDATORS_TYPES.TEXT_INPUT_TEL), _ELEMENT_TYPES$TEXT_I)), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.TEXT_AREA, VALIDATORS_TYPES.TEXT_AREA), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.SELECT_INPUT, VALIDATORS_TYPES.SELECT_INPUT), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.RADIO_GROUP, VALIDATORS_TYPES.RADIO_GROUP), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.CHECKBOX_GROUP, VALIDATORS_TYPES.CHECKBOX_GROUP), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.CHECKBOX, VALIDATORS_TYPES.CHECKBOX), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.DATE_PICKER, VALIDATORS_TYPES.DATE_PICKER), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.FILE_UPLOADER, VALIDATORS_TYPES.FILE_UPLOADER), _ELEMENT_TYPE_TO_VALI);
var UPLOAD_STATUSES = {
    NOT_STARTED: 'NOT_STARTED',
    STARTED: 'STARTED',
    FAILED: 'FAILED',
    DONE: 'DONE'
};

var getValidationMessage = function getValidationMessage(validityKey) {
    return INVALID_MESSAGES[validityKey];
};
var addErrorToValidateData = function addErrorToValidateData(validateData, validityKey, validationMessage) {
    var _$defaults;

    return {
        validity: _lodash2.default.defaults((_$defaults = {}, _defineProperty(_$defaults, validityKey, true), _defineProperty(_$defaults, VALIDITY_KEYS.VALID, false), _$defaults), validateData.validity),
        validationMessage: validationMessage
    };
};

var addCustomValidityToValidateData = function addCustomValidityToValidateData(validateData, validationMessage) {
    return addErrorToValidateData(validateData, VALIDITY_KEYS.CUSTOM_ERROR, validationMessage || '');
};

var addErrorToValidateDataAndKeepMessage = function addErrorToValidateDataAndKeepMessage(validateData, validityKey, validationMessage) {
    var newValidationMessage = validateData.validationMessage || validationMessage || getValidationMessage(validityKey);

    return addErrorToValidateData(validateData, validityKey, newValidationMessage);
};

var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var validUrlRegExp = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;

var isValidEmail = function isValidEmail(value) {
    return emailRegExp.test(value);
};
var isValidUrl = function isValidUrl(value) {
    return validUrlRegExp.test(value);
};
var getUploadStatus = function getUploadStatus(compState) {
    return _lodash2.default.get(compState, 'uploadStatus', UPLOAD_STATUSES.NOT_STARTED);
};
var isUploaded = function isUploaded(compState) {
    return getUploadStatus(compState) === UPLOAD_STATUSES.DONE;
};
var getFileMissingMessage = function getFileMissingMessage(compState) {
    if (getUploadStatus(compState) === UPLOAD_STATUSES.FAILED) {
        return _lodash2.default.get(compState, 'serverMessage', INVALID_MESSAGES[VALIDITY_KEYS.FILE_NOT_UPLOADED]);
    }

    return INVALID_MESSAGES[VALIDITY_KEYS.FILE_NOT_UPLOADED];
};

var validateRequired = function validateRequired(value, compData, compProps) {
    return function (validateData) {
        var isRequired = _lodash2.default.get(compProps, 'required', false);

        if (!isRequired || value) {
            return validateData;
        }

        return addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.VALUE_MISSING);
    };
};
var validateArrValueRequired = function validateArrValueRequired(value, compData, compProps) {
    return function (validateData) {
        var isRequired = _lodash2.default.get(compProps, 'required', false);

        if (!isRequired || !_lodash2.default.isEmpty(value)) {
            return validateData;
        }

        return addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.VALUE_MISSING);
    };
};
var validatePattern = function validatePattern(value, compData) {
    return function (validateData) {
        var pattern = _lodash2.default.get(compData, 'pattern');

        if (!pattern || _lodash2.default.isEmpty(value)) {
            return validateData;
        }

        // according to w3 spec: https://www.w3.org/TR/html5/forms.html#compiled-pattern-regular-expression
        var regExp = new RegExp('^(?:' + pattern + ')$');

        return regExp.test(value) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.PATTERN_MISMATCH);
    };
};
var validateRangeOverflow = function validateRangeOverflow(value, compData) {
    return function (validateData) {
        var max = _lodash2.default.get(compData, 'max');

        if (!_lodash2.default.isFinite(max) || _lodash2.default.isEmpty(value)) {
            return validateData;
        }

        return _lodash2.default.toFinite(value) <= max ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.RANGE_OVERFLOW);
    };
};
var validateRangeUnderflow = function validateRangeUnderflow(value, compData) {
    return function (validateData) {
        var min = _lodash2.default.get(compData, 'min');

        if (!_lodash2.default.isFinite(min) || _lodash2.default.isEmpty(value)) {
            return validateData;
        }

        return _lodash2.default.toFinite(value) >= min ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.RANGE_UNDERFLOW);
    };
};
var DEFAULT_STEP = 1;
var validateStepMismatch = function validateStepMismatch(value) {
    return function (validateData) {
        if (_lodash2.default.isEmpty(value)) {
            return validateData;
        }

        return _lodash2.default.toFinite(value) % DEFAULT_STEP === 0 ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.STEP_MISMATCH);
    };
};
var validateEmail = function validateEmail(value) {
    return function (validateData) {
        if (_lodash2.default.isEmpty(value)) {
            return validateData;
        }

        return isValidEmail(value) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.TYPE_MISMATCH);
    };
};
var validateUrl = function validateUrl(value) {
    return function (validateData) {
        if (_lodash2.default.isEmpty(value)) {
            return validateData;
        }

        return isValidUrl(value) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.TYPE_MISMATCH);
    };
};

var validateUploadStatus = function validateUploadStatus(value, compProps, compState) {
    return function (validateData) {
        var isRequired = _lodash2.default.get(compProps, 'required', false);
        var isAlreadyInvalid = !validateData.validity[VALIDITY_KEYS.VALID];

        if (!isRequired || !compState || isAlreadyInvalid) {
            return validateData;
        }

        return isUploaded(compState) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.FILE_NOT_UPLOADED, getFileMissingMessage(compState));
    };
};

var validatorByType = (_validatorByType = {}, _defineProperty(_validatorByType, VALIDATORS_TYPES.TEXT_INPUT_TEXT, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps), validatePattern(value, compData)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.TEXT_INPUT_PASSWORD, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps), validatePattern(value, compData)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.TEXT_INPUT_NUMBER, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps), validateRangeUnderflow(value, compData), validateRangeOverflow(value, compData), validateStepMismatch(value)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.TEXT_INPUT_EMAIL, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps), validateEmail(value), validatePattern(value, compData)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.TEXT_INPUT_URL, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps), validateUrl(value), validatePattern(value, compData)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.TEXT_INPUT_TEL, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps), validatePattern(value, compData)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.TEXT_AREA, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.SELECT_INPUT, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.RADIO_GROUP, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.CHECKBOX, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.CHECKBOX_GROUP, function (value, compData, compProps) {
    return _lodash2.default.flow([validateArrValueRequired(value, compData, compProps)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.DATE_PICKER, function (value, compData, compProps) {
    return _lodash2.default.flow([validateRequired(value, compData, compProps)]);
}), _defineProperty(_validatorByType, VALIDATORS_TYPES.FILE_UPLOADER, function (value, compData, compProps, compState) {
    return _lodash2.default.flow([validateArrValueRequired(value, compData, compProps), validateUploadStatus(value, compProps, compState)]);
}), _validatorByType);

var getValidatorByType = function getValidatorByType(validatorType, value, compData, compProps, compState) {
    var validatorByTypeFunc = validatorByType[validatorType];
    if (validatorByTypeFunc) {
        return validatorByTypeFunc(value, compData, compProps, compState);
    }
    return function (validateData) {
        return validateData;
    };
};

function extendGetValidatorByType(elementType, validatorsType, getValidatorByType) {
    if (validatorByType[validatorsType] || ELEMENT_TYPE_TO_VALIDATOR_TYPE[elementType] || VALIDATORS_TYPES[validatorsType]) {
        return false;
    }

    validatorByType[validatorsType] = getValidatorByType;
    VALIDATORS_TYPES[validatorsType] = validatorsType;
    ELEMENT_TYPE_TO_VALIDATOR_TYPE[elementType] = validatorsType;
    return true;
}

var getValidator = function getValidator(value, compData, compProps, compState) {
    var elementType = compData.type;

    if (elementType === ELEMENT_TYPES.TEXT_INPUT) {
        elementType += '.' + compData.textType;
    }

    var validatorType = _lodash2.default.get(ELEMENT_TYPE_TO_VALIDATOR_TYPE, elementType);

    return getValidatorByType(validatorType, value, compData, compProps, compState);
};

var validateValue = function validateValue(value, compData, compProps, compState) {
    var validator = getValidator(value, compData, compProps, compState);

    return validator(INITIAL_VALIDATE_DATA);
};

var getCustomValidity = function getCustomValidity(validateData) {
    var hasCustomError = _lodash2.default.get(validateData, 'validity.customError', false);

    return hasCustomError ? validateData.validationMessage : '';
};

var validators = {
    validateRequired: validateRequired,
    validatePattern: validatePattern,
    validateRangeUnderflow: validateRangeUnderflow,
    validateRangeOverflow: validateRangeOverflow,
    validateStepMismatch: validateStepMismatch,
    validateEmail: validateEmail,
    validateUrl: validateUrl
};

exports.getCustomValidity = getCustomValidity;
exports.validateValue = validateValue;
exports.addCustomValidityToValidateData = addCustomValidityToValidateData;
exports.extendGetValidatorByType = extendGetValidatorByType;
exports.validators = validators;
exports.addErrorToValidateDataAndKeepMessage = addErrorToValidateDataAndKeepMessage;
exports.VALIDITY_KEYS = VALIDITY_KEYS;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildFullUrlFromMediaRef(mediaRef) {
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    var mediaItemUri = mediaSrcHandler.createMediaSrc({ mediaId: mediaRef.videoId, type: mediaSrcHandler.types.VIDEO, title: mediaRef.fileName, width: mediaRef.posterImageRef.width, height: mediaRef.posterImageRef.height, posterId: mediaRef.posterImageRef.uri });
    if (mediaItemUri.error) {
        return null;
    }
    return mediaItemUri.item;
}

function extractModelDataFromSrc(src) {
    var backgroundUtils = _platformUtils2.default.getBackgroundUtils();
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    var parseMediaItem = mediaSrcHandler.parseMediaSrc(src, mediaSrcHandler.types.VIDEO);
    if (parseMediaItem.error) {
        return null;
    }

    return _lodash2.default.assign(backgroundUtils.getVideoPosterObject(parseMediaItem.mediaId, parseMediaItem.posterId, parseMediaItem.width, parseMediaItem.height), { fileName: parseMediaItem.title });
}

function getVideoId(videoId) {
    return videoId.replace('video/', '');
}

function isVideoUrl(src) {
    var mediaSrcHandler = _platformUtils2.default.getMediaSrcHandler();
    return mediaSrcHandler.isValidMediaSrc(src, mediaSrcHandler.types.VIDEO);
}

function getFullVideoData(videoId, callback) {
    videoId = getVideoId(videoId);
    var VIDEO_INFO_END_POINT = 'https://files.wix.com/files/' + videoId + '/info';
    fetch(VIDEO_INFO_END_POINT).then(function (response) {
        return response.json();
    }).then(function (response) {
        var backgroundUtils = _platformUtils2.default.getBackgroundUtils();
        var fullVideoMediaRef = backgroundUtils.getVideoBackgroundObject(response, {});
        callback(fullVideoMediaRef);
    });
}

exports.default = {
    buildFullUrlFromMediaRef: buildFullUrlFromMediaRef,
    isVideoUrl: isVideoUrl,
    extractModelDataFromSrc: extractModelDataFromSrc,
    getFullVideoData: getFullVideoData
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extendCompSchema = exports.getSchemaOfComp = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _gridEnums = __webpack_require__(49);

var _gridEnums2 = _interopRequireDefault(_gridEnums);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import reporter from '../reporter';
// import {generateError} from './errors';

var GALLERY_SCHEMA = {
    galleryImageOnClickAction: {
        schemaType: ['string'],
        enum: ['none', 'expand', 'link'],
        warnIfNil: true,
        acceptNil: true,
        validations: {
            type: true
        }
    },
    showNavigation: {
        schemaType: ['boolean'],
        validations: {
            type: true
        }
    },
    arrowMode: {
        schemaType: ['boolean'],
        validations: {
            type: true
        }
    },
    onChange: {
        schemaType: ['function'],
        validations: {
            type: true
        }
    },
    onItemClicked: {
        schemaType: ['function'],
        validations: {
            type: true
        }
    },
    items: {
        schemaType: ['array'],
        acceptNil: true,
        warnIfNil: true,
        validations: {
            type: true
        }
    },
    compExtensions: ['viewportMixin', 'element', 'clickableMixin', 'playableMixin']
};
var compDataSchemas = {
    Image: {
        src: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            mandatory: true,
            validations: {
                type: true
            }
        },
        description: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        title: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        alt: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        tooltip: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        id: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        width: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        height: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        clickAction: {
            schemaType: ['string'],
            enum: ['none', 'link', 'expand', 'magnified'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element', 'clickableMixin', 'linkableMixin']
    },
    Gallery: GALLERY_SCHEMA,
    ProGallery: GALLERY_SCHEMA,
    GoogleMap: {
        latitude: {
            schemaType: ['number'],
            maxVal: 90,
            minVal: -90,
            mandatory: true,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        longitude: {
            schemaType: ['number'],
            maxVal: 180,
            minVal: -180,
            mandatory: true,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        description: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    Box: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Button: {
        compExtensions: ['linkableMixin', 'clickableMixin', 'viewportMixin', 'element', 'labelMixin']
    },
    Lightbox: {
        name: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        }
    },
    modal: {
        url: {
            schemaType: ['url'],
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            },
            width: {
                schemaType: ['number'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            height: {
                schemaType: ['number'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            theme: {
                schemaType: ['string'],
                enum: ['DEFAULT', 'BARE'],
                acceptNil: true,
                validations: {
                    type: true
                }
            }
        }
    },

    popup: {
        url: {
            schemaType: ['url'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            },
            width: {
                schemaType: ['number', 'string'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            height: {
                schemaType: ['number', 'string'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            position: {
                schemaType: ['object'],
                mandatory: true,
                validations: {
                    type: true
                },
                origin: {
                    schemaType: ['string'],
                    enum: ['FIXED', 'RELATIVE', 'ABSOLUTE'],
                    mandatory: true,
                    validations: {
                        type: true
                    }
                },
                placement: {
                    schemaType: ['string'],
                    enum: ['TOP_LEFT', 'TOP_CENTER', 'TOP_RIGHT', 'CENTER_LEFT', 'CENTER', 'CENTER_RIGHT', 'BOTTOM_LEFT', 'BOTTOM_CENTER', 'BOTTOM_RIGHT', 'CENTER'],
                    acceptNil: true,
                    validations: {
                        type: true
                    }
                }

            },
            theme: {
                schemaType: ['string'],
                enum: ['DEFAULT', 'BARE'],
                acceptNil: true,
                validations: {
                    type: true
                }
            }
        }
    },

    sectionUrl: {
        sectionId: {
            schemaType: ['string'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },

    sectionIdentifier: {
        sectionIdentifier: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        sectionId: {
            schemaType: ['string'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        appDefinitionId: {
            schemaType: ['string'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },

    trackEvent: {
        eventName: {
            schemaType: ['string'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        data: {
            schemaType: ['object'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    Slideshow: {
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        showNavigationButtons: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        showSlideButtons: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        compExtensions: ['playableMixin', 'clickableMixin', 'viewportMixin', 'element'],
        slideInfo: {
            schemaType: ['object', 'integer'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    MultiStateBox: {
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        compExtensions: ['clickableMixin', 'viewportMixin', 'element'],
        stateInfo: {
            schemaType: ['object', 'string'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    Checkbox: {
        label: {
            schemaType: ['string'],
            acceptNil: true,
            maxLength: 400,
            minLength: 0,
            validations: {
                type: true,
                length: true
            }
        },
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin', 'checkedMixin']
    },
    Column: {
        compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    ColumnStrip: {
        compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    DatePicker: {
        value: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        maxDate: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        minDate: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        disabledDates: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'disableDate'
        },
        disableDate: {
            schemaType: ['date'],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        disabledDaysOfWeek: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'disableDayOfWeek'

        },
        disableDayOfWeek: {
            schemaType: ['number'],
            enum: [0, 1, 2, 3, 4, 5, 6],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin', 'readOnlyMixin']
    },
    Video: {
        videoUrl: {
            schemaType: ['url'],
            validationExpressions: 'validateVideoUrlFormats',
            validations: {
                type: true,
                regex: true
            }
        },
        compExtensions: ['element', 'viewportMixin']
    },
    Dropdown: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'selectOption'
        },
        selectOption: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            value: {
                acceptNil: true,
                schemaType: ['string'],
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                acceptNil: true,
                schemaType: ['string'],
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        placeholder: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        selectedIndex: {
            acceptNil: true,
            schemaType: ['integer'],
            validations: {
                type: true
            }
        }
    },
    RadioButtonGroup: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'RadioButton'
        },
        RadioButton: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            value: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        selectedIndex: {
            schemaType: ['integer'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    CheckboxGroup: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'Checkbox'
        },
        CheckboxInput: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            checked: {
                schemaType: ['boolean'],
                acceptNil: true,
                validations: {
                    type: true
                }
            },
            value: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        value: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        selectedIndices: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    UploadButton: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin'],
        filesSizeLimit: {
            schemaType: ['number'],
            maxVal: 15,
            minVal: 1,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        buttonLabel: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }

        },
        filesType: {
            schemaType: ['string'],
            enum: ['Image', 'Document', 'Video'],
            validations: {
                type: true
            }
        }
    },
    Footer: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Header: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Page: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    HoverBox: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'backgroundMixin']
    },
    Shape: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'linkableMixin']
    },
    Slide: {
        compExtensions: ['viewportMixin', 'element', 'backgroundMixin']
    },
    State: {
        compExtensions: ['viewportMixin', 'element', 'backgroundMixin']
    },
    Text: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element'],
        text: {
            schemaType: ['string'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        },
        html: {
            schemaType: ['string'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    TextBox: {
        compExtensions: ['clickableMixin', 'requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin', 'textInputMixin', 'readOnlyMixin'],
        wrap: {
            schemaType: ['string'],
            enum: ['hard', 'soft'],
            validations: {
                type: true
            }
        }
    },
    TextInput: {
        compExtensions: ['clickableMixin', 'requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin', 'textInputMixin', 'readOnlyMixin'],
        min: {
            schemaType: ['number'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        max: {
            schemaType: ['number'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        inputType: {
            schemaType: ['string'],
            enum: ['text', 'email', 'number', 'password', 'tel', 'url'],
            validations: {
                type: true
            }
        }
    },
    HtmlComponent: {
        compExtensions: ['viewportMixin', 'element'],
        url: {
            schemaType: ['url'],
            validations: {
                type: true
            }
        },
        message: {
            schemaType: ['object', 'string', 'number', 'boolean', 'array'],
            validations: {
                type: true
            }
        },
        onMessage: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        scrolling: {
            schemaType: ['string'],
            enum: ['no', 'yes', 'auto'],
            validations: {
                type: true
            }
        }
    },
    Repeater: {
        data: {
            schemaType: ['array'],
            validations: {
                type: true
            }
        },
        callback: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        _id: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        ids: {
            schemaType: ['array'],
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    Container: {
        compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    Table: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element'],
        onRowSelect: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        dataFetcherCallback: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onCellSelect: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        rowIndex: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        rows: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        row: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        columns: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        column: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            id: {
                schemaType: ['string'],
                mandatory: true,
                validations: {
                    type: true
                }
            }
        },
        sorting: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        filter: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        pagination: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            type: {
                schemaType: ['string'],
                mandatory: true,
                enum: _lodash2.default.map(_gridEnums2.default.PaginationType),
                validations: {
                    type: true
                }
            },
            rowsPerPage: {
                schemaType: ['number'],
                validations: {
                    type: true
                }
            }
        }
    },
    Window: {
        x: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        y: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        payload: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        target: {
            schemaType: ['string'],
            enum: ['parent'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        appDefinitionId: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        }
    },
    Document: {
        url: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    Location: {
        url: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        linkData: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        callback: {
            schemaType: ['function'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    Site: {
        appDefinitionId: {
            schemaType: ['string'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        eventData: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    VectorImage: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'linkableMixin']
    },
    VerticalMenu: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    AccountNavBar: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        navBarItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    MobileMenu: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        navBarItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    BasicMenuItem: {
        schemaType: ['object'],
        validations: {
            type: true
        },
        visibleOnDesktop: {
            schemaType: ['boolean'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        visibleOnMobile: {
            schemaType: ['boolean'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        icon: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        label: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        displayCount: {
            schemaType: ['number'],
            acceptNil: true,
            warnIfNil: false,
            validations: {
                type: true
            }
        },
        items: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'BasicMenuItem'
        }
    },
    QuickActionBar: {
        showLabels: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        alignment: {
            schemaType: ['string'],
            enum: ['left', 'right'],
            validations: {
                type: true
            }
        },
        colorScheme: {
            schemaType: ['string'],
            enum: ['brand', 'grey', 'black'],
            validations: {
                type: true
            }
        },
        invertColorScheme: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        onItemClicked: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    }
};

var compExtensions = {
    viewportMixin: {
        onViewportLeave: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onViewportEnter: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    linkableMixin: {
        link: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        target: {
            schemaType: ['string'],
            enum: ['_blank', '_self'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    clickableMixin: {
        onClick: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onDblClick: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    playableMixin: {
        onPause: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onPlay: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    readOnlyMixin: {
        readonly: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        }
    },
    requiredMixin: {
        required: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        }
    },
    textInputMixin: {
        placeholder: {
            schemaType: ['string'],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        maxlength: {
            schemaType: ['integer'],
            minVal: 0,
            acceptNil: true,
            validations: {
                type: true,
                minimum: true
            }
        },
        onKeyPress: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    backgroundMixin: {
        src: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    focusMixin: {
        onFocus: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onBlur: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    element: {
        onMouseIn: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onMouseOut: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    formElement: {
        required: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        value: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    checkedMixin: {
        checked: {
            schemaType: ['boolean'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    labelMixin: {
        label: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    }
};

function getSchemaOfComp(compType) {
    var compDataSchema = _lodash2.default.clone(_lodash2.default.get(compDataSchemas, compType));
    if (!compDataSchema) {
        return;
    }
    var res = {};
    if (compDataSchema.compExtensions) {
        compDataSchema.compExtensions.forEach(function (mixinName) {
            var mixinSchema = compExtensions[mixinName];
            _lodash2.default.assign(res, mixinSchema);
        });
    }
    _lodash2.default.assign(res, compDataSchema);
    return res;
}

function extendCompSchema(type, schema) {
    if (compDataSchemas[type]) {
        // reporter.reportSdkError(generateError.error_compSchemaType_already_exists({type}));
        return false;
    }

    _lodash2.default.set(compDataSchemas, type, schema);
    return true;
}

exports.getSchemaOfComp = getSchemaOfComp;
exports.extendCompSchema = extendCompSchema;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LinkableMixin = __webpack_require__(36);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _LabelMixin = __webpack_require__(75);

var _LabelMixin2 = _interopRequireDefault(_LabelMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Button
 * @summary A text button or an icon button.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.LabelMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.SiteButton
 * @viewername wysiwyg.common.components.imagebutton.viewer.ImageButton
 * @definitionId wysiwyg.viewer.components.SiteButton
 * @definitionId wysiwyg.viewer.components.PopupCloseTextButton
 * @definitionId wysiwyg.viewer.components.PopupCloseIconButton
 * @definitionId wysiwyg.common.components.imagebutton.viewer.ImageButton
 * @definitionId wysiwyg.viewer.components.SiteButton
 * @tagname button
 */
var Button = function (_Element) {
  _inherits(Button, _Element);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'toJSON',
    value: function toJSON() {
      var id = this.id,
          type = this.type,
          global = this.global,
          rendered = this.rendered,
          label = this.label;

      return { id: id, type: type, global: global, rendered: rendered, label: label };
    }

    //DESCRIPTION OVERRIDES
    /**
     * @member style
     * @label property
     * @syntax
     * get style(): Style
     * @summary Gets an object containing information about the button's styles.
     * @description
     * The following styles can be used with buttons:
     *
     *  + [`backgroundColor`]($w.Style.html#backgroundColor)
     *  + [`borderColor`]($w.Style.html#borderColor)
     *  + [`borderRadius`]($w.Style.html#borderRadius)
     *  + [`borderWidth`]($w.Style.html#borderWidth)
     *  + [`color`]($w.Style.html#color)
     *
     *
     *  Getting or setting a button's styles, gets or sets the styles of the
     *  button's regular state. It does not set the styles of the button's hover
     *  or disabled states.
     * @note
     *  Not all styles can be used on all button designs. To determine which styles
     *  work with a specific button design, go to the **Button Design** panel in
     *  the Editor, choose a design, and click **Customize Design**. The design
     *  options that you see in the **Button Design** panel for your particular
     *  button are the styles you can use in your code.
     * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
     * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
     * @type {$w.Style}
     * @memberof $w.Button
     * @readonly
     * @override
     */

    /**
     * @member label
     * @label property
     * @syntax
     * get label(): string
     * set label(value: string): void
     * @summary Sets or gets the label of a text button.
     * @type {external:String}
     * @snippet [Button-label_get.es6=Get a button's label]
     * @snippet [Button-label_set.es6=Set a button's label]
     * @default Empty string
     * @memberof $w.Button
     * @override
     */

    /**
     * @member label
     * @memberof $w.Button
     * @param {external:String} value
     */

  }]);

  return Button;
}(_Element3.default);

(0, _mixin2.default)(Button.prototype, _LinkableMixin2.default.prototype);
(0, _mixin2.default)(Button.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Button.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(Button.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Button.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(Button.prototype, _LabelMixin2.default.prototype);

exports.default = Button;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _validationsService = __webpack_require__(11);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin CheckedMixin
 * @description Provides functionality for elements that can be be checked.
 * @memberof $w
 */
var CheckedMixin = function () {
    function CheckedMixin() {
        _classCallCheck(this, CheckedMixin);
    }

    _createClass(CheckedMixin, [{
        key: 'checked',

        /**
         * @member checked
         * @label property
         * @syntax
         * get checked(): boolean
         * set checked(value: boolean): void
         * @summary Sets or gets whether the element is checked or not.
         * @type {external:Boolean}
         * @memberof $w.CheckedMixin
         * @instance
         */
        get: function get() {
            return Utils.getData(this, 'checked') || false;
        }

        /**
         * @member checked
         * @memberof $w.CheckedMixin
         * @param {external:Boolean} checked
         */
        ,
        set: function set(checked) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'checked',
                dataToValidate: { checked: checked },
                compName: this.id
            })) {
                return;
            }

            (0, _validationsService.runValidationsAfterChange)(RMI, compId, checked);
            if (_lodash2.default.isNil(checked)) {
                checked = false;
            }
            Utils.setData(this, { checked: checked });
        }
    }]);

    return CheckedMixin;
}();

exports.default = CheckedMixin;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _asyncDecorator = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function changeElementCollapsiblity(RMI, compId, isCollapsed, cb) {
    RMI.setProps(compId, { isCollapsed: isCollapsed }, cb);
}
/**
 * @mixin CollapsedMixin
 * @summary Provides functionality for elements that can be collapsed.
 *
 *  To learn about the behavior of a collapsed element,
 *  see the [`collapsed`](#collapsed) property.
 * @memberof $w
 */

var CollapsedMixin = function () {
    function CollapsedMixin() {
        _classCallCheck(this, CollapsedMixin);
    }

    _createClass(CollapsedMixin, [{
        key: 'collapse',


        /**
         * @function collapse
         * @syntax
         * function collapse(): Promise<void>
         * @summary Collapses the element and sets its `collapsed` property to `true`.
         * @description
         *  The `collapse()` function returns a Promise that is resolved when the
         *  element's [`collapsed`](#collapsed) property has been set to `true`.
         *
         *  To learn about the behavior of a collapsed element,
         *  see the [`collapsed`](#collapsed) property.
         *
         *  You can also collapse an element
         *  when the page loads by using the Properties panel in the Editor.
         * @returns {Promise}
         * @fulfill {void} When the element's `collapsed` property has been set to `true`.
         * @snippet [CollapsedMixin-collapse.es6=Collapse an element]
         * @snippet [CollapsedMixin-collapse_then.es6=Collapse an element and log a message when done]
         * @snippet [CollapsedMixin_toggle_collapsed.es6=Toggle an element's collapsed state]
         * @see [expand( )](#expand)
         * @see [collapsed](#collapsed)
         * @see [hide( )]($w.HiddenMixin.html#hide)
         * @memberof $w.CollapsedMixin
         */
        value: function collapse() {
            var _this = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this);
                var compId = members._compId.get(_this);

                if (!_this.collapsed) {
                    changeElementCollapsiblity(RMI, compId, true, resolve);
                } else {
                    resolve();
                }
            });
        }

        /**
         * @member collapsed
         * @label property
         * @syntax
         * get collapsed(): boolean
         * @summary Indicates if the element is collapsed or expanded.
         * @description
         *  If `collapsed` is `true`, the element is not displayed on the page under
         *  any circumstances. A collapsed element, unlike a
         *  [`hidden`]($w.HiddenMixin.html#hide) element, does not take up any
         *  space on the page. When collapsed, elements positioned within 70 pixels
         *  below the collapsed element and each other move up to take the
         *  collapsed element's place where possible. The elements that move up
         *  maintain their positions relative to one another.
         *
         *  If `collapsed` is `false`, the element _may_ be displayed on the page.
         *  Elements that moved up to take the collapsed element's place on the
         *  page are moved back down.
         *
         *  However, an expanded element (an element whose `collapsed` property is
         *  `false`) is still not displayed if:
         *
         *  + It is [hidden]($w.HiddenMixin.html#hidden).
         *  + Its [parent element]($w.Node.html#parent) is hidden or collapsed.
         *  + It is a slide in a [Slideshow]($w.Slideshow.html) which is
         *    currently not being displayed.
         *
         *
         *  Even if the element is not be displayed due to the conditions
         *  mentioned above, if its `collapsed` property is `false`, it's
         *  displayed when the conditions no longer apply.
         *
         *  To set the `collapsed` property on an element, use the element's
         *  [`collapse()`](#collapse) and [`expand()`](#expand) functions.
         *
         *  If you select **Collapsed on load** in the element's Properties panel
         *  in the Editor, the `collapsed` property is set to `true` when the page loads.
         * @snippet [CollapsedMixin-collapsed.es6=Get an element's collapsed status]
         * @snippet [CollapsedMixin_toggle_collapsed.es6=Toggle an element's collapsed state]
         * @type {external:Boolean}
         * @default false
         * @see [collapse( )](#collapse)
         * @see [expand( )](#expand)
         * @see [hide( )]($w.HiddenMixin.html#hide)
         * @see [show( )]($w.HiddenMixin.html#show)
         * @see [hidden]($w.HiddenMixin.html#hidden)
         * @memberof $w.CollapsedMixin
         * @attr {external:Boolean} collapsed
         * @readonly
         */

    }, {
        key: 'expand',


        /**
         * @function expand
         * @syntax
         * function expand(): Promise<void>
         * @summary Expands the element and sets its `collapsed` property to `false`.
         * @description
         *  The `expand()` function returns a Promise that is resolved when the
         *  element's [`collapsed`](#collapsed) property has been set to `false`.
         *
         *  To learn about the behavior of an expanded element,
         *  see the [`collapsed`](#collapsed) property.
         *
         * @returns {Promise}
         * @fulfill {void} When the element's `collapsed` property has been set to `false`.
         * @snippet [CollapsedMixin-expand.es6=Expand an element]
         * @snippet [CollapsedMixin-expand_then.es6=Expand an element and log a message when done]
         * @snippet [CollapsedMixin_toggle_collapsed.es6=Toggle an element's collapsed state]
         * @see [expand( )](#expand)
         * @see [collapsed](#collapsed)
         * @see [show( )]($w.HiddenMixin.html#show)
         * @memberof $w.CollapsedMixin
         */
        value: function expand() {
            var _this2 = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this2);
                var compId = members._compId.get(_this2);

                if (_this2.collapsed) {
                    changeElementCollapsiblity(RMI, compId, false, resolve);
                } else {
                    resolve();
                }
            });
        }
    }, {
        key: 'collapsed',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var props = RMI.getProps(compId);

            return Boolean(props && props.isCollapsed);
        }
    }]);

    return CollapsedMixin;
}();

(0, _asyncDecorator.setAsyncFunctions)(['expand', 'collapse']);

exports.default = CollapsedMixin;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _effectValidation = __webpack_require__(115);

var _effectValidation2 = _interopRequireDefault(_effectValidation);

var _constants = __webpack_require__(27);

var _asyncDecorator = __webpack_require__(29);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//TODO WEED-8265
// import _ from 'lodash';
// import * as postMessage from '../../privates/postMessage';

/**
 * @mixin HiddenMixin
 * @summary Provides functionality for elements that can be hidden.
 *
 *  To learn about the behavior of a hidden element,
 *  see the [`hidden`](#hidden) property.
 * @memberof $w
 */

function changeElementVisibility(RMI, compId, isHidden, cb) {
  RMI.setProps(compId, { isHidden: isHidden }, cb);
}

//TODO WEED-8265
// function resetAnimationAndChangeElementVisibility(RMI, compId, isHidden, cb) {
//     postMessage.sendMessage(
//         postMessage.Intent.WIX_CODE_SITE_API,
//         postMessage.MessageTypes.RESET_BEHAVIORS,
//         {compId},
//         changeElementVisibility.bind(null, RMI, compId, isHidden, cb)
//     );
// }
//
// function shouldOverrideEditorPresets(effectName, effectOptions) {
//     return isNil(effectName) && _.isEmpty(effectOptions);
// }

var HiddenMixin = function () {
  function HiddenMixin() {
    _classCallCheck(this, HiddenMixin);
  }

  _createClass(HiddenMixin, [{
    key: 'hide',


    /**
     * @function hide
     * @syntax
     * function hide([effectName: Effect], [effectOptions: EffectOptions]): Promise<void>
     * type Effect = "arc" | "bounce" | "fade" | "flip"
     * | "float" | "fly" | "fold" | "glide" | "puff"
     * | "roll" | "slide" | "spin" | "turn" | "zoom"
     * type EffectOptions = ArcEffectOptions | BounceEffectOptions
     * | FadeEffectOptions | FlipEffectOptions | FloatEffectOptions
     * | FlyEffectOptions | FoldEffectOptions | GlideEffectOptions
     * | PuffEffectOptions | RollEffectOptions | SlideEffectOptions
     * | SpinEffectOptions | TurnEffectOptions | ZoomEffectOptions
     * @summary Hides the element and sets its `hidden` property
     *  to `true`, using an effect if specified.
     * @description
     *  The `hide()` function hides the element and returns a Promise that is
     *  resolved when the effect is complete and the element's [`hidden`](#hidden)
     *  property has been set to `true`.
     *
     *  To learn about the behavior of a hidden element,
     *  see the [`hidden`](#hidden) property.
     *
     *  You can optionally apply an effect when hiding the element by providing
     *  an `effectName` value. You can also customize the effect by providing the
     *  optional `effectOptions` object.
     *
     *  Effects:
     *
     *  + [`"arc"`]($w.EffectOptions.html#ArcEffectOptions)
     *  + [`"bounce"`]($w.EffectOptions.html#BounceEffectOptions)
     *  + [`"fade"`]($w.EffectOptions.html#FadeEffectOptions)
     *  + [`"flip"`]($w.EffectOptions.html#FlipEffectOptions)
     *  + [`"float"`]($w.EffectOptions.html#FloatEffectOptions)
     *  + [`"fly"`]($w.EffectOptions.html#FlyEffectOptions)
     *  + [`"fold"`]($w.EffectOptions.html#FoldEffectOptions)
     *  + [`"glide"`]($w.EffectOptions.html#GlideEffectOptions)
     *  + [`"puff"`]($w.EffectOptions.html#PuffEffectOptions)
     *  + [`"roll"`]($w.EffectOptions.html#RollEffectOptions)
     *  + [`"slide"`]($w.EffectOptions.html#SlideEffectOptions)
     *  + [`"spin"`]($w.EffectOptions.html#SpinEffectOptions)
     *  + [`"turn"`]($w.EffectOptions.html#TurnEffectOptions)
     *  + [`"zoom"`]($w.EffectOptions.html#ZoomEffectOptions)
     *
     *
     *  You can also hide an element
     *  when the page loads by using the Properties panel in the Editor.
     * @param {external:String} [effectName] The name of the
     *  effect to play when hiding the item.
     * @param {$w.EffectOptions~ArcEffectOptions | $w.EffectOptions~BounceEffectOptions | $w.EffectOptions~FadeEffectOptions | $w.EffectOptions~FlipEffectOptions | $w.EffectOptions~FloatEffectOptions | $w.EffectOptions~FlyEffectOptions | $w.EffectOptions~FoldEffectOptions | $w.EffectOptions~GlideEffectOptions | $w.EffectOptions~PuffEffectOptions | $w.EffectOptions~RollEffectOptions | $w.EffectOptions~SlideEffectOptions | $w.EffectOptions~SpinEffectOptions | $w.EffectOptions~TurnEffectOptions | $w.EffectOptions~ZoomEffectOptions} [effectOptions] The effect's options.
     * @returns {Promise}
     * @fulfill {void} When the effect is complete and the element's `hidden` property has been set to `true`.
     * @see [show( )](#show)
     * @see [hidden](#hidden)
     * @see [collapse( )]($w.CollapsedMixin.html#collapse)
     * @snippet [HiddenMixin-hide.es6=Hide an element with no effect]
     * @snippet [HiddenMixin-hide_animation.es6=Hide an element with the "fade" effect]
     * @snippet [HiddenMixin-hide-FadeOptions.es6=Hide an element with an effect and log message when the effect is done]
     * @snippet [HiddenMixin-hide_then.es6=Hide an element with an effect and log message when the effect is done]
     * @snippet [HiddenMixin_toggle_hidden.es6=Toggle an element's hidden state]
     * @memberof $w.HiddenMixin
     */
    value: function hide(effectName, effectOptions) {
      var _this = this;

      return new Promise(function (resolve) {
        var RMI = members._RMI.get(_this);
        var compId = members._compId.get(_this);
        if (_this.hidden) {
          return resolve();
        }
        //TODO WEED-8265
        // if (shouldOverrideEditorPresets(effectName, effectOptions)) {
        //     return resetAnimationAndChangeElementVisibility(RMI, compId, true, resolve);
        // }

        //TODO WEED-8265 - for phase 1.1 only
        if (!effectName && _lodash2.default.isEmpty(effectOptions)) {
          return changeElementVisibility(RMI, compId, true, resolve);
        }
        var functionData = _constants.EFFECTS.HIDE;
        var isValid = _effectValidation2.default.validateEffect(effectName, effectOptions, 'hide', _this.id, functionData.deprecatedValues);
        if (!isValid) {
          return changeElementVisibility(RMI, compId, true, resolve);
        }

        var _effectValidation$bui = _effectValidation2.default.buildEffectObject(effectName, effectOptions, functionData),
            presetName = _effectValidation$bui.presetName,
            params = _effectValidation$bui.params;

        return RMI.executeAnimation(compId, presetName, params, changeElementVisibility.bind(null, RMI, compId, true, resolve));
      });
    }

    /**
     * @member hidden
     * @label property
     * @syntax
     * get hidden(): boolean
     * @summary Indicates if the element is visible or hidden.
     * @description
     *  If `hidden` is `true`, the element is not displayed on the page under
     *  any circumstances. A hidden element, unlike a
     *  [`collapsed`]($w.CollapsedMixin.html#collapsed) element, continues to
     *  take up the same space on the page as it did when it was visible.
     *
     *  If `hidden` is `false`, the element _may_ be displayed on the page.
     *
     *  However, an element whose `hidden` property is `false` is still not
     *  displayed if:
     *
     *  + It is [collapsed]($w.CollapsedMixin.html#collapsed).
     *  + Its [parent element]($w.Node.html#parent) is hidden or collapsed.
     *  + It is a slide in a [Slideshow]($w.Slideshow.html) which is
     *    currently not being displayed.
     *
     *
     *  Even if the element is not displayed due to the conditions
     *  mentioned above, if its `hidden` property is set to `false`, it's
     *  displayed when the conditions no longer apply.
     *
     *  To determine if the element is actually visible, use the
     *  [`isVisible`](#isVisible) property.
     *
     *  To set the `hidden` property on an element, use the element's
     *  [`hide()`](#hide) or [`show()`](#show) functions.
     *
     *  If you select **Hidden on load** in the element's Properties panel
     *  in the Editor, the `hidden` property is set to `true` when the page loads.
     *
     *  @note An element's `hidden` property is not the same as its
     *   [isVisible](#isVisible) property. The `hidden` property
     *   indicates whether the element _should_ be displayed, while `isVisible`
     *   indicates if it is actually displayed.
     * @snippet [HiddenMixin-hidden.es6=Get an element's hidden status]
     * @snippet [HiddenMixin_toggle_hidden.es6=Toggle an element's hidden state]
     * @type {external:Boolean}
     * @default false
     * @see [hide( )](#hide)
     * @see [show( )](#show)
     * @see [collapse( )]($w.CollapsedMixin.html#collapse)
     * @see [expand( )]($w.CollapsedMixin.html#expand)
     * @see [collapsed]($w.CollapsedMixin.html#collapsed)
     * @see [rendered]($w.Element.html#rendered)
     * @memberof $w.HiddenMixin
     * @attr {external:Boolean} hidden
     * @readonly
     */

  }, {
    key: 'show',


    /**
     * @function show
     * @syntax
     * function show([effectName: Effect], [effectOptions: EffectOptions]): Promise<void>
     * type Effect = "arc" | "bounce" | "fade" | "flip"
     * | "float" | "fly" | "fold" | "glide" | "puff"
     * | "roll" | "slide" | "spin" | "turn" | "zoom"
     * type EffectOptions = ArcEffectOptions | BounceEffectOptions
     * | FadeEffectOptions | FlipEffectOptions | FloatEffectOptions
     * | FlyEffectOptions | FoldEffectOptions | GlideEffectOptions
     * | PuffEffectOptions | RollEffectOptions | SlideEffectOptions
     * | SpinEffectOptions | TurnEffectOptions | ZoomEffectOptions
     * @summary Shows the element and sets its `hidden` property
     *  to `false`, using an effect if specified.
     * @description
     *  The `show()` function shows the element and returns a Promise that is
     *  resolved when the effect is complete and the element's [`hidden`](#hidden)
     *  property has been set to `false`.
     *
     *  You can optionally apply an effect when showing the element by providing
     *  an `effectName` value. You can also customize the effect by providing the
     *  optional `effectOptions` object.
     *
     *  Effects:
     *
     *  + [`"arc"`]($w.EffectOptions.html#ArcEffectOptions)
     *  + [`"bounce"`]($w.EffectOptions.html#BounceEffectOptions)
     *  + [`"fade"`]($w.EffectOptions.html#FadeEffectOptions)
     *  + [`"flip"`]($w.EffectOptions.html#FlipEffectOptions)
     *  + [`"float"`]($w.EffectOptions.html#FloatEffectOptions)
     *  + [`"fly"`]($w.EffectOptions.html#FlyEffectOptions)
     *  + [`"fold"`]($w.EffectOptions.html#FoldEffectOptions)
     *  + [`"glide"`]($w.EffectOptions.html#GlideEffectOptions)
     *  + [`"puff"`]($w.EffectOptions.html#PuffEffectOptions)
     *  + [`"roll"`]($w.EffectOptions.html#RollEffectOptions)
     *  + [`"slide"`]($w.EffectOptions.html#SlideEffectOptions)
     *  + [`"spin"`]($w.EffectOptions.html#SpinEffectOptions)
     *  + [`"turn"`]($w.EffectOptions.html#TurnEffectOptions)
     *  + [`"zoom"`]($w.EffectOptions.html#ZoomEffectOptions)
     * @param {external:String} [effectName] The name of the
     *  effect to play when showing the item.
     * @param {$w.EffectOptions~ArcEffectOptions | $w.EffectOptions~BounceEffectOptions | $w.EffectOptions~FadeEffectOptions | $w.EffectOptions~FlipEffectOptions | $w.EffectOptions~FloatEffectOptions | $w.EffectOptions~FlyEffectOptions | $w.EffectOptions~FoldEffectOptions | $w.EffectOptions~GlideEffectOptions | $w.EffectOptions~PuffEffectOptions | $w.EffectOptions~RollEffectOptions | $w.EffectOptions~SlideEffectOptions | $w.EffectOptions~SpinEffectOptions | $w.EffectOptions~TurnEffectOptions | $w.EffectOptions~ZoomEffectOptions} [effectOptions] The effect's options.
     * @returns {Promise}
     * @fulfill {void} When the effect is complete and the element's `hidden` property has been set to `false`.
     * @see [hide( )](#hide)
     * @see [hidden](#hidden)
     * @see [expand( )]($w.CollapsedMixin.html#expand)
     * @snippet [HiddenMixin-show.es6=Show an element with no effect]
     * @snippet [HiddenMixin-show_animation.es6=Show an element with the "fade" effect]
     * @snippet [HiddenMixin-show-FadeOptions.es6=Show an element with the "fade" effect and custom options]
     * @snippet [HiddenMixin-show_then.es6=Show an element with an effect and log message when the effect is done]
     * @snippet [HiddenMixin_toggle_hidden.es6=Toggle an element's hidden state]
     * @memberof $w.HiddenMixin
     */
    value: function show(effectName, effectOptions) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var RMI = members._RMI.get(_this2);
        var compId = members._compId.get(_this2);

        if (!_this2.hidden) {
          return resolve();
        }

        //TODO WEED-8265
        // if (shouldOverrideEditorPresets(effectName, effectOptions)) {
        //     return resetAnimationAndChangeElementVisibility(RMI, compId, false, resolve);
        // }

        //TODO WEED-8265 - for phase 1.1 only
        if (!effectName && _lodash2.default.isEmpty(effectOptions)) {
          return changeElementVisibility(RMI, compId, false, resolve);
        }

        var functionData = _constants.EFFECTS.SHOW;
        var isValid = _effectValidation2.default.validateEffect(effectName, effectOptions, 'show', _this2.id, functionData.deprecatedValues);
        if (!isValid) {
          return changeElementVisibility(RMI, compId, false, resolve);
        }

        var _effectValidation$bui2 = _effectValidation2.default.buildEffectObject(effectName, effectOptions, functionData),
            presetName = _effectValidation$bui2.presetName,
            params = _effectValidation$bui2.params;

        return RMI.executeAnimation(compId, presetName, params, changeElementVisibility.bind(null, RMI, compId, false, resolve));
      });
    }

    /**
     * @member isVisible
     * @label property
     * @syntax
     * get isVisible(): boolean
     * @summary Indicates if the element is actually visible.
     * @description
     *  If `isVisible` is `true`, the element is displayed on the page.
     *
     *  If `isVisible` is `false`, the element is not displayed on the page.
     *
     *  The value of the `isVisible` property is calculated based on the
     *  [`hidden`](#hidden), [`collapsed`](#collapsed), and [`rendered`]($w.Element#rendered)
     *  properties of the element and all of its ancestors. It is `true`
     *  only if the conditions exist in the element's property values and the
     *  property values of its ancestors such that the element is actually
     *  displayed on the page.
     * @note An element's `isVisible` property is not the same as its
     *  [hidden]($w.Element.html#hidden) property. The `isVisible` property
     *  indicates whether the element is actually displayed, while `hidden`
     *  indicates if it _should_ be displayed.
     *
     *  The `isVisible` property of an element remains `true` even if
     *  another element completely covers it so that a user cannot see it.
     * @snippet [HiddenMixin-isVisible.es6=Get whether an element is visible]
     * @type {external:Boolean}
     * @default true
     * @memberof $w.HiddenMixin
     * @attr {external:Boolean} visible
     * @see [hidden](#hidden)
     * @see [collapsed]($w.CollapsedMixin.html#collapsed)
     * @see [rendered]($w.Element.html#rendered)
     * @readonly
     */

  }, {
    key: 'hidden',
    get: function get() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);
      var props = RMI.getProps(compId);
      return !!props.isHidden;
    }
  }, {
    key: 'isVisible',
    get: function get() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      if (RMI.isGhostComponent(compId)) {
        return false;
      }

      var parentId = compId;
      while (parentId) {
        var parentProps = RMI.getProps(parentId);
        var parent = RMI.getComp(parentId);
        var isDisplayed = parent ? parent.isDisplayed : true;
        if (parentProps && (parentProps.isHidden || parentProps.isCollapsed || !isDisplayed)) {
          return false;
        }
        parentId = RMI.getParent(parentId);
      }
      return true;
    }

    /**
     * @namespace $w.EffectOptions
     * @summary The Rendering API is used to control when code is run as a page is being loaded.
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~ArcEffectOptions
     * @summary An object used to customize the `"arc"` effect.
     * @description
     *  The `ArcEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"arc"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`left`, `right`</td>
     *     <td>`left`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-ArcOptions.es6=Show an element using the arc effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~BounceEffectOptions
     * @summary An object used to customize the `"bounce"` effect.
     * @description
     *  The `BounceEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"bounce"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`topLeft`, `topRight`, `bottomRight`, `bottomLeft`, `center`</td>
     *     <td>`topLeft`</td>
     *   </tr>
     *   <tr>
     *     <td>`intensity`</td>
     *     <td>`soft`, `medium`, `hard`</td>
     *     <td>`medium`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @property {external:String} intensity
     * @snippet [HiddenMixin-show-BounceOptions.es6=Show an element using the bounce effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~FadeEffectOptions
     * @summary An object used to customize the `"fade"` effect.
     * @description
     *  The `FadeEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"fade"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @snippet [HiddenMixin-show-FadeOptions.es6=Show an element using the fade effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~FlipEffectOptions
     * @summary An object used to customize the `"flip"` effect.
     * @description
     *  The `FlipEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"flip"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`top`, `right`, `bottom`, `left`</td>
     *     <td>`right`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FlipOptions.es6=Show an element using the flip effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~FloatEffectOptions
     * @summary An object used to customize the `"float"` effect.
     * @description
     *  The `FloatEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"float"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`top`, `right`, `bottom`, `left`</td>
     *     <td>`right`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FloatOptions.es6=Show an element using the float effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~FlyEffectOptions
     * @summary An object used to customize the `"fly"` effect.
     * @description
     *  The `FlyEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"fly"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`top`, `right`, `bottom`, `left`</td>
     *     <td>`right`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FlyOptions.es6=Show an element using the fly effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~FoldEffectOptions
     * @summary An object used to customize the `"fold"` effect.
     * @description
     *  The `FoldEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"fold"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`top`, `right`, `bottom`, `left`</td>
     *     <td>`left`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FoldOptions.es6=Show an element using the fold effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~GlideEffectOptions
     * @summary An object used to customize the `"glide"` effect.
     * @description
     *  The `GlideEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"glide"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`angle`</td>
     *     <td>`0`-`360` degrees</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`distance`</td>
     *     <td>`0`-`300` pixels</td>
     *     <td>`0`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:Number} angle
     * @property {external:Number} distance
     * @snippet [HiddenMixin-show-GlideOptions.es6=Show an element using the glide effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~PuffEffectOptions
     * @summary An object used to customize the `"puff"` effect.
     * @description
     *  The `PuffEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"puff"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @snippet [HiddenMixin-show-PuffOptions.es6=Show an element using the puff effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~RollEffectOptions
     * @summary An object used to customize the `"roll"` effect.
     * @description
     *  The `RollEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"roll"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`top`, `right`, `bottom`, `left`</td>
     *     <td>`left`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-RollOptions.es6=Show an element using the roll effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~SlideEffectOptions
     * @summary An object used to customize the `"slide"` effect.
     * @description
     *  The `SlideEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"slide"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`top`, `right`, `bottom`, `left`</td>
     *     <td>`left`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-SlideOptions.es6=Show an element using the slide effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~SpinEffectOptions
     * @summary An object used to customize the `"spin"` effect.
     * @description
     *  The `SpinEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"spin"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`cw`, `ccw`</td>
     *     <td>`cw`</td>
     *   </tr>
     *   <tr>
     *     <td>`cycles`</td>
     *     <td>`1`-`15`</td>
     *     <td>`5`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @property {external:Number} cycles
     * @snippet [HiddenMixin-show-SpinOptions.es6=Show an element using the spin effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~TurnEffectOptions
     * @summary An object used to customize the `"turn"` effect.
     * @description
     *  The `TurnEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"turn"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     *   <tr>
     *     <td>`direction`</td>
     *     <td>`right`, `left`</td>
     *     <td>`right`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-TurnOptions.es6=Show an element using the turn effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

    /**
     * @typedef {external:Object} $w.EffectOptions~ZoomEffectOptions
     * @summary An object used to customize the `"zoom"` effect.
     * @description
     *  The `ZoomEffectOptions` object is used for the `effectOptions` parameter
     *  when calling the [`show()`](#show) and [`hide()`](#hide) functions with
     *  the `"zoom"` effect.
     *
     * <table style="border-collapse: collapse;">
     *   <tr>
     *     <td><b>Key</b></td>
     *     <td><b>Valid Values</b></td>
     *     <td><b>Default</b></td>
     *   </tr>
     *   <tr>
     *     <td>`duration`</td>
     *     <td>`0`-`4000` milliseconds</td>
     *     <td>`1200`</td>
     *   </tr>
     *   <tr>
     *     <td>`delay`</td>
     *     <td>`0`-`8000` milliseconds</td>
     *     <td>`0`</td>
     *   </tr>
     * </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @snippet [HiddenMixin-show-ZoomOptions.es6=Show an element using the zoom effect and options]
     * @see [show( )]($w.HiddenMixin.html#show)
     * @see [hide( )]($w.HiddenMixin.html#hide)
     */

  }]);

  return HiddenMixin;
}();

(0, _asyncDecorator.setAsyncFunctions)(['hide', 'show']);
(0, _livePreview.setStageUnfriendlyFunctions)(HiddenMixin, 'hide');

exports.default = HiddenMixin;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _utils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin LabelMixin
 * @description Provides functionality for elements that have a label.
 * @memberof $w
 */
var LabelMixin = function () {
    function LabelMixin() {
        _classCallCheck(this, LabelMixin);
    }

    _createClass(LabelMixin, [{
        key: 'label',

        /**
         * @member label
         * @label property
         * @syntax
         * get label(): string
         * set label(value: string): void
         * @summary Sets or gets the label of an element.
         * @type {external:String}
         * @default Empty string
         * @memberof $w.LabelMixin
         * @instance
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).label;
        }

        /**
         * @member label
         * @memberof $w.LabelMixin
         * @param {external:String} value
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'label',
                dataToValidate: { label: value },
                compName: this.id
            });
            if (!isValid) {
                return;
            }
            var label = (0, _utils.emptyStringIfNil)(value);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, { label: label });
        }
    }]);

    return LabelMixin;
}();

exports.default = LabelMixin;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validationsService = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ValidatableMixin
 * @summary Provides functionality for elements that can be validated.
 *
 * Certain input elements contain properties that are used in basic form
 * validation, such as [`required`]($w.RequiredMixin.html#required) and
 * [`maxlength`]($w.TextInputMixin.html#maxlength). More complex validation
 * logic is achieved using the properties and functions below.
 *
 * Basic validation of elements against the constraints set in the Editor or
 * programmatically is always peformed, regardless of any custom validation.
 *
 * However, sometimes more complex validation is needed, including validations
 * that depend on more than one element. This is typically achieved by adding
 * custom validation logic in an event handler that you set using the input
 * element's [`onCustomValidation()`](#onCustomValidation) function. Within that
 * handler, you call the `reject()` function to indicate that the element is
 * invalid. The element's validity is checked when the value of the element
 * changes either by user interaction or programmatically.
 *
 * Note that validations other than **required**, including custom validations,
 * are not run on input elements when they don't have a value.
 *
 * @memberof $w
 */
var ValidatableMixin = function () {
  function ValidatableMixin() {
    _classCallCheck(this, ValidatableMixin);
  }

  _createClass(ValidatableMixin, [{
    key: 'onCustomValidation',


    /**
     * @callback $w.Validator
     * @summary Function that runs when custom validation is checked.
     * @param {external:String|$w.UploadButton~File[]|external:Boolean} value The value of the element being validated.
     * @param {external:Function} reject A function that invalidates the element with the specified message.
     */

    /**
     * @function onCustomValidation
     * @syntax
     * function onCustomValidation(validator: Validator): void
     * callback Validator(value: string | File[] | boolean, reject: Function): void
     * @summary Adds an event handler that runs when the element's validation is checked.
     * @description
     *  The `onCustomValidation()` function allows you perform custom validation
     *  in addition to any basic validation that was defined in the Editor.
     *
     *  To invalidate the element, call the `reject()` function that is passed
     *  into the `validator` callback function and pass it a validation message.
     *
     *  The element's validity is checked when the value of the element
     *  changes either by user interaction or programmatically.
     *
     *  Note that validations other than **required**, including custom validations,
     *  are not run on input elements when they don't have a value.
     * @snippet [ValidatableMixin-onCustomValidation.es6=Set an element to invalid if its value is "evil"]
     * @param {$w.Validator} validator The name of the function or
     *  the function expression to run when the element's custom validation is checked.
     * @memberof $w.ValidatableMixin
     */
    value: function onCustomValidation(validator) {
      //eslint-disable-line jsdoc-events
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      (0, _validationsService.onCustomValidation)(RMI, compId, validator);
    }

    /**
     * @function updateValidityIndication
     * @syntax
     * function updateValidityIndication(): void
     * @summary Updates the element's visual validity indication based on its current validity state.
     * @description
     *  Many elements have a visual cue that indicates whether they are valid or
     *  not. For example, a text input that usually has a black outline might have
     *  a red outline when its value is not valid.
     * @snippet [ValidatableMixin-updateValidityIndication.es6=Update an element's validatity indicator]
     * @memberof $w.ValidatableMixin
     */

  }, {
    key: 'updateValidityIndication',
    value: function updateValidityIndication() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      (0, _validationsService.showValidityIndication)(RMI, compId);
    }

    /**
     * @function resetValidityIndication
     * @syntax
     * function resetValidityIndication(): void
     * @summary Resets the element's visual validity indication.
     * @description
     *  Many elements have a visual cue that indicates whether they are valid or
     *  not. For example, a text input that usually has a black outline might have
     *  a red outline when its value is not valid.
     *
     *  The `resetValidityIndication()` function resets the validity indication
     *  of an element to show the element as valid. The actual validity state of
     *  the element is not affected. If the element was invalid, it remains
     *  invalid. The validity indication shows the element as valid until
     *  the element's validity is checked when the value of the element
     *  changes either by user interaction or programmatically. At that point,
     *  the element's validity indication shows the element as invalid if
     *  its value is not valid.
     * @memberof $w.ValidatableMixin
     */

  }, {
    key: 'resetValidityIndication',
    value: function resetValidityIndication() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      (0, _validationsService.hideValidityIndication)(RMI, compId);
    }
  }, {
    key: 'valid',


    /**
     * @member valid
     * @label property
     * @syntax get valid(): boolean
     * @summary Indicates if an input element's value is valid.
     * @description
     *  The `valid` property indicates if an element's value satisfies
     *  all conditions to pass a validation check. This includes basic validity
     *  conditions, such as whether the element has a value if it is [required]($w.RequiredMixin.html#required),
     *  and those specified in its [`onCustomValidation()`](#onCustomValidation)
     *  event handler, if you defined one.
     *
     *  Note that validations other than **required**, including custom validations,
     *  are not run on input elements when they don't have a value.
     * @snippet [ValidatableMixin-valid.es6=Get whether the element is valid]
     * @type {external:Boolean}
     * @see [onCustomValidation( )](#onCustomValidation)
     * @memberof $w.ValidatableMixin
     * @readonly
     */
    get: function get() {
      var compId = members._compId.get(this);

      return (0, _validationsService.isValid)(compId);
    }

    /**
     * @member validationMessage
     * @label property
     * @syntax
     * get validationMessage(): string
     * @summary Gets a message indicating why the element is invalid, or an
     *  empty string if the message is valid.
     * @description
     *  Set the value of the `validationMessage` property using the
     *  `reject()` function of the [`onCustomValidation()`](#onCustomValidation)
     *  event handler.
     * @snippet [ValidatableMixin-validationMessage.es6=Get the validation message]
     * @type {external:String}
     * @see [validity](#validity)
     * @memberof $w.ValidatableMixin
     * @readonly
     */

  }, {
    key: 'validationMessage',
    get: function get() {
      var compId = members._compId.get(this);

      return (0, _validationsService.getValidationMessage)(compId);
    }

    /**
     * @typedef {external:Object} $w.ValidatableMixin~ValidityState
     * @summary Contains detailed information about the validity states of an element.
     * @description This object is returned by an element's
     *  [`validity`](#validity) property.
     * @property {external:Boolean} customError - `true` if the element's custom
     *  validity message has been set to a non-empty string.
     * @property {external:Boolean} valid - `true` if the element meets all
     *  constraint validations.
     * @property {external:Boolean} valueMissing - `true` if the element's
     *  [`required`]($w.RequiredElement.html#required) property is `true`, but
     *  it does not contain a value.
     * @property {external:Boolean} typeMismatch - `true` if the element's value
     *  does not match its type when the type is email or url.
     * @property {external:Boolean} patternMismatch - `true` if the element's
     *  value does not match its pattern validation.
     * @property {external:Boolean} tooLong - `true` if the length of the
     *  element's value exceeds its [`maxlength`]($w.TextInputElement.html#maxlength)
     *  property.
     * @property {external:Boolean} tooShort - `true` if the length of the
     *  element's value is smaller than its minlength.
     * @property {external:Boolean} rangeUnderflow - `true` if the element's
     *  value is less than the its [`min`]($w.TextInput.html#min) property.
     * @property {external:Boolean} rangeOverflow - `true` if the element's
     *  value is more than the its [`max`]($w.TextInput.html#max) property.
     * @property {external:Boolean} fileNotUploaded - `true` if the element is
     *  an upload button that is required and a file has been selected but not
     *  uploaded.
     * @property {external:Boolean} stepMismatch
     * @property {external:Boolean} badInput - `true` if the element's value
     *  cannot be converted to a value
     * @snippet [ValidityState.es6=Get ValidityState info]
     * @see [validity](#validity)
     */

    /**
     * @member validity
     * @label property
     * @syntax
     * get validity(): ValidityState
     * @summary Gets a ValidityState object that contains
     *  detailed information about the validity states of the element.
     * @snippet [ValidityState.es6=Log ValidityState info]
     * @type {$w.ValidatableMixin~ValidityState}
     * @see [validationMessage](#validationMessage)
     * @memberof $w.ValidatableMixin
     * @readonly
     */

  }, {
    key: 'validity',
    get: function get() {
      var compId = members._compId.get(this);

      return (0, _validationsService.getValidity)(compId);
    }
  }]);

  return ValidatableMixin;
}();

exports.default = ValidatableMixin;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(32);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _validation = __webpack_require__(3);

var _validationsService = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ValueMixin
 * @description Adds the value property to elements.
 * @memberof $w
 */
var ValueMixin = function () {
    function ValueMixin() {
        _classCallCheck(this, ValueMixin);
    }

    _createClass(ValueMixin, [{
        key: 'onChange',

        /**
         * @function onChange
         * @syntax
         * function onChange(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when an input element's value
         *  is changed.
         * @description
         *  An element receives a `change` event when a user changes the value
         *  in an input element.
         *
         *  A `change` event is not triggered when you change an element's value using
         *  the element's [`value`](#value) property.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element's value changes.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [FormElement-onChange.es6=Get the value of the element that was changed]
         * @memberof $w.ValueMixin
         * @eventtype change
         * @eventhandler
         */
        value: function onChange(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onChange',
                dataToValidate: { onChange: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, controllerId, cb);
            return this;
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets an element's value.
         * @description
         *  To reset the form element's value, set the `value` property to `null` or
         *  `undefined`.
         *
         * @note
         *  Changing an element's `value` in code does not trigger an `onChange` event.
         *
         *  If an element is connected to a dataset, setting the element's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [FormElement-value_get.es6=Get an element's value]
         * @snippet [FormElement-value_set.es6=Set an element's value]
         * @type {external:String}
         * @memberof $w.ValueMixin
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).value;
        }

        /**
         * @member value
         * @memberof $w.ValueMixin
         * @param {external:String} val
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'value',
                dataToValidate: { value: value },
                compName: this.id
            });

            if (!isValid) {
                return;
            }

            (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
            RMI.setData(compId, { value: value });
        }
    }]);

    return ValueMixin;
}();

exports.default = ValueMixin;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(31);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(28);

var _styleConstants2 = _interopRequireDefault(_styleConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BackgroundColorMixin = function () {
  function BackgroundColorMixin() {
    _classCallCheck(this, BackgroundColorMixin);
  }

  _createClass(BackgroundColorMixin, [{
    key: 'backgroundColor',


    /**
     * @member backgroundColor
     * @memberof $w.Style
     * @param {external:String} backgroundColor
     */
    set: function set(backgroundColor) {
      var compName = members._compName.get(this);
      var opacitySupport = true;

      var validColor = (0, _styleValidation.validateColorAndPerformCastingIfNecessary)(backgroundColor, opacitySupport, _styleConstants2.default.BACKGROUND_COLOR, compName);
      if (!validColor) {
        return;
      }
      _styleService2.default.setStyle.call(this, _styleConstants2.default.BACKGROUND_COLOR, validColor);
    }

    /**
     * @member backgroundColor
     * @label property
     * @syntax
     * get backgroundColor(): string
     * set backgroundColor(rgbaColor: string): void
     * @summary Sets or gets the background color of an element.
     * @description
     *  The background color value is a string representing an rgba color in one
     *  of the following formats:
     *
     *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"`: A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"`: An rgb() function color value.
     *  + `"#FF000000"`: A hexidecimal rgba color value.
     *  + `"rgba(255,0,0,1.0)"`: An rgba() function color value.
     * 
     * This style can be used with the following elements: 
     * 
     *  + [`Box`]($w.Box.html)
     *  + [`Button`]($w.Button.html)
     *  + [`Checkbox`]($w.Checkbox.html)
     *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`Footer`]($w.Footer.html)
     *  + [`Header`]($w.Header.html)
     *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html) 
     *  + [`UploadButton`]($w.UploadButton.html)
     * 
     * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
     * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    ,
    get: function get() {
      return _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.BACKGROUND_COLOR);
    }
  }]);

  return BackgroundColorMixin;
}();

exports.default = BackgroundColorMixin;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(31);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(28);

var _styleConstants2 = _interopRequireDefault(_styleConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BorderColorMixin = function () {
    function BorderColorMixin() {
        _classCallCheck(this, BorderColorMixin);
    }

    _createClass(BorderColorMixin, [{
        key: 'borderColor',


        /**
         * @member borderColor
         * @memberof $w.Style
         * @param {external:String} borderColor
         */
        set: function set(borderColor) {
            var compName = members._compName.get(this);
            var opacitySupport = true;

            var validColor = (0, _styleValidation.validateColorAndPerformCastingIfNecessary)(borderColor, opacitySupport, _styleConstants2.default.BORDER_COLOR, compName);
            if (!validColor) {
                return;
            }
            _styleService2.default.setStyle.call(this, _styleConstants2.default.BORDER_COLOR, validColor);
        }

        /**
         * @member borderColor
         * @label property
         * @syntax
         * get borderColor(): string
         * set borderColor(rgbaColor: string): void
         * @summary Sets or gets the border color of an element.
         * @description
         *  The border color value is a string representing an rgba color in one of
         *  the following formats:
         *
         *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
         *  + `"#FF0000"`: A hexidecimal rgb color value.
         *  + `"rgb(255,0,0)"`: An rgb() function color value.
         *  + `"#FF000000"`: A hexidecimal rgba color value.
         *  + `"rgba(255,0,0,1.0)"`: An rgba() function color value.
         * 
         * This style can be used with the following elements: 
         * 
         *  + [`Box`]($w.Box.html)
         *  + [`Button`]($w.Button.html)
         *  + [`Checkbox`]($w.Checkbox.html)
         *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
         *  + [`Dropdown`]($w.Dropdown.html)
         *  + [`Footer`]($w.Footer.html)
         *  + [`Header`]($w.Header.html)
         *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
         *  + [`TextBox`]($w.TextBox.html)
         *  + [`TextInput`]($w.TextInput.html) 
         *  + [`UploadButton`]($w.UploadButton.html)
         * 
         * @snippet [BorderMixin-borderColor_set.es6=Set the border color]
         * @snippet [BorderMixin-borderColor_get.es6=Get the border color]
         * @type {external:String}
         * @memberof $w.Style
         * @instance
         */
        ,
        get: function get() {
            return _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.BORDER_COLOR);
        }
    }]);

    return BorderColorMixin;
}();

exports.default = BorderColorMixin;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(31);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(28);

var _styleConstants2 = _interopRequireDefault(_styleConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BorderRadiusMixin = function () {
    function BorderRadiusMixin() {
        _classCallCheck(this, BorderRadiusMixin);
    }

    _createClass(BorderRadiusMixin, [{
        key: 'borderRadius',


        /**
         * @member borderRadius
         * @memberof $w.Style
         * @param {external:String} borderRadius
         */
        set: function set(borderRadius) {
            var compName = members._compName.get(this);

            var isValidBorderRadius = (0, _styleValidation.validatePixel)(borderRadius, _styleConstants2.default.BORDER_RADIUS, compName, 'radius');
            if (!isValidBorderRadius) {
                return;
            }
            _styleService2.default.setStyle.call(this, _styleConstants2.default.BORDER_RADIUS, borderRadius);
        }

        /**
         * @member borderRadius
         * @label property
         * @syntax
         * get borderRadius(): string
         * set borderRadius(radius: string): void
         * @summary Sets or gets the border radius of an element.
         * @description
         *  The [border radius](https://www.w3schools.com/cssref/css3_pr_border-radius.asp)
         *  value is a string representing the element's border radius in pixels.
         *  For example, `"1px"`.
         * 
         * This style can be used with the following elements: 
         * 
         *  + [`Button`]($w.Button.html)
         *  + [`Checkbox`]($w.Checkbox.html)
         *  + [`Dropdown`]($w.Dropdown.html)
         *  + [`TextBox`]($w.TextBox.html)
         *  + [`TextInput`]($w.TextInput.html) 
         *  + [`UploadButton`]($w.UploadButton.html)     
         *  
         * @snippet [BorderRadiusMixin-borderRadius_set.es6=Set the border radius]
         * @snippet [BorderRadiusMixin-borderRadius_get.es6=Get the border radius]
         * @type {external:String}
         * @memberof $w.Style
         * @instance
         */
        ,
        get: function get() {
            return _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.BORDER_RADIUS);
        }
    }]);

    return BorderRadiusMixin;
}();

exports.default = BorderRadiusMixin;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(31);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(28);

var _styleConstants2 = _interopRequireDefault(_styleConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BorderWidthMixin = function () {
    function BorderWidthMixin() {
        _classCallCheck(this, BorderWidthMixin);
    }

    _createClass(BorderWidthMixin, [{
        key: 'borderWidth',

        /**
         * @member borderWidth
         * @memberof $w.Style
         * @param {external:String} width
         */
        set: function set(width) {
            var compName = members._compName.get(this);

            var isValid = (0, _styleValidation.validatePixel)(width, _styleConstants2.default.BORDER_WIDTH, compName, 'width');
            if (!isValid) {
                return;
            }
            _styleService2.default.setStyle.call(this, _styleConstants2.default.BORDER_WIDTH, width);
        }

        /**
         * @member borderWidth
         * @label property
         * @syntax
         * get borderWidth(): string
         * set borderWidth(width: string): void
         * @summary Sets or gets the border width of an element.
         * @description
         *  The border width value is a string representing the element's border
         *  width in pixels. For example, `"1px"`.
         * 
         * This style can be used with the following elements: 
         * 
         *  + [`Button`]($w.Button.html)
         *  + [`Checkbox`]($w.Checkbox.html)
         *  + [`Dropdown`]($w.Dropdown.html)
         *  + [`TextBox`]($w.TextBox.html)
         *  + [`TextInput`]($w.TextInput.html) 
         *  + [`UploadButton`]($w.UploadButton.html)     
         *  
         * @snippet [BorderMixin-borderWidth_set.es6=Set the border width]
         * @snippet [BorderMixin-borderWidth_get.es6=Get the border width]
         * @type {external:String}
         * @memberof $w.Style
         * @instance
         */
        ,
        get: function get() {
            return _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.BORDER_WIDTH);
        }
    }]);

    return BorderWidthMixin;
}();

exports.default = BorderWidthMixin;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(31);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(28);

var _styleConstants2 = _interopRequireDefault(_styleConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ForegroundColorMixin = function () {
  function ForegroundColorMixin() {
    _classCallCheck(this, ForegroundColorMixin);
  }

  _createClass(ForegroundColorMixin, [{
    key: 'foregroundColor',


    /**
     * @member foregroundColor
     * @memberof $w.Style
     * @param {external:String} foregroundColor
     */
    set: function set(foregroundColor) {
      var compName = members._compName.get(this);
      var opacitySupport = true;

      var validColor = (0, _styleValidation.validateColorAndPerformCastingIfNecessary)(foregroundColor, opacitySupport, _styleConstants2.default.FOREGROUND_COLOR, compName);
      if (!validColor) {
        return;
      }
      _styleService2.default.setStyle.call(this, _styleConstants2.default.FOREGROUND_COLOR, validColor);
    }

    /**
     * @member foregroundColor
     * @label property
     * @syntax
     * get foregroundColor(): string
     * set foregroundColor(rgbaColor: string): void
     * @summary Sets or gets the foreground color of an element.
     * @description
     *  The foreground color value is a string representing an rgba color in one
     *  of the following formats:
     *
     *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"`: A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"`: An rgb() function color value.
     *  + `"#FF000000"`: A hexidecimal rgba color value.
     *  + `"rgba(255,0,0,1.0)"`: An rgba() function color value.
     * 
     * This style can be used with the following elements: 
     * 
     *  + [`ProgressBar`]($w.ProgressBar.html)
     * 
     * @snippet [foregroundColorMixin-foregroundColor_set.es6=Set the foreground color]
     * @snippet [foregroundColorMixin-foregroundColor_get.es6=Get the foreground color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    ,
    get: function get() {
      return _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.FOREGROUND_COLOR);
    }
  }]);

  return ForegroundColorMixin;
}();

exports.default = ForegroundColorMixin;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(31);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(28);

var _styleConstants2 = _interopRequireDefault(_styleConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * @mixin TextColorMixin
 * @summary Provides functionality for changing an element's text color.
 *
 * @memberof $w.Style
 */
var TextColorMixin = function () {
  function TextColorMixin() {
    _classCallCheck(this, TextColorMixin);
  }

  _createClass(TextColorMixin, [{
    key: 'color',


    /**
     * @member color
     * @memberof $w.Style
     * @param {external:String} color
     */
    set: function set(color) {
      var compName = members._compName.get(this);
      var opacitySupport = false;

      var validColor = (0, _styleValidation.validateColorAndPerformCastingIfNecessary)(color, opacitySupport, _styleConstants2.default.COLOR, compName);
      if (!validColor) {
        return;
      }
      _styleService2.default.setStyle.call(this, _styleConstants2.default.COLOR, validColor);
    }

    /**
     * @member color
     * @label property
     * @syntax
     * get color(): string
     * set color(rgbColor: string): void
     * @summary Sets or gets the text color of an element.
     * @description
     *  The text color value is a string representing an rgb color in one
     *  of the following formats:
     *
     *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"`: A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"`: An rgb() function color value.
     * 
     * This style can be used with the following elements: 
     * 
     *  + [`Button`]($w.Button.html)
     *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html) 
     *  + [`UploadButton`]($w.UploadButton.html)
     * 
     * @snippet [TextColorMixin-color_set.es6=Set the text color]
     * @snippet [TextColorMixin-color_get.es6=Get the text color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    ,
    get: function get() {
      return _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.COLOR);
    }
  }]);

  return TextColorMixin;
}();

exports.default = TextColorMixin;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _ui = __webpack_require__(46);

var _ui2 = _interopRequireDefault(_ui);

var _document = __webpack_require__(92);

var _document2 = _interopRequireDefault(_document);

var _componentsBatchFunctions = __webpack_require__(39);

var _componentsBatchFunctions2 = _interopRequireDefault(_componentsBatchFunctions);

var _utils = __webpack_require__(5);

var _readyManager = __webpack_require__(51);

var _wixSelectorUtils = __webpack_require__(119);

var _wixSelectorUtils2 = _interopRequireDefault(_wixSelectorUtils);

var _HiddenCollapsedElement = __webpack_require__(59);

var _HiddenCollapsedElement2 = _interopRequireDefault(_HiddenCollapsedElement);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

var _WixBaseEvent = __webpack_require__(66);

var _WixBaseEvent2 = _interopRequireDefault(_WixBaseEvent);

var _errors = __webpack_require__(9);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _ghostMixin = __webpack_require__(106);

var _ghostMixin2 = _interopRequireDefault(_ghostMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixSelector = function () {
    function WixSelector() {
        _classCallCheck(this, WixSelector);
    }

    _createClass(WixSelector, [{
        key: 'initialize',
        value: function initialize(_ref) {
            var currentRMI = _ref.currentRMI,
                contextId = _ref.contextId,
                globalRMI = _ref.globalRMI;

            this.currentRMI = currentRMI;
            this.globalRMI = globalRMI || currentRMI;
            this.contextId = contextId;
        }
    }, {
        key: 'scoped$W',
        value: function scoped$W(controllerId, logName) {
            var _this = this;

            var $w = function $w(selector) {
                return _this.$w(controllerId, logName, selector, false);
            };
            var createEvent = function createEvent(type, params) {
                return _this.createEvent(type, params);
            };
            var at = function at(context) {
                return _this.at($w, controllerId, context);
            };

            $w.createEvent = createEvent;
            $w.at = at;

            $w.scoped = function (selector) {
                return _this.$w(controllerId, logName, selector, true);
            };

            $w.scoped.createEvent = createEvent;
            $w.scoped.at = at;
            return $w;
        }
    }, {
        key: '$w',
        value: function $w(controllerId, logName, compSelector, onlyNestedScope) {
            var _this2 = this;

            if (_lodash2.default.isFunction(compSelector)) {
                (0, _readyManager.onReady)(compSelector, logName);
                return;
            }

            if (!_lodash2.default.isString(compSelector)) {
                throw new _monitoring2.default.MonitoringErrorToIgnore(_errors.errors.ERROR_SELECTOR_TYPE_STRING);
            }

            if (!this.currentRMI) {
                throw new _monitoring2.default.MonitoringErrorToIgnore(_errors.errors.ERROR_SELECTOR_BEFORE_ON_READY);
            }

            var scopedRMI = this.currentRMI.getScopedRMI(controllerId);
            var wixComps = [];

            var isCompName = function isCompName(compSelector) {
                return compSelector.trim().indexOf('#') === 0;
            };
            var isRole = function isRole(compSelector) {
                return compSelector.trim().indexOf('@') === 0;
            };
            var isType = function isType(compSelector) {
                return _utils.types.getPotentialViewerTypes(compSelector).length > 0 || compSelector === 'PageContent';
            };
            var getType = function getType(compSelector) {
                return compSelector === 'PageContent' ? 'Page' : compSelector;
            };
            var isMulti = function isMulti(compSelector) {
                return compSelector.indexOf(',') > -1;
            };
            var isDocument = function isDocument(compSelector) {
                return compSelector === 'Document';
            };
            var selector = compSelector.trim().substr(1);

            switch (true) {
                case isDocument(compSelector):
                    var cIds = _wixSelectorUtils2.default.getCompIdsForRole(scopedRMI, selector, onlyNestedScope);
                    return new _document2.default(scopedRMI, cIds[0], this.contextId, this, controllerId, undefined, { compType: 'Document' });
                case isType(compSelector):
                    var type = getType(compSelector);
                    var comps = _wixSelectorUtils2.default.getCompsForType(_utils.types, scopedRMI, type, onlyNestedScope);
                    comps.forEach(function (comp) {
                        wixComps.push(_this2.getInstance(scopedRMI, comp.type, comp.id, controllerId));
                    });
                    return _componentsBatchFunctions2.default.expose(wixComps);
                case isMulti(compSelector):
                    var selectors = compSelector.split(',');
                    var selectedComps = [];
                    selectors.forEach(function (comp) {
                        if (isCompName(comp)) {
                            var sel = comp.trim().substr(1);
                            var id = _wixSelectorUtils2.default.getCompIdsForRole(scopedRMI, sel, onlyNestedScope)[0];
                            var component = _this2.getInstance(scopedRMI, scopedRMI.getType(id), id, controllerId);
                            if (!_lodash2.default.isArray(component)) {
                                var isCompInArr = _lodash2.default.find(selectedComps, { id: id });
                                if (!isCompInArr) {
                                    selectedComps.push({
                                        id: id,
                                        type: scopedRMI.getType(id)
                                    });
                                }
                            }
                        } else if (isType(comp.trim())) {
                            var _type = getType(comp.trim());
                            var _comps = _wixSelectorUtils2.default.getCompsForType(_utils.types, scopedRMI, _type);
                            _comps.forEach(function (comp) {
                                var isCompInArr = _lodash2.default.find(selectedComps, { id: comp.id });
                                if (!isCompInArr) {
                                    selectedComps.push(comp);
                                }
                            });
                        }
                    });
                    selectedComps.forEach(function (comp) {
                        wixComps.push(_this2.getInstance(scopedRMI, comp.type, comp.id, controllerId));
                    });
                    return _componentsBatchFunctions2.default.expose(_lodash2.default.without(wixComps, undefined));
                case isCompName(compSelector):
                    var ids = _wixSelectorUtils2.default.getCompIdsForRole(scopedRMI, selector, onlyNestedScope);
                    return !_lodash2.default.isEmpty(ids) ? this.getInstance(scopedRMI, scopedRMI.getType(ids[0]), ids[0], controllerId) : [];
                case isRole(compSelector):
                    var compIds = _wixSelectorUtils2.default.getCompIdsForRole(scopedRMI, selector, onlyNestedScope);
                    compIds.forEach(function (compId) {
                        wixComps.push(_this2.getInstance(scopedRMI, scopedRMI.getType(compId), compId, controllerId, selector));
                    });
                    return _componentsBatchFunctions2.default.expose(wixComps);
                default:
                    return [];
            }
        }
    }, {
        key: 'getInstance',
        value: function getInstance(scopedRMI, viewerType, compId, controllerId, role) {
            var compType = _wixSelectorUtils2.default.getSdkConstructorName(_utils.types, scopedRMI, compId);
            var Clazz = _ui2.default[compType] || _HiddenCollapsedElement2.default;
            if (!viewerType) {
                return [];
            }

            var instance = new Clazz(scopedRMI, compId, this.contextId, this, controllerId, role, { compType: compType, viewerType: viewerType });
            return !scopedRMI.isGhostComponent(compId) ? instance : (0, _ghostMixin2.default)(instance);
        }
    }, {
        key: 'getCurrentScopedContext',
        value: function getCurrentScopedContext() {
            return this.currentRMI.getCurrentScope();
        }
    }, {
        key: 'createNew$w',
        value: function createNew$w(_ref2) {
            var currentRMI = _ref2.currentRMI,
                _ref2$globalRMI = _ref2.globalRMI,
                globalRMI = _ref2$globalRMI === undefined ? currentRMI : _ref2$globalRMI,
                _ref2$context = _ref2.context,
                context = _ref2$context === undefined ? this.contextId : _ref2$context,
                _ref2$controller = _ref2.controller,
                controller = _ref2$controller === undefined ? context : _ref2$controller;

            var selector = new this.constructor();

            selector.initialize({ currentRMI: currentRMI, globalRMI: globalRMI, contextId: context });

            var $w = selector.scoped$W(controller);
            _lodash2.default.assign($w, _platformUtils2.default.getEmitter().createScopedEmitter(controller));

            return $w;
        }
    }, {
        key: 'getGlobalSelector',
        value: function getGlobalSelector(controller, context) {
            return this.createNew$w({ controller: controller, context: context, currentRMI: this.globalRMI });
        }
    }, {
        key: 'getScopedSelector',
        value: function getScopedSelector(compId, scopedContext, scopedController) {
            var scopedRMI = this.currentRMI.getScopedRMIByCompId(compId);

            if (scopedRMI === this.currentRMI) {
                var contextId = scopedContext || this.contextId;
                var controllerId = scopedController || contextId;
                var $w = this.scoped$W(controllerId);
                _lodash2.default.assign($w, _platformUtils2.default.getEmitter().createScopedEmitter(controllerId));
                return $w;
            }
            return this.createNew$w({ controller: scopedController, context: scopedContext, currentRMI: scopedRMI, globalRMI: this.globalRMI });
        }
    }, {
        key: 'getScopedSelectorForDisplayedOnlyComp',
        value: function getScopedSelectorForDisplayedOnlyComp(repeaterCompId, itemId, scopedContext, scopedController) {
            var scopedRMI = this.currentRMI.getScopedRMIForRepeaterItem(repeaterCompId, itemId);

            return this.createNew$w({ controller: scopedController, context: scopedContext, currentRMI: scopedRMI, globalRMI: this.globalRMI });
        }
    }, {
        key: 'createEvent',
        value: function createEvent(type, params) {
            var context = this.getCurrentScopedContext();

            if (_lodash2.default.get(context, 'additionalData.itemId')) {
                context.itemId = context.additionalData.itemId;
            }

            var event = new _WixBaseEvent2.default({ type: type, context: context });

            return _lodash2.default.defaults(event, params);
        }
    }, {
        key: 'at',
        value: function at($w, controllerId, context) {
            var currentScopedContext = this.getCurrentScopedContext();

            if (_lodash2.default.isEqual(_lodash2.default.omit(context, ['itemId']), currentScopedContext)) {
                return $w;
            }

            if (this.currentRMI.isRepeaterScope(context)) {
                return this.getScopedSelectorForDisplayedOnlyComp(context.compId, context.additionalData.itemId, null, controllerId);
            }

            return this.getGlobalSelector(controllerId);
        }
    }]);

    return WixSelector;
}();

exports.default = _monitoring2.default.monitorClass(WixSelector, function () {
    return { currentRMI: this.currentRMI, contextId: this.contextId };
});

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = {"roll":{"In":"reveal","Out":"conceal"},"puff":{"In":"drop","Out":"pop"},"zoom":{"In":"expand","Out":"collapse"}}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = {"arc":{"duration":1.2,"delay":0,"direction":"left"},"bounce":{"duration":1.2,"delay":0,"direction":"topLeft","bounce":"medium"},"puff":{"duration":1.2,"delay":0},"zoom":{"duration":1.2,"delay":0},"fade":{"duration":1.2,"delay":0},"flip":{"duration":1.2,"delay":0,"direction":"left"},"float":{"duration":1.2,"delay":0,"direction":"left"},"fly":{"duration":1.2,"delay":0,"direction":"left"},"fold":{"duration":1.2,"delay":0,"direction":"left"},"glide":{"duration":1.2,"delay":0,"angle":0,"distance":0},"roll":{"duration":1.2,"delay":0,"direction":"left"},"slide":{"duration":1.2,"delay":0,"direction":"left"},"spin":{"duration":1.2,"delay":0,"direction":"cw","cycles":5},"turn":{"duration":1.2,"delay":0,"direction":"right"}}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = {"bounce":{"keys":{"intensity":"bounce"},"values":{"direction":{"topLeft":"top left","topRight":"top right","bottomLeft":"bottom left","bottomRight":"bottom right"},"duration":{"convertMsToSecs":true},"delay":{"convertMsToSecs":true}}},"ALL":{"values":{"duration":{"convertMsToSecs":true},"delay":{"convertMsToSecs":true}}}}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = {"arc":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["left","right"]}},"bounce":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["topLeft","topRight","bottomRight","bottomLeft","center"]},"intensity":{"type":"string","enum":["soft","medium","hard"]}},"puff":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}}},"zoom":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}}},"fade":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}}},"flip":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"float":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"fly":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"fold":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"glide":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"angle":{"type":"integer","range":{"minValue":0,"maxValue":360}},"distance":{"type":"integer","range":{"minValue":0,"maxValue":300}}},"roll":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","default":"left","enum":["left","right","top","bottom"]}},"slide":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"spin":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","enum":["cw","ccw"]},"cycles":{"type":"integer","default":5,"range":{"minValue":1,"maxValue":15}}},"turn":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":8000}},"direction":{"type":"string","default":"right","enum":["right","left"]}}}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(91),
    OPEN_TAG_START = _require.OPEN_TAG_START,
    TAG_END = _require.TAG_END,
    SELF_CLOSING = _require.SELF_CLOSING,
    CLOSING_TAG_START = _require.CLOSING_TAG_START,
    HTML_END = _require.HTML_END,
    SPACE = _require.SPACE;

var selfClosingTags = __webpack_require__(90);

var selfClosingTagsSet = new Set(selfClosingTags);
var bracketsSet = new Set([OPEN_TAG_START, TAG_END, SELF_CLOSING, CLOSING_TAG_START]);

function parseTagName(html, lastBracketTokenEnd, currentTokenIndex, indexOfFirstSpaceAfterOpenBracket) {
  var indexOfTagNameEnd = indexOfFirstSpaceAfterOpenBracket || currentTokenIndex;
  return html.slice(lastBracketTokenEnd + 1, indexOfTagNameEnd).toLowerCase();
}

function parseProps(html, lastBracketTokenEnd, currentTokenIndex, indexOfFirstSpaceAfterOpenBracket) {
  var indexOfTagNameEnd = indexOfFirstSpaceAfterOpenBracket || currentTokenIndex;
  return html.slice(indexOfTagNameEnd + 1, currentTokenIndex);
}

function processTagEnd(html, lastBracketToken, lastBracketTokenEnd, currentTokenIndex, indexOfFirstSpaceAfterOpenBracket, callbacks) {
  var tagName = parseTagName(html, lastBracketTokenEnd, currentTokenIndex, indexOfFirstSpaceAfterOpenBracket);

  if (lastBracketToken === OPEN_TAG_START) {
    var props = parseProps(html, lastBracketTokenEnd, currentTokenIndex, indexOfFirstSpaceAfterOpenBracket);
    if (selfClosingTagsSet.has(tagName)) {
      callbacks.onSelfClosingTag && callbacks.onSelfClosingTag({ tagName: tagName, props: props });
    } else {
      callbacks.onOpenTag && callbacks.onOpenTag({ tagName: tagName, props: props });
    }
  } else {
    callbacks.onClosingTag && callbacks.onClosingTag({ tagName: tagName, props: '' });
  }
}

function detectToken(html, i) {
  var currentTokenStart = i;
  var currentToken = void 0;

  switch (html[i]) {
    case '<':
      if (html[i + 1] === '/') {
        currentToken = CLOSING_TAG_START;
        i++;
        break;
      }
      currentToken = OPEN_TAG_START;
      break;
    case '>':
      currentToken = TAG_END;
      break;
    case '/':
      if (html[i + 1] === '>') {
        currentToken = SELF_CLOSING;
        i++;
        break;
      }
    case ' ':
      currentToken = SPACE;
      break;
    default:
      currentToken = html[i];
  }

  if (i === html.length) {
    currentToken = HTML_END;
  }

  return currentToken;
}

function parseFragment(html) {
  var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var currentToken = void 0;
  var currentTokenStart = void 0;
  var currentTokenEnd = void 0;

  var lastBracketToken = void 0;
  var lastBracketTokenStart = void 0;
  var lastBracketTokenEnd = void 0;

  var indexOfFirstSpaceAfterOpenBracket = void 0;
  var htmlLength = html.length;
  var i = 0;

  while (i <= htmlLength) {
    //detect token at current token and move pointer to the end of the token
    currentTokenStart = i;
    currentToken = detectToken(html, i);
    i = currentTokenEnd = currentTokenStart + currentToken.length - 1;

    switch (currentToken) {
      case OPEN_TAG_START:
      case CLOSING_TAG_START:
        {
          var text = html.slice(lastBracketTokenEnd + 1, currentTokenStart);

          if (text && callbacks.onText) {
            callbacks.onText(text);
          }

          indexOfFirstSpaceAfterOpenBracket = null;
          break;
        }

      case TAG_END:
        processTagEnd(html, lastBracketToken, lastBracketTokenEnd, i, indexOfFirstSpaceAfterOpenBracket, callbacks);
        break;

      case SELF_CLOSING:
        {
          if (!callbacks.onSelfClosingTag) {
            break;
          }

          callbacks.onSelfClosingTag({
            tagName: parseTagName(html, lastBracketTokenEnd, currentTokenStart, indexOfFirstSpaceAfterOpenBracket),
            props: parseProps(html, lastBracketTokenEnd, currentTokenStart, indexOfFirstSpaceAfterOpenBracket)
          });
          break;
        }

      case SPACE:
        if (!indexOfFirstSpaceAfterOpenBracket && (lastBracketToken === OPEN_TAG_START || lastBracketToken === CLOSING_TAG_START)) {
          indexOfFirstSpaceAfterOpenBracket = i;
        }
        break;

      case HTML_END:
        if (!callbacks.onText) break;

        if (!lastBracketToken) {
          //all html is text
          callbacks.onText(html);
          return;
        }

        //text after last tag
        if (lastBracketTokenEnd !== htmlLength - 1) {
          callbacks.onText(html.slice(lastBracketTokenEnd + 1, htmlLength));
        }
        break;
    }

    //if current token is bracket save it to lastBrackToken
    if (bracketsSet.has(currentToken)) {
      lastBracketToken = currentToken;
      lastBracketTokenEnd = currentTokenEnd;
      lastBracketTokenStart = currentTokenStart;
    }

    i++;
  }
}

module.exports = {
  parseFragment: parseFragment
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  HTML_END: 'HTML_END',
  OPEN_TAG_START: '<',
  TAG_END: '>',
  SELF_CLOSING: '/>',
  CLOSING_TAG_START: '</',
  SPACE: ' '
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(5);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _ui = __webpack_require__(46);

var _ui2 = _interopRequireDefault(_ui);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _backgroundMediaUtils = __webpack_require__(44);

var _backgroundMediaUtils2 = _interopRequireDefault(_backgroundMediaUtils);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getBackgroundPropertyDataPath(property) {
    var deviceType = _platformUtils2.default.getRGI().getDeviceType();
    return 'pageBackgrounds.' + deviceType + '.ref.' + property;
}

function getCurrentMediaRefData() {
    var RMI = members._RMI.get(this);
    var contextId = members._contextId.get(this);
    var contextData = RMI.getData(contextId);
    var mediaRefPath = getBackgroundPropertyDataPath('mediaRef');
    return _lodash2.default.get(contextData, mediaRefPath) || {};
}
/**
 * @typedef $w.Document~BackgroundOptions
 * @summary An object used by the `background` property that contains the background options.
 * @description
 *  Setting the `src` property of the `BackgroundOptions` object changes the
 *  displayed image or video to the image or video found at the new `src` value.
 *
 *  Getting the `src` property of the `BackgroundOptions` object returns the
 *  location of the current image or video file.
 *
 *  Images can either be from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
 *  or an external image from any web location. Videos must come from the
 *  <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>.
 *
 *  The URL formats supported are:
 *
 *  + Images from the Media Manager:
 *    `wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
 *  + Videos from the Media Manager:
 *    `wix:video://v1/<video_uri>/<filename>#posterUri=<poster_uri>&posterWidth=<width>&posterHeight=<height>`
 *  + Images from the web:
 *    `http(s)://<image url>`
 * @property {external:String} src The file location of the background image.
 * @snippet [Background-background_get.es6=Get the background information]
 * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
 * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
 * @see [background](#background)
 */

/**
 * @class Document
 * @summary A complete web page, which consists of a Header, Page, and Footer.
 * @classdesc
 *  Select the current document using: `$w("Document")`.
 * @memberof $w
 */

var Document = function () {
    function Document(RMI, compId, contextId, wixSelector, controllerId) {
        _classCallCheck(this, Document);

        members._RMI.set(this, RMI);
        members._compId.set(this, compId);
        members._contextId.set(this, contextId);
        members._wixSelector.set(this, wixSelector);
        members._controllerId.set(this, controllerId);
    }

    /**
     * @member background
     * @label property
     * @syntax
     * get background(): BackgroundOptions
     * @summary Gets an object containing information about the document's background, such as its image or video source.
     * @type {$w.Document~BackgroundOptions}
     * @snippet [Background-background_get.es6=Get the background information]
     * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
     * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
     * @memberof $w.Document
     * @readonly
     */


    _createClass(Document, [{
        key: 'background',
        get: function get() {
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            return new WrappedBackgroundOptions(RMI, contextId);
        }

        /**
         * @member children
         * @label property
         * @syntax
         * get children(): Node[]
         * @summary Gets the document's Header, Page, and Footer.
         * @snippet [Document-children_get.es6=Get the document's children]
         * @type {$w.Node[]}
         * @memberof $w.Document
         * @see [Header]($w.Header.html)
         * @see [Page]($w.Page.html)
         * @see [Footer]($w.Footer.html)
         * @readonly
         */

    }, {
        key: 'children',
        get: function get() {
            var childrens = [];
            var childrenTypes = ['Page', 'Header', 'Footer'];
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);
            var appDefId = RMI.getAppDefinitionId();
            var connectedCompIds = RMI.getAllCompIdsInScope();

            function getInstance(compType, viewerType) {
                var Clazz = _ui2.default[compType] || Element;
                var compId = RMI.getCompIdsFromType(viewerType)[0];
                if (_lodash2.default.isUndefined(appDefId) || appDefId === 'dataBinding' || _lodash2.default.includes(connectedCompIds, compId)) {
                    return new Clazz(RMI, compId, contextId, wixSelector, controllerId, undefined, { compType: compType, viewerType: viewerType });
                }
            }

            childrenTypes.forEach(function (type) {
                var viewerType = _utils.types.getPotentialViewerTypes(type)[0];
                var children = getInstance(type, viewerType);
                if (children) {
                    childrens.push(children);
                }
            });

            return childrens;
        }

        /**
         * @member type
         * @label property
         * @syntax
         * get type(): string
         * @summary Gets the document's type.
         * @description
         *  Gets the string `"$w.Document"`.
         * @snippet [Document-type_get.es6=Get the document's type]
         * @type {external:String}
         * @memberof $w.Document
         * @readonly
         */

    }, {
        key: 'type',
        get: function get() {
            return '$w.Document';
        }
    }]);

    return Document;
}();

exports.default = _monitoring2.default.monitorComponent(Document);

var BackgroundOptions = function () {
    function BackgroundOptions(RMI, contextId) {
        _classCallCheck(this, BackgroundOptions);

        members._RMI.set(this, RMI);
        members._contextId.set(this, contextId);
    }

    _createClass(BackgroundOptions, [{
        key: 'src',
        get: function get() {
            var mediaRef = getCurrentMediaRefData.call(this);
            return _backgroundMediaUtils2.default.buildFullUrlFromMediaRef(mediaRef);
        },
        set: function set(value) {
            var _this = this;

            if (!(0, _validation.validate)({
                compType: 'Document',
                functionName: 'backgroundImageUrl',
                dataToValidate: { url: value },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var contextData = RMI.getData(contextId);
            var mediaRefPath = getBackgroundPropertyDataPath('mediaRef');
            var currentMediaRef = _lodash2.default.get(contextData, mediaRefPath) || {};

            if ((0, _utils.isNilOrEmptyString)(value)) {
                _lodash2.default.set(contextData, mediaRefPath, null);
                RMI.setData(contextId, _lodash2.default.assign(contextData, {
                    pageBackgrounds: contextData.pageBackgrounds
                }));
                return;
            }

            var mediaData = _backgroundMediaUtils2.default.getMediaDataFromSrc(value);
            if (!mediaData) {
                return;
            }
            if (currentMediaRef && currentMediaRef.opacity) {
                _lodash2.default.assign(mediaData, { opacity: currentMediaRef.opacity });
            }
            _backgroundMediaUtils2.default.getFullMediaData(mediaData, function (fullMediaRefData) {
                if (!fullMediaRefData) {
                    return;
                }
                var updatedMediaRefData = getCurrentMediaRefData.call(_this);
                /*setDesignAsync with all media data*/
                _lodash2.default.set(contextData, mediaRefPath, mediaData);
                _lodash2.default.assign(updatedMediaRefData, fullMediaRefData);
                _lodash2.default.set(contextData, mediaRefPath, updatedMediaRefData);
                RMI.setData(contextId, _lodash2.default.assign(contextData, {
                    pageBackgrounds: contextData.pageBackgrounds
                }));
            });

            _lodash2.default.set(contextData, mediaRefPath, mediaData);
            RMI.setData(contextId, _lodash2.default.assign(contextData, {
                pageBackgrounds: contextData.pageBackgrounds
            }));
        }
    }]);

    return BackgroundOptions;
}();

var WrappedBackgroundOptions = _monitoring2.default.monitorClass(BackgroundOptions, _monitoring2.default.getRavenContextForComponent);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(94);

var _events2 = _interopRequireDefault(_events);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BIReporter = function () {
    function BIReporter(biService, pageUrl) {
        _classCallCheck(this, BIReporter);

        this.userCodeControllerIds = biService.userCodeContextIds;
        this.viewMode = biService.viewMode;
        this.restrictedReporters = _lodash2.default.mapValues(biService.reporters, function (reportFunc) {
            return _lodash2.default.once(reportFunc);
        });
        this.pageUrl = pageUrl;
    }

    _createClass(BIReporter, [{
        key: 'report',
        value: function report(_ref) {
            var eventName = _ref.eventName,
                params = _ref.params;

            if (this.restrictedReporters.reportBI) {
                this.restrictedReporters.reportBI((0, _events2.default)(eventName), params);
            }
        }
    }, {
        key: 'reportWixCodeInteraction',
        value: function reportWixCodeInteraction(_ref2) {
            var controllerId = _ref2.controllerId,
                appDefinitionId = _ref2.appDefinitionId;

            if (_lodash2.default.isNil(this.viewMode)) {
                return;
            }

            if (this.isUserCode(appDefinitionId, controllerId)) {
                var params = { pageUrl: this.pageUrl };
                this.report({ eventName: '$W_INTERACTION_' + _lodash2.default.upperCase(this.viewMode), params: params });
            }
        }
    }, {
        key: 'isUserCode',
        value: function isUserCode(appDefinitionId, controllerId) {
            return _lodash2.default.isUndefined(appDefinitionId) && _lodash2.default.isUndefined(controllerId) || _lodash2.default.includes(this.userCodeControllerIds, controllerId);
        }
    }]);

    return BIReporter;
}();

exports.default = BIReporter;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = {
    "$W_INTERACTION_PREVIEW": {
        "endpoint": "platform",
        "params": {
            "evid": 150,
            "src": 79
        }
    },
    "$W_INTERACTION_SITE": {
        "endpoint": 'platform-viewer',
        "params": {
            "evid": 136,
            "src": 79
        }
    }
};

function getBIEvent(eventName) {
    return _lodash2.default.get(events, eventName);
}

exports.default = getBIEvent;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.booleanInputClearance = exports.booleanInputInitialize = undefined;

var _validationsService = __webpack_require__(11);

var _valueValidatableInitialize = __webpack_require__(20);

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.checked;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
    };
};

var updateValidationState = function updateValidationState(RMI, compId) {
    return (0, _validationsService.runValidations)(RMI, compId);
};

var booleanInputInitialize = function booleanInputInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

var booleanInputClearance = function booleanInputClearance(RMI, contextId, compId) {
    return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.booleanInputInitialize = booleanInputInitialize;
exports.booleanInputClearance = booleanInputClearance;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxGroupClearance = exports.checkboxGroupInitialize = undefined;

var _validatableWithSyncInitialize = __webpack_require__(35);

var _validatableWithSyncInitialize2 = _interopRequireDefault(_validatableWithSyncInitialize);

var _valueValidatableInitialize = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkboxGroupInitialize = function checkboxGroupInitialize(RMI, contextId, compId) {
  return (0, _validatableWithSyncInitialize2.default)(RMI, contextId, compId);
};

var checkboxGroupClearance = function checkboxGroupClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.checkboxGroupInitialize = checkboxGroupInitialize;
exports.checkboxGroupClearance = checkboxGroupClearance;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.comboBoxInputClearance = exports.comboBoxInputInitialize = undefined;

var _valueValidatableInitialize = __webpack_require__(20);

var comboBoxInputInitialize = function comboBoxInputInitialize(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableInitialize)(RMI, contextId, compId);
};

var comboBoxInputClearance = function comboBoxInputClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.comboBoxInputInitialize = comboBoxInputInitialize;
exports.comboBoxInputClearance = comboBoxInputClearance;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePickerClearance = exports.datePickerInitialize = undefined;

var _validatableWithSyncInitialize = __webpack_require__(35);

var _validatableWithSyncInitialize2 = _interopRequireDefault(_validatableWithSyncInitialize);

var _valueValidatableInitialize = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var datePickerInitialize = function datePickerInitialize(RMI, contextId, compId) {
  return (0, _validatableWithSyncInitialize2.default)(RMI, contextId, compId);
};
var datePickerClearance = function datePickerClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.datePickerInitialize = datePickerInitialize;
exports.datePickerClearance = datePickerClearance;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioGroupClearance = exports.radioGroupInitialize = undefined;

var _validatableWithSyncInitialize = __webpack_require__(35);

var _validatableWithSyncInitialize2 = _interopRequireDefault(_validatableWithSyncInitialize);

var _valueValidatableInitialize = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var radioGroupInitialize = function radioGroupInitialize(RMI, contextId, compId) {
  return (0, _validatableWithSyncInitialize2.default)(RMI, contextId, compId);
};

var radioGroupClearance = function radioGroupClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.radioGroupInitialize = radioGroupInitialize;
exports.radioGroupClearance = radioGroupClearance;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textAreaInputClearance = exports.textAreaInputInitialize = undefined;

var _valueValidatableInitialize = __webpack_require__(20);

var textAreaInputInitialize = function textAreaInputInitialize(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableInitialize)(RMI, contextId, compId);
};

var textAreaInputClearance = function textAreaInputClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.textAreaInputInitialize = textAreaInputInitialize;
exports.textAreaInputClearance = textAreaInputClearance;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textInputClearance = exports.textInputInitialize = undefined;

var _valueValidatableInitialize = __webpack_require__(20);

var textInputInitialize = function textInputInitialize(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableInitialize)(RMI, contextId, compId);
};

var textInputClearance = function textInputClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.textInputInitialize = textInputInitialize;
exports.textInputClearance = textInputClearance;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadButtonClearance = exports.uploadButtonInitialize = undefined;

var _validationsService = __webpack_require__(11);

var _valueValidatableInitialize = __webpack_require__(20);

var onChangeValidationsEventHandler = function onChangeValidationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.value;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, value);
    };
};

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        return (0, _validationsService.runValidationsAndSync)(RMI, e.syntheticEvent.id);
    };
};

var updateValidationState = function updateValidationState(RMI, compId) {
    return (0, _validationsService.runValidationsAndSync)(RMI, compId);
};

var uploadButtonInitialize = function uploadButtonInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, onChangeValidationsEventHandler(RMI));
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().VALIDATE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

var uploadButtonClearance = function uploadButtonClearance(RMI, contextId, compId) {
    return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.uploadButtonInitialize = uploadButtonInitialize;
exports.uploadButtonClearance = uploadButtonClearance;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createEventFrom;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _WixEvent = __webpack_require__(19);

var _WixEvent2 = _interopRequireDefault(_WixEvent);

var _MouseEvent = __webpack_require__(161);

var _MouseEvent2 = _interopRequireDefault(_MouseEvent);

var _KeyboardEvent = __webpack_require__(160);

var _KeyboardEvent2 = _interopRequireDefault(_KeyboardEvent);

var _HtmlComponentMessageEvent = __webpack_require__(158);

var _HtmlComponentMessageEvent2 = _interopRequireDefault(_HtmlComponentMessageEvent);

var _GalleryItemClickedEvent = __webpack_require__(157);

var _GalleryItemClickedEvent2 = _interopRequireDefault(_GalleryItemClickedEvent);

var _GalleryItemChangedEvent = __webpack_require__(65);

var _GalleryItemChangedEvent2 = _interopRequireDefault(_GalleryItemChangedEvent);

var _TableCellEvent = __webpack_require__(163);

var _TableCellEvent2 = _interopRequireDefault(_TableCellEvent);

var _TableRowEvent = __webpack_require__(164);

var _TableRowEvent2 = _interopRequireDefault(_TableRowEvent);

var _IconMouseInEvent = __webpack_require__(159);

var _IconMouseInEvent2 = _interopRequireDefault(_IconMouseInEvent);

var _QuickActionBarItemClickedEvent = __webpack_require__(162);

var _QuickActionBarItemClickedEvent2 = _interopRequireDefault(_QuickActionBarItemClickedEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createEventFrom(data, controllerId) {
    var RMI = _platformUtils2.default.getRMI();
    var wixSelector = _platformUtils2.default.getWixSelector();
    var comp = wixSelector.getInstance(RMI, RMI.getType(data.compId), data.compId, controllerId);
    var EventTypes = RMI.getEventTypes();
    var type = _lodash2.default.get(data, 'event.action') || _lodash2.default.get(data, 'event.type');
    if (_lodash2.default.isUndefined(type)) {
        return new _WixEvent2.default(comp);
    }

    switch (type) {
        case EventTypes.MOUSE_IN:
        case EventTypes.MOUSE_OUT:
        case EventTypes.CLICK:
        case EventTypes.DBL_CLICK:
        case EventTypes.SCREEN_IN:
            return new _MouseEvent2.default(comp, data.event);
        case EventTypes.IMAGE_EXPANDED:
        case EventTypes.IMAGE_CHANGED:
            return new _GalleryItemChangedEvent2.default(comp, data.event);
        case EventTypes.KEY_PRESS:
            return new _KeyboardEvent2.default(comp, data.event);
        case EventTypes.MESSAGE:
            return new _HtmlComponentMessageEvent2.default(comp, data.event);
        case EventTypes.ITEM_CLICKED:
            return new _GalleryItemClickedEvent2.default(comp, data.event);
        case EventTypes.CELL_EDIT:
        case EventTypes.CELL_SELECT:
            return new _TableCellEvent2.default(comp, data.event);
        case EventTypes.ROW_SELECT:
            return new _TableRowEvent2.default(comp, data.event);
        case EventTypes.ICON_MOUSE_IN:
            return new _IconMouseInEvent2.default(comp, data.event);
        case EventTypes.QUICK_ACTION_BAR_ITEM_CLICKED:
            return new _QuickActionBarItemClickedEvent2.default(comp, data.event);
        default:
            return new _WixEvent2.default(comp, data.event);
    }
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* TURNED OFF JSDOC FOR THIS BLOCK; I DON'T THINK IT NEEDS TO BE EXPOSED TO THE USER:
 * @summary Types of links
 * @memberof $w
 * @enum {external:String}
 * @readonly
 */
var LinkType = {
  /**
   * Indicates linking to a Wix page
   */
  PAGE: 'PageLink',

  /**
   * Indicates linking to an external website
   */
  EXTERNAL: 'ExternalLink',
  /**
   * Indicates linking to an email address
   */
  EMAIL: 'EmailLink',
  /**
   * Indicates linking to a download
   */
  DOCUMENT: 'DocumentLink',

  /**
   * Indicates linking to the top of the page
   */
  PAGE_TOP: 'AnchorLink',
  /**
   * Indicates linking to the bottom of the page
   */
  PAGE_BOTTOM: 'AnchorLink',

  /**
   * Indicates linking to a Wix page w/ an Anchor
   */
  ANCHOR: 'AnchorLink',

  /**
   * Indicates linking to a phone number
   */
  PHONE: 'PhoneLink'
};

exports.default = LinkType;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(27);

var _namedReferenceRegex = __webpack_require__(109);

var _namedReferenceRegex2 = _interopRequireDefault(_namedReferenceRegex);

var _htmlEntitiesMap = __webpack_require__(55);

var _htmlEntitiesMap2 = _interopRequireDefault(_htmlEntitiesMap);

var _numericEntitiesMap = __webpack_require__(110);

var _numericEntitiesMap2 = _interopRequireDefault(_numericEntitiesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTITY_START = '&';
var ENTITY_END = ';';

function codePointToSymbol(codePoint) {
  var output = '';

  if (codePoint in _numericEntitiesMap2.default) {
    return _numericEntitiesMap2.default[codePoint];
  }

  if (codePoint > 0xFFFF) {
    codePoint -= 0x10000;
    output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
    codePoint = 0xDC00 | codePoint & 0x3FF;
  }

  return output + String.fromCharCode(codePoint);
}

function getEntities(str) {
  var result = [];
  var buffer = [];
  var include = false;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = str[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var char = _step.value;

      if (include && char !== ENTITY_END) {
        buffer.push(char);
      }

      if (char === ENTITY_START) {
        include = true;
      }

      if (char === ENTITY_END) {
        result.push(buffer.join(''));
        include = false;
        buffer = [];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

function decode(rawText) {
  if (!rawText) {
    return rawText;
  }

  if (self.he) {
    return self.he.decode(rawText);
  }

  var entities = getEntities(rawText);
  var canConvert = entities.every(function (entity) {
    return entity in _htmlEntitiesMap2.default || entity[0] === '#';
  });

  if (canConvert) {
    return rawText.replace(_namedReferenceRegex2.default, function ($0, $1, $2, $3) {

      if ($1) {
        return _htmlEntitiesMap2.default[$1];
      }

      if ($2) {
        return codePointToSymbol(parseInt($2, 10));
      }

      if ($3) {
        return codePointToSymbol(parseInt($3, 16));
      }

      return $0;
    });
  }

  self.importScripts(_constants.HE_URL);

  return decode(rawText);
}

exports.default = decode;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (receiver) {
    var receiverPropNames = getAllPropertyNames(receiver);

    (0, _lodash2.default)(receiverPropNames).filter(_asyncDecorator.isAsyncFunction).forEach(function (prop) {
        return Object.defineProperty(receiver, prop, {
            value: function value() {
                return Promise.resolve();
            },
            configurable: true
        });
    });

    var GhostClazz = _GhostClasses2.default[receiver.constructor.name + 'Ghost'];
    return GhostClazz ? (0, _mixin2.default)(receiver, GhostClazz.prototype) : receiver;
};

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _asyncDecorator = __webpack_require__(29);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _GhostClasses = __webpack_require__(165);

var _GhostClasses2 = _interopRequireDefault(_GhostClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllPropertyNamesRecursively = function getAllPropertyNamesRecursively(obj, propNames) {
    _lodash2.default.forEach(Object.getOwnPropertyNames(obj), function (name) {
        return propNames.add(name);
    });

    var prototype = Object.getPrototypeOf(obj);
    if (prototype && Object.getPrototypeOf(prototype)) {
        getAllPropertyNamesRecursively(Object.getPrototypeOf(obj), propNames);
    }
    return Array.from(propNames);
};

var getAllPropertyNames = function getAllPropertyNames(obj) {
    var propNames = new Set();
    return getAllPropertyNamesRecursively(obj, propNames);
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateId(prefix) {
    return _lodash2.default.uniqueId(prefix);
}

exports.default = { generateId: generateId };

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (receiver, suppliers) {
    var receiverProps = Object.getOwnPropertyNames(receiver);
    receiverProps.forEach(function (prop) {
        return delete receiver[prop];
    });

    return suppliers.map(function (supplier) {
        return (0, _mixin2.default)(receiver, supplier);
    });
};

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _htmlEntitiesMap = __webpack_require__(55);

var _htmlEntitiesMap2 = _interopRequireDefault(_htmlEntitiesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var namedReferences = Object.keys(_htmlEntitiesMap2.default).sort(function (a, b) {
  return b.length - a.length;
});

exports.default = new RegExp('&(' + namedReferences.join('|') + ');|&#([0-9]+);|&#[xX]([a-fA-F0-9]+);', 'g');

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "0": "\uFFFD",
  "128": "\u20AC",
  "130": "\u201A",
  "131": "\u0192",
  "132": "\u201E",
  "133": "\u2026",
  "134": "\u2020",
  "135": "\u2021",
  "136": "\u02C6",
  "137": "\u2030",
  "138": "\u0160",
  "139": "\u2039",
  "140": "\u0152",
  "142": "\u017D",
  "145": "\u2018",
  "146": "\u2019",
  "147": "\u201C",
  "148": "\u201D",
  "149": "\u2022",
  "150": "\u2013",
  "151": "\u2014",
  "152": "\u02DC",
  "153": "\u2122",
  "154": "\u0161",
  "155": "\u203A",
  "156": "\u0153",
  "158": "\u017E",
  "159": "\u0178"
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function findCurrentPage(pagesData, currentPageId) {
    for (var i = 0; i < pagesData.length; i++) {
        var currPage = pagesData[i];
        if (currPage.id === currentPageId) {
            return currPage;
        }
        if (currPage.childPages) {
            currPage = findCurrentPage(currPage.childPages, currentPageId);
            if (currPage && currPage.id === currentPageId) {
                return currPage;
            }
        }
    }
}

function removeCompIdFromPagesData(pagesData) {
    pagesData.forEach(function (pageData) {
        delete pageData.id;
        if (pageData.childPages) {
            removeCompIdFromPagesData(pageData.childPages);
        }
    });
}
//
// function isDynamicPage(routers, pageId) {
//     return some(routers, (routerData) => {
//         return includes(values(routerData.pages), pageId);
//     });
// }

function isDynamicPage(pageSiteStructureData) {
    return pageSiteStructureData.prefix;
}

function getPageURI(currentPageSiteStructureData, currentNavigationInfo) {
    if (isDynamicPage(currentPageSiteStructureData)) {
        return "/" + currentNavigationInfo.routerDefinition.prefix + "/" + currentNavigationInfo.innerRoute;
    }
    if (currentPageSiteStructureData) {
        return currentPageSiteStructureData.url;
    }
}

exports.findCurrentPage = findCurrentPage;
exports.removeCompIdFromPagesData = removeCompIdFromPagesData;
exports.isDynamicPage = isDynamicPage;
exports.getPageURI = getPageURI;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TypesUtil = function () {
    function TypesUtil(typesData) {
        _classCallCheck(this, TypesUtil);

        this.typesData = typesData;
    }

    /**
     * @typedef {Object} TypesData
     * @propery {Object} supportedComponentAPIs
     * @property {Object} viewerTypeToSdkTypeDefinitions
     */

    _createClass(TypesUtil, [{
        key: 'getPotentialViewerTypes',
        value: function getPotentialViewerTypes(sdkType) {
            var typeUtils = _platformUtils2.default.getTypeUtils();
            return typeUtils.getPotentialViewerTypes(sdkType);
        }
    }, {
        key: 'getSdkConstructorName',
        value: function getSdkConstructorName(compType) {
            var compData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var typeUtils = _platformUtils2.default.getTypeUtils();
            var widgetId = _lodash2.default.get(compData, ['widgetId']);
            return typeUtils.getSdkType(compType, widgetId);
        }
    }, {
        key: 'getDefaultSdkType',
        value: function getDefaultSdkType() {
            var typeUtils = _platformUtils2.default.getTypeUtils();
            return _lodash2.default.get(typeUtils, 'defaultSdkType');
        }
    }, {
        key: 'setType',
        value: function setType(viewerType, sdkType) {
            var typeUtils = _platformUtils2.default.getTypeUtils();
            typeUtils.setType(viewerType, sdkType);
        }
    }, {
        key: 'possibleTypes',
        get: function get() {
            var typeUtils = _platformUtils2.default.getTypeUtils();
            return _lodash2.default.get(typeUtils, 'Types');
        }
    }, {
        key: 'supportedComponentAPIs',
        get: function get() {
            return this.typesData.supportedComponentAPIs;
        }
    }]);

    return TypesUtil;
}();

exports.default = TypesUtil;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var supportedComponentAPIs = {
    'wysiwyg.viewer.components.BoxSlideShow': ['onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.StripContainerSlideShow': ['onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.SlideShowGallery': ['currentIndex', 'currentItem', 'showNavigationButtons', 'onCurrentItemChanged', 'onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.SliderGallery': ['clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.MatrixGallery': ['clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.PaginatedGridGallery': ['showNavigationButtons', 'onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Collage': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Masonry': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Honeycomb': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Accordion': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Freestyle': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Thumbnails': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'showNavigationButtons', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.StripShowcase': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'showNavigationButtons', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.StripSlideshow': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.tpapps.TPA3DCarousel': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.tpapps.TPA3DGallery': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Impress': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked']
};

/**
 * @typedef {Object} TypesData
 * @propery {Object} supportedComponentAPIs
 * @property {Object} viewerTypeToSdkTypeDefinitions
 */
exports.default = {
    supportedComponentAPIs: supportedComponentAPIs
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPresetNameOfEffect = exports.getOptionsMappingsOfEffect = exports.getOptionsDefaultsOfEffect = exports.getValidationSchemaOfEffect = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var effectValidationSchemas = __webpack_require__(88);
var effectOptionsMapping = __webpack_require__(87);
var effectOptionsDefaults = __webpack_require__(86);
var effectNameMappings = __webpack_require__(85);

function getValidationSchemaOfEffect(effect) {
    return _lodash2.default.get(effectValidationSchemas, effect);
}

function getOptionsDefaultsOfEffect(effect) {
    return _lodash2.default.get(effectOptionsDefaults, effect);
}

function getOptionsMappingsOfEffect(effect) {
    return _lodash2.default.get(effectOptionsMapping, effect, effectOptionsMapping.ALL);
}

function getPresetNameOfEffect(effect, suffix, noSuffixPresets) {
    effect = _lodash2.default.get(effectNameMappings, effect + '.' + suffix, effect);
    var capitalizedEffect = (0, _utils.capitalize)(effect);
    //Preset name is the name of the effect that we send to the viewer
    return _lodash2.default.includes(noSuffixPresets, effect) ? capitalizedEffect : '' + capitalizedEffect + suffix;
}

exports.getValidationSchemaOfEffect = getValidationSchemaOfEffect;
exports.getOptionsDefaultsOfEffect = getOptionsDefaultsOfEffect;
exports.getOptionsMappingsOfEffect = getOptionsMappingsOfEffect;
exports.getPresetNameOfEffect = getPresetNameOfEffect;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _effectSchemaAPI = __webpack_require__(114);

var _validation = __webpack_require__(3);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var effectOptionsForEffectInfoLink = function effectOptionsForEffectInfoLink(effectName) {
    return 'https://www.wix.com/code/reference/$w.EffectOptions.html#' + (0, _utils.capitalize)(effectName) + 'EffectOptions';
};
var effectInfoLink = function effectInfoLink(functionName) {
    return 'https://www.wix.com/code/reference/$w.HiddenMixin.html#' + functionName;
};
var effectOptionsInfoLink = 'https://www.wix.com/code/reference/$w.EffectOptions.html#';

function validateAndReportDeprecatedEffect(effectName, options, functionName, compName) {
    if (!_lodash2.default.isEmpty(options)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_deprecated_effect_with_options({
            functionName: functionName,
            compName: compName,
            effectName: effectName,
            infoLink: effectInfoLink(functionName)
        }));
        return false;
    }
    // TODO Uncomment when new docs are released
    // reporter.reportSdkWarning(generateError.warning_deprecated_effect_name({
    //     functionName,
    //     compName,
    //     effectName,
    //     infoLink: effectInfoLink(functionName)
    // }));
    return true;
}

function reportInvalidOptionsValue(value, key, functionName, compName, effectName) {
    _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_effect_options({
        functionName: functionName,
        compName: compName,
        effectName: effectName,
        wrongProperty: 'value',
        wrongValue: 'the key "' + key + '" cannot be set to the value "' + value + '"',
        infoLink: effectOptionsForEffectInfoLink(effectName)
    }));
}

function validateOptionKeysAndReportIfNecessary(effectName, optionKeys, validKeys, functionName, compName) {
    var invalidKeys = _lodash2.default.difference(optionKeys, validKeys);

    if (!_lodash2.default.isEmpty(invalidKeys)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_effect_options({
            functionName: functionName,
            compName: compName,
            effectName: effectName,
            wrongProperty: 'keys',
            wrongValue: invalidKeys,
            infoLink: effectOptionsForEffectInfoLink(effectName)
        }));
        return false;
    }
    return true;
}

function validateOptionValuesAndReportIfNecessary(effectName, options, validations, functionName, compName) {
    var res = true;
    _lodash2.default.forEach(options, function (value, k) {
        var effectValidations = validations[k];
        if (!(0, _validation.validateByType)({ value: value, expectedType: effectValidations.type })) {
            reportInvalidOptionsValue(value, k, functionName, compName, effectName);
            res = false;
            return;
        }

        if (effectValidations.enum && !_lodash2.default.includes(effectValidations.enum, value)) {
            reportInvalidOptionsValue(value, k, functionName, compName, effectName);
            res = false;
            return;
        }

        if (effectValidations.range && !(0, _validation.isValueInRange)({ value: value, minValue: effectValidations.range.minValue, maxValue: effectValidations.range.maxValue })) {
            reportInvalidOptionsValue(value, k, functionName, compName, effectName);
            res = false;
        }
    });
    return res;
}

function validateEffect(effect, options, functionName, compName, deprecatedValues) {
    if (!effect) {
        if (!_lodash2.default.isEmpty(options)) {
            _reporter2.default.reportSdkWarning(_errors.generateError.warning_effect_options_not_set({
                functionName: functionName,
                compName: compName,
                infoLink: effectInfoLink(functionName)
            }));
            return false;
        }
        return true;
    }

    if (_lodash2.default.includes(deprecatedValues, effect)) {
        return validateAndReportDeprecatedEffect(effect, options, functionName, compName);
    }

    var validationSchema = (0, _effectSchemaAPI.getValidationSchemaOfEffect)(effect);
    if (!validationSchema) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_effect_name({
            functionName: functionName,
            compName: compName,
            effectName: effect,
            infoLink: effectInfoLink(functionName)
        }));

        return false;
    }

    if (!_lodash2.default.isNil(options) && !(0, _validation.validateByType)({ value: options, expectedType: _validation.TYPES.OBJECT })) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_type_effect_options({
            functionName: functionName,
            compName: compName,
            effectName: effect,
            wrongValue: options,
            infoLink: effectOptionsInfoLink
        }));
        return false;
    }

    var validKeys = _lodash2.default.keys(validationSchema);
    var optionKeys = _lodash2.default.keys(options);
    var allOptionKeysValid = validateOptionKeysAndReportIfNecessary(effect, optionKeys, validKeys, functionName, compName);
    if (!allOptionKeysValid) {
        return false;
    }

    return validateOptionValuesAndReportIfNecessary(effect, options, validationSchema, functionName, compName);
}

function buildEffectParams(options, optionsDefaults, optionsMappings) {
    var params = _lodash2.default.clone(optionsDefaults);
    _lodash2.default.forEach(options, function (v, k) {
        var path = _lodash2.default.get(optionsMappings, 'keys.' + k) || k;

        var value = v;
        value = _lodash2.default.get(optionsMappings, 'values.' + k + '.convertMsToSecs') ? v / 1000 : value;
        value = _lodash2.default.get(optionsMappings, 'values.' + k + '.' + v, value);

        _lodash2.default.set(params, path, value);
    });
    return params;
}

function buildEffectObject(effect, options, functionData) {
    var deprecatedValues = functionData.deprecatedValues,
        suffix = functionData.suffix,
        noSuffixPresets = functionData.noSuffixPresets;

    if (_lodash2.default.includes(deprecatedValues, effect)) {
        return { presetName: effect, params: {} };
    }

    var presetName = (0, _effectSchemaAPI.getPresetNameOfEffect)(effect, suffix, noSuffixPresets);
    var optionsDefaults = (0, _effectSchemaAPI.getOptionsDefaultsOfEffect)(effect);
    var params = buildEffectParams(options, optionsDefaults, (0, _effectSchemaAPI.getOptionsMappingsOfEffect)(effect));

    return {
        presetName: presetName,
        params: params
    };
}

exports.default = {
    validateEffect: validateEffect,
    buildEffectObject: buildEffectObject
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cssLevel1 = {
    black: '#000000',
    silver: '#c0c0c0',
    gray: '#808080',
    white: '#ffffff',
    maroon: '#800000',
    red: '#ff0000',
    purple: '#800080',
    fuchsia: '#ff00ff',
    green: '#008000',
    lime: '#00ff00',
    olive: '#808000',
    yellow: '#ffff00',
    navy: '#000080',
    blue: '#0000ff',
    teal: '#008080',
    aqua: '#00ffff'
};

var cssLevel2 = {
    orange: '#ffa500',
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    blanchedalmond: '#ffebcd',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2'
};

var cssLevel3 = {
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    oldlace: '#fdf5e6',
    olivedrab: '#6b8e23',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    whitesmoke: '#f5f5f5',
    yellowgreen: '#9acd32'
};

var cssLevel4 = {
    rebeccapurple: '#663399'
};

var colorKeywords = _lodash2.default.assign({}, cssLevel1, cssLevel2, cssLevel3, cssLevel4);

exports.default = colorKeywords;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var validationExpressions = {
    validYouTubeLongUrlReg: /(?:youtube\.com\/watch[^\s]*[\?&]v=)([\w-]+)/,
    validYouTubeShortUrlReg: /(?:youtu\.be\/)([\w-]+)/,
    validVimeoUrlReg: /vimeo\.com\/(\d+)$/,
    validDailymotionUrlReg: /dailymotion\.com\/(?:video|playlist)\/([^_/]+)/,
    validFacebookUrlReg: /facebook\.com\/.+\/videos\/[A-Za-z0-9._%-]*/,
    validRepeaterItemId: /^[a-zA-Z\d-]+$/,
    validUUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
};

exports.default = validationExpressions;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unsetCompValidationState = exports.setCompValidationState = exports.getCompValidationState = exports.initValidationsServiceState = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validationsServiceState = void 0;

var initValidationsServiceState = function initValidationsServiceState() {
    validationsServiceState = {};
};

var getCompValidationState = function getCompValidationState(compId) {
    return _lodash2.default.clone(_lodash2.default.get(validationsServiceState, compId));
};

var setCompValidationState = function setCompValidationState(compId, validationState) {
    var currentValidationState = getCompValidationState(compId);

    var newValidationState = _lodash2.default.assign({}, currentValidationState, validationState);

    _lodash2.default.set(validationsServiceState, [compId], newValidationState);
};

var unsetCompValidationState = function unsetCompValidationState(compId) {
    _lodash2.default.unset(validationsServiceState, compId);
};

exports.initValidationsServiceState = initValidationsServiceState;
exports.getCompValidationState = getCompValidationState;
exports.setCompValidationState = setCompValidationState;
exports.unsetCompValidationState = unsetCompValidationState;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCompsForType(types, scopedRMI, type, onlyNestedScope) {
    return _lodash2.default.transform(types.getPotentialViewerTypes(type), function (result, value) {
        var compIds = scopedRMI.getCompIdsFromType(value, onlyNestedScope) || [];
        var ghostIds = scopedRMI.getGhostCompIdsFromType ? scopedRMI.getGhostCompIdsFromType(value, onlyNestedScope) || [] : [];
        _lodash2.default.concat(compIds, ghostIds).forEach(function (compId) {
            if (getSdkPublicName(types, scopedRMI, compId) === type) {
                result.push({
                    id: compId,
                    type: value
                });
            }
        });
    }, []);
}

function getCompIdsForRole(scopedRMI, role, onlyNestedScope) {
    var compIds = scopedRMI.getCompIdsFromRole(role, onlyNestedScope);
    var ghostIds = scopedRMI.getGhostCompIdsFromRole ? scopedRMI.getGhostCompIdsFromRole(role, onlyNestedScope) : [];
    return _lodash2.default.concat(compIds, ghostIds);
}

function getSdkConstructorName(types, RMI, compId) {
    var compType = RMI.getType(compId);
    var compData = RMI.getData(compId);
    if (!compType) {
        return null;
    }
    /**
     * Temporary fix for proGallery wixCodeSDK so they can rollout their Iframe/Native Mode to some users.
     * Once they will finish rollout we can remove this code together with this code:
     * https://github.com/wix-private/santa-core/blob/2c230728281e247c7df79d89ba446d37ef4ced27/santa-platform-utils/src/typeUtils/typeData.js#L77
     * This will enable proGallery to expose wixCode API via the controller and not ProGallery.es6
     */
    if (compType === 'wysiwyg.viewer.components.tpapps.TPAWidgetNative' && _lodash2.default.get(compData, 'widgetId') === '142bb34d-3439-576a-7118-683e690a1e0d') {
        return 'Native';
    }
    return types.getSdkConstructorName(compType, compData);
}

function getSdkPublicName(types, RMI, compId) {
    var compType = RMI.getType(compId);
    var compData = RMI.getData(compId);
    if (!compType) {
        return null;
    }
    return types.getSdkConstructorName(compType, compData);
}

exports.default = {
    getCompsForType: getCompsForType,
    getCompIdsForRole: getCompIdsForRole,
    getSdkConstructorName: getSdkConstructorName,
    getSdkPublicName: getSdkPublicName
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _menuUtils = __webpack_require__(40);

var _menuUtils2 = _interopRequireDefault(_menuUtils);

var _validation = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @class AccountNavBar
 * @summary Provides all functionality related to UserProfileMenu
 * @classdesc The `UserProfileMenu` class provides functionality related to Wix UserProfileMenu.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof wix.ui
 * @tagname AccountNavBar
 * @viewername wysiwyg.viewer.components.LoginSocialBar
 * @definitionId wysiwyg.viewer.components.LoginSocialBar
 */
var AccountNavBar = function (_Element) {
    _inherits(AccountNavBar, _Element);

    function AccountNavBar() {
        _classCallCheck(this, AccountNavBar);

        return _possibleConstructorReturn(this, (AccountNavBar.__proto__ || Object.getPrototypeOf(AccountNavBar)).apply(this, arguments));
    }

    _createClass(AccountNavBar, [{
        key: 'menuItems',
        set: function set(menuItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'menuItems',
                dataToValidate: { menuItems: menuItems },
                compName: this.id
            })) {
                return this;
            }
            if (_lodash2.default.isNil(menuItems)) {
                menuItems = [];
            }
            var validMenuItems = _menuUtils2.default.checkUserProfileMenuItemsValidation({
                navItems: menuItems,
                functionName: 'menuItems',
                compName: this.id
            });
            var convertedMenuItems = _lodash2.default.map(validMenuItems, function (menuItem, menuItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'menuItems');
            });

            RMI.setData(members._compId.get(this), { menuItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedMenuItems } } });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var menuItems = _lodash2.default.get(data, 'menuItemsRef.menuRef.items');
            return _lodash2.default.map(menuItems, function (menuItem) {
                return _menuUtils2.default.convertNavItemToUserFormat(menuItem);
            });
        }
    }, {
        key: 'navBarItems',
        set: function set(navBarItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'navBarItems',
                dataToValidate: { navBarItems: navBarItems },
                compName: this.id
            })) {
                return this;
            }
            if (_lodash2.default.isNil(navBarItems)) {
                navBarItems = [];
            }
            var validNavBarItems = _menuUtils2.default.checkUserProfileNavBarItemsValidation({
                navItems: navBarItems,
                functionName: 'navBarItems',
                compName: this.id
            });
            var convertedNavItems = _lodash2.default.map(validNavBarItems, function (navItem, navItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, navItem, navItemIndex, 'navBarItems', true);
            });
            RMI.setData(members._compId.get(this), { iconItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedNavItems } } });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var navBarItems = _lodash2.default.get(data, 'iconItemsRef.menuRef.items');
            return _lodash2.default.map(navBarItems, function (navBarItem) {
                return _menuUtils2.default.convertNavItemToUserFormat(navBarItem);
            });
        }
    }]);

    return AccountNavBar;
}(_Element3.default);

(0, _mixin2.default)(AccountNavBar.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = AccountNavBar;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = __webpack_require__(33);

var _Node3 = _interopRequireDefault(_Node2);

var _ViewportMixin = __webpack_require__(48);

var _ViewportMixin2 = _interopRequireDefault(_ViewportMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Anchor
 * @summary <a href="https://www.wix.com/support/html5/article/about-anchors" target="_blank">Anchors</a>
 *  are invisible position markers which you can place anywhere on your site.
 *  They are a useful way to direct users to important sections.
 * @mixes $w.Node
 * @mixes $w.ViewportMixin
 * @memberof $w
 * @viewername wysiwyg.common.components.anchor.viewer.Anchor
 * @definitionId wysiwyg.common.components.anchor.viewer.Anchor
 * @tagname Anchor
 */
var Anchor = function (_Node) {
    _inherits(Anchor, _Node);

    function Anchor() {
        _classCallCheck(this, Anchor);

        return _possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).apply(this, arguments));
    }

    _createClass(Anchor, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                name = this.name;

            return { id: id, type: type, global: global, rendered: rendered, name: name };
        }
    }, {
        key: 'name',

        /**
         * @member name
         * @label property
         * @syntax
         * get name(): string
         * @summary Gets the name of an anchor.
         * @description
         *  An anchor's `name` is used as a label for the anchor. The value of the `name`
         *  property appears in [anchor menus](https://support.wix.com/en/article/anchor-menu).
         *
         *  An anchor's `name` is set in the Editor using the Anchor Settings panel.
         *  ![Anchor Settings](images/anchor_settings.png "Anchor Settings")
         * @snippet [Anchor-name.es6=Get an anchor's name]
         * @type {external:String}
         * @see [id](#id)
         * @memberof $w.Anchor
         * @instance
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).name;
        }
    }]);

    return Anchor;
}(_Node3.default);

(0, _mixin2.default)(Anchor.prototype, _ViewportMixin2.default.prototype);

exports.default = Anchor;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppController2 = __webpack_require__(58);

var _AppController3 = _interopRequireDefault(_AppController2);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* DISABLING JSDOC FOR THIS CLASS UNTIL FURTHER NOTICE:
 * @class AppWidget
 * @summary Provides functionality for the Wix Application Controller.
 * @mixes $w.Node
 * @mixes $w.AppController
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname AppWidget
 * @viewername platform.components.AppWidget
 */
var AppWidget = function (_AppController) {
  _inherits(AppWidget, _AppController);

  function AppWidget() {
    _classCallCheck(this, AppWidget);

    return _possibleConstructorReturn(this, (AppWidget.__proto__ || Object.getPrototypeOf(AppWidget)).apply(this, arguments));
  }

  return AppWidget;
}(_AppController3.default);

(0, _mixin2.default)(AppWidget.prototype, _ContainableMixin2.default.prototype);
(0, _mixin2.default)(AppWidget.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = AppWidget;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Box
 * @summary Container <a href="https://support.wix.com/en/article/container-boxes" target="_blank">boxes</a>
 *  are used to structure your site. You can <a href="https://support.wix.com/en/article/attaching-elements-to-a-box" target="_blank">attach</a>
 *  any element to a container box and move the box around, which is a useful
 *  way to to keep elements together. Some actions performed on a box affect the
 *  elements it contains. For example, [hiding](#hide) a box also effectively
 *  hides all the elements in the box, although the values of the
 *  [hidden](#hidden) properties of the elements contained in the box do not change.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @tagname Box
 * @viewername mobile.core.components.Container
 * @definitionId mobile.core.components.Container
 * @definitionId wysiwyg.viewer.components.Group
 */

/**
 * @member style
 * @label property
 * @syntax
 * get style(): Style
 * @summary Gets an object containing information about the box's styles.
 * @description
 *  The following styles can be used with boxes:
 *
 *  + [`backgroundColor`]($w.Style.html#backgroundColor)
 *  + [`borderColor`]($w.Style.html#borderColor)
 *  + [`borderWidth`]($w.Style.html#borderWidth)
 * @note
 *  Not all styles can be used on all box designs. To determine which styles
 *  work with a specific box design, go to the **Box Design** panel in
 *  the Editor, choose a design, and click **Customize Design**. The design
 *  options that you see in the **Box Design** panel for your particular
 *  box are the styles you can use in your code.
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Box
 * @readonly
 * @override
 */

var Box = function (_Element) {
  _inherits(Box, _Element);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  return Box;
}(_Element3.default);

(0, _mixin2.default)(Box.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Box.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Box.prototype, _ContainableMixin2.default.prototype);
(0, _mixin2.default)(Box.prototype, _StyleMixin2.default.prototype);

exports.default = Box;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _validation = __webpack_require__(3);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(32);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

var _CheckedMixin = __webpack_require__(72);

var _CheckedMixin2 = _interopRequireDefault(_CheckedMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Checkbox
 * @summary Checkboxes are used for a single binary choice.
 * @mixes $w.FormElement
 * @mixes $w.DisabledMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @mixes $w.CheckedMixin
 * @memberof $w
 * @tagname checkbox
 * @viewername wysiwyg.viewer.components.inputs.Checkbox
 * @AppController wysiwyg.viewer.components.inputs.Checkbox
 */
var Checkbox = function (_FormElement) {
  _inherits(Checkbox, _FormElement);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'toJSON',
    value: function toJSON() {
      var id = this.id,
          type = this.type,
          global = this.global,
          rendered = this.rendered,
          required = this.required,
          value = this.value,
          checked = this.checked;

      return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, checked: checked };
    }
  }, {
    key: 'value',


    /**
     * @member value
     * @label property
     * @syntax
     * get value(): string
     * set value(value: string): void
     * @summary Sets or gets a checkbox's value.
     * @description
     *  The `value` property is not related to whether the checkbox is checked or
     *  not. To determine the checked status of a checkbox, use the [`checked`](#checked)
     *  property.
     *
     *  The `value` property is used for storing a value that is associated with
     *  the checkbox.
     *
     *  It is not considered when evaluating the checkbox's validity
     *  and it does not trigger an `onChange` event when the value is modified.
     *
     *  Even if a checkbox is connected to a dataset, its `value` property
     *  is not related to the value of the collection field it is connected to.
     *  The field's value is determined by the checkbox's [`checked`](#checked) property.
     * @note
     *  Changing a checkbox's `value` in code does not trigger an `onChange` event.
     * @snippet [FormElement-value_get.es6=Get an element's value]
     * @snippet [FormElement-value_set.es6=Set an element's value]
     * @type {external:String}
     * @memberof $w.Checkbox
     * @override
     */
    get: function get() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);
      return RMI.getData(compId).value;
    }

    /**
     * @member value
     * @memberof $w.Checkbox
     * @param {external:String} val
     */
    ,
    set: function set(val) {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);
      var compData = RMI.getFullDataWithOverrides(compId);
      var compType = members._type.get(this).compType;
      var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
      var isValid = (0, _validation.validate)({
        compType: compType,
        functionName: 'value',
        dataToValidate: { value: value },
        compName: this.id
      });

      if (!isValid) {
        return;
      }

      RMI.setData(compId, { value: value });
    }
  }]);

  return Checkbox;
}(_FormElement3.default);

// THE FOLLOWING JSDOC SNIPPETS ARE NOT ATTACHED TO ACTUAL CODE BUT WILL HELP TO MAKE
//  THESE CHECKBOX METHODS MORE UNDERSTANDABLE, AS THEY FUNCTION DIFFERENTLY FOR CHECKBOXES:

/**
 * @member checked
 * @label property
 * @syntax
 * get checked(): boolean
 * set checked(value: boolean): void
 * @summary Sets or gets whether a checkbox is checked.
 * @description
 *  Setting the `checked` property to `true` places a check in
 *  the checkbox. Setting it to `false` removes the check from the checkbox.
 *
 *  Getting the `checked` property returns
 *  whether the checkbox is checked or unchecked.
 * @snippet [Checkbox-checked_get.es6=Get whether a checkbox is checked]
 * @snippet [Checkbox-checked_set.es6=Set a checkbox to be checked]
 * @snippet [Checkbox-checked_toggle.es6=Toggle whether a checkbox is checked]
 * @type {external:Boolean}
 * @memberof $w.Checkbox
 * @override
 */

/**
 * @member checked
 * @memberof $w.Checkbox
 * @param {external:Boolean} val
 */

/**
 * @member required
 * @label property
 * @syntax
   * get required(): boolean
   * set required(value: boolean): void
 * @summary Determines if a checkbox is required to be checked.
 * @description
 *  If `required` is `true`, the checkbox is only valid if it is
 *  [checked](#checked).
 *
 *  If `required` is `false`, the checkbox is always valid.
 *
 *  You can also set a checkbox to be required
 *  by using the element's Settings pane in the Editor.
 * @type {external:Boolean}
 * @memberof $w.Checkbox
 * @override
 */

/**
 * @member required
 * @memberof $w.Checkbox
 * @param {external:Boolean} val
 */

/**
 * @member style
 * @label property
 * @syntax
 * get style(): Style
 * @summary Gets an object containing information about the checkbox's styles.
 * @description
 *  The following styles can be used with checkboxes:
 *
 *  + [`backgroundColor`]($w.Style.html#backgroundColor)
 *  + [`borderColor`]($w.Style.html#borderColor)
 *  + [`borderRadius`]($w.Style.html#borderRadius)
 *  + [`borderWidth`]($w.Style.html#borderWidth)
 *
 *
 *  Getting or setting a checkbox's styles, gets or sets the styles of the
 *  checkbox's regular state. It does not set the styles of the checkbox's hover,
 *  focus, error, or disabled states.
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Checkbox
 * @readonly
 * @override
 */

(0, _mixin2.default)(Checkbox.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(Checkbox.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Checkbox.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(Checkbox.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Checkbox.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(Checkbox.prototype, _RequiredMixin2.default.prototype);
(0, _mixin2.default)(Checkbox.prototype, _CheckedMixin2.default.prototype);

exports.default = Checkbox;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _utils = __webpack_require__(5);

var _validation = __webpack_require__(3);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(32);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _optionsUtils = __webpack_require__(41);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

var _checkboxGroupUtils = __webpack_require__(53);

var _validationsService = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class CheckboxGroup
 * @summary Checkbox groups are used for selecting any number of the given
 *  options. Checkbox groups consist of a list of [options](#Option). Each
 *  [option](#Option) contains a label, which is what the user sees, and a
 *  value, which is what is used in code and stored in you collections.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.CheckboxGroup
 * @definitionId wysiwyg.viewer.components.inputs.CheckboxGroup
 * @tagname CheckboxGroup
 */
var CheckboxGroup = function (_FormElement) {
    _inherits(CheckboxGroup, _FormElement);

    function CheckboxGroup() {
        _classCallCheck(this, CheckboxGroup);

        return _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).apply(this, arguments));
    }

    _createClass(CheckboxGroup, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                options = this.options,
                selectedIndices = this.selectedIndices;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, options: options, selectedIndices: selectedIndices };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the checkbox group's styles.
         * @description
         *  The following styles can be used with a checkbox group:
         *
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`color`]($w.Style.html#color)
         *
         * 
         * 
         * 
         *  Getting or setting a checkbox group's styles, gets or sets the styles of the
         *  checkbox group's regular state. It does not set the styles of the checkbox group's hover,
         *  focus, error, or disabled states.
         * 
         * 
         * 
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.CheckboxGroup
         * @readonly
         * @override
         */

    }, {
        key: 'options',


        /**
         * @typedef {external:Object} $w.CheckboxGroup~Option
         * @summary An object used by the `options` property that contains the attributes of checkbox item.
         * @property {external:String} value The value of the checkbox option. This is what you use in code and is what is stored in your collections.
         * @property {external:String} [label] The label of the checkbox option. This is what a user sees.
         * @see [options](#options)
         * @see [value](#value)
         */

        /**
         * @member options
         * @label property
         * @syntax
         * get options(): Option[]
         * set options(value: options[]): void
         * @summary Sets or gets the options of a checkbox group.
         * @description
         *  Setting the `options` property sets all the [options](#Option)
         *  available to a user.
         *
         *  Getting the `options` property returns the current
         *  list of [options](#Option) available to a user.
         *
         *  You cannot modify the data array in-place. To add, change, or remove
         *  individual checkbox options:
         *
         *    1. Store the value of the `options` property in a variable.
         *    1. Make changes to the options array.
         *    1. Reset the `options` property with the modified array.
         * @snippet [CheckboxGroup-options_get.es6=Get the list of options and the first option's label and value from a checkbox group]
         * @snippet [CheckboxGroup-options_set.es6=Set the list of options for a checkbox group]
         * @snippet [CheckboxGroup-add.es6=Add an option to a checkbox group]
         *  This example retrieves the options of a checkbox group, adds a new
         *  option, and then overwrites the old options.
         * @type {$w.CheckboxGroup~Option[]}
         * @default An empty array
         * @memberof $w.CheckboxGroup
         * @instance
         */
        get: function get() {
            return _optionsUtils.getOptionsFromFull.call(this);
        }

        /**
         * @member options
         * @memberof $w.CheckboxGroup
         * @param {$w.CheckboxGroup~Option[]} newOptions
         */
        ,
        set: function set(newOptions) {
            var _this2 = this;

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'options',
                dataToValidate: { options: newOptions },
                compName: this.id
            });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = _lodash2.default.every(newOptions, function (v, i) {
                return (0, _validation.validate)({
                    compType: compType,
                    functionName: 'options',
                    dataToValidate: { CheckboxInput: v },
                    shouldCheckMandatoryFields: true,
                    itemIndex: i,
                    compName: _this2.id
                }) && (0, _optionsUtils.validateOption)(v, i, 'CheckboxInput');
            });
            if (!arrItemsArrValid) {
                return;
            }

            var oldCheckedByValue = _lodash2.default.reduce(_optionsUtils.getOptionsFromFullWithChecked.call(this), function (checkedByValue, _ref) {
                var value = _ref.value,
                    checked = _ref.checked;

                checkedByValue[value] = checked;
                return checkedByValue;
            }, {});
            var options = (0, _utils.nullIfNil)(newOptions) ? (0, _optionsUtils.optionsToDisplay)(newOptions) : [];
            var value = _lodash2.default.get(RMI.getState(compId), 'value', []);
            var modifiedOptions = options.map(function (option) {
                return {
                    value: option.value,
                    label: option.label,
                    checked: _lodash2.default.get(oldCheckedByValue, option.value, _lodash2.default.includes(value, option.value)),
                    type: 'CheckboxInput'
                };
            });

            (0, _validationsService.runValidationsAndSync)(RMI, compId, (0, _checkboxGroupUtils.getCheckedValues)(modifiedOptions));
            Utils.setData(this, { options: modifiedOptions });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string[]
         * set value(value: string[]): void
         * @summary Sets or gets the value of the selected options.
         * @description
         *  Setting the `value` property sets the [`options`](#Option)
         *  with those values to be the selected options. You must set the `value`
         *  property to values that exists in the [`options`](#options) list.
         *
         *  To reset the checkbox group to have no options
         *  selected, set the `value` property to an empty array, `null` or `undefined`.
         *
         *  Getting the `value` property returns the values of
         *  the currently selected options. If no value is selected, the
         *  `value` property returns an empty array.
         * @note
         *  Changing a checkbox group's `value` in code does not trigger an `onChange` event.
         * @snippet [CheckboxGroup-value_get.es6=Get the values of the selected options]
         * @snippet [CheckboxGroup-value_set.es6=Set the selected options by values]
         * @type {external:String[]}
         * @memberof $w.CheckboxGroup
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            return (0, _checkboxGroupUtils.getCheckedValues)(_optionsUtils.getOptionsFromFullWithChecked.call(this));
        }

        /**
         * @member value
         * @memberof $w.CheckboxGroup
         * @param {external:String[]} val
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'value',
                dataToValidate: { value: val },
                compName: this.id
            });

            if (!isValid) {
                return;
            }
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var newState = _lodash2.default.defaults({ value: value }, RMI.getState(compId));

            RMI.updateModel(_defineProperty({}, compId, { state: newState }));

            var modifiedOptions = this.options.map(function (option) {
                return {
                    value: option.value,
                    label: option.label,
                    checked: _lodash2.default.includes(value, option.value),
                    type: 'CheckboxInput'
                };
            });

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, value);
            RMI.setData(compId, { options: modifiedOptions });
        }

        /**
         * @member selectedIndices
         * @label property
         * @syntax
         * get selectedIndices(): Number[]
         * set selectedIndices(value: Number[]): void
         * @summary Sets or gets the indices of the selected options.
         * @description
         *  Setting the `selectedIndices` property sets the options at
         *  each specified index to be a selected option.
         *
         *  To reset the checkbox group to have no option
         *  selected, set the `selectedIndices` property to an empty array or `undefined`.
         *
         *  Getting the `selectedIndices` property returns an array of the indices of
         *  all selected options. If no value is selected, the `selectedIndices`
         *  property returns an empty array.
         * @type {external:Number[]}
         * @snippet [CheckboxGroup-selectedIndices_get.es6=Get the indices of the selected options]
         * @snippet [CheckboxGroup-selectedIndices_set.es6=Select the selected options by indices]
         * @memberof $w.CheckboxGroup
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'selectedIndices',
        get: function get() {
            return (0, _checkboxGroupUtils.getCheckedIndices)(_optionsUtils.getOptionsFromFullWithChecked.call(this));
        }

        /**
         * @member selectedIndices
         * @memberof $w.CheckboxGroup
         * @param {external:Number[]} indices
         */
        ,
        set: function set(indices) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            var options = _optionsUtils.getOptionsFromFull.call(this);
            var acceptNil = true;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'selectedIndices',
                dataToValidate: { selectedIndices: indices },
                compName: this.id
            }) || _lodash2.default.some(indices, function (index) {
                return !(0, _validation.validateRange)({
                    functionName: 'selectedIndices',
                    propertyName: 'selectedIndices',
                    value: index,
                    minValue: 0,
                    maxValue: options.length - 1,
                    acceptNil: acceptNil
                });
            })) {
                return;
            }

            var value = [];

            var modifiedOptions = _lodash2.default.map(options, function (option, index) {
                var checked = _lodash2.default.includes(indices, index);
                if (checked) {
                    value.push(option.value);
                }
                return _lodash2.default.assign(option, { checked: checked, type: 'CheckboxInput' });
            });
            var newState = _lodash2.default.defaults({ value: value }, RMI.getState(compId));
            RMI.updateModel(_defineProperty({}, compId, { state: newState }));

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, (0, _checkboxGroupUtils.getCheckedValues)(modifiedOptions));
            Utils.setData(this, { options: modifiedOptions });
        }
    }]);

    return CheckboxGroup;
}(_FormElement3.default);

(0, _mixin2.default)(CheckboxGroup.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(CheckboxGroup.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(CheckboxGroup.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(CheckboxGroup.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(CheckboxGroup.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(CheckboxGroup.prototype, _RequiredMixin2.default.prototype);

exports.default = CheckboxGroup;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Background2 = __webpack_require__(21);

var _Background3 = _interopRequireDefault(_Background2);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Column
 * @summary A `Column` is a component part of a `ColumnStrip`.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.Background
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname column
 * @viewername wysiwyg.viewer.components.Column
 * @definitionId wysiwyg.viewer.components.Column
 */
var Column = function (_Background) {
  _inherits(Column, _Background);

  function Column() {
    _classCallCheck(this, Column);

    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }

  return Column;
}(_Background3.default);

(0, _mixin2.default)(Column.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Column.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Column.prototype, _ContainableMixin2.default.prototype);

exports.default = Column;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Background2 = __webpack_require__(21);

var _Background3 = _interopRequireDefault(_Background2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _componentsBatchFunctions = __webpack_require__(39);

var _componentsBatchFunctions2 = _interopRequireDefault(_componentsBatchFunctions);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class ColumnStrip
 * @summary A `ColumnStrip` is a strip of `Column` elements.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname columnstrip
 * @viewername wysiwyg.viewer.components.StripColumnsContainer
 * @definitionId wysiwyg.viewer.components.StripColumnsContainer
 */

var ColumnStrip = function (_Background) {
    _inherits(ColumnStrip, _Background);

    function ColumnStrip() {
        _classCallCheck(this, ColumnStrip);

        return _possibleConstructorReturn(this, (ColumnStrip.__proto__ || Object.getPrototypeOf(ColumnStrip)).apply(this, arguments));
    }

    _createClass(ColumnStrip, [{
        key: 'columns',


        /**
         * @member columns
         * @label property
         * @syntax
           * get columns(): Column[]
         * @summary Gets a list of all the columns contained in the column strip.
         * @description
         *  Note that the column indices in a column strip are zero-based, even though
         *  they are numbered starting from 1 in the Editor.
         * @snippet [ColumnStrip-columns.es6=Get a column strip's columns]
         * @snippet [ColumnStrip-columns_plus.es6=Get the columns, number of columns, and ID of the first column from a column strip]
         * @type {$w.Column[]}
         * @memberof $w.ColumnStrip
         * @instance
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var wixSelector = members._wixSelector.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);

            var columns = RMI.getChildren(compId).filter(function (id) {
                return _lodash2.default.includes(_utils.types.getPotentialViewerTypes('Column'), RMI.getComp(id).type);
            }).map(function (id) {
                return wixSelector.getInstance(RMI, RMI.getComp(id).type, id, controllerId);
            });

            return _componentsBatchFunctions2.default.expose(columns);
        }

        /**
         * @member background
         * @label property
         * @syntax
         * get background(): BackgroundOptions
         * @summary Gets an object containing information about the column strip's background, such as its image or video source.
         * @type {$w.Document~BackgroundOptions}
         * @snippet [Background-background_get.es6=Get the background information]
         * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
         * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
         * @memberof $w.ColumnStrip
         * @readonly
         */

    }, {
        key: 'background',
        get: function get() {
            if (this.columns.length === 1) {
                return _lodash2.default.head(this.columns).background;
            }

            return _get(ColumnStrip.prototype.__proto__ || Object.getPrototypeOf(ColumnStrip.prototype), 'background', this);
        }
    }]);

    return ColumnStrip;
}(_Background3.default);

(0, _mixin2.default)(ColumnStrip.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(ColumnStrip.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(ColumnStrip.prototype, _ContainableMixin2.default.prototype);

exports.default = ColumnStrip;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Background2 = __webpack_require__(21);

var _Background3 = _interopRequireDefault(_Background2);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Container
 * @summary A container for Repeater items.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.Background
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname cell
 * @viewername wysiwyg.viewer.components.MediaContainer
 * @definitionId wysiwyg.viewer.components.MediaContainer
 */

var Container = function (_Background) {
  _inherits(Container, _Background);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_Background3.default);

(0, _mixin2.default)(Container.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Container.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Container.prototype, _ContainableMixin2.default.prototype);

exports.default = Container;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _ReadOnlyMixin = __webpack_require__(38);

var _ReadOnlyMixin2 = _interopRequireDefault(_ReadOnlyMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _utils = __webpack_require__(5);

var _validationsService = __webpack_require__(11);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class DatePicker
 * @summary A `DatePicker` is used for entering dates. It lets users populate a
 *  date field by picking a date using a calendar popup.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ReadOnlyMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.DatePicker
 * @definitionId wysiwyg.viewer.components.inputs.DatePicker
 * @tagname datepicker
 */
var DatePicker = function (_FormElement) {
    _inherits(DatePicker, _FormElement);

    function DatePicker() {
        _classCallCheck(this, DatePicker);

        return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
    }

    _createClass(DatePicker, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                readOnly = this.readOnly,
                required = this.required,
                value = this.value,
                maxDate = this.maxDate,
                minDate = this.minDate,
                disabledDates = this.disabledDates,
                disabledDaysOfWeek = this.disabledDaysOfWeek;

            return {
                id: id,
                type: type,
                global: global,
                rendered: rendered,
                readOnly: readOnly,
                required: required,
                value: value,
                maxDate: maxDate,
                minDate: minDate,
                disabledDates: disabledDates,
                disabledDaysOfWeek: disabledDaysOfWeek
            };
        }
    }, {
        key: 'value',


        /**
         * @member value
         * @label property
         * @syntax
         * get value(): Date
         * set value(value: Date): void
         * @summary Sets or gets the value of the date picker.
         * @note
         *  Changing a date picker's `value` in code does not trigger an `onChange` event.
         *
         *  If a date picker is connected to a dataset, setting the date picker's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [DatePicker-value_get.es6=Get a datepicker's date value]
         * @snippet [DatePicker-value_set.es6=Set a datepicker's date value to be today]
         * @type {external:Date}
         * @memberof $w.DatePicker
         * @instance
         * @override
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            return RMI.getState(compId).selectedDate;
        }

        /**
         * @member value
         * @memberof $w.DatePicker
         * @param {external:Date} value
         */
        ,
        set: function set(value) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'value',
                dataToValidate: { value: value },
                compName: this.id
            });
            if (!_lodash2.default.isNil(value) && !isValid) {
                return;
            }

            var dateValue = (0, _utils.nullIfNil)(value);

            var newState = _lodash2.default.defaults({ selectedDate: dateValue }, RMI.getState(compId));

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, dateValue);
            RMI.updateModel(_defineProperty({}, compId, { state: newState }));
            RMI.executeCompBehavior(compId, 'setValue', { value: dateValue });
        }

        /**
         * @member maxDate
         * @label property
         * @syntax
         * get maxDate(): Date
         * set maxDate(value: Date): void
         * @summary Sets or gets the latest date that a user can select.
         * @description
         * Setting the `maxDate` property prevents users from selecting
         * dates past the maximum date. However, it does not limit your ability to
         * change the date picker's value to one that exceeds `maxDate`
         * programmatically.
         *
         * Set `maxDate` to `undefined` to remove the
         * current maximum date limitation.
         *
         * Getting the `maxDate` property returns the current maximum
         * date that a user can select.
         * @snippet [DatePicker-maxDate_get.es6=Get a date picker's maximum date]
         * @snippet [DatePicker-maxDate_set.es6=Set a date picker's maximum date to today]
         * @type {external:Date}
         * @default undefined
         * @see [minDate](#minDate)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'maxDate',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var maxDateISO = RMI.getData(compId).maxDate;

            return maxDateISO && new Date(maxDateISO);
        }

        /**
         * @member maxDate
         * @memberof $w.DatePicker
         * @param {external:Date} maxDate
         */
        ,
        set: function set(maxDate) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'maxDate',
                dataToValidate: { maxDate: maxDate },
                compName: this.id
            });
            if (!_lodash2.default.isNil(maxDate) && !isValid) {
                return;
            }
            var maxDateToSet = (0, _utils.nullIfNil)(maxDate) ? maxDate.toISOString() : null;
            RMI.setData(compId, { maxDate: maxDateToSet });
        }

        /**
         * @member minDate
         * @label property
         * @syntax
         * get minDate(): Date
         * set minDate(value: Date): void
         * @summary Sets or gets the earliest date that a user can select.
         * @description
         * Setting the `minDate` property prevents users from selecting
         * dates before the minimum date. However, it does not limit your ability to
         * change the date picker's value to one that preceeds `minDate`
         * programmatically.
         *
         * Set `minDate` to `undefined` to remove the current minimum date limitation.
         *
         * Getting the `minDate` property returns the current minimum
         * date that a user can select.
         * @snippet [DatePicker-minDate_get.es6=Get a date picker's minimum date]
         * @snippet [DatePicker-minDate_set.es6=Set a date picker's minimum date to today]
         * @type {external:Date}
         * @default undefined
         * @see [maxDate](#maxDate)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'minDate',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var minDateISO = RMI.getData(compId).minDate;

            return minDateISO && new Date(minDateISO);
        }

        /**
         * @member minDate
         * @memberof $w.DatePicker
         * @param {external:Date} minDate
         */
        ,
        set: function set(minDate) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'minDate',
                dataToValidate: { minDate: minDate },
                compName: this.id
            });
            if (!_lodash2.default.isNil(minDate) && !isValid) {
                return;
            }
            var minDateToSet = (0, _utils.nullIfNil)(minDate) ? minDate.toISOString() : null;
            RMI.setData(compId, { minDate: minDateToSet });
        }

        /**
         * @member disabledDates
         * @label property
         * @syntax
         * get disabledDates(): Date[]
         * set disabledDates(value: Date[]): void
         * @summary Sets or gets the dates that a user cannot select.
         * @description
         *  Setting the `disabledDates` property prevents users from
         *  selecting the specified dates. However, it does not limit your ability
         *  to set those dates programmatically.
         *
         *  Set `disabledDates` to an empty array (`[]`) to remove the current disabled dates.
         *
         *  Getting the `disabledDates` property returns the current
         *  list of disabled dates.
         * @snippet [DatePicker-disabledDates_get.es6=Get dates which are disabled]
         * @snippet [DatePicker-disabledDates_set.es6=Set dates which are disabled]
         * @type {external:Date[]}
         * @see [disabledDaysOfWeek](#disabledDaysOfWeek)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'disabledDates',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var disabledDates = RMI.getData(compId).disabledDates;

            return disabledDates && _lodash2.default.map(disabledDates, function (date) {
                return new Date(date);
            });
        }

        /**
         * @member disabledDates
         * @memberof $w.DatePicker
         * @param {external:Date[]} disabledDates
         */
        ,
        set: function set(disabledDates) {
            var _this2 = this;

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'disabledDates',
                dataToValidate: { disabledDates: disabledDates },
                compName: this.id
            });
            if (!_lodash2.default.isNil(disabledDates) && !isArrayValid) {
                return;
            }
            var arrItemsArrValid = _lodash2.default.every(disabledDates, function (v, i) {
                return (0, _validation.validate)({
                    compType: compType,
                    functionName: 'disabledDates',
                    dataToValidate: { 'disableDate': v },
                    itemIndex: i,
                    compName: _this2.id
                });
            });
            if (!arrItemsArrValid) {
                return;
            }
            var disabledDateToSet = _lodash2.default.isEmpty(disabledDates) ? [] : _lodash2.default.map(disabledDates, function (date) {
                return date.toISOString();
            });
            RMI.setData(compId, { disabledDates: disabledDateToSet });
        }

        /**
         * @member disabledDaysOfWeek
         * @label property
         * @syntax
         * get disabledDaysOfWeek(): Number[]
         * set disabledDaysOfWeek(value: Number[]): void
         * @summary Sets or gets the days of the week that a user cannot select.
         * @description
         *  Setting the `disabledDaysOfWeek` property prevents users
         *  from selecting the specified days of the weeks. However, it does not
         *  limit your ability to set those dates programmatically. Set
         *  `disabledDaysOfWeek` to an empty array (`[]`) to remove the current
         *  disabled days of the week.
         *
         *  Getting the `disabledDaysOfWeek` property returns the
         *  current list of disabled days of the week.
         *
         *  The `disabledDaysOfWeek` property accepts an array of integers from 0 to
         *  6, where 0 represent Sunday, 1 is Monday, 2 is Tuesday, and so on.
         * @snippet [DatePicker-disabledDaysOfWeek_get.es6=Get which days of the week are disabled]
         * @snippet [DatePicker-disabledDaysOfWeek_set.es6=Set Sundays and Saturdays to be disabled]
         * @type {external:Number[]}
         * @see [disabledDates](#disabledDates)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'disabledDaysOfWeek',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            return RMI.getData(compId).disabledDaysOfWeek;
        }

        /**
         * @member disabledDaysOfWeek
         * @memberof $w.DatePicker
         * @param {external:Number[]} disabledDaysOfWeek
         */
        ,
        set: function set(disabledDaysOfWeek) {
            var _this3 = this;

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'disabledDaysOfWeek',
                dataToValidate: { disabledDaysOfWeek: disabledDaysOfWeek },
                compName: this.id
            });
            if (!_lodash2.default.isNil(disabledDaysOfWeek) && !isArrayValid) {
                return this;
            }
            var arrItemsValid = _lodash2.default.every(disabledDaysOfWeek, function (v, i) {
                return (0, _validation.validate)({
                    compType: compType,
                    functionName: 'disabledDaysOfWeek',
                    dataToValidate: { 'disableDayOfWeek': v },
                    itemIndex: i,
                    compName: _this3.id
                });
            });
            if (!arrItemsValid) {
                return;
            }
            var disabledDateToSet = _lodash2.default.isEmpty(disabledDaysOfWeek) ? [] : disabledDaysOfWeek;
            RMI.setData(compId, { disabledDaysOfWeek: disabledDateToSet });
        }
    }]);

    return DatePicker;
}(_FormElement3.default);

(0, _mixin2.default)(DatePicker.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(DatePicker.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(DatePicker.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(DatePicker.prototype, _ReadOnlyMixin2.default.prototype);
(0, _mixin2.default)(DatePicker.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(DatePicker.prototype, _RequiredMixin2.default.prototype);

exports.default = DatePicker;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _utils = __webpack_require__(5);

var _validation = __webpack_require__(3);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validationsService = __webpack_require__(11);

var _valueSanitzationAlgorithm = __webpack_require__(32);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _optionsUtils = __webpack_require__(41);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Dropdown
 * @summary Dropdowns are used for selecting one of a number of options.
 *  They are especially useful when there are too many options to display using
 *  [radio buttons]($w.RadioButtonGroup.html). Dropdowns consist of a list
 *  of [options](#Option). Each [option](#Option) contains a label, which is
 *  what the user sees, and a value, which is what is used in code and stored in
 *  you collections.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.ComboBoxInput
 * @definitionId wysiwyg.viewer.components.inputs.ComboBoxInput
 * @tagname dropdown
 */
var DropDown = function (_FormElement) {
    _inherits(DropDown, _FormElement);

    function DropDown() {
        _classCallCheck(this, DropDown);

        return _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).apply(this, arguments));
    }

    _createClass(DropDown, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                options = this.options,
                placeholder = this.placeholder,
                selectedIndex = this.selectedIndex;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, options: options, placeholder: placeholder, selectedIndex: selectedIndex };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the dropdown's styles.
         * @description
         *  The following styles can be used with dropdowns:
         *
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a dropdown's styles, gets or sets the styles of the
         *  dropdown's regular state. It does not set the styles of the dropdown's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.Dropdown
         * @readonly
         * @override
         */

    }, {
        key: 'options',


        /**
         * @typedef {external:Object} $w.Dropdown~Option
         * @summary An object used by the `options` property that contains the attributes of a dropdown list item.
         * @property {external:String} value The value of the dropdown option. This is what you use in code and is what is stored in your collections.
         * @property {external:String} [label] The label of the dropdown option. This is what a user sees.
         * @snippet [Option.es6=Get option info]
         * @see [options](#Options)
         * @see [value](#value)
         */

        /**
         * @member options
         * @label property
         * @syntax
           * get options(): Option[]
           * set options(value: Options[]): void
         * @summary Sets or gets the options in a dropdown.
         * @description
         *  Setting the `options` property sets all the [options](#Option)
         *  available to a user.
         *
         *  Set `options` to an empty array (`[]`) to remove the current dropdown options.
         *
         *  Getting the `options` property returns the current
         *  list of [options](#Option) available to a user.
         *
         *  You cannot modify the options array in-place. To add, change, or remove
         *  individual dropdown options:
         *
         *    1. Store the value of the `options` property in a variable.
         *    1. Make changes to the options array.
         *    1. Reset the `options` property with the modified array.
         * @snippet [DropDown-options_get.es6=Get the list of options and the first option's label and value from dropdown]
         * @snippet [DropDown-options_set.es6=Set the list of options for a dropdown]
         * @snippet [DropDown-add.es6=Add an option to a dropdown]
         *  This example retrieves the options of a dropdown, adds a new
         *  option, and then overwrites the old options.
         * @type {$w.Dropdown~Option[]}
         * @default An empty array
         * @memberof $w.Dropdown
         * @see [Option](#Option)
         * @instance
         */
        get: function get() {
            var options = Utils.getData(this, 'options');

            return options ? options.map(function (option) {
                return { label: option.text, value: option.value };
            }) : options;
        }

        /**
         * @member options
         * @memberof $w.Dropdown
         * @param {$w.Dropdown~Option[]} newOptions
         */
        ,
        set: function set(newOptions) {
            var _this2 = this;

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'options',
                dataToValidate: { options: newOptions },
                compName: this.id
            });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = _lodash2.default.every(newOptions, function (v, i) {
                return (0, _validation.validate)({
                    compType: compType,
                    functionName: 'options',
                    dataToValidate: { selectOption: v },
                    shouldCheckMandatoryFields: true,
                    itemIndex: i,
                    compName: _this2.id
                }) && (0, _optionsUtils.validateOption)(v, i, 'selectOption');
            });
            if (!arrItemsArrValid) {
                return;
            }

            var options = (0, _utils.nullIfNil)(newOptions) ? (0, _optionsUtils.optionsToDisplay)(newOptions) : [];
            var modifiedOptions = options.map(function (option) {
                return {
                    value: option.value,
                    text: option.label,
                    type: 'SelectOption',
                    description: option.label,
                    disabled: false
                };
            });

            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(modifiedOptions, RMI.getData(compId).value || RMI.getData(compId).tempValue);
            (0, _validationsService.runValidations)(RMI, compId, valToValidate);
            var data = { options: modifiedOptions };
            if (valToValidate) {
                data.value = valToValidate;
                data.tempValue = undefined;
            }
            Utils.setData(this, data);
        }

        /**
         * @member placeholder
         * @label property
         * @syntax
           * get placeholder: string
           * set placeholder(value: string): void
         * @summary Sets or gets the dropdown's placeholder text.
         * @description
         *  Placeholder text is typically used to
         *  provide a hint to the user describing what the dropdown is for.
         *  When the user chooses an option, the placeholder text disappears.
         * @type {external:String}
         * @snippet [DropDown-placeholder_get.es6=Get a dropdown's placeholder text]
         * @snippet [DropDown-placeholder_set.es6=Set a dropdown's placeholder text]
         * @memberof $w.Dropdown
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'placeholder',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var placeholder = RMI.getData(compId).placeholder || RMI.getProps(compId).placeholder || {};
            return placeholder.value || '';
        }

        /**
         * @member placeholder
         * @memberof $w.Dropdown
         * @param {external:String} placeholderToSet
         */
        ,
        set: function set(placeholderToSet) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'placeholder',
                dataToValidate: { placeholder: placeholderToSet },
                compName: this.id
            });
            if (!isValid) {
                return;
            }
            placeholderToSet = (0, _utils.emptyStringIfNil)(placeholderToSet);
            RMI.setData(compId, {
                placeholder: {
                    text: placeholderToSet,
                    value: placeholderToSet
                }
            });
            RMI.setProps(compId, {
                placeholder: {
                    text: placeholderToSet,
                    value: placeholderToSet
                }
            });
        }

        /**
         * @member selectedIndex
         * @label property
         * @syntax
           * get selectedIndex: Number
           * set selectedIndex(value: Number): void
         * @summary Sets or gets the index of the selected option.
         * @description
         *  Setting the `selectedIndex` property sets the option at
         *  that index to be the selected option. To set one of the options to be
         *  selected, set the `selectedIndex` property to an index between `0` and
         *  `options.length - 1`.
         *
         *  To reset the dropdown to have no option
         *  selected, set the `selectedIndex` property to `undefined`.
         *
         *  Getting the `selectedIndex` property returns the index of
         *  the currently selected option. If no value is selected, the
         *  `selectedIndex` property returns `undefined`.
         * @type {external:Number}
         * @default -1
         * @snippet [DropDown-selectedIndex_get.es6=Get the index of the selected option]
         * @snippet [DropDown-selectedIndex_set.es6=Select the first option by index]
         * @memberof $w.Dropdown
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'selectedIndex',
        get: function get() {
            return (0, _utils.getIndexOrUndefined)(this.options, 'value', Utils.getData(this, 'value'));
        }

        /**
         * @member selectedIndex
         * @memberof $w.Dropdown
         * @param {external:Number} index
         */
        ,
        set: function set(index) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            var options = _optionsUtils.getOptionsFromFull.call(this);
            var acceptNil = true;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'selectedIndex',
                dataToValidate: { selectedIndex: index },
                compName: this.id
            }) || !(0, _validation.validateRange)({
                functionName: 'selectedIndex',
                propertyName: 'selectedIndex',
                value: index,
                minValue: 0,
                maxValue: options.length - 1,
                acceptNil: acceptNil
            })) {
                return;
            }

            var value = _lodash2.default.isNil(index) ? '' : options[index].value;

            (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
            Utils.setData(this, { value: value });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets an element's value.
         * @note
         *  Changing a dropdown's `value` in code does not trigger an `onChange` event.
         *
         *  If an element is connected to a dataset, setting the element's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [FormElement-value_get.es6=Get an element's value]
         * @snippet [FormElement-value_set.es6=Set an element's value]
         * @type {external:String}
         * @memberof $w.Dropdown
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var value = RMI.getData(compId).value;

            return (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);
        }

        /**
         * @member value
         * @memberof $w.Dropdown
         * @param {external:String} val
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'value',
                dataToValidate: { value: value },
                compName: this.id
            });

            if (!isValid) {
                return;
            }
            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);
            (0, _validationsService.runValidationsAfterChange)(RMI, compId, valToValidate);
            var tempValue = valToValidate !== value ? value : undefined;
            RMI.setData(compId, { value: valToValidate, tempValue: tempValue });
        }
    }]);

    return DropDown;
}(_FormElement3.default);

(0, _mixin2.default)(DropDown.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(DropDown.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(DropDown.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(DropDown.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(DropDown.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(DropDown.prototype, _RequiredMixin2.default.prototype);

exports.default = DropDown;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Footer
 * @summary The footer is the area of your site that appears at the bottom and
 *  throughout all of your pages.
 * @classdesc The footer is located at the bottom of the page:
 *  ![Wix Page Footer](images/footer.png "Wix Page Footer")
 *  The footer is a container that can contain other elements.
 *
 *  The contained elements are the footer's [children](#children) and the
 *  footer is the contained elements' [parent](#parent).
 *
 *  The same footer appears on all pages of your site. Therefore, the children
 *  elements of a footer appear on all pages of your site.
 * 
 *  The `Footer` is part of the [`Document`](#$w.Document.html). 
 * @see [Header]($w.Header.html)
 * @see [Document]($w.Document.html)
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.FooterContainer
 * @definitionId wysiwyg.viewer.components.FooterContainer
 * @tagname footer
 */
var Footer = function (_Element) {
  _inherits(Footer, _Element);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  return Footer;
}(_Element3.default);

/**
 * @member style
 * @label property
 * @syntax
 * get style(): Style
 * @summary Gets an object containing information about the footer's styles.
 * @description
 *  The following styles can be used with footers:
 *
 *  + [`backgroundColor`]($w.Style.html#backgroundColor)
 *  + [`borderColor`]($w.Style.html#borderColor)
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Footer
 * @readonly
 * @override
 */

(0, _mixin2.default)(Footer.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Footer.prototype, _ContainableMixin2.default.prototype);
(0, _mixin2.default)(Footer.prototype, _StyleMixin2.default.prototype);

exports.default = Footer;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BaseGallery = __webpack_require__(42);

var _BaseGallery2 = _interopRequireDefault(_BaseGallery);

var _ProGallery = __webpack_require__(145);

var _ProGallery2 = _interopRequireDefault(_ProGallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GalleryFactory(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    switch (type.viewerType) {
        case 'wysiwyg.viewer.components.tpapps.TPAWidget':
            return new _ProGallery2.default(RMI, compId, contextId, wixSelector, controllerId, role, type);
        default:
            return new _BaseGallery2.default(RMI, compId, contextId, wixSelector, controllerId, role, type);
    }
}

exports.default = GalleryFactory;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _utils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isNewGoogleMapsDataSchema(compData) {
    return _lodash2.default.isArray(compData.locations);
}

/**
 * @class GoogleMap
 * @summary A [Google Map element](https://www.wix.com/support/html5/article/adding-google-maps)
 *  that allows you to display a given location.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.GoogleMap
 * @definitionId wysiwyg.viewer.components.GoogleMap
 * @tagname GoogleMap
 */

var GoogleMap = function (_Element) {
    _inherits(GoogleMap, _Element);

    function GoogleMap() {
        _classCallCheck(this, GoogleMap);

        return _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).apply(this, arguments));
    }

    _createClass(GoogleMap, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                location = this.location;

            return { id: id, type: type, global: global, rendered: rendered, location: location };
        }
    }, {
        key: 'location',


        /**
         * @typedef {external:Object} $w.GoogleMap~MapLocation
         * @syntax {latitude: 37.8, longitude: -122.4, description: "My Humble Home"}
         * @summary An object used by the `location` property that
         *  contains the attributes of a marked map location.
         * @property {external:Number} latitude The latitude of the location. Must be between -90 and 90.
         * @property {external:Number} longitude The longitude of the location. Must be between -180 and 180.
         * @property {external:String} [description] The description of the location.
         * @snippet [GoogleMap-location_get.es6=Get map location info]
         * @see [location](#location)
         */

        /**
         * @member location
         * @memberof $w.GoogleMap
         * @param {$w.GoogleMap~MapLocation} location
         */
        set: function set(location) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'location',
                dataToValidate: location,
                shouldCheckMandatoryFields: true,
                compName: this.id
            })) {
                return;
            }
            var description = (0, _utils.emptyStringIfNil)(location.description);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            if (isNewGoogleMapsDataSchema(compData)) {
                compData.locations[0] = _lodash2.default.defaults({
                    latitude: location.latitude,
                    longitude: location.longitude,
                    title: description
                }, compData.locations[0]);
                RMI.setData(compId, {
                    locations: compData.locations
                });
                return;
            }
            RMI.setData(compId, {
                latitude: location.latitude,
                longitude: location.longitude,
                addressInfo: description
            });
        }

        /**
         * @member location
         * @label property
         * @syntax
         * get location(): MapLocation
         * set location(value: MapLocation): void
         * @summary Sets or gets the location information of a map's marked location.
         * @description
         *  Setting the `location` property to a [`MapLocation`](#MapLocation)
         *  object moves the map's marked location.
         *
         *  Getting the `location` property returns the [location
         *  information](#MapLocation) of the map's marked location.
         * @snippet [GoogleMap-location_get.es6=Get map location info]
         * @snippet [GoogleMap-location_set.es6=Set map location info]
         * @type {$w.GoogleMap~MapLocation}
         * @memberof $w.GoogleMap
         */
        ,
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            return isNewGoogleMapsDataSchema(compData) ? {
                latitude: compData.markers[0].latitude,
                longitude: compData.markers[0].longitude,
                description: compData.markers[0].title
            } : {
                latitude: compData.latitude,
                longitude: compData.longitude,
                description: compData.addressInfo
            };
        }
    }]);

    return GoogleMap;
}(_Element3.default);

(0, _mixin2.default)(GoogleMap.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = GoogleMap;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Header
 * @summary The header is the area of your site that appears at the top and
 *  throughout all of your pages.
 * @classdesc The header is located at the top of the page:
 *  ![Wix Page Header](images/header.png "Wix Page Header")
 *  The header is a container that can contain other elements.
 *
 *  The contained elements are the header's [children](#children) and the
 *  header is the contained elements' [parent](#parent).
 *
 *  The same header appears on all pages of your site. Therefore, The children
 *  elements of a header appear on all pages of your site.
 * 
 *  The `Header` is part of the [`Document`](#$w.Document.html). 
 * @see [Footer]($w.Footer.html)
 * @see [Document]($w.Document.html)
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.HeaderContainer
 * @definitionId wysiwyg.viewer.components.HeaderContainer
 * @tagname header
 */
var Header = function (_Element) {
  _inherits(Header, _Element);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  return Header;
}(_Element3.default);

/**
 * @member style
 * @label property
 * @syntax
 * get style(): Style
 * @summary Gets an object containing information about the header's styles.
 * @description
 *  The following styles can be used with headers:
 *
 *  + [`backgroundColor`]($w.Style.html#backgroundColor)
 *  + [`borderColor`]($w.Style.html#borderColor)
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Header
 * @readonly
 * @override
 */

(0, _mixin2.default)(Header.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Header.prototype, _ContainableMixin2.default.prototype);
(0, _mixin2.default)(Header.prototype, _StyleMixin2.default.prototype);

exports.default = Header;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Background2 = __webpack_require__(21);

var _Background3 = _interopRequireDefault(_Background2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class HoverBox
 * @summary A hover box is a container that changes when the mouse hovers over
 *  it. A hover box has two views: regular and hover. You can
 *  <a href="https://support.wix.com/en/article/attaching-elements-to-a-box" target="_blank">attach</a>
 *  elements to a hover box. Some actions performed on a hover box affect the
 *  elements it contains. For example, [hiding](#hide) a hover box also
 *  effectively hides all the elements in the hover box, although the
 *  values of the [hidden](#hidden) properties of the elements contained in the 
 *  hover box do not change.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.HoverBox
 * @definitionId wysiwyg.viewer.components.HoverBox
 */
var HoverBox = function (_Background) {
  _inherits(HoverBox, _Background);

  function HoverBox() {
    _classCallCheck(this, HoverBox);

    return _possibleConstructorReturn(this, (HoverBox.__proto__ || Object.getPrototypeOf(HoverBox)).apply(this, arguments));
  }

  return HoverBox;
}(_Background3.default);

(0, _mixin2.default)(HoverBox.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(HoverBox.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(HoverBox.prototype, _ContainableMixin2.default.prototype);

exports.default = HoverBox;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _IFrame2 = __webpack_require__(60);

var _IFrame3 = _interopRequireDefault(_IFrame2);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _postMessage2 = __webpack_require__(15);

var _postMessage = _interopRequireWildcard(_postMessage2);

var _validation = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.HtmlElementEventHandler
 * @description Handles events fired when a message is received from an HTML
 *  Component.
 * @param {$w.HtmlComponentMessageEvent} event The message event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class HtmlComponent
 * @summary A container for internal or external HTML code. Messages can be sent
 *  from your page code to the code in an HTML component and from the HTML
 *  component to your page code using the [`postMessage()`](#postMessage) and
 *  [`onMessage()`](#onMessage) functions. To learn more about what code an HTML
 *  component can hold, see <a href="https://support.wix.com/en/article/guidelines-and-limitations-of-the-html-code-and-embed-a-site-elements" target="_blank">here</a>.
 *
 *  For an overview of working with an HTML Component using code, see <a href="https://support.wix.com/en/article/working-with-the-html-element" target="_blank">Working with the HTML Element</a>.
 * @mixes $w.IFrame
 * @memberof $w
 * @tagname IFrame
 * @viewername wysiwyg.viewer.components.HtmlComponent
 * @definitionId wysiwyg.viewer.components.HtmlComponent
 */

var HtmlComponent = function (_IFrame) {
    _inherits(HtmlComponent, _IFrame);

    function HtmlComponent() {
        _classCallCheck(this, HtmlComponent);

        return _possibleConstructorReturn(this, (HtmlComponent.__proto__ || Object.getPrototypeOf(HtmlComponent)).apply(this, arguments));
    }

    _createClass(HtmlComponent, [{
        key: 'postMessage',


        // METHODS:
        /**
         * @function postMessage
         * @syntax
         * function postMessage(message: string | number | boolean | object | array)
         * @summary Sends a message to the HTML Component.
         * @description
         *  The `postMessage()` function sends a message from your page code to the
         *  HTML Component.
         *
         *  To receive the message sent from the `postMessage()` function in your
         *  HTML Component, create an event handler for the `window.onmessage` event
         *  in the component's code. You create the event handler within an HTML
         *  `<script>` tag. You get the received data by getting the data property
         *  of the event handler's event parameter.
         *
         *  Often, you define the `window.onMessage` event handler in a function
         *  that gets called when the HTML component loads using the `body onload`
         *  or `window.onload`:
         *
         *      <script type="text/javascript">
         *        window.onmessage = (event) => {
         *          if (event.data) {
         *            console.log(`HTML Component received a message: ${event.data}`);
         *            // additional code here
         *          }
         *        }
         *      </script>
         *
         *
         *  For more information on sending and receiving messages between your page
         *  and your HTML Component, see <a href="https://support.wix.com/en/article/working-with-the-html-component-in-wix-code#messaging-1" target="_blank">Working with the HTML Component in Wix Code</a>.
         * @note
         *  An HTML Component needs to load before you can send it messages using the
         *  `postMessage()` function. Usually an HTML Component finishes loading a
         *  short time after the page it is on finishes loading. So if you call
         *  `postMessage()` inside the page’s [`onReady()`]($w.html#onReady)
         *  event handler, the HTML Component might not be ready yet.
         *
         *  To call `postMessage()` as soon as possible after a page loads, send a
         *  message from the HTML Component to the page code as when the HTML
         *  Component is loaded and then call `postMessage()` upon receipt of that
         *  message.
         * @snippet [HtmlComponent-postMessage.es6=Send a message to an HTML Component]
         * @snippet [HtmlComponent-full.es6=Send a message to an HTML Component and receive a confirmation]
         *  This example assumes you have created a page with an HTML Component
         *  whose ID is `myHtmlComponent` and a button whose onClick event handler
         *  is set to `messageSendButton_onClick`.
         *
         *  When the user clicks the button, a message is sent to the HTML Code
         *  element. Code inside the element receives and displays the message. Then
         *  it sends a message back to the page code. The page code receives and
         *  logs the message.
         * @param {external:String | external:Number | external:Boolean | external:Object | external:Array} message The message to send to the HTML Component.
         * @see [onMessage( )](#onMessage)
         * @memberof $w.HtmlComponent
         */
        value: function postMessage(msg) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'postMessage',
                dataToValidate: { message: msg },
                compName: this.id
            })) {
                return this;
            }
            var compId = members._compId.get(this);
            _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                command: _postMessage.MessageTypes.POST_HTML_MESSAGE,
                data: {
                    id: compId,
                    msg: msg
                },
                controllerId: members._controllerId.get(this)
            });
            return this;
        }

        /**
         * @function onMessage
         * @syntax
         * function onMessage(handler: HtmlElementEventHandler): HtmlComponent
         * callback HtmlElementEventHandler(event: HtmlComponentMessageEvent, $w: Function): void
         * @summary Adds an event handler that runs when the HTML Component
         *  sends a message.
         * @description
         *  The `onMessage()` function allows your page code to receive messages
         *  from an HTML Component on your page. When a message is received,
         *  the specified event handler is executed and the message can be retrieved
         *  using `event.data`.
         *
         *  To send a message from your HTML Component, use the postMessage() function
         *  in the HTML component's code. Generally, you call postMessage()
         *  from within a function:
         *
         *      <script type="text/javascript">
         *        function sendReturnMessage(msg) {
         *          window.parent.postMessage(msg, "*");
         *        }
         *      </script>
         *
         *
         *  For more information on sending and receiving messages between your page
         *  and your HTML Component, see <a href="https://support.wix.com/en/article/working-with-the-html-component-in-wix-code#messaging-1" target="_blank">Working with the HTML Component in Wix Code</a>.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @snippet [HtmlComponent-onMessage.es6=Receive a message from an HTML Component]
         * @snippet [HtmlComponent-full.es6=Send a message to an HTML Component and receive a confirmation]
         *  This example assumes you have created a page with an HTML Component
         *  whose ID is `myHtmlComponent` and a button whose onClick event handler
         *  is set to `messageSendButton_onClick`.
         *
         *  When the user clicks the button, a message is sent to the HTML Code
         *  element. Code inside the element receives and displays the message. Then
         *  it sends a message back to the page code. The page code receives and
         *  logs the message.
         * @param {$w.HtmlComponentMessageEventHandler} handler The name of the function or
         *  the function expression to run when the HTML Component sends a message.
         * @returns {$w.HtmlComponent} The HTML Code element that triggered the event.
         * @see [postMessage( )](#postMessage)
         * @memberof $w.HtmlComponent
         * @eventtype message
         * @eventhandler
         */

    }, {
        key: 'onMessage',
        value: function onMessage(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onMessage',
                dataToValidate: { onMessage: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().MESSAGE, controllerId, cb);
            return this;
        }

        /**
         * @function allowFullScreen
         * @label property
         * @syntax
         * function allowFullScreen(): HtmlComponent
         * @summary Allows the HTML Component to be put into full screen mode.
         * @description
         *  By default, users cannot place the HTML Component in full screen mode. Calling
         *  this function allows a user to place the HTML Component in full screen mode.
         * @snippet [HtmlComponent-allowFullScreen.es6=Allow an HTML Component to be placed in full screen mode]
         * @returns {$w.HtmlComponent}
         * @memberof $w.HtmlComponent
         */

    }, {
        key: 'allowFullScreen',
        value: function allowFullScreen() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, {
                allowFullScreen: true
            });
            return this;
        }
    }, {
        key: 'src',


        // PROPERTIES:
        /**
         * @member src
         * @memberof $w.HtmlComponent
         * @param {external:String} url
         */
        set: function set(url) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'src',
                dataToValidate: { url: url },
                shouldCheckMandatoryFields: true,
                compName: this.id
            })) {
                return;
            }
            Utils.setData(this, { url: url });
        }

        /**
         * @member src
         * @label property
         * @syntax
         * get src(): string
         * set src(value: string): void
         * @summary Sets or gets the URL of the HTML Component's code.
         * @description
         *  Setting the `src` property sets the website that is
         *  displayed in the HTML Component. The `src` value must be set to an HTTPS
         *  URL.
         *
         *  Getting the `src` property returns the URL of the website
         *  that is displayed in the HTML Component.
         * @note
         *  The `src` property must be an HTTPS URL. To use an HTTP URL, [turn off
         *  SSL for your site](https://support.wix.com/en/article/turning-ssl-on-or-off-for-your-site).
         * @snippet [HtmlComponent-src_get.es6=Get the displayed website's URL]
         * @snippet [HtmlComponent-src_set.es6=Set the displayed website]
         * @type {external:String}
         * @memberof $w.HtmlComponent
         * @instance
         */
        ,
        get: function get() {
            return Utils.getData(this, 'url') || null;
        }

        /**
         * @member scrolling
         * @memberof $w.HtmlComponent
         * @param {external:String} value
         */

    }, {
        key: 'scrolling',
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'scrolling',
                dataToValidate: {
                    scrolling: value
                },
                compName: this.id
            });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, {
                scrolling: value
            });
        }

        /**
         * @member scrolling
         * @label property
         * @syntax
         * get scrolling(): ScrollType
         * set scrolling(value: ScrollType): void
         * type ScrollType = "auto" | "no" | "yes"
         * @summary Sets or gets whether the HTML Component displays scrollbars.
         * @description
         *  Setting the `scrolling` property sets what happens when the content in
         *  the HTML Component is larger than the size of the component.
         *
         *  The value can be set to:
         *
         *  + `"auto"`: Scrollbars are displayed only if needed. (This is the default.)
         *  + `"yes"`: Scrollbars are always shown, even if they are not needed.
         *  + `"no"`: Scrollbars are never shown, even if they are needed).
         *
         *  Getting the `scrolling` property returns which `ScrollType` the component
         *  is set to use.
         * @snippet [HtmlComponent-scrolling_set.es6=Set whether the Html Component displays scrollbars]
         * @snippet [HtmlComponent-scrolling_get.es6=Get whether the Html Component displays scrollbars]
         * @type {string}
         * @memberof $w.HtmlComponent
         */
        ,
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).scrolling || 'auto';
        }
    }]);

    return HtmlComponent;
}(_IFrame3.default);

exports.default = HtmlComponent;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _utils = __webpack_require__(5);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _LinkableMixin = __webpack_require__(36);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _validation = __webpack_require__(3);

var _constants = __webpack_require__(27);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Image
 * @summary Images are images stored in the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
 *  or retreived from an external web location.
 *
 *  The URL formats for images are:
 *
 *  + Images from the Media Manager: `wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
 *  + Images from the web: `http(s)://<image url>`
 * @memberof $w
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @viewername wysiwyg.viewer.components.WPhoto
 * @definitionId wysiwyg.viewer.components.WPhoto
 * @tagname image
 */
var Image = function (_Element) {
    _inherits(Image, _Element);

    function Image() {
        _classCallCheck(this, Image);

        return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
    }

    _createClass(Image, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                alt = this.alt,
                tooltip = this.tooltip,
                src = this.src;

            return { id: id, type: type, global: global, rendered: rendered, alt: alt, tooltip: tooltip, src: src };
        }
    }, {
        key: 'alt',


        /**
         * @member alt
         * @label property
         * @syntax
         * get alt(): string
         * set alt(value: string): void
         * @summary Sets or gets an image's alt text.
         * @description
         *  An image's alternative text is typically a relatively short phrase that
         *  describes what the image depicts.
         *
         *  The alternative text is used:
         *
         *  + If the browser cannot display the image.
         *  + If the user is utilizing a screen reader.
         *  + By search engines to understand what images are on your site.
         * @snippet [Image-alt_get.es6=Get the image's alt text]
         * @snippet [Image-alt_set.es6=Set the image's alt text]
         * @type {external:String}
         * @default An empty string
         * @memberof $w.Image
         * @instance
         * @attr {external:String}
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            return RMI.getData(members._compId.get(this)).alt;
        }

        /**
         * @member alt
         * @memberof $w.Image
         * @param {external:String} value
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'alt',
                dataToValidate: { alt: value },
                compName: this.id
            });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, {
                alt: (0, _utils.emptyStringIfNil)(value)
            });
        }

        /**
         * @member tooltip
         * @label property
         * @syntax
         * get tooltip(): string
         * set tooltip(value: string): void
         * @summary Sets or gets an image's tooltip.
         *  An image's tooltip text is displayed when a user hovers over the image
         *  or when the image opens in a popup.
         * @snippet [Image-tooltip_get.es6=Get the image's tooltip text]
         * @snippet [Image-tooltip_set.es6=Set the image's tooltip text]
         * @type {external:String}
         * @default An empty string
         * @memberof $w.Image
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'tooltip',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).title;
        }

        /**
         * @member tooltip
         * @memberof $w.Image
         * @param {external:String} value
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'tooltip',
                dataToValidate: { tooltip: value },
                compName: this.id
            });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var title = (0, _utils.emptyStringIfNil)(value);
            RMI.setData(compId, { title: title });
        }

        /**
         * @member src
         * @label property
         * @syntax
         * get src(): string
         * set src(value: string): void
         * @summary Sets or gets the file location of the image.
         * @description
         *  Setting the `src` property changes the displayed image to
         *  the image found at the new `src` value.
         *
         *  Getting the `src` property returns the location of the
         *  current image file.
         *
         *  The image file can either be an image file from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
         *  or an external file from any web location.
         *
         *  The URL formats supported are:
         *
         *  + Images from the Media Manager: `wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
         *  + Images from the web: `http(s)://<image url>`
         * @snippet [Image-src_get.es6=Get the image's location]
         * @snippet [Image-src_set_wix.es6=Set the image to be an image from the Media Manager]
         * @snippet [Image-src_set_web.es6=Set the image to be an image from the web]
         * @type {external:String}
         * @default An empty string
         * @memberof $w.Image
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'src',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId) || {};

            return _imageUtils2.default.buildFullUrlFromUri(compData.uri, compData.width, compData.height, compData.title);
        }

        /**
         * @member src
         * @memberof $w.Image
         * @param {external:String} value
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'src',
                dataToValidate: { src: value },
                compName: this.id
            });
            if (!isValid) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var imageData = void 0;

            if ((0, _utils.isNilOrEmptyString)(value)) {
                imageData = { uri: '' };
            } else {
                imageData = _imageUtils2.default.convertImageToModelFormatAndReportIfError(value, 'src', 'src');
                if (!imageData) {
                    return;
                }
            }

            imageData.crop = null;

            RMI.setData(compId, imageData);
        }

        /**
         * @member clickAction
         * @label property
         * @syntax
         * get clickAction(): string
         * set clickAction(value: ClickActionType): void
         * type ClickActionType = "expand" | "link" | "magnified" | "none"
         * @summary Sets or gets the action that occurs when an image is clicked.
         * @description
         *  Setting the `clickAction` property sets what happens when
         *  an image is clicked.
         *
         *  The value can be set to:
         *
         *  + `"none"`: Nothing happens.
         *  + `"expand"`: The image opens in a popup window
         *  + `"link"`: The image's [`link`](#link) opens.
         *  + `"magnified"`: The cursor becomes a magnifying glass when a visitor hovers over the image.
         *
         *
         *  Getting the `clickAction` property returns what happens when
         *  an image is clicked.
         * @snippet [Image-clickAction_get.es6=Get the action that occurs when an image is clicked]
         * @snippet [Image-clickAction_set.es6=Set the action that occurs when an image is clicked]
         * @type {external:String}
         * @memberof $w.Image
         * @instance
         */

    }, {
        key: 'clickAction',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var clickAction = RMI.getProps(compId).onClickBehavior;
            return _lodash2.default.findKey(_constants.IMAGE_CLICK_ACTIONS, function (v) {
                return v === clickAction;
            });
        }

        /**
         * @member clickAction
         * @memberof $w.Image
         * @param {external:String} action
         */
        ,
        set: function set(action) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'clickAction',
                dataToValidate: { clickAction: action },
                compName: this.id
            });

            if (!isValid) {
                return;
            }

            var clickAction = _lodash2.default.isNil(action) ? _constants.IMAGE_CLICK_ACTIONS.none : _constants.IMAGE_CLICK_ACTIONS[action];

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, { onClickBehavior: clickAction });
        }
    }]);

    return Image;
}(_Element3.default);

(0, _mixin2.default)(Image.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Image.prototype, _LinkableMixin2.default.prototype);
(0, _mixin2.default)(Image.prototype, _ClickableMixin2.default.prototype);

exports.default = Image;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Background2 = __webpack_require__(21);

var _Background3 = _interopRequireDefault(_Background2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
* @class MediaBox
* @summary A container for media items.
* @mixes $w.Element
* @mixes $w.HiddenCollapsedMixin
* @mixes $w.Background
* @memberof $w
* @tagname mediaBox
* @viewername wysiwyg.viewer.components.MediaBox
* @definitionId wysiwyg.viewer.components.MediaBox
*/

var MediaBox = function (_Background) {
  _inherits(MediaBox, _Background);

  function MediaBox() {
    _classCallCheck(this, MediaBox);

    return _possibleConstructorReturn(this, (MediaBox.__proto__ || Object.getPrototypeOf(MediaBox)).apply(this, arguments));
  }

  return MediaBox;
}(_Background3.default);

(0, _mixin2.default)(MediaBox.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = MediaBox;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class MenuContainer
 * @summary A menu container is a container that holds the elements in a
 *  mobile menu. You can add and remove elements to the container to customize
 *  your site's mobile menu. The menu only appears in the mobile version of your
 *  site.
 * @memberof $w
 * @mixes $w.Element
 * @viewername wysiwyg.viewer.components.MenuContainer
 * @definitionId wysiwyg.viewer.components.MenuContainer
 * @tagname menuContainer
 */

var MenuContainer = function (_Element) {
    _inherits(MenuContainer, _Element);

    function MenuContainer() {
        _classCallCheck(this, MenuContainer);

        return _possibleConstructorReturn(this, (MenuContainer.__proto__ || Object.getPrototypeOf(MenuContainer)).apply(this, arguments));
    }

    _createClass(MenuContainer, [{
        key: 'open',

        /**
         * @function open
         * @summary Opens a mobile menu.
         * @description
         *  The `open()` function returns a Promise that is resolved when the
         *  mobile menu's container has finished opening.
         * @returns {Promise}
         * @fulfill {void} When the mobile menu has finished opening.
         * @snippet [MenuContainer-open.es6=Open a custom mobile menu]
         * @snippet [MenuContainer-open_then.es6=Open a custom mobile menu and log a message when done]
         * @see [close( )](#close)
         * @memberof $w.MenuContainer
         */
        value: function open() {
            var _this2 = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this2);

                var menuId = members._compId.get(_this2);

                RMI.executeCompBehavior(menuId, 'open', {}, resolve);
            });
        }

        /**
         * @function close
         * @summary Closes a mobile menu.
         * @description
         *  The `close()` function returns a Promise that is resolved when the
         *  custom mobile menu's container has finished closing.
         * @returns {Promise}
         * @fulfill {void} When the mobile menu has finished closing.
         * @snippet [MenuContainer-close.es6=Close a custom mobile menu]
         * @snippet [MenuContainer-close_then.es6=Close a custom mobile menu and log a message when done]
         * @see [open( )](#open)
         * @memberof $w.MenuContainer
         */

    }, {
        key: 'close',
        value: function close() {
            var _this3 = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this3);

                var menuId = members._compId.get(_this3);

                RMI.executeCompBehavior(menuId, 'close', {}, resolve);
            });
        }
    }]);

    return MenuContainer;
}(_Element3.default);

exports.default = MenuContainer;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _menuUtils = __webpack_require__(40);

var _menuUtils2 = _interopRequireDefault(_menuUtils);

var _validation = __webpack_require__(3);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @class MobileMenu
 * @summary Provides all functionality related to MobileMenu
 * @classdesc The `MobileMenu` class provides functionality related to Wix MobileMenu.
 * The component is avaliable only on mobile
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof wix.ui
 * @tagname MobileMenu
 * @viewername wysiwyg.viewer.components.mobile.TinyMenu
 * @definitionId wysiwyg.viewer.components.mobile.TinyMenu
 */
var MobileMenu = function (_Element) {
    _inherits(MobileMenu, _Element);

    function MobileMenu() {
        _classCallCheck(this, MobileMenu);

        return _possibleConstructorReturn(this, (MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).apply(this, arguments));
    }

    _createClass(MobileMenu, [{
        key: 'accountNavBar',


        /*
         * @member accountNavBar
         * @label property
         * @syntax
         * @summary Gets an object containing function to preform on accountNavBar when its available on mobile menu.
         * @memberof $w.MobileMenu
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var type = members._type.get(this);
            var compId = members._compId.get(this);
            return new WrappedAccountNavBarOptions(RMI, compId, contextId, type);
        }
    }]);

    return MobileMenu;
}(_Element3.default);

(0, _mixin2.default)(MobileMenu.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = MobileMenu;

var AccountNavBarOptions = function () {
    function AccountNavBarOptions(RMI, compId, contextId, type) {
        _classCallCheck(this, AccountNavBarOptions);

        members._RMI.set(this, RMI);
        members._contextId.set(this, contextId);
        members._type.set(this, type);
        members._compId.set(this, compId);
    }

    _createClass(AccountNavBarOptions, [{
        key: 'menuItems',
        set: function set(menuItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            var compId = members._compId.get(this);
            var compName = RMI.getId(compId);
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'menuItems',
                dataToValidate: { menuItems: menuItems },
                compName: compName
            })) {
                return this;
            }
            if (_lodash2.default.isNil(menuItems)) {
                menuItems = [];
            }
            var validMenuItems = _menuUtils2.default.checkUserProfileTinyMenuItemsValidation({
                navItems: menuItems,
                functionName: 'menuItems',
                compName: compName
            });
            var convertedMenuItems = _lodash2.default.map(validMenuItems, function (menuItem, menuItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'menuItems');
            });
            var currentData = RMI.getData(compId);
            var loginSocialBarRef = _lodash2.default.get(currentData, 'loginSocialBarRef');
            var newData = _lodash2.default.assign(loginSocialBarRef, { menuItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedMenuItems } } });
            RMI.setData(members._compId.get(this), { loginSocialBarRef: newData });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var menuItems = _lodash2.default.get(data, 'loginSocialBarRef.menuItemsRef.menuRef.items');
            return _lodash2.default.map(menuItems, function (item) {
                return _menuUtils2.default.convertNavItemToUserFormat(item, ['visibleOnDesktop']);
            });
        }
    }, {
        key: 'navBarItems',
        set: function set(navBarItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            var compId = members._compId.get(this);
            var compName = RMI.getId(compId);
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'navBarItems',
                dataToValidate: { navBarItems: navBarItems },
                compName: compName
            })) {
                return this;
            }
            if (_lodash2.default.isNil(navBarItems)) {
                navBarItems = [];
            }
            var validNavBarItems = _menuUtils2.default.checkUserProfileTinyMenuNavBarItemsValidation({
                navItems: navBarItems,
                functionName: 'navBarItems',
                compName: compName
            });
            var convertedNavItems = _lodash2.default.map(validNavBarItems, function (navItem, navItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, navItem, navItemIndex, 'navBarItems', true);
            });
            var currentData = RMI.getData(compId);
            var loginSocialBarRef = _lodash2.default.get(currentData, 'loginSocialBarRef');
            var newData = _lodash2.default.assign(loginSocialBarRef, { iconItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedNavItems } } });
            RMI.setData(members._compId.get(this), { loginSocialBarRef: newData });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var navBarItems = _lodash2.default.get(data, 'loginSocialBarRef.iconItemsRef.menuRef.items');
            return _lodash2.default.map(navBarItems, function (item) {
                return _menuUtils2.default.convertNavItemToUserFormat(item, ['visibleOnDesktop']);
            });
        }
    }]);

    return AccountNavBarOptions;
}();

var WrappedAccountNavBarOptions = _monitoring2.default.monitorClass(AccountNavBarOptions, _monitoring2.default.getRavenContextForComponent);

(0, _mixin2.default)(MobileMenu.prototype, _HiddenCollapsedMixin2.default.prototype);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _State = __webpack_require__(63);

var _State2 = _interopRequireDefault(_State);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateStateInfo = function validateStateInfo(compType, stateInfo, stateIndex, stateboxID) {
    if (!(0, _validation.validate)({
        compType: compType,
        functionName: 'changeState',
        dataToValidate: _lodash2.default.isNil(stateInfo) ? {} : { stateInfo: stateInfo },
        shouldCheckMandatoryFields: true,
        compName: stateboxID
    })) {
        return false;
    }
    if (_lodash2.default.isObject(stateInfo) && !(stateInfo instanceof _State2.default)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_type({
            functionName: 'changeState',
            propertyName: 'stateInfo',
            wrongValue: stateInfo,
            expectedType: 'state,string'
        }));
        return false;
    }

    if (stateIndex < 0) {
        if (stateIndex instanceof _State2.default) {
            _reporter2.default.reportSdkError(_errors.generateError.error_state_input({
                propertyName: 'stateInfo',
                functionName: 'changeState',
                stateboxID: stateboxID,
                wrongValue: stateInfo }));
        } else {
            _reporter2.default.reportSdkError(_errors.generateError.error_state_input({
                propertyName: 'stateInfo',
                functionName: 'changeState',
                stateboxID: stateboxID,
                wrongValue: stateInfo
            }));
        }
        return false;
    }

    return true;
};

var computeStateIndex = function computeStateIndex(RMI, compId, stateInfo) {
    var children = RMI.getChildren(compId);
    return stateInfo instanceof _State2.default ? children.indexOf(members._compId.get(stateInfo)) : _lodash2.default.findIndex(children, function (childId) {
        return RMI.getComp(childId).id === stateInfo;
    });
};

/**
 * @class MultiStateBox
 * @summary MultiStateBoxes are containers for States. A MultiStateBox can show one State at a time.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.PlayableMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.StateBox
 * @viewername wysiwyg.viewer.components.StateStrip
 * @definitionId wysiwyg.viewer.components.StateBox
 * @definitionId wysiwyg.viewer.components.StateStrip
 * @tagname multistatebox
 */

var MultiStateBox = function (_Element) {
    _inherits(MultiStateBox, _Element);

    function MultiStateBox() {
        _classCallCheck(this, MultiStateBox);

        return _possibleConstructorReturn(this, (MultiStateBox.__proto__ || Object.getPrototypeOf(MultiStateBox)).apply(this, arguments));
    }

    _createClass(MultiStateBox, [{
        key: 'onChange',


        /**
         * @function onChange
         * @syntax
         * function onChange(handler: EventHandler): MultiStateBox
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the multistatebox moves to a new state.
         * @description
         *  A multistatebox moves to a new state programatically via code or in an app.
         *
         *  The event handler set by the `onChange` function is run immediately before
         *  the multistatebox moves to the new state. Therefore, reading the multistatebox's
         *  [`currentState`](#currentState) within
         *  the event handler function returns the state that the multistatebox
         *  is moving away from.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} eventHandler The name of the function or
         *  the function expression to run when the multistatebox moves to a new state.
         * @returns {$w.MultiStateBox} The multistatebox on which the event is now registered.
         * @see [changeState( )](#changeState)
         * @memberof $w.MultiStateBox
         * @eventtype change
         * @eventhandler
         */
        value: function onChange(callback) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onChange',
                dataToValidate: { onChange: callback },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, controllerId, callback);
            return this;
        }

        /**
         * @member currentState
         * @label property
         * @syntax
         * get currentState(): State
         * @summary Gets the multistatebox's current state.
         * @type {$w.State}
         * @memberof $w.MultiStateBox
         * @instance
         * @readonly
         */

    }, {
        key: 'changeState',


        /**
         * @function changeState
         * @syntax
         * function changeState(stateReference: String | State): Promise<State>
         * @summary Change the multistatebox's current state to a specific state or state id.
         * @description
         *  The `changeState()` function returns a Promise that is resolved when
         *  the multistatebox finishes moving from the current state to the state
         *  referred to by `stateReference`.
         *
         *  You can retrieve [`State`]($w.State.html) objects to pass to the
         *  `stateReference` parameter from your multistatebox using the
         *  [`currentState`](#currentState) or [`states`](#states) properties.
         *
         *  If passing a string, note that state ids in a multistatebox are accessible through the
         *  id of a state.
         * @param {external:String|$w.State} stateReference The state to move to. Either the id of the state or a [`State`](#w.State.html) from the MultiStateBox.
         * @returns {external:Promise}
         * @fulfill {$w.State} The state that the multistatebox changed to.
         * @throws {external:Error} If no argument was provided or the argument is not a string or an existing state.
         * @memberof $w.MultiStateBox
         */

        value: function changeState(stateInfo) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var compType = members._type.get(_this2).compType;
                var RMI = members._RMI.get(_this2);
                var compId = members._compId.get(_this2);
                var wixSelector = members._wixSelector.get(_this2);
                var controllerId = members._controllerId.get(_this2);

                var stateIndex = computeStateIndex(RMI, compId, stateInfo);
                if (!validateStateInfo(compType, stateInfo, stateIndex, compId)) {
                    return reject(_errors.generateError.error_state_input({
                        propertyName: 'stateInfo',
                        functionName: 'changeState',
                        stateboxID: _this2.id,
                        wrongValue: stateInfo
                    }));
                }

                RMI.executeCompBehavior(compId, 'changeState', { stateIndex: stateIndex }, function () {
                    var childrenIds = RMI.getChildren(compId);
                    var stateCompID = childrenIds[stateIndex];
                    var state = RMI.getComp(stateCompID);
                    resolve(wixSelector.getInstance(RMI, state.type, stateCompID, controllerId));
                });
            });
        }

        /**
         * @member states
         * @label property
         * @syntax
           * get states(): State[]
         * @summary Gets a list of all the states contained in the multistatebox.
         * @description
         *  Note that the state indices in a multistatebox are zero-based, even though
         *  they are numbered starting from 1 in the Editor.
         * @type {$w.State[]}
         * @memberof $w.MultiStateBox
         * @instance
         * @readonly
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                currentState = this.currentState;

            return { id: id, type: type, global: global, rendered: rendered, currentStateId: currentState.id };
        }
    }, {
        key: 'currentState',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);

            var currentStateIndex = RMI.getState(compId).currentIndex;
            var currentStateCompId = RMI.getChildren(compId)[currentStateIndex];
            var currentStateType = RMI.getType(currentStateCompId);

            return wixSelector.getInstance(RMI, currentStateType, currentStateCompId, controllerId);
        }
    }, {
        key: 'states',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);

            return RMI.getChildren(compId).map(function (id) {
                return wixSelector.getInstance(RMI, RMI.getComp(id).type, id, controllerId);
            });
        }
    }]);

    return MultiStateBox;
}(_Element3.default);

(0, _mixin2.default)(MultiStateBox.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(MultiStateBox.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(MultiStateBox.prototype, _ContainableMixin2.default.prototype);

exports.default = MultiStateBox;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Native = function (_Element) {
    _inherits(Native, _Element);

    function Native(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Native);

        var _this = _possibleConstructorReturn(this, (Native.__proto__ || Object.getPrototypeOf(Native)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        var publicAPI = RMI.getPublicAPI(compId);
        if (_lodash2.default.isFunction(publicAPI)) {
            var controllerData = RMI.getData(compId);
            var exportsObject = publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id));
            (0, _mixin2.default)(_this, exportsObject);
        } else if (publicAPI) {
            _lodash2.default.assign(_this, publicAPI);
        }
        return _this;
    }

    return Native;
}(_Element3.default);

(0, _mixin2.default)(Native.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = Native;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Page
 * @summary A page is a web page that can contain other elements.
 * @classdesc
 *  Some `Page` properties refer only to the central part of the web page as show here:
 *
 * ![Wix Page](images/page.png "Wix Page")
 *
 *  For example, elements placed within this central area are the page's
 *  [children](#children), but elements placed in the page
 *  [header]($w.Header.html) are not.
 *
 *  Other `Page` properties refer to the page in general.
 * 
 *  The `Page` is part of the [`Document`](#$w.Document.html). 
 * @see [Header]($w.Header.html)
 * @see [Footer]($w.Footer.html)
 * @see [Document]($w.Document.html)
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername mobile.core.components.Page
 * @definitionId mobile.core.components.Page
 * @tagname page
 */

var Page = function (_Element) {
    _inherits(Page, _Element);

    function Page() {
        _classCallCheck(this, Page);

        return _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
    }

    _createClass(Page, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                title = this.title,
                description = this.description,
                url = this.url,
                fullUrl = this.fullUrl,
                keywords = this.keywords,
                visibleInMenu = this.visibleInMenu;

            return { id: id, type: type, global: global, rendered: rendered, title: title, description: description, url: url, fullUrl: fullUrl, keywords: keywords, visibleInMenu: visibleInMenu };
        }
    }, {
        key: 'description',


        /**
         * @member description
         * @label property
         * @syntax
         * get description(): string
         * @summary Gets the page's <a href="https://support.wix.com/en/article/adding-seo-page-titles-and-descriptions-meta-tags" target="_blank">SEO description</a>.
         * @description
         *  The page description is a meta tag. It provides potential site visitors
         *  with a summary of what the page is about. It is not visible to users,
         *  but appears below your site's title in search results.
         *
         *  A page's `description` is <a href="https://support.wix.com/en/article/changing-your-page-description" target="_blank">set in the Editor</a>
         *  using the <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
         * @snippet [Page-description_get.es6=Get the page's description]
         * @type {external:String}
         * @memberof $w.Page
         * @instance
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var pageData = RMI.getPageData();

            return pageData && pageData.currentPageSEODescription;
        }

        /**
         * @member keywords
         * @label property
         * @syntax
         * get keywords(): string[]
         * @summary Gets the page's keywords.
         * @description
         *  The <a href="https://support.wix.com/en/article/page-keywords" target="_blank">page's keywords</a>
         *  are not used by Google, but may be used by other search engines.
         *
         *  Page `keywords` are set in the Editor using the
         *  <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
         * @snippet [Page-keywords_get.es6=Get the page's description]
         * @type {external:String[]}
         * @memberof $w.Page
         * @instance
         * @readonly
         */

    }, {
        key: 'keywords',
        get: function get() {
            var RMI = members._RMI.get(this);
            var pageData = RMI.getPageData();

            return pageData && pageData.currentPageSEOKeywords;
        }

        /**
         * @member {external:String} title
         * @label property
         * @syntax
         * get title(): string
         * @summary Gets the page's title.
         * @description
         *  The <a href="https://www.wix.com/support/html5/article/page-title-meta-tag" target="_blank">page title</a> is used in:
         *
         *  + Search results.
         *  + When saving to favorites.
         *  + In the browser's tab.
         *
         *
         *  A page's `title` is <a href="https://support.wix.com/en/article/changing-your-page-title" target="_blank">set in the Editor</a>
         *  using the <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
         * @note
         *  The `title` in Preview mode is different than the `title` of the published site.
         * @snippet [Page-title_get.es6=Get the page's title]
         * @memberof $w.Page
         * @instance
         * @readonly
         */

    }, {
        key: 'title',
        get: function get() {
            var RMI = members._RMI.get(this);
            var pageData = RMI.getPageData();

            return pageData && pageData.currentUrlPageTitle;
        }

        /**
         * @member visibleInMenu
         * @label property
         * @syntax
         * get visibleInMenu(): boolean
         * @summary Indicates if the page is included in the site's menu.
         * @description
         *  Whether a page is visible in the site menu is <a href="https://www.wix.com/support/html5/article/hiding-a-page-from-the-menu" target="_blank">set in the Editor</a>
         *  using the <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
         * @snippet [Page-visibleInMenu_get.es6=Get whether the page appears in the site menu]
         * @type {external:Boolean}
         * @memberof $w.Page
         * @instance
         * @readonly
         */

    }, {
        key: 'visibleInMenu',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var pageData = RMI.getData(compId);
            if (pageData) {
                return !pageData.hidePage;
            }
        }
    }]);

    return Page;
}(_Element3.default);

(0, _mixin2.default)(Page.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(Page.prototype, _ContainableMixin2.default.prototype);

exports.default = Page;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = __webpack_require__(33);

var _Node3 = _interopRequireDefault(_Node2);

var _Element = __webpack_require__(8);

var _Element2 = _interopRequireDefault(_Element);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateRelatedTo = function validateRelatedTo(reject, relatedTo) {
    if (relatedTo instanceof _Element2.default) {
        return true;
    }

    var errorMessage = _errors.generateError.error_type({
        propertyName: 'relatedTo',
        functionName: 'showPopover',
        wrongValue: relatedTo,
        expectedType: 'Element'
    });
    _reporter2.default.reportSdkError(errorMessage);
    reject(new Error(errorMessage));
    return false;
};

var Popover = function (_Node) {
    _inherits(Popover, _Node);

    function Popover() {
        _classCallCheck(this, Popover);

        return _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
    }

    _createClass(Popover, [{
        key: 'showPopover',
        value: function showPopover(relatedTo) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var RMI = members._RMI.get(_this2);

                if (!validateRelatedTo(reject, relatedTo)) {
                    return;
                }

                var popoverId = members._compId.get(_this2);
                var targetId = members._compId.get(relatedTo);

                RMI.executeCompBehavior(popoverId, 'showPopover', { targetId: targetId }, resolve);
            });
        }
    }, {
        key: 'hidePopover',
        value: function hidePopover() {
            var _this3 = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this3);
                var popoverId = members._compId.get(_this3);
                RMI.executeCompBehavior(popoverId, 'hidePopover', {}, resolve);
            });
        }
    }]);

    return Popover;
}(_Node3.default);

(0, _livePreview.setStageUnfriendlyFunctions)(Popover, 'showPopover');

exports.default = Popover;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _BaseGallery2 = __webpack_require__(42);

var _BaseGallery3 = _interopRequireDefault(_BaseGallery2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _validation = __webpack_require__(3);

var _constants = __webpack_require__(27);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PRO_GALLERY_APP_DEF_ID = '14271d6f-ba62-d045-549b-ab972ae1f70e';

function getPubSub(contextId) {
    return _platformUtils2.default.getPubSubService().getBoundedAPI(contextId, PRO_GALLERY_APP_DEF_ID);
}

function initGalleryPubSub(contextId, compId, RMI) {
    var pubSubService = getPubSub(contextId);
    pubSubService.unsubscribe('galleryAction_' + compId);
    pubSubService.subscribe('galleryAction_' + compId, function (_ref) {
        var data = _ref.data;

        if (_lodash2.default.get(data, 'action') === 'onItemClicked') {
            var callbackIds = RMI.getEventCallbackIds(compId, RMI.getEventTypes().ITEM_CLICKED);
            _lodash2.default.forEach(callbackIds, function (callbackId) {
                var dynamicCallback = RMI.getCallbackById(callbackId, true);
                var staticCallback = _platformUtils2.default.getStaticEventHandler(callbackId);
                var eventHandler = dynamicCallback || staticCallback;
                var callback = _lodash2.default.get(eventHandler, 'callback');
                if (_lodash2.default.isFunction(callback)) {
                    callback(_lodash2.default.get(data, 'payload.event'));
                }
            });
        }
    });
}

/* REMOVING ALL JSDOC FOR THIS CLASS AND ITS APIs (see https://jira.wixpress.com/browse/WCD-3056) */

var Gallery = function (_BaseGallery) {
    _inherits(Gallery, _BaseGallery);

    // This is named Gallery on purpose so that the user sees it as Gallery
    function Gallery(RMI, compId, contextId, wixSelector, controllerId, role, type, emitter) {
        _classCallCheck(this, Gallery);

        var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type, emitter));

        initGalleryPubSub(contextId, compId, RMI);
        return _this;
    }

    /* REMOVING JSDOC FROM THIS API (see https://jira.wixpress.com/browse/WCD-3056) */


    _createClass(Gallery, [{
        key: 'onItemClicked',


        // The following block of JSDoc must be included due to jsdoc-events lint rule:
        /**
         * @function onItemClicked
         * @param {$w.GalleryItemClickedEventHandler} handler
         * @returns {$w.Gallery}
         * @see [clickAction](#clickAction)
         * @memberof $w.Gallery
         * @eventtype itemClicked
         * @eventhandler
         * @ignore
         */
        value: function onItemClicked(cb) {
            var compType = members._type.get(this).compType;
            if ((0, _validation.validate)({
                compType: compType,
                functionName: 'onItemClicked',
                dataToValidate: { onItemClicked: cb },
                compName: this.id
            })) {
                var RMI = members._RMI.get(this);
                var contextId = members._contextId.get(this);
                var controllerId = members._controllerId.get(this);
                var compId = members._compId.get(this);
                RMI.registerEvent(contextId, compId, RMI.getEventTypes().ITEM_CLICKED, controllerId, cb);
            }
            return this;
        }

        /* REMOVING JSDOC FROM THIS API (see https://jira.wixpress.com/browse/WCD-3056) */

    }, {
        key: 'type',
        get: function get() {
            return '$w.Gallery';
        }

        /* REMOVING JSDOC FROM THIS API (see https://jira.wixpress.com/browse/WCD-3056) */

    }, {
        key: 'items',
        set: function set(items) {
            var _this2 = this;

            var imageItems = _imageUtils2.default.filterImageItems(items);
            var areAllImagesValid = _lodash2.default.every(imageItems, function (imageData, imageIndex) {
                return _imageUtils2.default.checkImageValidation({ imageData: imageData, imageIndex: imageIndex, compName: _this2.id });
            });
            if (!areAllImagesValid) {
                return;
            }
            var newItems = _lodash2.default.map(items, function (item, index) {
                if (_lodash2.default.includes(imageItems, item)) {
                    return _imageUtils2.default.dataFormat.toModel(item, index);
                }
                return item;
            });

            if (!_lodash2.default.every(newItems)) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var contextId = members._contextId.get(this);
            RMI.setData(compId, { items: newItems });
            getPubSub(contextId).publish('galleryAction_' + compId, { action: 'setItems', payload: { items: newItems } }, true);
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            if (!data.items) {
                _reporter2.default.reportSdkWarning('retrieving items from a Pro Gallery is only supported after the items have been set via code');
                return null;
            }
            var items = data.items || [];
            var imageItems = _imageUtils2.default.filterImageItems(items);
            return _lodash2.default.map(items, function (item, index) {
                if (_lodash2.default.includes(imageItems, item)) {
                    return _imageUtils2.default.dataFormat.toUser(item, index);
                }
                return item;
            });
        }
    }, {
        key: 'galleryCapabilities',
        get: function get() {
            return Object.freeze({
                isPlayable: false,
                hasCurrentItem: false,
                hasNavigationButtons: false,
                supportsAllMediaTypes: true
            });
        }
    }, {
        key: 'clickAction',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var galleryImageClickAction = _lodash2.default.get(RMI.getProps(compId), 'galleryImageOnClickAction');
            if (!galleryImageClickAction) {
                _reporter2.default.reportSdkWarning('retrieving clickAction from a Pro Gallery is only supported after the items have been set via code');
                return null;
            }
            return _lodash2.default.findKey(_constants.GALLERY_CLICK_ACTIONS, function (v) {
                return v === galleryImageClickAction;
            });
        },
        set: function set(action) {
            var compType = members._type.get(this).compType;
            if ((0, _validation.validate)({
                compType: compType,
                functionName: 'clickAction',
                dataToValidate: { galleryImageOnClickAction: action },
                compName: this.id
            })) {
                var galleryImageClickAction = _lodash2.default.isNil(action) ? _constants.GALLERY_CLICK_ACTIONS.none : _constants.GALLERY_CLICK_ACTIONS[action];
                var RMI = members._RMI.get(this);
                var compId = members._compId.get(this);
                var contextId = members._contextId.get(this);
                RMI.setProps(compId, { galleryImageOnClickAction: galleryImageClickAction });
                getPubSub(contextId).publish('galleryAction_' + compId, { action: 'setClickAction', payload: { action: galleryImageClickAction } }, true);
            }
        }
    }]);

    return Gallery;
}(_BaseGallery3.default);

(0, _mixin2.default)(Gallery.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = Gallery;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _quickActionBarUtils = __webpack_require__(56);

var _quickActionBarUtils2 = _interopRequireDefault(_quickActionBarUtils);

var _styleConstants = __webpack_require__(28);

var _styleConstants2 = _interopRequireDefault(_styleConstants);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class QuickActionBar
 * @summary A [quick action bar](https://support.wix.com/en/article/adding-and-setting-up-the-quick-action-bar-on-your-mobile-site)
 *  helps your visitors contact you instantly from their mobile devices. You can
 *  choose which actions appear on it and customize the design to match your site.
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.QuickActionBar
 * @definitionId wysiwyg.viewer.components.QuickActionBar
 * @tagname QuickActionBar
 */

var QuickActionBar = function (_Element) {
    _inherits(QuickActionBar, _Element);

    function QuickActionBar(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, QuickActionBar);

        var _this = _possibleConstructorReturn(this, (QuickActionBar.__proto__ || Object.getPrototypeOf(QuickActionBar)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(QuickActionBar.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this;
    }

    /**
     * @member showLabels
     * @label property
     * @syntax
     * get showLabels(): Boolean
     * set showLabels(value: Boolean): void
     * @summary Sets or gets whether a quick action bar's labels are shown.
     * @description
     *  Setting the `showLabels` property to `true` shows labels along with the icons
     *  in the quick action bar. Setting it to `false` hides the labels.
     *
     *  Getting the `showLabels` property returns whether the labels are shown or not.
     * @snippet [QuickActionBar-showLabels_set.es6=Set whether the labels are shown]
     * @snippet [QuickActionBar-showLabels_get.es6=Get whether the labels are shown]
     * @type {external:Boolean}
     * @memberof $w.QuickActionBar
     */


    _createClass(QuickActionBar, [{
        key: 'onItemClicked',


        /**
         * @function onItemClicked
         * @syntax
         * function onItemClicked(handler: QuickActionBarItemClickedEventHandler): QuickActionBar
         * callback QuickActionBarItemClickedEventHandler(event: QuickActionBarItemClickedEvent, $w: Function): void
         * @summary Adds an event handler that runs when an item in a quick action bar is
         *  clicked.
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.QuickActionBarItemClickedEventHandler} handler The name of the
         *  function or the function expression to run when a quick action bar item is
         *  clicked.
         * @returns {$w.QuickActionBar} The quick action bar that triggered the event.
         * @snippet [QuickActionBar-onItemClicked.es6=Get the information of the item that was clicked]
         * @memberof $w.QuickActionBar
         * @eventtype itemClicked
         * @eventhandler
         */
        value: function onItemClicked(cb) {
            var compType = members._type.get(this).compType;

            if ((0, _validation.validate)({
                compType: compType,
                functionName: 'onItemClicked',
                dataToValidate: { onItemClicked: cb },
                compName: this.id
            })) {

                var RMI = members._RMI.get(this);
                var contextId = members._contextId.get(this);
                var controllerId = members._controllerId.get(this);
                var compId = members._compId.get(this);
                RMI.registerEvent(contextId, compId, RMI.getEventTypes().QUICK_ACTION_BAR_ITEM_CLICKED, controllerId, cb);
            }
            return this;
        }
    }, {
        key: 'showLabels',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return !RMI.getProps(compId).hideText;
        }

        /**
         * @member showLabels
         * @memberof $w.QuickActionBar
         * @param {external:Boolean} showLabels
         */
        ,
        set: function set(showLabels) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'showLabels',
                dataToValidate: { showLabels: showLabels },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, { hideText: !showLabels });
        }

        /**
         * @member alignment
         * @label property
         * @syntax
         * get alignment(): Alignment
         * set alignment(alignment: Alignment): void
         * type Alignment = "right" | "left"
         * @summary Sets or gets a quick action bar's alignment.
         * @description
         *  Setting the `alignment` property to `"right"` shows the quick action bar on
         *  the right side of the user's device. Setting it to `"left"` shows it on the
         *  left side.
         *
         *  Getting the `alignment` property returns whether the quick action bar is shown
         *  on the left or right side of the user's device.
         * @note
         *  Only vertical quick action bar designs support the `alignment` property.
         * @snippet [QuickActionBar-alignment_set.es6=Set the quick action bar alignment]
         * @snippet [QuickActionBar-alignment_get.es6=Get the quick action bar alignment]
         * @type {external:Boolean}
         * @memberof $w.QuickActionBar
         */

    }, {
        key: 'alignment',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getProps(compId).alignment;
        }

        /**
         * @member alignment
         * @memberof $w.QuickActionBar
         * @param {external:Boolean} alignment
         */
        ,
        set: function set(alignment) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'alignment',
                dataToValidate: { alignment: alignment },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, { alignment: alignment });
        }

        /**
         * @member colorScheme
         * @label property
         * @syntax
         * get colorScheme(): ColorScheme
         * set colorScheme(colorScheme: ColorScheme): void
         * type ColorScheme = "grey" | "black" | "brand"
         * @summary Sets or gets a quick action bar's color scheme.
         * @description
         *  One of:
         *
         *  + `"grey"`: Buttons are grey.
         *  + `"black"`: Buttons are black.
         *  + `"brand"`: Buttons are various colors.
         * @snippet [QuickActionBar-colorScheme_set.es6=Set the color scheme]
         * @snippet [QuickActionBar-colorScheme_get.es6=Get the color scheme]
         * @type {external:String}
         * @memberof $w.QuickActionBar
         */

    }, {
        key: 'colorScheme',
        get: function get() {
            var colorSchemeStyleProperty = _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.COLOR_SCHEME, false);
            return _quickActionBarUtils2.default.getColorSchemeParts(colorSchemeStyleProperty).colorScheme;
        }

        /**
         * @member colorScheme
         * @memberof $w.QuickActionBar
         * @param {external:String} colorScheme
         */
        ,
        set: function set(colorScheme) {
            var compName = members._compName.get(this);
            var compType = members._type.get(this).compType;

            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'colorScheme',
                dataToValidate: { colorScheme: colorScheme },
                compName: compName
            })) {
                return this;
            }

            var currentColorScheme = _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.COLOR_SCHEME, false);
            var currentInvertColorsPart = _quickActionBarUtils2.default.getColorSchemeParts(currentColorScheme).invertColorScheme;
            var newColorSchemeStyleProperty = colorScheme.concat(currentInvertColorsPart);

            _styleService2.default.setStyle.call(this, _styleConstants2.default.COLOR_SCHEME, newColorSchemeStyleProperty, false);
        }

        /**
         * @member invertColorScheme
         * @label property
         * @syntax
         * get invertColorScheme(): Boolean
         * set invertColorScheme(value: Boolean): void
         * @summary Sets or gets whether a quick action bar's color scheme is inverted.
         * @description
         *  Setting the `invertColorScheme` property to `true` applies the quick action
         *  bar's colors to the bar's background. Setting it to `false` applies the colors
         *  to the bar's icons.
         *
         *  Getting the `invertColorScheme` property returns whether the color scheme is
         *  inverted or not.
         * @snippet [QuickActionBar-invertColorScheme_set.es6=Set whether the color scheme is inverted]
         * @snippet [QuickActionBar-invertColorScheme_get.es6=Get whether the color scheme is inverted]
         * @type {external:Boolean}
         * @memberof $w.QuickActionBar
         */

    }, {
        key: 'invertColorScheme',
        get: function get() {
            var colorSchemeStyleProperty = _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.COLOR_SCHEME, false);
            return !!_quickActionBarUtils2.default.getColorSchemeParts(colorSchemeStyleProperty).invertColorScheme;
        }

        /**
         * @member invertColorScheme
         * @memberof $w.QuickActionBar
         * @param {external:Boolean} invertColorScheme
         */
        ,
        set: function set(invertColorScheme) {
            var compName = members._compName.get(this);
            var compType = members._type.get(this).compType;

            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'invertColorScheme',
                dataToValidate: { invertColorScheme: invertColorScheme },
                compName: compName
            })) {
                return this;
            }

            var currentColorScheme = _styleService2.default.getStyleParamValue.call(this, _styleConstants2.default.COLOR_SCHEME, false);
            var currentColorSchemeParts = _quickActionBarUtils2.default.getColorSchemeParts(currentColorScheme);
            var shouldUpdateInvertColors = !!currentColorSchemeParts.invertColorScheme !== invertColorScheme;
            if (shouldUpdateInvertColors) {
                var newColorSchemeStyleProperty = _quickActionBarUtils2.default.getColorSchemeStyleProperty(currentColorSchemeParts.colorScheme, invertColorScheme);
                _styleService2.default.setStyle.call(this, _styleConstants2.default.COLOR_SCHEME, newColorSchemeStyleProperty, false);
            }
        }
    }]);

    return QuickActionBar;
}(_Element3.default);

exports.default = QuickActionBar;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _utils = __webpack_require__(5);

var _validation = __webpack_require__(3);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(32);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _validationsService = __webpack_require__(11);

var _optionsUtils = __webpack_require__(41);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class RadioButtonGroup
 * @summary Radio button groups are used for selecting one of a number of
 *  options. Radio button groups consist of a list of [options](#Option). Each
 *  [option](#Option) contains a label, which is what the user sees, and a
 *  value, which is what is used in code and stored in you collections.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.RadioGroup
 * @definitionId wysiwyg.viewer.components.inputs.RadioGroup
 * @tagname RadioButtonGroup
 */
var RadioButtonGroup = function (_FormElement) {
    _inherits(RadioButtonGroup, _FormElement);

    function RadioButtonGroup() {
        _classCallCheck(this, RadioButtonGroup);

        return _possibleConstructorReturn(this, (RadioButtonGroup.__proto__ || Object.getPrototypeOf(RadioButtonGroup)).apply(this, arguments));
    }

    _createClass(RadioButtonGroup, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                options = this.options,
                selectedIndex = this.selectedIndex;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, options: options, selectedIndex: selectedIndex };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the radio button group's styles.
         * @description
         *  The following styles can be used with radio button groups:
         *
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a radio button group's styles, gets or sets the styles of the
         *  radio button group's regular state. It does not set the styles of the radio button group's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.RadioButtonGroup
         * @readonly
         * @override
         */

    }, {
        key: 'options',


        /**
         * @typedef {external:Object} $w.RadioButtonGroup~Option
         * @summary An object used by the `options` property that contains the attributes of a radio button item.
         * @property {external:String} value The value of the radio button option. This is what you use in code and is what is stored in your collections.
         * @property {external:String} [label] The label of the radio button option. This is what a user sees.
         * @see [options](#options)
         * @see [value](#value)
         */

        /**
         * @member options
         * @label property
         * @syntax
         * get options(): Option[]
         * set options(value: options[]): void
         * @summary Sets or gets the options in a radio button group.
         * @description
         *  Setting the `options` property sets all the [options](#Option)
         *  available to a user.
         *
         *  Set `options` to an empty array (`[]`) to remove the current radio button group options.
         *
         *  Getting the `options` property returns the current
         *  list of [options](#Option) available to a user.
         *
         *  You cannot modify the data array in-place. To add, change, or remove
         *  individual radio button options:
         *
         *    1. Store the value of the `options` property in a variable.
         *    1. Make changes to the options array.
         *    1. Reset the `options` property with the modified array.
         * @snippet [RadioButtonGroup-options_get.es6=Get the list of options and the first option's label and value from a radio button group]
         * @snippet [RadioButtonGroup-options_set.es6=Set the list of options for a radio button group]
         * @snippet [RadioButtonGroup-add.es6=Add an option to a radio button group]
         *  This example retrieves the options of a radio button group, adds a new
         *  option, and then overwrites the old options.
         * @type {$w.RadioButtonGroup~Option[]}
         * @default An empty array
         * @memberof $w.RadioButtonGroup
         * @instance
         */
        get: function get() {
            var options = Utils.getData(this, 'options');

            return options ? options.map(function (option) {
                return { label: option.label, value: option.value };
            }) : options;
        }

        /**
         * @member options
         * @memberof $w.RadioButtonGroup
         * @param {$w.RadioButtonGroup~Option[]} newOptions
         */
        ,
        set: function set(newOptions) {
            var _this2 = this;

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'options',
                dataToValidate: { options: newOptions },
                compName: this.id
            });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = _lodash2.default.every(newOptions, function (v, i) {
                return (0, _validation.validate)({
                    compType: compType,
                    functionName: 'options',
                    dataToValidate: { RadioButton: v },
                    shouldCheckMandatoryFields: true,
                    itemIndex: i,
                    compName: _this2.id
                }) && (0, _optionsUtils.validateOption)(v, i, 'RadioButton');
            });
            if (!arrItemsArrValid) {
                return;
            }

            var options = (0, _utils.nullIfNil)(newOptions) ? (0, _optionsUtils.optionsToDisplay)(newOptions) : [];
            var modifiedOptions = options.map(function (option) {
                return {
                    value: option.value,
                    label: option.label,
                    type: 'RadioButton'
                };
            });

            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(modifiedOptions, RMI.getData(compId).value);

            (0, _validationsService.runValidationsAndSync)(RMI, compId, valToValidate);
            Utils.setData(this, { options: modifiedOptions });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets the value of the selected option.
         * @description
         *  Setting the `value` property sets the [`Option`](#Option)
         *  with that value to be the selected option. You must set the `value`
         *  property to a value that exists in the [`options`](#options) list.
         *
         *  To reset the radio button group to have no option
         *  selected, set the `value` property to `null` or `undefined`.
         *
         *  Getting the `value` property returns the value of
         *  the currently selected option. If no value is selected, the
         *  `value` property returns an empty string.
         * @note
         *  Changing a radio button group's `value` in code does not trigger an `onChange` event.
         *
         *  If a radio button group is connected to a dataset, setting the radio button group's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [RadioButtonGroup-value_get.es6=Get the value of the selected option]
         * @snippet [RadioButtonGroup-value_set.es6=Select an option by value]
         * @type {external:String}
         * @memberof $w.RadioButtonGroup
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var value = RMI.getData(compId).value;

            return (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);
        }

        /**
         * @member value
         * @memberof $w.RadioButtonGroup
         * @param {external:String} val
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'value',
                dataToValidate: { value: value },
                compName: this.id
            });

            if (!isValid) {
                return;
            }

            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, valToValidate);

            RMI.setData(compId, { value: valToValidate });
        }

        /**
         * @member selectedIndex
         * @label property
         * @syntax
         * get selectedIndex(): Number
         * set selectedIndex(value: Number): void
         * @summary Sets or gets the index of the selected option.
         * @description
         *  Setting the `selectedIndex` property sets the option at
         *  that index to be the selected option. To set one of the options to be
         *  selected, set the `selectedIndex` property to an index between `0` and
         *  `options.length - 1`.
         *
         *  To reset the radio button group to have no option
         *  selected, set the `selectedIndex` property to `undefined`.
         *
         *  Getting the `selectedIndex` property returns the index of
         *  the currently selected option. If no value is selected, the
         *  `selectedIndex` property returns `undefined`.
         * @type {external:Number}
         * @snippet [RadioButtonGroup-selectedIndex_get.es6=Get the index of the selected option]
         * @snippet [RadioButtonGroup-selectedIndex_set.es6=Select the first option by index]
         * @default -1
         * @memberof $w.RadioButtonGroup
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'selectedIndex',
        get: function get() {
            return (0, _utils.getIndexOrUndefined)(this.options, 'value', Utils.getData(this, 'value'));
        }

        /**
         * @member selectedIndex
         * @memberof $w.RadioButtonGroup
         * @param {external:Number} index
         */
        ,
        set: function set(index) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            var options = _optionsUtils.getOptionsFromFull.call(this);
            var acceptNil = true;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'selectedIndex',
                dataToValidate: { selectedIndex: index },
                compName: this.id
            }) || !(0, _validation.validateRange)({
                functionName: 'selectedIndex',
                propertyName: 'selectedIndex',
                value: index,
                minValue: 0,
                maxValue: options.length - 1,
                acceptNil: acceptNil
            })) {
                return;
            }

            var value = _lodash2.default.isNil(index) ? '' : options[index].value;

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, value);
            Utils.setData(this, { value: value });
        }
    }]);

    return RadioButtonGroup;
}(_FormElement3.default);

(0, _mixin2.default)(RadioButtonGroup.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(RadioButtonGroup.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(RadioButtonGroup.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(RadioButtonGroup.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(RadioButtonGroup.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(RadioButtonGroup.prototype, _RequiredMixin2.default.prototype);

exports.default = RadioButtonGroup;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _validation = __webpack_require__(3);

var _regexValidations = __webpack_require__(57);

var _regexValidations2 = _interopRequireDefault(_regexValidations);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _compInitializeService = __webpack_require__(50);

var _compInitializeService2 = _interopRequireDefault(_compInitializeService);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRepeaterOrDataItems(RMI, compId) {
    var compData = RMI.getData(compId);
    return compData.fullItems || _lodash2.default.map(compData.items, function (itemId) {
        return { _id: itemId };
    });
}

function executeBehaviorByTypeForItems(RMI, wixSelector, repeaterId, behaviorType, items, callWith$w, compName, functionName) {
    var componentEvents = RMI.getEvents(repeaterId);
    var filteredBehaviors = _lodash2.default.filter(componentEvents, { eventType: behaviorType });
    var compBehaviors = _lodash2.default.transform(filteredBehaviors, function (result, behavior) {
        var funcRef = behavior.callbackId;
        var dynamicCallback = RMI.getCallbackById(funcRef, true);
        var staticCallback = _platformUtils2.default.getStaticEventHandler(funcRef);
        var eventHandler = dynamicCallback || staticCallback;
        if (eventHandler) {
            result.push({ cb: _lodash2.default.get(eventHandler, 'callback'), contextId: _lodash2.default.get(eventHandler, 'contextId'), controllerId: _lodash2.default.get(eventHandler, 'controllerId') || _lodash2.default.get(eventHandler, 'contextId') });
        }
    }, []);

    executeBehaviorForItems(wixSelector, repeaterId, compBehaviors, items, callWith$w, compName, functionName);
}

function logErrorFromFunction(compName, functionName, errorMessage) {
    _reporter2.default.reportSdkError(_errors.generateError.error_function_throws_error({
        compName: compName,
        functionName: functionName,
        errorMessage: errorMessage
    }));
}

function executeBehaviorForItems(wixSelector, repeaterId, compBehaviors, items, callWith$w, compName, functionName) {
    var _this = this;

    if (_lodash2.default.isEmpty(items) || _lodash2.default.isEmpty(compBehaviors)) {
        return;
    }
    _lodash2.default.forEach(items, function (item) {
        var $wToContextAndController = {};
        _lodash2.default.forEach(compBehaviors, function (behavior) {
            var controllerId = behavior.controllerId;
            var contextId = behavior.contextId;
            if (!callWith$w) {
                try {
                    behavior.cb.call(_this, item.item);
                } catch (e) {
                    logErrorFromFunction(compName, functionName, e.message);
                }
                return;
            }
            var $w = _lodash2.default.get($wToContextAndController, [contextId, controllerId]);
            if (!$w) {
                $w = wixSelector.getScopedSelectorForDisplayedOnlyComp(repeaterId, item.item._id, contextId, controllerId);
                _lodash2.default.set($wToContextAndController, [contextId, controllerId], $w);
            }
            try {
                behavior.cb.call(_this, $w, item.item, item.index);
            } catch (e) {
                logErrorFromFunction(compName, functionName, e.message);
            }
        });
    });
}

function getCompsWithData(RMI, repeaterId, reduceItems) {
    var repeaterUtils = _platformUtils2.default.getRepeaterUtils();
    return _lodash2.default.reduce(repeaterUtils.items.getTemplateCompsId(RMI, repeaterId, reduceItems), function (result, compId) {
        result[compId] = RMI.getComp(compId);
        return result;
    }, {});
}

function validateItemIdFormatAndReportIfNecessary(id, index, repeaterId) {
    if (!_regexValidations2.default.validateRepeaterItemIdFormat(id)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_bad_item_id_format({
            repeaterId: repeaterId,
            wrongValue: id,
            index: index
        }));

        return false;
    }
    return true;
}

/**
 * @class Repeater
 * @summary A repeating layout.
 * @classdesc
 *  Repeaters provide a way for you to add repeating content to a page.
 *  Repeaters consist of repeating items, each with the same layout
 *  but different data.
 *
 *  For example, the repeater below contains three items, each with the same
 *  layout. There is an image on the left and two text elements on the right.
 *  However, the data in each item is different. That is, the actual images and
 *  text values are different in each repeated item.
 *
 *  ![Repeater example](images/repeater.png "Repeater example")
 *
 *  The data displayed in a repeater comes from either:
 *
 *  + Connecting the repeater and the elements contained within its items to a
 *    dataset in the Editor.
 *  + Using the [`data`](#data) property in conjunction with the [`forEachItem()`](#forEachItem),
 *    [`forItems()`](#forItems), and [`onItemReady()`](#onItemReady) functions
 *    in code.
 *
 *
 *  <h3 id="item-template">Repeated Item Template</h3>
 *
 *  Each repeater has an item template that contains the elements and initial data
 *  that are used when new items are created. The template's initial state is the
 *  state of the first repeated item that appears in the Editor. Using code, you
 *  can set the properties of, get the properties of, or call functions on the
 *  elements of the item template by selecting the elements using
 *  [`$w()`]($w.html#w), the [global scope](#global-scope) selector function.
 *
 *  <h3 id="selector-scope">Selector Scope</h3>
 *
 *  Selector functions are used to select specific page elements so you can work
 *  with them in code. Depending on which selector you use, you are able to
 *  select elements from the different scopes described below.
 *
 *  There are two types of selector functions:
 *
 *  + [Global Scope Selectors](#global-scope)
 *  + [Repeated Item Scope Selectors](#repeated-item-scope)
 *
 *
 *  <h4 id="global-scope">Global Scope</h4>
 *  The [`$w()`]($w.html#w) function that is available to your Page
 *  and Site code selects elements in the global scope.
 *
 *  A selector with global scope can be used to select any element that is not
 *  contained in a repeater. You can also use it to select an element that is
 *  contained in a repeater, but you need to understand what that selection means.
 *
 *  When you select an element contained in a repeater from the global scope and
 *  you get the value of one of the element's properties, you receive the value
 *  of that element's property from the repeater's [item template](#item-template).
 *
 *  For example, here `templateText` is the `text` value of the `myRepeatedText`
 *  element from the repeater's item template.
 *
 *  ```javascript
 *  $w.onReady( function () {
 *    let templateText = $w("#myRepeatedText").text;
 *  } );
 *  ```
 *
 *  When you select an element contained in a repeater from the global scope and
 *  you set the value of one of the element's properties or call one of the
 *  element's functions, the value is set or the function is called on the
 *  repeater's [item template](#item-template) **and** all repeated instances of
 *  that element.
 *
 *
 *  For example, here the item template is changed so that `"New Text"` is the
 *  `text` value of the `myRepeatedText` element. Also, all existing repeated
 *  items have the `text` value of their `myRepeatedText` element set to `"New Text"`.
 *
 *  ```javascript
 *  $w.onReady( function () {
 *    $w("#myRepeatedText").text = "New Text";
 *  } );
 *  ```
 *
 *  And here the item template is changed so that the `myRepeatedImage` element
 *  is hidden. Also, all existing repeated items have their `myRepeatedImage` element hidden.
 *
 *  ```javascript
 *  $w.onReady( function () {
 *    $w("#myRepeatedImage").hide();
 *  } );
 *  ```
 *
 *  <h4 id="repeated-item-scope">Repeated Item Scope</h4>
 *  There are two instances where you get a repeated-item-scope selector:
 *
 *  + The `$item` parameter of the [`forEachItem()`](#forEachItem),
 *    [`forItems()`](#forItems), and [`onItemReady()`](#onItemReady) event
 *    handlers.
 *  + When calling the [$w.at()]($w.html#at) and passing it an event whose
 *    [`context`]($w.Event.html#context) is "COMPONENT_SCOPE". This is usually
 *    done in an event handler that handles event on an element inside a repeater.
 *
 *
 *  A selector with repeated item scope can be used to select a specific instance
 *  of a repeating element.
 *
 *  For example, here when the `myRepeatedImage` element is clicked, the value of
 *  a text element in the same repeated item where the image was clicked is changed
 *  to "Selected". All the other text elements elements with the ID `myRepeatedText`
 *  in the other items of the repeater are not affected.
 *
 *  ```javascript
 *  $w.onReady( function () {
 *    $w("#myRepeatedImage").onClick( (event) => {
 *      let $item = $w.at(event.context);
 *      $item("#myRepeatedText").text = "Selected";
 *    } );
 *  } );
 *  ```
 *
 *  And here, when each item is ready, the value of a text element is set to a
 *  value found in that specific item's data.
 *
 *  ```javascript
 *  $w("#myRepeater").onItemReady( ($item, itemData, index) => {
 *    $item("#myRepeatedText").text = itemData.textField;
 *  } );
 *  ```
 *
 *  You can also use a selector with repeated item scope to select non-repeating
 *  elements from the global scope. However, you cannot change a repeater's
 *  [item template](#item-template) using a selector with repeated item scope.
 *
 *  You can restrict a selector with repeated item scope to only select
 *  elements from the current repeated items and their descendants, but not elements
 *  from the global scope by adding `.scoped()` to the selector so the function
 *  call looks like `$item.scoped("#idToSelect")`.
 *
 *  <h3 id="select-item">Retrieve Repeater Item Data When Clicked</h3>
 *
 *  Each repeated item in a repeater has a [`Container`]($w.Container.html) element
 *  that holds all of its repeated elements. To retrieve the data associated
 *  with a specific repeated item when it is clicked, create an `onClick` event
 *  handler for the item's `Container`. Depending on how you populated the repeater
 *  with data, you either user the connected dataset or the repeater's `data`
 *  array to retrieve the clicked item's data in the event handler.
 *
 *  For a repeater populated by connecting it to a dataset:
 *
 *  ```javascript
 *  $w.onReady( function () {
 *    $w("#repeatedContainer").onClick( (event) => {
 *      let $item = $w.at(event.context);
 *      let clickedItemData = $item("#myDataset").getCurrentItem();
 *    } );
 *  } );
 *  ```
 *
 *  For a repeater populated by setting its [`data`](#data) property:
 *
 *  ```javascript
 *  $w.onReady( function () {
 *    $w("#repeatedContainer").onClick( (event) => {
 *      const data = $w("#myRepeater").data;
 *      let clickedItemData = data.filter(item => item._id === event.context.itemId);
 *    } );
 *  } );
 *  ```
 *
 *
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.Repeater
 * @definitionId wysiwyg.viewer.components.Repeater
 * @tagname PLACEHOLDER
 */

var Repeater = function (_Element) {
    _inherits(Repeater, _Element);

    function Repeater() {
        _classCallCheck(this, Repeater);

        return _possibleConstructorReturn(this, (Repeater.__proto__ || Object.getPrototypeOf(Repeater)).apply(this, arguments));
    }

    _createClass(Repeater, [{
        key: 'onItemReady',


        /**
         * @callback $w.ItemReadyEventHandler
         * @description Handles repeater item ready events.
         * @param {$w.$w} $item A selector function with [repeated item scope](#repeated-item-scope).
         * @param {external:Object} itemData The object from the repeater's `data` array that corresponds to the repeated item being created.
         * @param {external:Number} index The index of the `itemData` object in the `data` array.
         */

        /**
         * @function onItemReady
         * @syntax
         * function onItemReady(handler: ItemReadyEventHandler): Repeater
         * callback ItemReadyEventHandler($item: Function, itemData: Object, index: Number): void
         * @summary Sets the function that runs when a new repeated item is created.
         * @description
         *  Use the `onItemReady()` function for code you want to run before new
         *  repeated items are rendered.
         *
         *  The callback is triggered when you add new items by setting the
         *  [`data`](#data) property. It is not triggered for existing items that
         *  are updated when you set the [`data`](#data) property. To run code after
         *  updating existing items, use the [`forEachItem`](#forEachItem) or
         *  [`forItems`](#forItems) functions.
         *
         *
         *  Usually, you use `onItemReady()` to:
         *
         *  + Apply the repeated item's `itemData` to the properties and functions
         *    of the repeated elements contained in the repeated item being created.
         *  + Add event handlers to the repeated elements contained in
         *    the repeated item being created.
         * @note
         *   When using a dataset to populate the contents of your repeated items,
         *   the `onItemReady()` callback function is triggered before the dataset
         *   populates the values of your page elements. Therefore, element values
         *   that you set using `onItemReady()` may be overridden when the dataset is
         *   ready. To change the values set by the dataset, use [`forEachItem`](#forEachItem)
         *   inside the datset's [`onReady()`](wix-dataset.html#onReady). For more
         *   information, see the [`forEachItem`](#forEachItem) examples.
         * @snippet [Repeater-onItemReady.es6=Set up new repeated items]
         * @snippet [Repeater-onItemReady_scenario.es6=Set up new repeated items]
         *  This example creates an event handler that sets up new repeated items by
         *  setting the source of a repeated image element and the text value of a
         *  repeated text element to values from the repeated item's data.
         *
         *  It also sets an event handler that runs when the image in a repeated
         *  item is clicked. The event handler changes the value of a repeated text
         *  element to indicate whether the repeated item is "selected". It also
         *  changes the value of a non-repeated text element which serves as a
         *  counter for how many repeated items are "selected".
         * @param {$w.ItemReadyEventHandler} handler The name of the function or
         *  the function expression to run when the item is ready.
         * @returns {$w.Repeater} The element on which the event is now registered.
         * @eventtype itemReady
         * @eventhandler
         * @memberof $w.Repeater
         */

        value: function onItemReady(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onItemReady',
                dataToValidate: { callback: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().ITEM_READY, controllerId, cb);

            /*Trigger onItemReady on existing items, only after the first set items()*/
            var compData = RMI.getData(compId);
            if (compData.fullItems) {
                var currentItems = getRepeaterOrDataItems(RMI, compId);
                var wixSelector = members._wixSelector.get(this);
                var newBehavior = [{ cb: cb, contextId: contextId, controllerId: controllerId }];
                var itemsWithIndex = _lodash2.default.map(currentItems, function (item, index) {
                    return { item: item, index: index };
                });

                executeBehaviorForItems(wixSelector, compId, newBehavior, itemsWithIndex, true, this.id, 'onItemReady');
            }

            return this;
        }

        /**
         * @callback $w.ItemRemovedEventHandler
         * @description Handles repeater item removed events.
         * @param {external:Object} itemData The object from the repeater's `data` array that corresponds to the repeated item being removed.
         */

        /**
         * @function onItemRemoved
         * @syntax
         * function onItemRemoved(handler: ItemRemovedEventHandler): Repeater
         * callback ItemRemovedEventHandler(itemData: Object): void
         * @summary Sets the function that runs when a repeated item is removed.
         * @description
         *  Use the `onItemRemoved()` function for code you want to run when
         *  repeated items are removed. The callback is triggered when you remove
         *  items by setting the value of the [`data`](#data) property to an array
         *  in which some of the existing item IDs are no longer present.
         * @note
         *  The `onItemRemoved()` callback function is not called when the static
         *  repeated items that were set in the Editor are removed.
         * @snippet [Repeater-onItemRemoved.es6=Get data from items being removed]
         * @param {$w.ItemRemovedEventHandler} handler The name of the function or
         *  the function expression to run when the item is removed.
         * @returns {$w.Repeater} The element on which the event is now registered.
         * @eventtype itemRemoved
         * @eventhandler
         * @memberof $w.Repeater
         */

    }, {
        key: 'onItemRemoved',
        value: function onItemRemoved(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onItemRemoved',
                dataToValidate: { callback: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().ITEM_REMOVED, controllerId, cb);

            return this;
        }

        /**
         * @callback $w.ForItemCallback
         * @description Runs for items in a repeater.
         * @param {$w.$w} $item A selector function with [repeated item scope](#repeated-item-scope).
         * @param {external:Object} itemData The object from the repeater's `data` array that corresponds to the current repeated item.
         * @param {external:Number} index The index of the `itemData` object in the `data` array.
         */

        /**
         * @function forEachItem
         * @syntax
         * function forEachItem(callback: ForItemCallback): void
         * callback ForItemCallback($item: Function, itemData: Object, index: Number): void
         * @summary Runs a function for each repeated item.
         * @description
         *  Use the `forEachItem()` function to run a function on all of a repeater's
         *  repeated items. You can use the callback function to update or pull
         *  information from all of the repeater's repeated items.
         *
         *  When you set a repeater's [`data`](#data) property with data that changes
         *  items with existing IDs, those changes are not automatically reflected
         *  in the elements contained in the repeater. That is because you are
         *  responsible for applying a repeater's data to its repeated items.
         *
         *  To apply the data to items with new IDs, you can use the [`onItemReady()`](#onItemReady)
         *  event handler.
         *
         *  To update items with existing IDs, you can use the `forEachItem()` or
         *  [`forItems()`](#forItems) functions.
         *
         *  Usually, when updating repeated items you:
         *
         *  + Apply the repeated item's `itemData` to the elements contained in each
         *    of the repeater's repeated items.
         *  + Add event handlers to the elements contained in each of the
         *    repeater's repeated items.
         * @snippet [Repeater-forEachItem.es6=Loop through all of a repeater's repeated items]
         * @snippet [Repeater-forEachItem_scenario.es6=Update data in all of a repeater's repeated items]
         * @snippet [Repeater-forEachItem_dataset_override.es6=Update data in all of a repeater's repeated items]
         *  This example uses a `forEachItem()` to override some of the data populated
         *  into a repeater that is connected to a dataset. Here we want a text element
         *  to contain text that changes based on the value of a certain boolean field.
         *  When a page loads, the dataset loads after the repeater. So we wait for the
         *  dataset's [`onReady()`](wix-dataset.html#onReady) to call a `forEachItem()`
         *  that sets the desired values.
         * @param {$w.ForItemCallback} callback The name of the function or the function expression to run for each repeated item.
         * @memberof $w.Repeater
         */

    }, {
        key: 'forEachItem',
        value: function forEachItem(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'forEachItem',
                dataToValidate: { callback: cb },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var repeaterItems = getRepeaterOrDataItems(RMI, compId);
            var wixSelector = members._wixSelector.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);

            _lodash2.default.forEach(repeaterItems, function (itemData, index) {
                try {
                    cb(wixSelector.getScopedSelectorForDisplayedOnlyComp(compId, itemData._id, contextId, controllerId), itemData, index);
                } catch (error) {
                    throw new _monitoring2.default.MonitoringErrorToIgnore(error);
                }
            });
        }

        /**
         * @function forItems
         * @syntax
         * function forItems(itemIds: String[], callback: ForItemCallback): void
         * callback ForItemCallback(selector: Function, itemData: Object, index: Number): void
         * @summary Runs a function for each repeated item with the given IDs.
         * @description
         *  Use the `forItems()` function to run a function on a specified list of
         *  repeated items. You can use the callback function to update or pull
         *  information from the specified repeated items.
         *
         *  When you set a repeater's [`data`](#data) property with data that changes
         *  items with existing IDs, those changes are not automatically reflected
         *  in the elements contained in the repeater. That is because you are
         *  responsible for applying a repeater's data to its repeated items.
         *
         *  To apply the data to items with new IDs, you can use the [`onItemReady()`](#onItemReady)
         *  event handler.
         *
         *  To update items with existing IDs, you can use the `forEachItem()` or
         *  [`forItems()`](#forItems) functions.
         *
         *  Usually, when updating repeated items you:
         *
         *  + Apply the repeated item's `itemData` to the elements contained in each
         *    of the repeater's repeated items.
         *  + Add event handlers to the elements contained in each of the
         *    repeater's repeated items.
         *
         *
         * @snippet [Repeater-forItems.es6=Loop through some of a repeater's repeated items]
         * @snippet [Repeater-forItems_scenario.es6=Update data in some of a repeater's repeated items]
         * @param {external:String[]} itemIds The IDs of the items on which to run the callback function.
         * @param {$w.ForItemCallback} callback The name of the function or the function expression to run for each repeated item.
         * @memberof $w.Repeater
         */

    }, {
        key: 'forItems',
        value: function forItems(ids, cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'forItems',
                dataToValidate: { callback: cb, ids: ids },
                compName: this.id
            })) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var repeaterItems = getRepeaterOrDataItems(RMI, compId);
            var wixSelector = members._wixSelector.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);

            var existItems = _lodash2.default.transform(ids, function (result, id) {
                var itemIndex = _lodash2.default.findIndex(repeaterItems, { _id: id });
                if (itemIndex === -1) {
                    _reporter2.default.reportSdkWarning(_errors.generateError.warning_non_existing_item({
                        functionName: 'forItems',
                        _id: id
                    }));

                    return;
                }

                result.push({ itemData: repeaterItems[itemIndex], index: itemIndex });
            }, []);

            _lodash2.default.forEach(existItems, function (item) {
                try {
                    cb(wixSelector.getScopedSelectorForDisplayedOnlyComp(compId, item.itemData._id, contextId, controllerId), item.itemData, item.index);
                } catch (error) {
                    throw new _monitoring2.default.MonitoringErrorToIgnore(error);
                }
            });
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                items = this.items;

            return { id: id, type: type, global: global, rendered: rendered, items: items };
        }
    }, {
        key: 'data',


        /**
         * @member data
         * @label property
         * @syntax
         * get data(): Object[]
         * set data(value: Object[]): void
         * @summary Sets or gets the repeater data.
         * @description
         *  A repeater's data is stored as an array of objects. Each object in the array
         *  must contain a unique `_id` property which is used to match the object's
         *  data to the individual repeated items of the repeater as described below.
         *  The value of the `_id` property can only contain alphanumeric
         *  characters and hyphens (`-`). Other than `_id`, the objects in the
         *  repeater's data array can contain anything you want.
         *
         *  For example, a simple array of repeater data may look like this:
         *
         *  ```javascript
         *  [
         *    {
         *      "_id": "1",
         *      "firstName": "John",
         *      "lastName": "Doe",
         *      "image": "http://someImageUrl/john.jpg"
         *    },
         *    {
         *      "_id": "2",
         *      "firstName": "Jane",
         *      "lastName": "Doe",
         *      "image": "http://someImageUrl/jane.jpg"
         *    }
         *  ]
         *  ```
         *
         *  Repeater data is not automatically applied to the elements in the reapeated
         *  items. You choose how to use the repeater's data in the [`onItemReady()`](#onItemReady),
         *  [`onItemRemoved()`](#onItemRemoved), [`forItems()`](#forItems), and
         *  [`forEachItem()`](#forEachItem) callback functions. Most often, you
         *  apply the data of a repeated item to the properties and functions
         *  of the repeated elements contained in that repeated item.
         *
         *  You cannot modify the data array in-place. To add, change, or remove
         *  objects from the repeater's data array:
         *
         *    1. Store the value of the `data` property in a variable.
         *    1. Make changes to the objects of the shouldTriggerOnItemRemoved array.
         *    1. Reset the `data` property with the modified array.
         *
         *
         *  When the repeater's `data` property is set:
         *
         *    1. New repeated items are created for each object that has an `_id` value
         *       that is not already present in the current array of data objects. The elements
         *       in the new items are first populated with the data of the repeater's
         *       [item template](#item-template). Then the [`onItemReady()`](#onItemReady)
         *       event handler is triggered for each of the new items. Usually, you
         *       overwrite some or all of the data populated from the item template
         *       in the [`onItemReady()`](#onItemReady) event handler with the data for
         *       that specific item. When all of the [`onItemReady()`](#onItemReady)
         *       event handlers have finished running, the new items are displayed.
         *    1. Repeated items are removed if their IDs are no longer in the array of
         *       data objects. The [`onItemRemoved()`](#onItemRemoved) event handler is
         *       triggered for each of the removed items.
         *    1. Nothing occurs to repeated items whose IDs were already in the array
         *       of data objects, even if other data in the object has changed. To update
         *       repeated items with the new data, use the [`forEachItem()`](#forEachItem)
         *       or [`forItems()`](#forItems) functions.
         *
         *
         *  Getting the `data` property returns the repeater's current data. If you
         *  have not yet explicitly set the repeater's `data`, getting the `data`
         *  property returns only the IDs of the current repeated items that were
         *  set in the Editor.
         * @snippet [Repeater-data_get.es6=Get a repeater's data]
         * @snippet [Repeater-data_set.es6=Set a repeater's data]
         * @snippet [Repeater-data_set-query.es6=Set a repeater's data from a database query]
         * @snippet [Repeater-data_change.es6=Modify a repeater's data]
         * @snippet [Repeater-data_set-scenario.es6=Set a repeater's data]
         *  This example defines an event handler to handle the creation of new items
         *  and sets a repeater's data.
         * @snippet [Repeater-data_set-scenario-add.es6=Set a repeater's data and add new data on a button click]
         *  This example defines an event handler to handle the creation of new items
         *  and sets a repeater's data. It also adds an event handler to an
         *  "addButton" that is not part of the repeater. Clicking the button resets
         *  the repeater's data, adding another item.
         * @snippet [Repeater-data_set-scenario-remove.es6=Set the a repeater's data and remove some data on a button click]
         *  This example defines event handlers to handle the creation of new items
         *  and the removal of existing items. Then it sets a repeater's data.
         *  Lastly, it adds an event handler to a "removeButton" that is not part of
         *  the repeater. Clicking the button resets the repeater's data, removing
         *  one of the items.
         * @type {external:Object[]}
         * @memberof $w.Repeater
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return getRepeaterOrDataItems(RMI, compId);
        }

        /**
         * @member data
         * @memberof $w.Repeater
         * @param {external:Object[]} items
         */
        ,
        set: function set(items) {
            var _this3 = this;

            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            var compId = members._compId.get(this);

            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'data',
                dataToValidate: { data: items },
                compName: this.id
            }) || !(0, _validation.validateArrayContainsItemsWithIds)({ items: items }) || !_lodash2.default.every(items, function (item, index) {
                return validateItemIdFormatAndReportIfNecessary(item._id, index, _this3.id) && (0, _validation.validate)({
                    compType: compType,
                    functionName: 'data',
                    dataToValidate: { _id: item._id },
                    compName: _this3.id
                });
            })) {
                return;
            }

            var contextId = members._contextId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var compData = RMI.getData(compId);
            var shouldTriggerOnItemRemoved = !!compData.fullItems;
            var currentItems = getRepeaterOrDataItems(RMI, compId);
            var uniqueItems = _lodash2.default.uniqBy(items, '_id');
            var repeaterUtils = _platformUtils2.default.getRepeaterUtils();
            var addedItems = repeaterUtils.items.getAddedItems(currentItems, uniqueItems);
            var removedItems = repeaterUtils.items.getRemovedItems(currentItems, uniqueItems);
            var removedComps = getCompsWithData(RMI, compId, removedItems);
            var itemIds = _lodash2.default.uniq(_lodash2.default.map(items, '_id'));

            RMI.startTransaction();
            RMI.setDataWithoutUpdate(compId, { fullItems: uniqueItems });
            RMI.setData(compId, { items: itemIds });

            var addedComps = getCompsWithData(RMI, compId, addedItems);
            _compInitializeService2.default.componentsInitialize(RMI, contextId, addedComps);
            _compInitializeService2.default.componentsRemoval(RMI, contextId, removedComps);

            executeBehaviorByTypeForItems(RMI, wixSelector, compId, RMI.getEventTypes().ITEM_READY, addedItems, true, this.id, 'onItemReady');
            if (shouldTriggerOnItemRemoved) {
                executeBehaviorByTypeForItems(RMI, wixSelector, compId, RMI.getEventTypes().ITEM_REMOVED, removedItems, false, this.id, 'onItemRemoved');
            }
            RMI.endTransaction();
        }
    }]);

    return Repeater;
}(_Element3.default);

(0, _mixin2.default)(Repeater.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = Repeater;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fieldTypeOperatorTyp;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _Link = __webpack_require__(30);

var _Link2 = _interopRequireDefault(_Link);

var _gridEnums = __webpack_require__(49);

var _gridEnums2 = _interopRequireDefault(_gridEnums);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _utils = __webpack_require__(5);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fieldTypeOperatorTypeMapping = (_fieldTypeOperatorTyp = {}, _defineProperty(_fieldTypeOperatorTyp, _gridEnums2.default.FieldType.STRING, 'StringOperator'), _defineProperty(_fieldTypeOperatorTyp, _gridEnums2.default.FieldType.NUMBER, 'NumericOperator'), _defineProperty(_fieldTypeOperatorTyp, _gridEnums2.default.FieldType.DATE, 'DateOperator'), _fieldTypeOperatorTyp);

function processRowLinks(rows, columnDefs, linksTarget) {
    var linkPaths = _lodash2.default.reduce(columnDefs, function (links, columnDef) {
        if (columnDef.linkPath) {
            links.push(columnDef.linkPath);
        }
        return links;
    }, []);
    if (linkPaths.length > 0) {
        _lodash2.default.map(rows, function (row) {
            _lodash2.default.forEach(linkPaths, function (linkPath) {
                var url = _lodash2.default.get(row, linkPath);
                var linkData = void 0;
                try {
                    var link = new _Link2.default(url, linksTarget);
                    linkData = link.getData();
                } catch (ex) {
                    if (!_lodash2.default.isEmpty(url)) {
                        _reporter2.default.reportSdkError('Error: couldn\'t process link with url "' + url + '": ' + ex.message);
                    }
                    linkData = {};
                } finally {
                    var linkObjPath = linkPath + '_linkObj';
                    _lodash2.default.set(row, linkObjPath, linkData);
                }
            });
        });
    }
    return rows;
}

function processRowImageURIs(rows, columnDefs) {
    var imageColumns = _lodash2.default.filter(columnDefs, function (_ref) {
        var type = _ref.type;
        return type === _gridEnums2.default.FieldType.IMAGE;
    });
    _lodash2.default.forEach(imageColumns, function (columnDef) {
        _lodash2.default.forEach(rows, function (row) {
            var src = _lodash2.default.get(row, columnDef.dataPath);
            if (!_lodash2.default.isNil(src)) {
                var imageData = _imageUtils2.default.extractModelDataFromSrc(src);
                if (!_lodash2.default.isNil(imageData)) {
                    _lodash2.default.set(row, columnDef.dataPath, imageData);
                }
            }
        });
    });
    return rows;
}

function validateDates(rows, columnDefs) {
    var dateColumns = _lodash2.default.filter(columnDefs, { type: _gridEnums2.default.FieldType.DATE });
    _lodash2.default.forEach(dateColumns, function (columnDef) {
        _lodash2.default.forEach(rows, function (row) {
            var dateValue = _lodash2.default.get(row, columnDef.dataPath);
            if (!_lodash2.default.isNil(dateValue)) {
                var date = new Date(dateValue);
                if (isNaN(date)) {
                    _reporter2.default.reportSdkError('Error: Invalid date: "' + dateValue + '" in column \'"' + columnDef.dataPath + '"\'');
                }
            }
        });
    });
}

function executeModificationRowBehaviour(delta) {
    var RMI = members._RMI.get(this);
    var compId = members._compId.get(this);
    RMI.executeCompBehavior(compId, 'modifyRow', delta);
}

function _processData(rows, columnDefs, linksTarget) {
    validateDates(rows, columnDefs);
    var processedRows = processRowLinks(rows, columnDefs, linksTarget);
    processedRows = processRowImageURIs(rows, columnDefs);
    return processedRows;
}

function dataFetchHandler(RMI) {
    return function (e) {
        var compId = e.syntheticEvent.id;
        var compData = RMI.getData(compId);
        var rowRetrievalFunc = _lodash2.default.get(compData, 'dataFetchHandlers');
        if (!_lodash2.default.isFunction(rowRetrievalFunc)) {
            return;
        }
        rowRetrievalFunc(e.syntheticEvent.startRow, e.syntheticEvent.endRow, e.syntheticEvent.sorting, e.syntheticEvent.filter).then(function (data) {
            var props = RMI.getProps(compId);
            var pageRows = _processData(data.pageRows, props.columns, props.linkTarget);
            var prevNumberOfRows = RMI.getData(compId).numberOfDisplayedRows;
            var currNumberOfRows = props.pagination.type === _gridEnums2.default.PaginationType.PAGES ? pageRows.length : prevNumberOfRows;
            RMI.setData(compId, {
                rows: pageRows,
                rowsCount: data.totalRowsCount,
                numberOfDisplayedRows: currNumberOfRows,
                revision: Date.now()
            });
        });
    };
}

/**
 * @class Table
 * @summary A table for displaying data.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.Grid
 * @definitionId wysiwyg.viewer.components.Grid
 */

var Table = function (_Element) {
    _inherits(Table, _Element);

    function Table() {
        _classCallCheck(this, Table);

        return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
    }

    _createClass(Table, [{
        key: 'getDataSourceType',

        // METHODS

        value: function getDataSourceType() {
            return _lodash2.default.get(Utils.getData(this, 'dataSource'), 'type');
        }

        // PROPERTIES:

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `sorting` is not going to be included in "the first release"
         * @typedef {external:Object} $w.Table~SortParam
         * @summary An object used by the `sorting` property that contains one set of sorting parameters.
         * @property {external:String} colId The [column]($w.Table~Column) ID to sort
         * @property {ASC|DSC|NONE} direction The sorting direction
         * @see [sorting](#sorting)
         */

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `sorting` is not going to be included in "the first release"
         * @member {$w.Table~SortParam[]} sorting
         * @label property
         * @syntax
         * let tableSortParams = $w("#myTable").sorting;
         * $w("#myTable").sorting = tableSortParams;
         * @summary Sets the parameters being used to sort the specified table, or returns the existing sort parameters.
         * @description The `sorting` property is composed of an array of {@link $w.Table~SortParam|`SortParam[]`} objects.
         *  The order of the objects in the array determines the order in which the columns are sorted. ___Not clear if
         *  the first object in the array is sorted last or first i.e. is the primary sort key or the least significant sort key___
         * @note When setting the filter, if the `fieldType` or `operator` provided in [tableFilterParams]($w.Table~FilterParam)
         *  is not valid, an error is printed to the console.
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'refresh',


        // METHODS:

        /**
         * @function refresh
         * @syntax
         * function refresh(): void
         * @summary Fetches the most current data and updates the table.
         * @snippet [Table-refresh.es6=Refresh a table]
         * @memberof $w.Table
         */
        value: function refresh() {
            var type = this.getDataSourceType();
            if (_lodash2.default.isUndefined(type)) {
                _reporter2.default.reportSdkError('Error: (Table.refresh) no data source is set');
                return;
            }
            Utils.setData(this, { dataSource: {
                    type: type,
                    revision: Date.now()
                } });
        }

        /**
         * @function onDataChange
         * @syntax
         * function onDataChange(handler: DataChangeEventHandler): void
         * callback DataChangeEventHandler(event: DataChangeEvent, $w: Function): void
         * @summary Adds an event handler that runs when the table's data is changed.
         * @description
         *  A table receives a `dataChange` event when the table's data is changed
         *  using the [`rows`](#rows) property or a data request triggers the
         *  [`onDataRequest` handler](#onDataRequest).
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @param {$w.EventHandler} eventHandler The name of the function or
         *  the function expression to run when the table's data is changed.
         * @memberof $w.Table
         * @eventtype dataChange
         * @eventhandler
         */

    }, {
        key: 'onDataChange',
        value: function onDataChange(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onDataChange',
                dataToValidate: { onDataChange: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            return Utils.onEvent(this, RMI.getEventTypes().DATA_CHANGE, cb);
        }

        /**
         * @function onCellSelect
         * @syntax
         * function onCellSelect(handler: TableCellEventHandler): Table
         * callback TableCellEventHandler(event: TableCellEvent, $w: Function): void
         * @summary Adds an event handler that runs when a table cell is selected.
         * @description
         *  A table receives a [`TableCellEvent`]($w.TableCellEvent.html) when the
         *  table is set [set](https://support.wix.com/en/article/table-settings) in
         *  the Editor to select cells when clicked.
         * ![Clicking Selects Cells](images/table_settings_click_cells.png "Clicking Selects Cells")
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
         * @param {$w.TableCellEventHandler} eventHandler The name of the function or
         *  the function expression to run when the cell is selected.
         * @returns {$w.Table} The table that triggered the event.
         * @memberof $w.Table
         * @eventtype cellSelect
         * @eventhandler
         */

    }, {
        key: 'onCellSelect',
        value: function onCellSelect(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onCellSelect',
                dataToValidate: { onCellSelect: cb },
                compName: this.id
            })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            return Utils.onEvent(this, RMI.getEventTypes().CELL_SELECT, cb);
        }

        /**
         * @function onRowSelect
         * @syntax
         * function onRowSelect(handler: TableRowEventHandler): Table
         * callback TableRowEventHandler(event: TableRowEvent, $w: Function): void
         * @summary Adds an event handler that runs when a table row is selected.
         * @description
         *  A table receives a [`TableRowEvent`]($w.TableRowEvent.html) when the
         *  table is set [set](https://support.wix.com/en/article/table-settings) in
         *  the Editor to select rows when clicked.
         * ![Clicking Selects Rows](images/table_settings_click_rows.png "Clicking Selects Rows")
         * @note
         *  **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
         *  a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
         *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
         *  <a href="https://www.wix.com/code/home/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers" target="_blank">here</a>.
         * @snippet [TableRowEvent-all.es6=Get the selected table cell information]
         * @snippet [TableRowEvent-rowData_dataset.es6=Get the full item information from the dataset]
         * @param {$w.TableRowEventHandler} eventHandler The name of the function or
         *  the function expression to run when the row is selected.
         * @returns {$w.Table} The table that triggered the event.
         * @memberof $w.Table
         * @eventtype rowSelect
         * @eventhandler
         */

    }, {
        key: 'onRowSelect',
        value: function onRowSelect(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'onRowSelect',
                dataToValidate: { onRowSelect: cb },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            return Utils.onEvent(this, RMI.getEventTypes().ROW_SELECT, cb);
        }

        /**
         * @function selectRow
         * @syntax
         * function selectRow(index: Number): void
         * @summary Selects a table row by index.
         * @param {external:Number} index The number of the row to select.
         * @description
         *  The rows in a table are zero-based and do not include the table header.
         *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
         * @snippet [Table-selectRow.es6=Select the table's first row]
         * @memberof $w.Table
         */

    }, {
        key: 'selectRow',
        value: function selectRow(index) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'selectRow',
                dataToValidate: { rowIndex: index },
                compName: this.id
            })) {
                return this;
            }
            if (!(0, _validation.validateRange)({
                functionName: 'selectRow',
                propertyName: 'rowIndex',
                value: index,
                minValue: 0,
                maxValue: this.rows.length - 1
            })) {
                return this;
            }
            RMI.executeCompBehavior(compId, 'modifySelection', { userSelection: { rowIndex: index } });
        }

        /**
         * @function updateRow
         * @syntax
         * function updateRow(index: Number, rowData: Object) : void
         * @summary Updates a the row data of a single row at the specified index.
         * @param {external:Number} index The number of the row to update.
         * @param {external:Object} rowData A row data object of field_name:value pairs where the keys are the table columns.
         * @description
         *  The rows in a table are zero-based and do not include the table header.
         *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
         * @snippet [Table-updateRow.es6=Update the table's first row]
         * @snippet [Table-updateRow-scenario.es6=Update the table's first row]
         * @memberof $w.Table
         */

    }, {
        key: 'updateRow',
        value: function updateRow(index, rowData) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'updateRow',
                dataToValidate: { rowIndex: index, row: rowData },
                compName: this.id
            })) {
                return this;
            }

            var type = this.getDataSourceType();
            if (type === _gridEnums2.default.DataSourceType.DYNAMIC) {
                executeModificationRowBehaviour.call(this, {
                    rowDataDelta: {
                        revision: Date.now(),
                        index: index,
                        op: _gridEnums2.default.RowModification.UPDATE,
                        data: rowData
                    }
                });
            } else {
                var rowsData = Utils.getData(this, 'rows');
                rowsData.splice(index, 1, rowData);
                Utils.setData(this, {
                    dataSource: { type: _gridEnums2.default.DataSourceType.STATIC, revision: Date.now() },
                    rows: rowsData,
                    revision: Date.now()
                });
            }
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                sorting = this.sorting,
                filter = this.filter,
                pagination = this.pagination,
                columns = this.columns,
                rows = this.rows;

            return { id: id, type: type, global: global, rendered: rendered, sorting: sorting, filter: filter, pagination: pagination, columns: columns, rows: rows };
        }
    }, {
        key: 'sorting',
        get: function get() {
            return Utils.getProp(this, 'sorting');
        }

        // param [{colId: String, sort: SortDirection}] sortDef
        /**
         * @ignore
         */
        ,
        set: function set(sortDef) {
            var directions = _lodash2.default.map(_gridEnums2.default.SortDirection);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'sorting',
                dataToValidate: { sorting: sortDef },
                compName: this.id
            });
            if (!isArrayValid) {
                return;
            }
            var allItemsFromEnum = true;

            _lodash2.default.forEach(sortDef, function (colSort, index) {
                if (!_lodash2.default.isObject(colSort) || !(0, _validation.validateValueFromEnum)({
                    functionName: 'sorting',
                    propertyName: 'sortDef',
                    value: colSort.sort,
                    enumValues: directions,
                    itemIndex: index
                })) {
                    allItemsFromEnum = false;
                }
            });

            if (!allItemsFromEnum) {
                return;
            }
            Utils.setProp(this, { sorting: sortDef });
        }

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `filter` is not going to be included in "the first release"
         * @typedef {external:Object} $w.Table~FilterParam
         * @summary An object used by the `filter` property that contains one set of filter parameters.
         * @property {STRING|NUMBER|DATE|IMAGE|BOOLEAN|RICH_TEXT} fieldType The data type of the field to be filtered. ___Not sure about this...___
         * @property {$w.Table~StringOperator|$w.Table~NumericOperator|$w.Table~DateOperator} operator
         *  The comparison operator to use, such as ENDS_WITH or GREATER_THAN.
         * @property {external:String|external:Number|external:Date} value The value used for the comparison.
         * @see [filter](#filter)
         */

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `filter` is not going to be included in "the first release"
         * @member {$w.Table~FilterParam} filter
         * @label property
         * @syntax
         * let tableFilterParams = $w("#myTable").filter;
         * $w("#myTable").filter = tableFilterParams;
         * @summary Sets the parameters being used to filter the specified table, or returns the existing filter parameters.
         * @description ___I'm not sure if by setting this you actually execute the filtering of a table, but it would seem so___
         * @note When setting the filter, if the `fieldType` or `operator` provided in [tableFilterParams]($w.Table~FilterParam) is
         *  not valid, an error is printed to the console.
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'filter',
        get: function get() {
            return Utils.getProp(this, 'filter');
        }

        // param {columnId: {type: Enums.FieldType, operator: Table.StringOperator|Table.NumberOperator|Table.DateOperator}} filter
        /**
         * @ignore
         */
        ,
        set: function set(filter) {
            var fieldTypes = _lodash2.default.map(_gridEnums2.default.FieldType);
            var compType = members._type.get(this).compType;
            var isObj = (0, _validation.validate)({
                compType: compType,
                functionName: 'filter',
                dataToValidate: { filter: filter },
                compName: this.id
            });
            if (!isObj) {
                return;
            }
            var isValid = true;
            _lodash2.default.forEach(_lodash2.default.map(filter), function (currentFilter) {
                if (!(0, _validation.validateValueFromEnum)({
                    functionName: 'filter',
                    propertyName: 'filter',
                    value: currentFilter.type,
                    enumValues: fieldTypes
                })) {
                    isValid = false;
                    return;
                }
                var operatorType = fieldTypeOperatorTypeMapping[currentFilter.type];
                if (!(0, _validation.validateValueFromEnum)({
                    functionName: 'filter',
                    propertyName: 'filter',
                    value: currentFilter.operator,
                    enumValues: _lodash2.default.map(_gridEnums2.default.filtering[operatorType])
                })) {
                    isValid = false;
                }
            });
            if (!isValid) {
                return;
            }

            Utils.setProp(this, { filter: filter });
        }

        /**
         * @typedef {external:Object} $w.Table~PaginationOptions
         * @summary An object used by the `pagination` property that
         * contains the pagination options which determine if and how the table
         * is paginated.
         * @description
         * The table can paginate in three ways:
         *
         *  + `"normal"`: No pagination. The table is scrollable if there are more
         *    rows than can be displayed at once. All data is fetched at once.
         *  + `"pagination"`: The data is separated into pages which are navigatable
         *    using paging buttons. New data is fetched when a user clicks on a
         *    paging button.
         *  + `"virtual"`: The data is separated into pages which are navigated by
         *    scrolling. New data is fetched when user a user scrolls below the
         *    displayed rows.
         * @property {external:String} type The type of pagination to use: `"normal"`, `"pagination"`, or `"virtual"`.
         * @property {external:Number} rowsPerPage The number of rows per page.
         * @snippet [Table-pagination_get.es6=Get the table's pagination options]
         * @snippet [Table-pagination_set.es6=Set the table's pagination options]
         * @see [pagination](#pagination)
         */

        /**
         * @member pagination
         * @label property
         * @syntax
         * set pagination(): PaginationOptions
         * get pagination(value: PaginationOptions): void
         * @summary Sets or gets the table's pagination options.
         * @description
         *  Setting the `pagination` property sets the table's
         *  [pagination options](#PaginationOptions) and changes the way the table
         *  is paginated.
         *
         *  Getting the `pagination` property returns the table's
         *  current [pagination options](#PaginationOptions).
         * @snippet [Table-pagination_get.es6=Get the table's pagination options]
         * @snippet [Table-pagination_set.es6=Set the table's pagination options]
         * @memberof $w.Table
         * @type {$w.Table~PaginationOptions}
         * @instance
         */

    }, {
        key: 'pagination',
        get: function get() {
            return _lodash2.default.omit(Utils.getProp(this, 'pagination'), ['manualHeightProps']);
        }

        /**
         * @member pagination
         * @memberof $w.Table
         * @param {$w.Table~PaginationOptions} pagination
         */
        ,
        set: function set(pagination) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'pagination',
                dataToValidate: { pagination: pagination },
                shouldCheckMandatoryFields: true,
                compName: this.id
            })) {
                return;
            }
            Utils.setProp(this, { pagination: pagination });
        }

        /**
         * @typedef {external:Object} $w.Table~Column
         * @summary An object used by the `columns` property that
         *  contains the properties that define a table column. Table columns do not
         *  store any data.
         * @property {external:String} id The column ID.
         * @property {external:String} dataPath The location of the data displayed
         *  in the column.
         *
         *  When the table is populated by a connection to a dataset, the `dataPath`
         *  value is a field key from the collection that the dataset is connected to.
         *
         *  When the table is populated by using the [`rows`](#rows) or
         *  [`dataFetcher`](#dataFetcher) properties, the `dataPath` value is one of the
         *  property keys from the table's row objects.
         * @property {external:String} label The column header label.
         * @property {external:String} type The type of data in this column: `"number"`, `"string"`, `"date"`, `"image"`, `"bool"`, or `"richText"`.
         * @property {external:Number} [width] The pixel width of the column.
         * @property {external:Boolean} [visible] Whether the column is visible.
         * @property {external:String} [linkPath] The location of the links used when
         *  the items in the column are clicked.
         *
         *  When the table is populated by a connection to a dataset, the `linkPath`
         *  value is a field key from the collection that the dataset is connected to.
         *  The collection field can be a [regular field](https://support.wix.com/en/article/about-database-collections#regular-fields)
         *  that contains URLs or a [calculated field](https://support.wix.com/en/article/about-database-collections#calculated-fields)
         *  that contains relative links to dynamic pages.
         *
         *  When the table is populated by using the [`rows`](#rows) or
         *  [`dataFetcher`](#dataFetcher) properties, the `linkPath` value is one of the
         *  property keys from the table's rows objects.
         *  The property values associated with that key contain URLs or relative links.
         * @snippet [Table-columns_get.es6=Get the list of columns and the first column's information]
         * @snippet [Table-columns_set.es6=Set the list of columns for a table]
         * @snippet [Table-columns_set_data.es6=Set the columns, data, and links for a table]
         *  This example sets the columns of the table using the table's `columns`
         *  property. The items in the first column are linked using the URLs found
         *  in the `wikiLink` property of the table data. It then populates a table
         *  with static data using the table's `rows` property.
         * @see [columns](#columns)
         */

        /**
         * @member columns
         * @label property
         * @syntax
         * set columns(): Column[]
         * get columns(value: Column[]): void
         * @summary Sets or gets the defining properties of the columns in a table.
         * @description
         *  Table [columns](#Column) do not store any data. They contain the
         *  properties, such as the `label` and `type`, that define a table column.
         *
         *  Setting the `columns` property sets the [columns](#Column)
         *  in the table.
         *
         *  Getting the `columns` property returns the current
         *  list of [columns](#Column) in the table.
         *
         *  You cannot modify the data array in-place. To add, change, or remove
         *  individual columns:
         *
         *    1. Store the value of the `columns` property in a variable.
         *    1. Make changes to the columns array.
         *    1. Reset the `columns` property with the modified array.
         * @snippet [Table-columns_get.es6=Get the list of columns and the first column's information]
         * @snippet [Table-columns_set.es6=Set the list of columns for a table]
         * @snippet [Table-add.es6=Add a column to a table]
         *  This example retrieves the columns of a table, adds a new column, and
         *  then overwrites the old options.
         * @type {$w.Table~Column[]}
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'columns',
        get: function get() {
            return Utils.getProp(this, 'columns');
        }

        /**
         * @member columns
         * @memberof $w.Table
         * @param {$w.Table~Column[]} columns
         */
        ,
        set: function set(columns) {
            var _this2 = this;

            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'columns',
                dataToValidate: { columns: columns },
                compName: this.id
            });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = _lodash2.default.every(columns, function (v, i) {
                return (0, _validation.validate)({
                    compType: compType,
                    functionName: 'columns',
                    dataToValidate: { column: v },
                    shouldCheckMandatoryFields: true,
                    itemIndex: i,
                    compName: _this2.id
                });
            });
            if (!arrItemsArrValid) {
                return;
            }
            columns = (0, _utils.nullIfNil)(columns) ? columns : [];
            Utils.setProp(this, {
                columns: _lodash2.default.map(columns, function (column) {
                    // Set column.visible to true by default
                    return _lodash2.default.assign({ visible: true }, column);
                })
            });
        }

        /* Taken out of docs in change back to dataFetcher property
         * @typedef {external:Object} $w.Table~RequestedData
         * @summary An object return by the handler set by the `onDataRequest` function.
         * @property {external:Object[]} pageRows An array of row data objects with field_name:value pairs.
         * @property {external:Number} totalRowsCount The number of total rows in all pages.
         * @snippet [Table-onDataRequest_set.es6=Set the function that fetches more data]
         * @snippet [Table-onDataRequest-scenario.es6=Fetch data from a static array]
         * @see [onDataRequest](#onDataRequest)
         */

        /* Taken out of docs in change back to dataFetcher property
         * @callback $w.DataRequestHandler
         * @summary Function that runs when a new page of table data is to be displayed.
         * @param {external:Number} startRow The index of the first row to get.
         * @param {external:Number} endRow The index after the last row to get.
         * @returns {Promise}
         * @fulfill {$w.Table~RequestedData} A row data object with field_name:value pairs.
         */

        /**
         * @member dataFetcher
         * @memberof $w.Table
         * @param {Function} rowRetrievalFunc
         */

    }, {
        key: 'dataFetcher',
        set: function set(rowRetrievalFunc) {
            var compType = members._type.get(this).compType;
            if (!_lodash2.default.isNil(rowRetrievalFunc) && !(0, _validation.validate)({
                compType: compType,
                functionName: 'dataFetcher',
                dataToValidate: { dataFetcherCallback: rowRetrievalFunc },
                compName: this.id
            })) {
                return this;
            }

            var RMI = members._RMI.get(this);
            var fetchDataEvent = RMI.getEventTypes().FETCH_DATA;

            Utils.setDataWithoutUpdate(this, { dataFetchHandlers: rowRetrievalFunc });
            var componentEvents = Utils.getEvents(this);
            var filteredBehaviors = _lodash2.default.filter(componentEvents, { eventType: fetchDataEvent });
            if (_lodash2.default.isEmpty(filteredBehaviors)) {
                Utils.onEvent(this, fetchDataEvent, dataFetchHandler(RMI));
            }

            Utils.setData(this, {
                numberOfDisplayedRows: 0,
                dataSource: { type: _gridEnums2.default.DataSourceType.DYNAMIC, revision: Date.now() }
            });
            if (this.pagination.type === _gridEnums2.default.PaginationType.NONE) {
                this.pagination = _lodash2.default.assign(this.pagination, { type: _gridEnums2.default.PaginationType.SCROLL });
            }
        }

        /**
         * @member dataFetcher
         * @label property
         * @syntax
         * get dataFetcher: function
         * set dataFetcher(rowRetrievalFunction: function): void
         * @summary Sets the function that is called when a new page of table data is to be displayed.
         * @description
         *  The `dataFetcher` property is typically used when you are populating
         *  your table with data from an external (non-Wix) data source. You set it
         *  to a function that fetches the data to display.
         *
         *  The function that runs to fetch a new page of data must conform to the
         *  following structure:
         *
         *    ```javascript
         *    function rowRetrievalFunction(startRow, endRow) {
         *      return new Promise( (resolve, reject) => {
         *        // Data retrieval code here
         *        if( retrievalSuccess ) {
         *          resolve( {
         *            pageRows: fetchedRows,
         *            totalRowsCount: numRows
         *          } );
         *        }
         *        else {
         *          reject();
         *        }
         *      } );
         *    }
         *    ```
         *
         *  Meaning, your function must:
         *
         *    + Take in two parameters:
         *        + `startRow` the index of the first row to get
         *        + `endRow` the index after the last row to get
         *    + Return a Promise which:
         *        + Either resolves to an object with the following properties:
         *            + `pageRows` is an array of column:value row data
         *            + `totalRowsCount` is the number of total rows in all pages
         *        + Or rejects
         *
         *
         *  Another way of populating your table with data programmatically is to
         *  use the [`rows`](#rows) property.
         * @snippet [Table-dataFetcher_set.es6=Set the function that fetches more data]
         * @snippet [Table-dataFetcher-scenario.es6=Fetch data from a static array]
         *  This example stores row data in a static array and uses `dataFetcher`
         *  to set the `getRows` function as the function to run when the table
         *  needs new data. The example assumes you have a table with ID `myTable`
         *  that contains two fields, `name` (type Text) and `num` (type Number).
         * @memberof $w.Table
         * @type {Function}
         * @instance
         * @see [rows](#rows)
         */
        ,
        get: function get() {
            return Utils.getData(this, 'dataFetchHandlers');
        }

        /**
         * @member rows
         * @memberof $w.Table
         * @param {external:Object[]} data
         */

    }, {
        key: 'rows',
        set: function set(data) {
            var _this3 = this;

            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'rows',
                dataToValidate: { rows: data },
                compName: this.id
            });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = _lodash2.default.every(data, function (v, i) {
                return (0, _validation.validate)({
                    compType: compType,
                    functionName: 'rows',
                    dataToValidate: { row: v },
                    shouldCheckMandatoryFields: true,
                    itemIndex: i,
                    compName: _this3.id
                });
            });
            if (!arrItemsArrValid) {
                return;
            }
            data = (0, _utils.nullIfNil)(data) ? data : [];
            var linksTarget = Utils.getProp(this, 'linkTarget');
            var rowsData = _processData(data, this.columns, linksTarget);
            Utils.setData(this, {
                dataSource: { type: _gridEnums2.default.DataSourceType.STATIC, revision: Date.now() },
                rows: rowsData,
                revision: Date.now(),
                numberOfDisplayedRows: rowsData.length
            });
        }

        /**
         * @member rows
         * @label property
         * @syntax
         * get rows(): Object[]
         * set rows(value: Object[]): void
         * @summary Sets or gets the table's row data.
         * @description
         *  Setting the `rows` property sets the data of the table's rows. A table's
         *  data is stored as an array of objects where each object represents a row
         *  in the table.
         *
         *  The objects are composed of `"key":"value"` pairs where:
         *
         *  + `key` is:
         *    + A table column **Field Name** if the columns were set in the Editor
         *      using the **Manage Table** panel.
         *    + A [table column](#Column) `dataPath` if the columns were set in code
         *      using the [`columns`](#columns) property.
         *  + `value` is the value to be placed in that table column for the current row.
         *
         *
         *  For example, a simple array of table data may look like this:
         *
         *  ```javascript
         *  [
         *    {
         *      "firstName": "John",
         *      "lastName": "Doe",
         *      "email": "john.doe@somedomain.com",
         *      "image": "http://someImageUrl/john.jpg"
         *    },
         *    {
         *      "firstName": "Jane",
         *      "lastName": "Doe",
         *      "email": "jane.doe@somedomain.com",
         *      "image": "http://someImageUrl/jane.jpg"
         *    }
         *  ]
         *  ```
         *
         *  If the `rows` array contains objects with values whose keys are not
         *  table columns, those values do not appear in the table. For example,
         *  assuming the `rows` array shown above, if the table does not have an
         *  **email** column, the email values do not appear in the table.
         *
         *  Set `rows` to an empty array (`[]`) to remove the current rows.
         *
         *  Getting the `rows` property returns the current list of
         *  the table's row data. If the table is connected to a dataset, `rows`
         *  does not include the fields from the dataset items that are not
         *  connected to table columns.
         *
         *  To update an individual table row, use the [`updateRow()`](#updateRow)
         *  function.
         *
         *  To add or remove individual table rows:
         *
         *    1. Store the value of the `rows` property in a variable.
         *    1. Apply standard JavaScript array operators to the rows array.
         *    1. Reset the `rows` property with the new array.
         *
         *
         *  To set a table's row data based on a [`query`](wix-data.html#query)
         *  you perform using the [`wix-data`](wix-data.html) API:
         *
         *  1. Set the columns of the table in the Editor using the **Manage Table**
         *     panel or in code using the [`columns`](#columns) property to include
         *     the collection fields you want to display.
         *  1. Execute a [`query()`](wix-data.html#query) using the [`find()`]
         *     function.
         *  1. Set the tables `rows` to the [`items`](wix-data.WixDataQueryResult.html#items)
         *     of the query's [results](wix-data.WixDataQueryResult.html).
         *
         *
         *  Note that you can optionally add to, remove from, or modify the data
         *  returned from the query before using it to set the table's row data.
         * @snippet [Table-rows_get.es6=Get a table's row data]
         * @snippet [Table-rows_set.es6=Set a table's row data]
         * @snippet [Table-rows-add.es6=Add a row to a table]
         *  This example retrieves the rows of a table, adds a new row, and then
         *  overwrites the old rows.
         * @snippet [Table-rows_scenario-array.es6=Set a table's row data from an array]
         * @snippet [Table-rows_scenario-query.es6=Set a table's row data from a query]
         * @snippet [Table-rows_scenario-query-plus.es6=Set a table's row data from a query]
         *  This example populates a table that displays information about documents
         *  that are stored in a collection and allows users to download each document
         *  by clicking a link in the table.
         *
         *  When the page is loaded, we first set the columns of the table to match
         *  the fields of the collection that contains the documents, excluding the
         *  field that contains the actual document. We also create one additional
         *  column whose value is not taken from the collection. The values users
         *  see in that column are set later, but the links are set to take
         *  their URLs from a collection field.
         *
         *  Then a query is executed to retrieve information from the collection.
         *  Before setting the query results to be the table's row data, we add a
         *  property and value to each retrieved item. These are the values that
         *  are populated in the additional column that was created earlier.
         * @memberof $w.Table
         * @type {external:Object[]}
         * @instance
         */
        ,
        get: function get() {
            return Utils.getData(this, 'rows');
        }
    }]);

    return Table;
}(_Element3.default);

(0, _mixin2.default)(Table.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Table.prototype, _ClickableMixin2.default.prototype);

exports.default = Table;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(5);

var _idGenerator = __webpack_require__(107);

var _idGenerator2 = _interopRequireDefault(_idGenerator);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _linkGenerator = __webpack_require__(34);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _validation = __webpack_require__(3);

var _decodeHtmlEntities = __webpack_require__(105);

var _decodeHtmlEntities2 = _interopRequireDefault(_decodeHtmlEntities);

var _neatHtmlParser = __webpack_require__(89);

var _neatHtmlParser2 = _interopRequireDefault(_neatHtmlParser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var wixGuard = '<span class="wixGuard">&#8203;</span>';

function buildHtmlFromTagStack(tagStack, textInTheMiddle) {
    var openTags = '';
    var closingTags = '';

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = tagStack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;
            var tagName = _ref2.tagName,
                props = _ref2.props;

            openTags += props ? '<' + tagName + ' ' + props + '>' : '<' + tagName + '>';
            closingTags = '</' + tagName + '>' + closingTags;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return openTags + textInTheMiddle + closingTags;
}

function insertTextInHtml(html, text) {
    var tagStack = [];
    var stop = false;

    _neatHtmlParser2.default.parseFragment(html, {
        onText: function onText() {
            stop = true;
        },
        onOpenTag: function onOpenTag(tag) {
            if (tag.tagName === 'span' && tag.props === 'class="wixGuard"') {
                stop = true;
            }
            if (!stop) {
                tagStack.push(tag);
            }
        },
        onClosingTag: function onClosingTag() {
            if (!stop) {
                //if we are here than tag is empty
                tagStack.pop();
            }
        }
    });

    return buildHtmlFromTagStack(tagStack, text);
}

//regex taken from santa/htmlParser
var startTagRegex = '<([-A-Za-z0-9_?:]+)((?:\\s+(?:x:)?[-A-Za-z0-9_]+(?:\\s*=\\s*(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>\\s]+))?)*)\\s*(/?)>';
var endTagRegex = '</([-A-Za-z0-9_?:]+)[^>]*>';
var endBlockTagRegex = '</(h[1-6]|p)[^>]*>';

function getTarget(str) {
    if (!str) {
        return;
    }
    var res = str.match(/target=(?:['"])(.*)(?:['"])/);
    return res && res[1];
}
function convertToTextComponentData(compId, htmlStr) {
    var links = [];
    var linkRegexp = /<a(.*?)href=['"](.*?)["'](.*?)>(.*?)<\/a>/g;
    var textData = htmlStr.replace(linkRegexp, function (matched, g1, urlGroup, g3, linkTextGroup) {
        var target = getTarget(g1) || getTarget(g3) || undefined;
        var linkData = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(urlGroup, target, 'html', undefined, htmlStr);

        if (_lodash2.default.isNil(linkData)) {
            return linkTextGroup;
        }

        linkData.id = _idGenerator2.default.generateId(compId + '_runtime_');
        links.push(linkData);
        return '<a' + g1 + 'dataquery="#' + linkData.id + '"' + g3 + '>' + linkTextGroup + '</a>';
    });
    return {
        text: textData,
        linkList: links
    };
}

function convertLinkForGetHtml() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var linkRegexp = /<a(.*?)dataquery="#(.*?)"(.*?)>(.*?)<\/a>/g;

    var text = data.text && data.text.replace(linkRegexp, function (matched, g1, dataQueryId, g3, linkTextGroup) {
        var link = _lodash2.default.find(data.linkList, { id: dataQueryId });
        var linkUrl = _linkGenerator2.default.convertLinkToUrlAndReportIfError(link, undefined, 'html');
        if (!_lodash2.default.isNil(linkUrl)) {
            return '<a' + g1 + 'href="' + linkUrl + '"' + g3 + '>' + linkTextGroup + '</a>';
        }
        return linkTextGroup;
    });
    return text;
}
function removeWixGuard(htmlStr) {
    return htmlStr.replace(/<span class="wixGuard">([^<]*)<\/span>/g, function (matched) {
        var g1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        if (g1.trim() === '&#8203;') {
            return '';
        }
        return g1;
    });
}
/**
 * @class Text
 * @summary Provides functionality for text elements.
 * @classdesc
 *  `Text` type elements contain text which can be formatted using a subset of
 *  standard HTML tags and CSS styles, as detailed below.
 *
 *  <h3 id="formatting-text">Formatting Text</h3>
 *  <h4 id="the-html-subset-supported">Supported HTML Subset</h4>
 *
 *  The supported HTML tags are:
 *
 *  + `<p>`
 *  + `<h1>`, `<h2>`, `<h3>`, `<h4>`, `<h5>`, and `<h6>`
 *  + `<a>`
 *  + `<span>`
 *  + `<ul>`, `<ol>`, and `<li>`
 *  + `<br>`
 *
 *
 *  <h4 id="built-in-text-themes">Text Theme Translation</h4>
 *
 *  Each text theme in the Editor corresponds to a specific set of HTML and CSS attributes:
 *
 *  + **Site Title** — `<h1>`
 *  + **Page Title** — `<h2>`
 *  + **Huge Heading** — `<h3>`
 *  + **Large Heading** — `<h4>`
 *  + **Basic Heading** — `<h5>`
 *  + **Small Heading** — `<h6>`
 *  + **Paragraph 1** — `<p class="p1">`
 *  + **Paragraph 2** — `<p>` or `<p class="p2">`
 *  + **Paragraph 3** — `<p class="p3">`
 *
 *
 *  <h4 id="inline-styling">Inline Styling</h4>
 *
 *  Text elements support inline styling via the `<span>` HTML element. The element can contain the following attributes:
 *
 *  + `style`: For example, `<span style="font-size: 1.5em"></span>`
 *  + `dir` (text direction): For example, `<span dir="rtl"></span>`
 *
 *
 *  The `style` attribute supports the following properties:
 *
 *  + `font-face`
 *  + `font-size`
 *  + `font-weight`
 *  + `font-style`
 *  + `text-decoration`
 *  + `color`
 *  + `background-color`
 *  + `text-align`
 *  + `margin-left`
 *  + `text-shadow`
 *  + `line-height`
 *  + `letter-spacing`
 *
 *
 *  <h4 id="bullets-and-numbering">Bulleted and Numbered Lists</h4>
 *
 *  Text elements can contain bulleted and numbered lists using standard HTML tags:
 *
 *  + Numbered lists — using `<ol>` and `<li>`
 *  + Bulleted lists — using `<ul>` and `<li>`
 *
 *
 *  <h4 id="links">Links</h4>
 *
 *  You can create links using the standard HTML `<a>` anchor element. Anchor elements support the `href` and `target`
 *  attributes. For example:
 *  <p>`<a href="http://wix.com" target="_blank">Stunning</a>`</p>
 *
 *  The `href` attribute can contain all link types in the [Wix link]($w.LinkableMixin.html#link) format.
 *
 * @see <a href="https://www.wix.com/support/html5/article/customizing-and-saving-text-themes"
 *  target="_blank">Customizing and Saving Text Themes</a>
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.WRichText
 * @definitionId wysiwyg.viewer.components.WRichText
 * @tagname text
 * @defaultcontent {html}
 */

var Text = function (_Element) {
    _inherits(Text, _Element);

    function Text() {
        _classCallCheck(this, Text);

        return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
    }

    _createClass(Text, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                html = this.html,
                text = this.text;

            return { id: id, type: type, global: global, rendered: rendered, html: html, text: text };
        }
    }, {
        key: 'html',

        /**
         * @member html
         * @label property
         * @syntax
         * get html(): string
         * set html(value: string): void
         * @summary Sets or gets the contents of a text element using standard HTML.
         * @description
         *  Setting the `html` property sets the text and styling of
         *  the text element. You can use a subset of HTML tags and CSS attributes
         *  as described [above](#formatting-text). Any text that the element
         *  already contained is replaced.
         *
         *  Getting the `html` property returns the element's text, including
         *  HTML tags.
         *
         *  The `html` property maps the Editor's built-in text themes and custom
         *  formatting to HTML and CSS [as described here](#built-in-text-themes).
         *
         *  To set or get the plain, unstyled contents of a text element, use the
         *  [`text`](#text) property instead.
         * @snippet [Text-html_get.es6=Get a text element's HTML content]
         * @snippet [Text-html_set.es6=Set a text element's HTML content]
         * @type {external:String}
         * @see [Formatting Text](#formatting-text)
         * @see [text](#text)
         * @memberof $w.Text
         * @instance
         * @attr {external:String}
         */
        get: function get() {
            var richTextUtils = _platformUtils2.default.getRichTextUtils();
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            return _lodash2.default.flow([convertLinkForGetHtml, richTextUtils.applyTransformationForGetHtml, removeWixGuard])(data);
        }

        /**
         * @member html
         * @memberof $w.Text
         * @param {external:String} value
         */
        ,
        set: function set(value) {
            var richTextUtils = _platformUtils2.default.getRichTextUtils();
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'html',
                dataToValidate: { html: value },
                compName: this.id
            });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            value = richTextUtils.applyTransformationForSetHtml((0, _utils.emptyStringIfNil)(value));
            RMI.setData(compId, convertToTextComponentData(compId, value));
            return value;
        }

        /**
         * @member text
         * @label property
         * @syntax
         * get text(): string
         * set text(value: string): void
         * @summary Sets or gets the plain-text contents of a text element.
         * @description
         *  Setting the `text` property sets the plain-text contents of
         *  the text element. Any text that the element already contained is
         *  replaced. The new text is formatted using the formatting that was used
         *  on of the first character of the previous `text` value.
         *
         *  Getting the `text` property returns the plain-text content
         *  of the element, without any HTML tags.
         *
         *  To set or get the HTML contents of a text element, use the
         *  [`html`](#html) property instead.
         * @type {external:String}
         * @default An empty string
         * @snippet [Text-text_get.es6=Get a text element's plain-text content]
         * @snippet [Text-text_set.es6=Set a text element's plain-text content]
         * @see [html](#html)
         * @memberof $w.Text
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'text',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var rawText = data.text && _lodash2.default.unescape(removeWixGuard(data.text).replace(/\n/g, '').replace(/<br><\/br>/g, '\n').replace(/<br\s*\/?>/g, '\n').replace(new RegExp(endBlockTagRegex, 'mg'), '\n').replace(new RegExp(endTagRegex, 'mg'), '').replace(new RegExp(startTagRegex, 'mg'), '').trim());
            if (_lodash2.default.isUndefined(rawText)) {
                return '';
            }

            return (0, _decodeHtmlEntities2.default)(rawText);
        }

        /**
         * @member text
         * @memberof $w.Text
         * @param {external:String} value
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)({
                compType: compType,
                functionName: 'text',
                dataToValidate: { text: value },
                compName: this.id
            });
            if (!isValid) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            value = value ? _lodash2.default.escape(value).replace(/\n/g, '<br>') : wixGuard;
            compData.text = insertTextInHtml(compData.text, value);

            RMI.setData(compId, compData);
            return compData.text;
        }
    }]);

    return Text;
}(_Element3.default);

(0, _mixin2.default)(Text.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(Text.prototype, _ClickableMixin2.default.prototype);

exports.default = Text;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _TextInputMixin = __webpack_require__(47);

var _TextInputMixin2 = _interopRequireDefault(_TextInputMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ReadOnlyMixin = __webpack_require__(38);

var _ReadOnlyMixin2 = _interopRequireDefault(_ReadOnlyMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class TextBox
 * @summary An input element for capturing large amounts of text.
 * @mixes $w.FormElement
 * @mixes $w.DisabledMixin
 * @mixes $w.TextInputMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ReadOnlyMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.TextAreaInput
 * @definitionId wysiwyg.viewer.components.inputs.TextAreaInput
 * @tagname textarea
 */
var TextBox = function (_FormElement) {
    _inherits(TextBox, _FormElement);

    function TextBox() {
        _classCallCheck(this, TextBox);

        return _possibleConstructorReturn(this, (TextBox.__proto__ || Object.getPrototypeOf(TextBox)).apply(this, arguments));
    }

    _createClass(TextBox, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                readOnly = this.readOnly,
                required = this.required,
                value = this.value,
                wrap = this.wrap;

            return { id: id, type: type, global: global, rendered: rendered, readOnly: readOnly, required: required, value: value, wrap: wrap };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the text box's styles.
         * @description
         *  The following styles can be used with text boxes:
         *
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a text box's styles, gets or sets the styles of the
         *  text box's regular state. It does not set the styles of the text box's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.TextBox
         * @readonly
         * @override
         */

    }, {
        key: 'wrap',


        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets a text input's value.
         * @description
         *  To reset the text box, restoring any placeholder text, set the `value`
         *  property to `null` or `undefined`.
         *
         * @note
         *  Changing a text box's `value` in code does not trigger an `onChange` event.
         *
         *  If an element is connected to a dataset, setting the element's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [FormElement-value_get.es6=Get an element's value]
         * @snippet [FormElement-value_set.es6=Set an element's value]
         * @type {external:String}
         * @memberof $w.TextBox
         * @override
         */

        /**
         * @member value
         * @memberof $w.TextBox
         * @param {external:String} value
         */

        /**
           * @member wrap
           * @label property
           * @syntax
           * get wrap(): string
           * set wrap(value: WrapType): void
           * type WrapType = "hard" | "soft"
           * @summary Determines if the text contains line breaks when its value is read.
           * @description
           *  Setting the `wrap` property sets how the text box's contents
           *  are returned when its value is read. Setting `wrap` to `"hard"`
           *  means line breaks are automatically inserted into the text. The width of
           *  the text box determines where the line breaks are placed. Setting `wrap`
           *  to `"soft"` means line breaks are not inserted when the value of the
           *  text box is read.
           *
           *  Getting the `wrap` property gets how the text box's contents
           *  are returned when its value is read.
           * @snippet [TextBox-wrap_get.es6=Get a text box's wrapping]
           * @snippet [TextBox-wrap_set.es6=Set a text box's wrapping]
           * @default "soft"
           * @type {external:String}
           * @memberof $w.TextBox
           * @instance
           */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getProps(compId).wrap;
        }

        /**
         * @member wrap
         * @memberof $w.TextBox
         * @param {external:String} wrap
         */
        ,
        set: function set(wrap) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'wrap',
                dataToValidate: { wrap: wrap },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, { wrap: wrap });
        }
    }]);

    return TextBox;
}(_FormElement3.default);

(0, _mixin2.default)(TextBox.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(TextBox.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(TextBox.prototype, _TextInputMixin2.default.prototype);
(0, _mixin2.default)(TextBox.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(TextBox.prototype, _ReadOnlyMixin2.default.prototype);
(0, _mixin2.default)(TextBox.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(TextBox.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(TextBox.prototype, _RequiredMixin2.default.prototype);

exports.default = TextBox;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _FormElement2 = __webpack_require__(16);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _TextInputMixin = __webpack_require__(47);

var _TextInputMixin2 = _interopRequireDefault(_TextInputMixin);

var _ReadOnlyMixin = __webpack_require__(38);

var _ReadOnlyMixin2 = _interopRequireDefault(_ReadOnlyMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _validationsService = __webpack_require__(11);

var _utils = __webpack_require__(5);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class TextInput
 * @summary An input element for capturing small amounts of text.
 * @classdesc
 *  A text input is configured to receive
 *  <a href="https://www.wix.com/support/html5/article/text-input-settings" target="_blank">different types
 *  of information</a>, such as strings, numbers, or passwords.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.TextInputMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ReadOnlyMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.TextInput
 * @definitionId wysiwyg.viewer.components.inputs.TextInput
 * @tagname textinput
 */
var TextInput = function (_FormElement) {
    _inherits(TextInput, _FormElement);

    function TextInput() {
        _classCallCheck(this, TextInput);

        return _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).apply(this, arguments));
    }

    _createClass(TextInput, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                readOnly = this.readOnly,
                required = this.required,
                value = this.value,
                max = this.max,
                min = this.min,
                inputType = this.inputType;

            return { id: id, type: type, global: global, rendered: rendered, readOnly: readOnly, required: required, value: value, max: max, min: min, inputType: inputType };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the text input's styles.
         * @description
         *  The following styles can be used with text input elements:
         *
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a text input's styles, gets or sets the styles of the
         *  text input's regular state. It does not set the styles of the text input's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.TextInput
         * @readonly
         * @override
         */

    }, {
        key: 'max',


        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets a text input's value.
         * @description
         *  To reset the text input, restoring any placeholder text, set the value
         *  property to `null` or `undefined`.
         *
         * @note
         *  Changing a text input's `value` in code does not trigger an `onChange` event.
         *
         *  Using the **Input Settings** panel in the Editor you can set the type of
         *  a text input. That type is used only for validation purposes. The value
         *  returned by the `value` property of a text input is always a string,
         *  regardless of the type set in the Editor.
         *
         *  If an element is connected to a dataset, setting the element's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [FormElement-value_get.es6=Get an element's value]
         * @snippet [FormElement-value_set.es6=Set an element's value]
         * @type {external:String}
         * @memberof $w.TextInput
         * @override
         */

        /**
         * @member value
         * @memberof $w.TextInput
         * @param {external:String} value
         */

        /**
         * @member max
         * @label property
         * @syntax
         * get max(): Number
         * set max(value: Number): void
         * @summary Sets or gets the maximum value for a text input element whose
         *  type is set to **Number**.
         * @description
         *  Setting the `max` property restricts users from changing
         *  the text input's value to a number greater than `max` if the
         *  text input is set to be a **Number** type. However, it does not limit
         *  your ability to change the value to a number greater than `max`
         *  programmatically.
         *
         *  Set `max` to `undefined` to remove the current maximum value limitation.
         *
         *  Getting the `max` property returns the maximum value a user
         *  can enter into the text input.
         *
         *  You can also set an element's `max` property in the Editor using the Settings pane:
         *  ![Input Settings pane](images/input_settings-max_value.png)
         * @snippet [TextInput-max_get.es6=Gets a text input's max value]
         * @snippet [TextInput-max_set.es6=Sets a text input's max value]
         * @type {external:Number}
         * @memberof $w.TextInput
         * @see [min](#min)
         * @instance
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);

            return compData && compData.max;
        }

        /**
         * @member max
         * @memberof $w.TextInput
         * @param {external:Number} max
         */
        ,
        set: function set(max) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var minValue = this.min;

            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'max',
                dataToValidate: { max: max },
                compName: this.id
            }) || !_lodash2.default.isNil(max) && _lodash2.default.isNumber(minValue) && !(0, _validation.validateMinimum)({
                functionName: 'max',
                propertyName: 'max',
                value: max,
                minValue: minValue
            })) {
                return;
            }

            RMI.setData(compId, { max: (0, _utils.nullIfNil)(max) });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, this.value);
        }

        /**
         * @member min
         * @label property
         * @syntax
         * get min(): Number
         * set min(value: Number): void
         * @summary Sets or gets the minimum value for a text input element whose
         *  type is set to **Number**.
         * @description
         *  Setting the `min` property restricts users from changing
         *  the text input's value to a number lower than `min` if the
         *  text input is set to be a **Number** type. However, it does not limit
         *  your ability to change the value to a number lower than `min`
         *  programmatically.
         *
         *  Set `min` to `undefined` to remove the current minimum value limitation.
         *
         *  Getting the `min` property returns the minimum value a user
         *  can enter into the text input.
         *
         *  You can also set an element's `min` property in the Editor using the Settings pane:
         *  ![Input Settings pane](images/input_settings-min_value.png)
         * @snippet [TextInput-min_get.es6=Gets a text input's min value]
         * @snippet [TextInput-min_set.es6=Sets a text input's min value]
         * @type {external:Number}
         * @memberof $w.TextInput
         * @see [max](#max)
         * @instance
         */

    }, {
        key: 'min',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            return compData && compData.min;
        }

        /**
         * @member min
         * @memberof $w.TextInput
         * @param {external:Number} min
         */
        ,
        set: function set(min) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var maxValue = this.max;

            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'min',
                dataToValidate: { min: min },
                compName: this.id
            }) || !_lodash2.default.isNil(min) && _lodash2.default.isNumber(maxValue) && !(0, _validation.validateMaximum)({
                functionName: 'min',
                propertyName: 'min',
                value: min,
                maxValue: maxValue
            })) {
                return;
            }

            RMI.setData(compId, { min: (0, _utils.nullIfNil)(min) });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, this.value);
        }

        /**
         * @member inputType
         * @label property
         * @syntax
         * get inputType(): InputType
         * set inputType(value: InputType): void
         * type InputType = "text" | "password" | "number" | "url" | "tel"
         * @summary Sets or gets the input type of an Input element.
         * @description
         *  Setting the `inputType` property sets what type of data a
         *  user can enter into the text input element. However, it does not limit
         *  your ability to change the value programmatically.
         *
         *  Getting the `inputType` property gets what type of data a
         *  user can enter into the text input element.
         *
         *  The text input types are:
         *
         *  + `"text"`: Can contain any type of character.
         *  + `"password"`: A password field. Text is hidden with bullets (•••).
         *  + `"number"`: A valid number.
         *  + `"email"`: A valid email address.
         *  + `"url"`: A valid web address.
         *  + `"tel"`: Can contain only digits and certain symbols.
         *
         *
         *  You can also set an element's `inputType` property in the Editor using the Settings pane:
         *  ![Input Settings pane](images/input_settings-type.png)
         * @snippet [TextInput-inputType_get.es6=Gets a text input's input type]
         * @snippet [TextInput-inputType_set.es6=Sets a text input's input type]
         * @type {external:String}
         * @memberof $w.TextInput
         * @attr {external:String}
         */

    }, {
        key: 'inputType',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);

            return compData && compData.textType;
        }

        /**
         * @member inputType
         * @memberof $w.TextInput
         * @param {external:String} newType
         */
        ,
        set: function set(newType) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'inputType',
                dataToValidate: { inputType: newType },
                compName: this.id
            })) {
                return;
            }
            RMI.setData(compId, {
                textType: newType
            });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, this.value);
        }
    }]);

    return TextInput;
}(_FormElement3.default);

(0, _mixin2.default)(TextInput.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(TextInput.prototype, _DisabledMixin2.default.prototype);
(0, _mixin2.default)(TextInput.prototype, _TextInputMixin2.default.prototype);
(0, _mixin2.default)(TextInput.prototype, _FocusMixin2.default.prototype);
(0, _mixin2.default)(TextInput.prototype, _ReadOnlyMixin2.default.prototype);
(0, _mixin2.default)(TextInput.prototype, _ClickableMixin2.default.prototype);
(0, _mixin2.default)(TextInput.prototype, _StyleMixin2.default.prototype);
(0, _mixin2.default)(TextInput.prototype, _RequiredMixin2.default.prototype);

exports.default = TextInput;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

/*
 * @enum {external:String}
 * @summary Types of elements that you can access using Wix Code.
 * @readonly
 */
var getTypes = function getTypes() {
  return _utils.types.possibleTypes;
};

exports.default = getTypes;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _LinkableMixin = __webpack_require__(36);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _vectorImageUtils = __webpack_require__(45);

var _vectorImageUtils2 = _interopRequireDefault(_vectorImageUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class VectorImage
 * @summary Vector images are digital illustrations based on geometric shapes.
 *  They maintain their high quality when resized.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.svgshape.SvgShape
 * @viewername wysiwyg.viewer.components.VectorImage
 * @AppController wysiwyg.viewer.components.svgshape.SvgShape
 * @AppController wysiwyg.viewer.components.VectorImage
 * @tagname vectorImage
 */
var VectorImage = function (_Element) {
    _inherits(VectorImage, _Element);

    function VectorImage() {
        _classCallCheck(this, VectorImage);

        return _possibleConstructorReturn(this, (VectorImage.__proto__ || Object.getPrototypeOf(VectorImage)).apply(this, arguments));
    }

    _createClass(VectorImage, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                src = this.src;

            return { id: id, type: type, global: global, rendered: rendered, src: src };
        }
    }, {
        key: 'src',


        /**
         * @member src
         * @label property
         * @syntax
         * get src(): string
         * set src(value: string): void
         * @summary Sets or gets the file location of the vector image.
         * @description
         *  Setting the `src` property changes the displayed vector image to
         *  the vector image found at the new `src` value.
         *
         *  Getting the `src` property returns the location of the
         *  current vector image file.
         *
         *  The vector image file is an image file from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>,
         *  an external SVG image from any web location, or a literal SVG XML string.
         *
         *  The formats supported are:
         *
         *  + Vector images from the Media Manager: `wix:vector://v1/<vector_uri>/<filename>`
         *  + Vector images from the web: `http(s)://<vector image url>`
         *  + Vector XML string: `<svg>...</svg>`
         * @snippet [VectorImage-src_get.es6=Get the vector image's location]
         * @snippet [VectorImage-src_set_wix.es6=Set the vector image to be a vector image from the Media Manager]
         * @snippet [VectorImage-src_set_web.es6=Set the vector image to be a vector image from the web]
         * @snippet [VectorImage-src_set_xml.es6=Set the vector image to be a vector image from an XML string]
         * @type {external:String}
         * @default An empty string
         * @memberof $w.VectorImage
         * @instance
         * @attr {external:String}
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId) || {};

            if (compData.hasOwnProperty('mediaSrc')) {
                return compData.mediaSrc.value;
            }

            return _vectorImageUtils2.default.buildFullUrlFromSvgId(compData.svgId, compData.title);
        }

        /**
         * @member src
         * @memberof $w.VectorImage
         * @param {external:String} value
         */
        ,
        set: function set(value) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.setData(compId, { mediaSrc: _vectorImageUtils2.default.convertToMediaSrcAndReportIfError(value, 'src', 'src') });
        }
    }]);

    return VectorImage;
}(_Element3.default);

(0, _mixin2.default)(VectorImage.prototype, _HiddenCollapsedMixin2.default.prototype);
(0, _mixin2.default)(VectorImage.prototype, _LinkableMixin2.default.prototype);
(0, _mixin2.default)(VectorImage.prototype, _ClickableMixin2.default.prototype);

exports.default = VectorImage;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _menuUtils = __webpack_require__(40);

var _menuUtils2 = _interopRequireDefault(_menuUtils);

var _validation = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @class VerticalMenu
 * @summary Provides all functionality related to Vertical Menu.22
 * @classdesc The `VerticalMenu` class provides functionality related to Wix VerticalMenu.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof wix.ui
 * @tagname VerticalMenu
 * @viewername wysiwyg.common.components.verticalmenu.viewer.VerticalMenu
 * @definitionId wysiwyg.common.components.verticalmenu.viewer.VerticalMenu
 */
var VerticalMenu = function (_Element) {
    _inherits(VerticalMenu, _Element);

    function VerticalMenu() {
        _classCallCheck(this, VerticalMenu);

        return _possibleConstructorReturn(this, (VerticalMenu.__proto__ || Object.getPrototypeOf(VerticalMenu)).apply(this, arguments));
    }

    _createClass(VerticalMenu, [{
        key: 'items',
        set: function set(menuItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'items',
                dataToValidate: { menuItems: menuItems },
                compName: this.id
            })) {
                return this;
            }
            if (_lodash2.default.isNil(menuItems)) {
                menuItems = [];
            }
            _menuUtils2.default.checkMenuItemsValidation({
                menuItems: menuItems,
                functionName: 'items',
                compName: this.id
            });
            var convertedMenuItems = _lodash2.default.map(menuItems, function (menuItem, menuItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'items');
            });
            RMI.setData(members._compId.get(this), { menuRef: { items: convertedMenuItems } });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var menuItems = data.menuRef.items;
            return _lodash2.default.map(menuItems, _menuUtils2.default.convertMenuItemToUserFormat);
        }
    }]);

    return VerticalMenu;
}(_Element3.default);

(0, _mixin2.default)(VerticalMenu.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = VerticalMenu;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _Element2 = __webpack_require__(8);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Video
 * @summary An element that displays a video.
 * @classdesc
 *  **Deprecation Note:** This video player has been deprecated. Use the
 *  [VideoPlayer]($w.VideoPlayer.html) element instead.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.Video
 * @definitionId wysiwyg.viewer.components.Video
 * @tagname Video
 */
var Video = function (_Element) {
    _inherits(Video, _Element);

    function Video() {
        _classCallCheck(this, Video);

        return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
    }

    _createClass(Video, [{
        key: 'videoUrl',


        /**
         * @member videoUrl
         * @memberof $w.Video
         * @param {external:String} newUrl
         */
        set: function set(newUrl) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)({
                compType: compType,
                functionName: 'videoUrl',
                dataToValidate: { videoUrl: newUrl },
                compName: this.id
            })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var videoUrlUtils = _platformUtils2.default.getVideoUrlUtils();
            var newVideoData = videoUrlUtils.getVideoDataFromUrl(newUrl);
            if (!_lodash2.default.isEmpty(newVideoData)) {
                RMI.setData(compId, newVideoData);
            }
        }

        /**
         * @member videoUrl
         * @label property
         * @syntax
         * get videoUrl(): string
         * set videoUrl(value: string): void
         * @summary Sets or gets the URL of the video.
         * @description
         *  **Deprecation Note:** This video player has been deprecated. Use the
         *  [VideoPlayer]($w.VideoPlayer.html) element instead.
         *
         *  Setting the value of the `videoUrl` property sets the video that the
         *  element plays.
         *
         *  Getting the value of the `videoUrl` property gets the URL of the video
         *  that the element plays.
         * @snippet [Video-videoUrl_set.es6=Set the video to play]
         * @snippet [Video-videoUrl_get.es6=Get the video to play]
         * @type {external:String}
         * @memberof $w.Video
         * @instance
         */
        ,
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            var videoUrlUtils = _platformUtils2.default.getVideoUrlUtils();
            return videoUrlUtils.getVideoUrl(compData);
        }
    }]);

    return Video;
}(_Element3.default);

(0, _mixin2.default)(Video.prototype, _HiddenCollapsedMixin2.default.prototype);

exports.default = Video;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GalleryItemChangedEvent = __webpack_require__(65);

var _GalleryItemChangedEvent2 = _interopRequireDefault(_GalleryItemChangedEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.GalleryItemClickedEventHandler
 * @summary Handles events fired when an image in a gallery is clicked.
 * @param {$w.GalleryItemClickedEvent} event The event that has occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class GalleryItemClickedEvent
 * @summary Event that is fired when an image in a gallery is clicked.
 * @memberof $w
 * @mixes $w.GalleryItemChangedEvent
 * @mixes $w.Event
 */
var GalleryItemClickedEvent = function (_GalleryItemChangedEv) {
  _inherits(GalleryItemClickedEvent, _GalleryItemChangedEv);

  function GalleryItemClickedEvent() {
    _classCallCheck(this, GalleryItemClickedEvent);

    return _possibleConstructorReturn(this, (GalleryItemClickedEvent.__proto__ || Object.getPrototypeOf(GalleryItemClickedEvent)).apply(this, arguments));
  }

  return GalleryItemClickedEvent;
}(_GalleryItemChangedEvent2.default);

exports.default = GalleryItemClickedEvent;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.HtmlComponentMessageEventHandler
 * @summary Handles events fired when the code in an HtmlComponent sends a message.
 * @param {$w.HtmlComponentMessageEvent} event The HtmlComponent event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class HtmlComponentMessageEvent
 * @summary Event that is fired when the code in an HtmlComponent sends a message.
 * @memberof $w
 * @mixes $w.Event
 */
var HtmlComponentMessageEvent = function (_WixEvent) {
  _inherits(HtmlComponentMessageEvent, _WixEvent);

  function HtmlComponentMessageEvent(target, event) {
    _classCallCheck(this, HtmlComponentMessageEvent);

    var _this = _possibleConstructorReturn(this, (HtmlComponentMessageEvent.__proto__ || Object.getPrototypeOf(HtmlComponentMessageEvent)).call(this, target, event));

    _this.data = _lodash2.default.get(event, 'data');
    return _this;
  }

  /**
   * @member {$w.Element} data
   * @label property
   * @syntax
   * get data(): string
   * @summary Gets the event data.
   * @snippet [HtmlComponent-onMessage.es6=Receive a message from an HTML Component]
   * @memberof $w.HtmlComponentMessageEvent
   * @readonly
   */


  return HtmlComponentMessageEvent;
}(_WixEvent3.default);

exports.default = HtmlComponentMessageEvent;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.IconMouseInEventHandler
 * @summary Handles events fired when a user hovers over a star on the rating component.
 * @param {$w.IconMouseInEvent} event The event that occurred.
 */

/**
 * @class IconMouseInEvent
 * @summary Event that is fired when a user hovers over a star on a ratings input component.
 * @memberof $w
 * @mixes $w.Event
 */
var IconMouseInEvent = function (_WixEvent) {
  _inherits(IconMouseInEvent, _WixEvent);

  function IconMouseInEvent(target, event) {
    _classCallCheck(this, IconMouseInEvent);

    var _this = _possibleConstructorReturn(this, (IconMouseInEvent.__proto__ || Object.getPrototypeOf(IconMouseInEvent)).call(this, target, event));

    _this.label = event.label;
    _this.value = event.value;
    return _this;
  }

  return IconMouseInEvent;
}(_WixEvent3.default);

/**
 * @member {external:String} label
 * @label property
 * @syntax
 * get label(): string
 * @summary Gets the display label that corresponds to the icon that the mouse entered.
 * @snippet [IconMouseInEvent-all.es6=Get information about the icon that the mouse entered]
 * @memberof $w.IconMouseInEvent
 * @readonly
 */

/**
 * @member {external:Number} value
 * @label property
 * @syntax
 * get value(): number
 * @summary Gets the value (1-5) that corresponds to the icon that the mouse entered.
 * @snippet [IconMouseInEvent-all.es6=Get information about the icon that the mouse entered]
 * @memberof $w.IconMouseInEvent
 * @readonly
 */


exports.default = IconMouseInEvent;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.KeyboardEventHandler
 * @summary Handles events fired when the keyboard is pressed.
 * @param {$w.KeyboardEvent} event The keyboard event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class KeyboardEvent
 * @summary Event that is fired when the keyboard is pressed.
 * @description
 *  A `KeyboardEvent` event occurs when the user presses a key while the cursor
 *  is located inside a [`TextInput`]($w.TextInput.html), [`TextBox`]($w.TextBox.html),
 *  or [`RichTextBox`]($w.RichTextBox.html).
 * @memberof $w
 * @mixes $w.Event
 */
var KeyboardEvent = function (_WixEvent) {
  _inherits(KeyboardEvent, _WixEvent);

  function KeyboardEvent(target, event) {
    _classCallCheck(this, KeyboardEvent);

    var _this = _possibleConstructorReturn(this, (KeyboardEvent.__proto__ || Object.getPrototypeOf(KeyboardEvent)).call(this, target, event));

    _this.metaKey = _lodash2.default.get(event, 'metaKey');
    _this.altKey = _lodash2.default.get(event, 'altKey');
    _this.shiftKey = _lodash2.default.get(event, 'shiftKey');
    _this.ctrlKey = _lodash2.default.get(event, 'ctrlKey');
    _this.key = _lodash2.default.get(event, 'key');
    _this.code = _lodash2.default.get(event, 'keyCode');
    return _this;
  }

  /**
   * @member {external:Boolean} metaKey
   * @label property
   * @syntax
   * get metaKey(): boolean
   * @summary Indicates if the ⌘ Command key on a Mac or ⊞ Windows key on a PC
   *  was pressed.
   * @snippet [KeyboardEvent-metaKey.es6=Get the keyboard event's `metaKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:Boolean} altKey
   * @label property
   * @syntax
   * get altKey(): boolean
   * @summary Indicates if the Option key on a Mac or Alt key on a PC was pressed.
   * @snippet [KeyboardEvent-altKey.es6=Get the keyboard event's `altKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:Boolean} shiftKey
   * @label property
   * @syntax
   * get shiftKey(): boolean
   * @summary Indicates if the Shift key was pressed.
   * @snippet [KeyboardEvent-shiftKey.es6=Get the keyboard event's `shiftKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:Boolean} ctrlKey
   * @label property
   * @syntax
   * get ctrlKey(): boolean
   * @summary Indicates if the Control (Ctrl) key was pressed.
   * @snippet [KeyboardEvent-ctrlKey.es6=Get the keyboard event's `ctrlKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:String} key
   * @label property
   * @syntax
   * get key(): string
   * @summary Gets a string representation of the key that was pressed.
   * @description
   *  For keys representing a printable character, the `key` property gets a 
   *  Unicode character string containing the printable representation of the 
   *  key that was pressed. This does not necessarily correspond to what is
   *  printed on the physical key since the user could have changed the keyboard 
   *  layout.
   *
   *  For keys that have no printable representation, a string indicating the
   *  key's purpose is returned. Some examples are: 
   * 
   *  + `"Backspace"`
   *  + `"Enter"`
   *  + `"F1"`
   *  + `"Escape"`
   *  + `"Tab"`
   *
   * @snippet [KeyboardEvent-key.es6=Get the keyboard event's `key` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example get the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /* REMOVING THIS FOR NOW; IT'S BASICALLY USELESS AS IT'S COMPLETELY BROWSER-DEPENDENT
   * @member {external:String} code
   * @label property
   * @syntax let charCode = event.code;
   * @summary Gets the numeric Unicode value of the character that was pressed.
   * @description
   *  The `code` property gets the ASCII code of the
   *  pressed key's physical representation, regardless of the current keyboard layout. For example, if
   *  the keyboard layout is set to Spanish on a US keyboard, pressing "ñ" results in a
   *  `code` value of 186. This is the ASCII code for a semicolon, since that is what is printed on the key.
   *
   *  For the exceptions where a [non-printable keypress](#non-printable) generates a `KeyboardEvent` event:
   *  * If the Enter key is pressed, `code` returns 13.
   *  * If the Escape key is pressed, `code` returns 27.
   *  * If more than one key is pressed and the combination includes a modifier that makes the resulting keystroke
   *    non-printing, the returned value is the printable character. For example, if the non-printing combination
   *    Ctrl-A is pressed, `code` returns the letter "a".
   *
   * @see [#key](#key)
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  return KeyboardEvent;
}(_WixEvent3.default);

exports.default = KeyboardEvent;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.MouseEventHandler
 * @summary Handles events fired when the mouse is clicked.
 * @param {$w.MouseEvent} event The mouse event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class MouseEvent
 * @summary Event that is fired when the mouse is clicked.
 * @description
 *  The properties of a `MouseEvent` refer to the client, page, and screen.
 *  These terms refer to different containers as shown in the diagrams below.
 *  ![Coodinate Reference](images/coordinates_client.png "Coordinate Reference")
 *  ![Coodinate Reference](images/coordinates_page.png "Coordinate Reference")
 *  ![Coodinate Reference](images/coordinates_screen.png "Coordinate Reference")
 * @memberof $w
 * @mixes $w.Event
 */
var MouseEvent = function (_WixEvent) {
  _inherits(MouseEvent, _WixEvent);

  function MouseEvent(target, event) {
    _classCallCheck(this, MouseEvent);

    var _this = _possibleConstructorReturn(this, (MouseEvent.__proto__ || Object.getPrototypeOf(MouseEvent)).call(this, target, event));

    _this.pageX = _lodash2.default.get(event, 'pageX');
    _this.pageY = _lodash2.default.get(event, 'pageY');
    _this.screenX = _lodash2.default.get(event, 'screenX');
    _this.screenY = _lodash2.default.get(event, 'screenY');
    _this.clientX = _lodash2.default.get(event, 'clientX');
    _this.clientY = _lodash2.default.get(event, 'clientY');
    _this.offsetX = _lodash2.default.get(event, 'nativeEvent.offsetX');
    _this.offsetY = _lodash2.default.get(event, 'nativeEvent.offsetY');
    return _this;
  }

  /**
   * @member {external:Number} pageX
   * @label property
   * @syntax
   * get pageX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the page.
   * @description The page refers to the entire web page, even parts that are
   *  not currently viewable in the browser. Therefore, two clicks on the same
   *  physical point of the screen return different `pageX` values if the
   *  page is scrolled horizontally in the meantime. But two clicks on the
   *  same point on the page return the same `pageX` values even if the
   *  page is scrolled horizontally in the meantime.
   *  ![Coodinate Reference](images/coordinates_page.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} pageY
   * @label property
   * @syntax
   * get pageY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the page.
   * @description The page refers to the entire web page, even parts that are
   *  not currently viewable in the browser. Therefore, two clicks on the same
   *  physical point of the screen return different `pageY` values if the
   *  page is scrolled vertically in the meantime. But two clicks on the
   *  same point on the page return the same `pageY` values even if the
   *  page is scrolled vertically in the meantime.
   *  ![Coodinate Reference](images/coordinates_page.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} screenX
   * @label property
   * @syntax
   * get screenX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the screen or screens.
   * @description The screen refers to the physical screen or screens.
   *  Therefore, two clicks on the same physical point of the screen
   *  return the same `screenX` values even if the page is scrolled horizontally in
   *  the meantime. But two clicks on the
   *  same point on the page return different `screenX` values if the
   *  page is scrolled horizontally in the meantime.
   *  ![Coodinate Reference](images/coordinates_screen.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} screenY
   * @label property
   * @syntax
   * get screenY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the screen or screens.
   * @description The screen refers to the physical screen or screens.
   *  Therefore, two clicks on the same physical point of the screen
   *  return the same `screenY` values if the page is scrolled vertically in
   *  the meantime. But two clicks on the
   *  same point on the page return different `screenY` values if the
   *  page is scrolled vertically in the meantime.
   *  ![Coodinate Reference](images/coordinates_screen.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} clientX
   * @label property
   * @syntax
   * get clientX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the browser's viewable area.
   * @description The browser's viewable area refers to the viewable contents
   *  of the page and excludes elements such as a sidebar and scrollbar.
   *  Therefore, two clicks on the same physical point of the screen
   *  return the same `clientX` values even if the page is scrolled horizontally in
   *  the meantime. But two clicks on the
   *  same point on the page return different `clientX` values if the
   *  page is scrolled horizontally in the meantime.
   *  ![Coodinate Reference](images/coordinates_client.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} clientY
   * @label property
   * @syntax
   * get clientY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the browser's viewable area.
   * @description The browser's viewable area refers to the viewable contents
   *  of the page and excludes elements such as a toolbar and scrollbar.
   *  Therefore, two clicks on the same physical point of the screen
   *  return the same `clientY` values if the page is scrolled vertically in
   *  the meantime. But two clicks on the
   *  same point on the page return different `clientY` values if the
   *  page is scrolled vertically in the meantime.
   *  ![Coodinate Reference](images/coordinates_client.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} offsetX
   * @label property
   * @syntax
   * get offsetX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the element that triggered this event.
   * @description
   *  Scrolling the web page causes its elements to shift relative to the
   *  browser window. Therefore, two clicks on the same physical point of the
   *  screen return different `offsetX` values if the page is scrolled
   *  horizontally in the meantime. But two clicks on the
   *  same point on the element return the same `offsetX` values even if the
   *  page is scrolled horizontally in the meantime.
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} offsetY
   * @label property
   * @syntax
   * get offsetY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the element that triggered this event.
   * @description
   *  Scrolling the web page causes its elements to shift relative to the
   *  browser window. Therefore, two clicks on the same physical point of the
   *  screen return different `offsetY` values if the page is scrolled
   *  vertically in the meantime. But two clicks on the
   *  same point on the element return the same `offsetY` values even if the
   *  page is scrolled horizontally in the meantime.
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  return MouseEvent;
}(_WixEvent3.default);

exports.default = MouseEvent;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

var _quickActionBarUtils = __webpack_require__(56);

var _quickActionBarUtils2 = _interopRequireDefault(_quickActionBarUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.QuickActionBarItemClickedEventHandler
 * @summary Handles events fired when an item in a quick action bar is clicked.
 * @param {$w.QuickActionBarItemClickedEvent} event The event that has occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class QuickActionBarItemClickedEvent
 * @summary Event that is fired when a quick action bar item is clicked.
 * @memberof $w
 * @mixes $w.Event
 */
var QuickActionBarItemClickedEvent = function (_WixEvent) {
  _inherits(QuickActionBarItemClickedEvent, _WixEvent);

  function QuickActionBarItemClickedEvent(target, event) {
    _classCallCheck(this, QuickActionBarItemClickedEvent);

    var _this = _possibleConstructorReturn(this, (QuickActionBarItemClickedEvent.__proto__ || Object.getPrototypeOf(QuickActionBarItemClickedEvent)).call(this, target, event));

    _this.item = _quickActionBarUtils2.default.convertToUserFormat(event.item);
    _this.itemIndex = event.actionIndex;
    return _this;
  }

  /**
   * @typedef $w.QuickActionBarItemClickedEvent~QuickActionBarItem
   * @summary An object representing a quick action bar item.
   * @description
   *  The `itemType` is one of:
   *
   *  + `"3dots"`
   *  + `"3dotsvertical"`
   *  + `"about"`
   *  + `"add"`
   *  + `"address"`
   *  + `"arrowdown"`
   *  + `"arrowup"`
   *  + `"blog"`
   *  + `"booking"`
   *  + `"briefcase"`
   *  + `"clock"`
   *  + `"clothes"`
   *  + `"cloud"`
   *  + `"contactform"`
   *  + `"creditcard"`
   *  + `"crown"`
   *  + `"currency"`
   *  + `"earth"`
   *  + `"ecom"`
   *  + `"email"`
   *  + `"facebook"`
   *  + `"flag"`
   *  + `"flickr"`
   *  + `"freebutton"`
   *  + `"gallery"`
   *  + `"googleplus"`
   *  + `"hamburgermenu"`
   *  + `"heart"`
   *  + `"home"`
   *  + `"hot"`
   *  + `"hotel"`
   *  + `"hotsale"`
   *  + `"icecream"`
   *  + `"instagram"`
   *  + `"lightning"`
   *  + `"link"`
   *  + `"linkedin"`
   *  + `"music"`
   *  + `"new"`
   *  + `"page"`
   *  + `"phone"`
   *  + `"pinterest"`
   *  + `"present"`
   *  + `"register"`
   *  + `"restaurant"`
   *  + `"rocket"`
   *  + `"sale"`
   *  + `"search"`
   *  + `"shoppingcart"`
   *  + `"signup"`
   *  + `"smile"`
   *  + `"social"`
   *  + `"speaker"`
   *  + `"star"`
   *  + `"ticket"`
   *  + `"twitter"`
   *  + `"vimeo"`
   *  + `"vk"`
   *  + `"yelp"`
   *  + `"youtube"`
   * @property {external:String} itemType The quick action bar item type.
   * @property {external:String} label The quick action bar item label.
   * @property {external:String} link The quick action bar item link.
   */

  /**
   * @member item
   * @label property
   * @syntax
   * get item(): QuickActionBarItem
   * @summary Gets the gallery item.
   * @snippet [QuickActionBarItemClickedEvent-item.es6=Get the quick action bar item that was clicked]
   * @type {$w.QuickActionBarItemClickedEvent~QuickActionBarItem}
   * @memberof $w.QuickActionBarItemClickedEvent
   * @readonly
   */

  /**
   * @member itemIndex
   * @label property
   * @syntax
   * get itemIndex(): Number
   * @summary Gets the quick action bar item's index.
   * @snippet [QuickActionBarItemClickedEvent-itemIndex.es6=Get the index of the quick action bar item that was clicked]
   * @type {external:Number}
   * @memberof $w.QuickActionBarItemClickedEvent
   * @readonly
   */

  return QuickActionBarItemClickedEvent;
}(_WixEvent3.default);

exports.default = QuickActionBarItemClickedEvent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getCellData(event) {
  var cellData = void 0;

  if (_lodash2.default.get(event, 'cellData')) {
    cellData = JSON.parse(event.cellData);
  }

  return cellData;
}

/**
 * @callback $w.TableCellEventHandler
 * @summary Handles events fired when a table cell is selected.
 * @param {$w.TableCellEvent} event The table cell event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class TableCellEvent
 * @summary Event that is fired when a table cell is selected.
 * @description This event is only fired if the table is
 *  [set](https://support.wix.com/en/article/table-settings) in the Editor to
 *  select cells when clicked.
 * ![Clicking Selects Cells](images/table_settings_click_cells.png "Clicking Selects Cells")
 * @memberof $w
 * @mixes $w.Event
 */

var TableCellEvent = function (_WixEvent) {
  _inherits(TableCellEvent, _WixEvent);

  function TableCellEvent(target, event) {
    _classCallCheck(this, TableCellEvent);

    var _this = _possibleConstructorReturn(this, (TableCellEvent.__proto__ || Object.getPrototypeOf(TableCellEvent)).call(this, target, event));

    _this.cellRowIndex = _lodash2.default.get(event, 'rowIndex');
    _this.cellColumnId = _lodash2.default.get(event, 'columnId');
    _this.cellData = getCellData(event);
    return _this;
  }

  /**
   * @member {external:Number} cellRowIndex
   * @label property
   * @syntax
   * get cellRowIndex(): Number
   * @summary Gets the row index of the selected cell.
   * @description
   *  The rows in a table are zero-based and do not include the table header.
   *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
   * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
   * @memberof $w.TableCellEvent
   * @readonly
   */

  /**
   * @member {external:String} cellColumnId
   * @label property
   * @syntax
   * get cellColumnId(): string
   * @summary Gets the column ID of the selected cell.
   * @description
   *  The `cellColumnId` is the `id` property of the
   *  [`Column`]($w.Table.html#Column) object that corresponds to the column
   *  of the selected cell.
   * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
   * @memberof $w.TableCellEvent
   * @readonly
   */

  /**
   * @member {external:String} cellData
   * @label property
   * @syntax
   * get cellData(): string
   * @summary Gets the data from the selected cell.
   * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
   * @memberof $w.TableCellEvent
   * @readonly
   */


  return TableCellEvent;
}(_WixEvent3.default);

exports.default = TableCellEvent;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _WixEvent2 = __webpack_require__(19);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRowData(event) {
  var rowData = void 0;

  if (_lodash2.default.get(event, 'rowData')) {
    rowData = JSON.parse(event.rowData);
  }

  return rowData;
}

/**
 * @callback $w.TableRowEventHandler
 * @summary Handles events fired when a table row is selected.
 * @param {$w.TableRowEvent} event The event that has occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class TableRowEvent
 * @summary Event that is fired when a table row is selected.
 * @description This event is only fired if the table is
 *  [set](https://support.wix.com/en/article/table-settings) in the Editor to
 *  select rows when clicked.
 * ![Clicking Selects Rows](images/table_settings_click_rows.png "Clicking Selects Rows")
 * @memberof $w
 * @mixes $w.Event
 */

var TableRowEvent = function (_WixEvent) {
  _inherits(TableRowEvent, _WixEvent);

  function TableRowEvent(target, event) {
    _classCallCheck(this, TableRowEvent);

    var _this = _possibleConstructorReturn(this, (TableRowEvent.__proto__ || Object.getPrototypeOf(TableRowEvent)).call(this, target, event));

    _this.rowIndex = _lodash2.default.get(event, 'rowIndex');
    _this.rowData = getRowData(event);
    return _this;
  }

  /**
   * @member {external:Number} rowIndex
   * @label property
   * @syntax
   * get rowIndex(): Number
   * @summary Gets the index of the selected row.
   * @description
   *  The rows in a table are zero-based and do not include the table header.
   *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
   * @snippet [TableRowEvent-all.es6=Get the selected table row information]
   * @memberof $w.TableRowEvent
   * @readonly
   */

  /**
   * @member {external:Object} rowData
   * @label property
   * @syntax
   * get rowData(): Object
   * @summary Gets the data for the selected row.
   * @description
   *  The row data is a JSON object of `columnName:cellData` key:value pairs.
   *  The object only contains the data that is displayed in the table.
   *
   *  If the table is connected to a dataset, the `rowData` does not include the
   *  fields from the dataset item that are not connected to table columns.
   *
   *  To retrieve the dataset item data that corresponds to the table row data,
   *  use the dataset [`getCurrentItem()`](wix-dataset.html#getCurrentItem)
   *  function in the dataset [`onCurrentIndexChanged()`](wix-dataset.html#onCurrentIndexChanged)
   *  event handler.
   *
   *  Getting the `rowData` gets the same object that is returned in the array
   *  of rows when readingthe table's [`rows`]($w.Table.html#rows) property.
   * @snippet [TableRowEvent-all.es6=Get the selected table row information]
   * @snippet [TableRowEvent-rowData_dataset.es6=Get the full item information from the dataset]
   * @memberof $w.TableRowEvent
   * @readonly
   */

  return TableRowEvent;
}(_WixEvent3.default);

exports.default = TableRowEvent;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Slideshow2 = __webpack_require__(62);

var _Slideshow3 = _interopRequireDefault(_Slideshow2);

var _PlayableMixin2 = __webpack_require__(37);

var _PlayableMixin3 = _interopRequireDefault(_PlayableMixin2);

var _UploadButton2 = __webpack_require__(64);

var _UploadButton3 = _interopRequireDefault(_UploadButton2);

var _errors = __webpack_require__(9);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _BaseGallery2 = __webpack_require__(42);

var _BaseGallery3 = _interopRequireDefault(_BaseGallery2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SlideshowGhost = function (_Slideshow) {
    _inherits(SlideshowGhost, _Slideshow);

    function SlideshowGhost() {
        _classCallCheck(this, SlideshowGhost);

        return _possibleConstructorReturn(this, (SlideshowGhost.__proto__ || Object.getPrototypeOf(SlideshowGhost)).apply(this, arguments));
    }

    _createClass(SlideshowGhost, [{
        key: 'changeSlide',
        value: function changeSlide(slideInfo) {
            var errorMessage = _errors.generateError.error_ghost_slide_input({
                propertyName: 'slideInfo',
                functionName: 'changeSlide',
                wrongValue: slideInfo
            });
            return Promise.reject(new Error(errorMessage));
        }
    }]);

    return SlideshowGhost;
}(_Slideshow3.default);

var PlayableMixinGhost = function (_PlayableMixin) {
    _inherits(PlayableMixinGhost, _PlayableMixin);

    function PlayableMixinGhost() {
        _classCallCheck(this, PlayableMixinGhost);

        return _possibleConstructorReturn(this, (PlayableMixinGhost.__proto__ || Object.getPrototypeOf(PlayableMixinGhost)).apply(this, arguments));
    }

    _createClass(PlayableMixinGhost, [{
        key: 'next',
        value: function next() {
            var errorMessage = _errors.generateError.error_ghost_function({
                functionName: 'next',
                compType: members._type.get(this).compType
            });
            return Promise.reject(new Error(errorMessage));
        }
    }, {
        key: 'previous',
        value: function previous() {
            var errorMessage = _errors.generateError.error_ghost_function({
                functionName: 'previous',
                compType: members._type.get(this).compType
            });
            return Promise.reject(new Error(errorMessage));
        }
    }]);

    return PlayableMixinGhost;
}(_PlayableMixin3.default);

var UploadButtonGhost = function (_UploadButton) {
    _inherits(UploadButtonGhost, _UploadButton);

    function UploadButtonGhost() {
        _classCallCheck(this, UploadButtonGhost);

        return _possibleConstructorReturn(this, (UploadButtonGhost.__proto__ || Object.getPrototypeOf(UploadButtonGhost)).apply(this, arguments));
    }

    _createClass(UploadButtonGhost, [{
        key: 'startUpload',
        value: function startUpload() {
            var errorMessage = _errors.generateError.error_ghost_function({
                functionName: 'startUpload',
                compType: members._type.get(this).compType
            });
            return Promise.reject(new Error(errorMessage));
        }
    }]);

    return UploadButtonGhost;
}(_UploadButton3.default);

var GalleryGhost = function (_BaseGallery) {
    _inherits(GalleryGhost, _BaseGallery);

    function GalleryGhost() {
        _classCallCheck(this, GalleryGhost);

        return _possibleConstructorReturn(this, (GalleryGhost.__proto__ || Object.getPrototypeOf(GalleryGhost)).apply(this, arguments));
    }

    return GalleryGhost;
}(_BaseGallery3.default);

(0, _mixin2.default)(SlideshowGhost.prototype, PlayableMixinGhost.prototype);
(0, _mixin2.default)(GalleryGhost.prototype, PlayableMixinGhost.prototype);

var GhostClasses = {
    SlideshowGhost: SlideshowGhost,
    UploadButtonGhost: UploadButtonGhost,
    GalleryGhost: GalleryGhost
};

exports.default = GhostClasses;

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publicPage = function publicPage(includePageId) {
  return function () {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _lodash2.default.omitBy({
      name: page.name,
      type: page.type,
      url: page.url,
      applicationId: page.applicationId,
      prefix: page.prefix,
      isHomePage: page.isMainPage,
      id: includePageId ? page.id : undefined
    }, function (val, key) {
      return _lodash2.default.isUndefined(val) || key === 'isHomePage' && !val;
    });
  };
};

var publicLightBox = function publicLightBox(includePageId) {
  var includeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    var lightbox = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _lodash2.default.omitBy({
      name: lightbox.name,
      id: includePageId ? lightbox.id : undefined,
      type: includeType ? 'lightbox' : undefined
    }, _lodash2.default.isUndefined);
  };
};

var publicPrefix = function publicPrefix() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash2.default.omitBy({
    name: prefix.name,
    prefix: prefix.prefix,
    type: prefix.type,
    applicationId: prefix.applicationId
  }, _lodash2.default.isUndefined);
};

exports.default = {
  getSiteStructure: function getSiteStructure() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$includePageId = _ref.includePageId,
        includePageId = _ref$includePageId === undefined ? false : _ref$includePageId;

    var RMI = _platformUtils2.default.getRMI('wix-site.getSiteStructure');
    var siteStructure = RMI.getSiteStructure();

    return {
      pages: (siteStructure.pages || []).map(publicPage(includePageId)),
      prefixes: (siteStructure.prefixes || []).map(publicPrefix),
      lightboxes: (siteStructure.lightboxes || []).map(publicLightBox(includePageId))
    };
  },
  getCurrentPage: function getCurrentPage() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$includePageId = _ref2.includePageId,
        includePageId = _ref2$includePageId === undefined ? false : _ref2$includePageId;

    var RMI = _platformUtils2.default.getRMI();
    var contextId = _platformUtils2.default.getRGI().getContextId();
    var siteStructure = RMI.getSiteStructure();

    var page = _lodash2.default.find(siteStructure.pages, { id: contextId });
    if (page) {
      return publicPage(includePageId)(page);
    }

    var lightbox = _lodash2.default.find(siteStructure.lightboxes, { id: contextId });
    if (lightbox) {
      return publicLightBox(includePageId, true)(lightbox);
    }

    _monitoring2.default.reportError(new Error('No page nor lightbox was found for contextId: ' + contextId));

    return null;
  }
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _Link = __webpack_require__(30);

var _Link2 = _interopRequireDefault(_Link);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _validation = __webpack_require__(3);

var _errors = __webpack_require__(9);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace wix-location
 * @summary The wix-location module contains functionality for getting information
 *  about the URL of the current page and for navigating to other pages.
 * @description
 *  To use the location module, import wixLocation from the wix-location module:
 *
 *    ```javascript
 *    import wixLocation from 'wix-location';
 *    ```
 *
 *  The APIs in `wix-location` can only be used in front-end code and only after
 *  the page is ready.
 *
 * #### Premium Sites
 * Given the premium site URL: `https://domain.com/animals/mammals/elephant?species=african-elephant`,
 * the URL is broken down as shown in the table below:
 *
 * <table style="border-collapse: collapse;">
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=9>url</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=3>baseUrl</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" colspan=6></td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >protocol</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" ></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >host</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >prefix</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >path</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" ></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >query</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">https</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">://</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">domain.com</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/animals</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/mammals/elephant</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">?</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">species=african-elephant</td>
 *     </tr>
 * </table>
 *
 * #### Free Site
 * Given the free site URL: `https://user.wix-sites.com/zoo/animals/mammals/elephant?species=african-elephant`,
 * the URL is broken down as shown in the table below:
 *
 * <table style="border-collapse: collapse;">
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=11>url</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=5>baseUrl</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" colspan=6></td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">protocol</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa"></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">host</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa"></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">site</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">prefix</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">path</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa"></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">query</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">https</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">://</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">user.wix-sites.com</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">zoo</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/animals</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/mammals/elephant</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">?</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">species=african-elephant</td>
 *     </tr>
 * </table>
 *
 *
 */
var Location = function () {
    function Location(appDefId) {
        _classCallCheck(this, Location);

        members._appDefId.set(this, appDefId);
        _lodash2.default.bindAll(this, ['to']);
    }

    /**
     * @member url
     * @label property
     * @syntax
     * get url(): string
     * @summary Gets the full URL of the current page.
     * @description
     *  Premium sites:
     *  ![Premium site URL](images/url_premium_url.png "Premium site URL")
     *
     *  Free sites:
     *  ![Free site URL](images/url_free_url.png "Free site URL")
     *
     *  If the site is not yet published, the function returns null.
     * @type {external:String}
     * @snippet [Location-url.es6=Get the full URL of the current page]
     * @see [baseUrl](#baseUrl)
     * @memberof wix-location
     * @readonly
     */


    _createClass(Location, [{
        key: 'to',


        /**
         * @function to
         * @syntax
         * function to(url: string): void
         * @summary Directs the browser to navigate to the specified URL.
         * @description
         *  The `to()` function navigates the browser to another web page.
         *
         * `to()` supports the following link patterns:
         *
         *  + `/localPageURL`: another page on your site
         *  + `/localPageURL?queryParam=value`: another page on your site with query parameters
         *  + `/`: your site's home page
         *  + `http(s)://<url>`: an external web address
         *  + `wix:document://<location>`: a document stored in the Media Manager
         *  + `mailto:<address>@<someplace.com>?subject=<subject>`: an email
         *  + `tel:<phone number>`: a phone number
         *
         *
         *  To find the local URL of a page on your site in the Editor:
         *
         *  + Regular page: See the **SEO** tab of the **Page Settings** panel.
         *  + Dynamic page: See the **Page Info** tab of the **Page Settings** panel
         *    for the URL structure. The actual URL used for navigation needs to contain
         *    values where the placeholders are.
         *
         *    For example, if the URL structure of your dynamic page looks like:
         *
         *    ![Dynamic Page URL](images/dynamic_url.png "Dynamic Page URL")
         *
         *    and you have an item with the title "Waffles", the local URL to that page
         *    is /Recipes/Waffles.
         *  + Router page: You cannot navigate directly to a specific router page. You
         *    can navigate to a URL with the router's prefix and the router code
         *    decides which page to route to.
         *
         *
         *  The `to()` function attempts to properly encode the URL parameter that
         *  is passed to it. For example, `.../some page` is encoded to
         *  `.../some%20page`. However, some URLs do not have one unambiguous encoding.
         *  In those cases it is up to you to encode the URL to reflect your intentions.
         *  Because of these situations, it is a best practice to always encode URLs
         *  before you pass them to the `to()` function.
         *
         *  Note that Wix URLs do not contain spaces. A page which has spaces in its
         *  name has its spaces replaced with dashes (`-`). Similarly, a dynamic page
         *  whose URL contains the value of a field in your collection with spaces
         *  has its spaces replaced with dashes (`-`).
         * @param {external:String} url The URL of the page or website to navigate to.
         * @snippet [Location-to_set_local.es6=Navigate to a local link]
         * @snippet [Location-to_set_weblink.es6=Navigate to an external web link]
         * @snippet [Location-to_set_mailto.es6=Open a new email window]
         * @snippet [Location-to_set_document.es6=Open a document]
         * @snippet [Location-to_set_telephone.es6=Make a phone call]
         * @memberof wix-location
         */
        value: function to(url) {
            var linkData = void 0;
            if (!(0, _validation.validate)({ compType: 'Location', functionName: 'to', dataToValidate: { url: url } })) {
                return this;
            }
            try {
                linkData = new _Link2.default(url).getData();
            } catch (e) {
                if (e.message === _errors.errors.ERROR_API_BEFORE_PAGE_READY) {
                    throw new _monitoring2.default.MonitoringErrorToIgnore(_errors.generateError.error_api_with_name_before_page_ready({ apiName: 'wix-location.to' }));
                }
                var message = e.message === 'Unsupported link type' ? url + ' is an unsupported url' : e.message;
                _reporter2.default.reportSdkError(message);
                return this;
            }

            if (linkData.hasOwnProperty('pageId')) {
                linkData.pageId = linkData.pageId === '#' ? linkData.pageId : linkData.pageId.replace('#', '');
            }

            if (linkData.hasOwnProperty('target')) {
                delete linkData.target;
            }

            postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                command: postMessage.MessageTypes.NAVIGATE_TO,
                data: linkData,
                appDefinitionId: members._appDefId.get(this)
            });
        }

        /**
         * @typedef {external:Object} wix-location.Location
         * @summary An object containing information about a location.
         * @property {external:String} path Location path.
         * @snippet [Location-onChange.es6=Get the new location path]
         */

        /**
         * @callback wix-location.LocationChangeHandler
         * @summary Handles location change events.
         * @param {wix-location.Location} event The new location.
         */

        /**
         * @function onChange
         * @syntax
         * function onChange(handler: LocationChangeHandler): void
         * @summary Adds an event handler that runs when an application page's URL changes.
         * @description
         * The event handler set by the `onChange` function runs when the location is changed 
         * but the change doesn't trigger navigation. This situation occurs when navigating between 
         * subitems on a page that is managed by a full-page application.
         * 
         * For example, a store product page is a full-page application. When a product page's path 
         * changes because it is switching between items, no actual navigation is taking place. You 
         * can use the `onChange` event handler to determine when a new product is displayed and 
         * perform any necessary partial updates on the page.
         * 
         * To determine if a page is managed by a full-page application, use the `wix-site` 
         * [`currentPage`](wix-site.html#currentPage) property or [`getSiteStructure()`](wix-site.html#getSiteStructure)
         * function to retrieve a [`StructurePage`](wix-site.html#StructurePage) object that
         * corresponds to the page. If the object contains an `applicationId` value, then the
         * page is managed by a full-page application.
         * @snippet [Location-onChange.es6=Get the new location path]
         * @param {wix-location.LocationChangeHandler} handler The name of the function or
         *  the function expression to run when the location changes.
         * @memberof wix-location
         */

    }, {
        key: 'onChange',
        value: function onChange(callback) {
            if (!(0, _validation.validate)({ compType: 'Location', functionName: 'onStateChanged', dataToValidate: { callback: callback } })) {
                return;
            }
            _platformUtils2.default.getRGI().addOnLocationChangeCallback(callback);
        }
    }, {
        key: 'url',
        get: function get() {
            return _platformUtils2.default.getRGI().getFullUrl();
        }

        /*
         ******* COMMENTED OUT — SEE https://jira.wixpress.com/browse/WCD-3608  ******
         * @member hash
         * @label property
         * @syntax
         * get hash(): string
         * @summary Gets the part of the page's URL after the hash (`#`).
         * @description
         *  Premium sites:
         *  ![Premium site hash](images/url_premium_hash.png "Premium site hash")
         *
         *  Free sites:
         *  ![Free site hash](images/url_free_hash.png "Free site hash")
         * @snippet [Location-hash.es6=Get the hash of the current page's URL]
         * @type {external:String}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'hash',
        get: function get() {
            var locationInfo = _platformUtils2.default.getRGI().getLocation();
            return locationInfo.hash;
        }

        /**
         * @member protocol
         * @label property
         * @syntax
         * get protocol(): string
         * @summary Gets the protocol of the page's URL.
         * @description
         *  Premium sites:
         *  ![Premium site protocol](images/url_premium_protocol.png "Premium site protocol")
         *
         *  Free sites:
         *  ![Free site protocol](images/url_free_protocol.png "Free site protocol")
         * @snippet [Location-protocol.es6=Get the protocol of the current page's URL]
         * @type {external:String}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'protocol',
        get: function get() {
            var locationInfo = _platformUtils2.default.getRGI().getLocation();
            return locationInfo.protocol;
        }

        /**
         * @member prefix
         * @memberof wix-location
         * @label property
         * @syntax
         * get prefix(): string
         * @summary Gets the prefix of a dynamic page's or router page's URL.
         * @description
         *  Only dynamic pages and router pages have a prefix. The value of the
         *  `prefix` property for other page types is always `undefined`.
         *
         *  Premium sites:
         *  ![Premium site prefix](images/url_premium_prefix.png "Premium site prefix")
         *
         *  Free sites:
         *  ![Free site prefix](images/url_free_prefix.png "Free site prefix")
         *
         *  To learn more about dynamic page prefixes, see [About URL Prefixes and Page Grouping of Dynamic Pages](https://support.wix.com/en/article/about-url-prefixes-and-page-grouping-of-dynamic-pages).
         *
         *  To learn more about router page prefixes, see [About Routers](https://support.wix.com/en/article/about-routers#url-prefix).
         * @snippet [Location-prefix.es6=Get the prefix of the current page's URL]
         * @type {external:String}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'prefix',
        get: function get() {
            var locationInfo = _platformUtils2.default.getRGI().getLocation();
            return locationInfo.prefix;
        }

        /**
         * @member path
         * @label property
         * @syntax
         * get path(): string[]
         * @summary Gets the path of the page's URL.
         * @description
         *  Premium sites:
         *  ![Premium site path](images/url_premium_path.png "Premium site path")
         *
         *  Free sites:
         *  ![Free site path](images/url_free_path.png "Free site path")
         * @snippet [Location-path.es6=Get the path of the current page's URL]
         * @type {external:String[]}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'path',
        get: function get() {
            var locationInfo = _platformUtils2.default.getRGI().getLocation();
            return locationInfo.path;
        }

        /**
         * @member query
         * @label property
         * @syntax
         * get query(): Object
         * @summary Gets an object that represents the query segment of the page's URL.
         * @description
         *  Premium sites:
         *  ![Premium site query](images/url_premium_query.png "Premium site query")
         *
         *  Free sites:
         *  ![Free site query](images/url_free_query.png "Free site query")
         * @snippet [Location-query.es6=Get the query of the current page's URL]
         * @type {external:Object}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'query',
        get: function get() {
            var locationInfo = _platformUtils2.default.getRGI().getLocation();
            return locationInfo.query;
        }

        /**
         * @member baseUrl
         * @label property
         * @syntax
         * get baseUrl(): string
         * @summary Gets the base URL of the page.
         * @description
         *  Premium sites:
         *  ![Premium site baseUrl](images/url_premium_baseUrl.png "Premium site baseUrl")
         *
         *  Free sites:
         *  ![Free site baseUrl](images/url_free_baseUrl.png "Free site baseUrl")
         *
         *  If the site is not yet published, the function returns null.
         * @snippet [Location-baseUrl.es6=Get the base URL of the current page]
         * @type {external:String}
         * @see [url](#url)
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'baseUrl',
        get: function get() {
            var RGI = _platformUtils2.default.getRGI();
            return RGI.getNavigationInfo().baseUrl;
        }
    }]);

    return Location;
}();

(0, _livePreview.setStageUnfriendlyFunctions)(Location, 'to');

exports.default = Location;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _validation = __webpack_require__(3);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(9);

var _siteImpl = __webpack_require__(168);

var _siteImpl2 = _interopRequireDefault(_siteImpl);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace wix-site
 * @summary The wix-site module contains functionality for obtaining information about your site and its pages.
 * @description
 *  To use the site module, import `wixSite` from the `wix-site` module:
 *
 *    ```javascript
 *    import wixSite from 'wix-site';
 *    ```
 *
 *  The APIs in `wix-site` can only be used in front-end code.
 */

/**
 * @typedef {external:Object} wix-site~SiteStructure
 * @summary An object that contains information about the site's pages, prefixes, and lightboxes.
 * @description
 *  The `SiteStructure` object is a flattened representation of the site. Use
 *  the [`getSiteStructure()`](#getSiteStructure) function to get the site's
 *  `SiteStructure` object. The structure does not include the headers and links
 *  from the site's **Pages** menu.
 * @snippet [Site-getSiteStructure.es6=Get information about the site's pages, prefixes, and lightboxes]
 *  This example gets the structure of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {wix-site~StructurePage[]} pages The pages of the site.
 * @property {wix-site~Prefix[]} prefixes The prefixes of the site's routers and dynamic pages.
 * @property {wix-site~StructureLightbox[]} lightboxes The site's lightboxes.
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

/**
 * @typedef {external:Object} wix-site~StructurePage
 * @summary An object that contains information about a page on the site.
 * @description
 *  The `StructurePage` object represents a page in the site. The page can be a
 *  regular page, dynamic page, router page, or page from an app.
 * @snippet [Site-currentPage_page.es6=Get information about the current page]
 * @snippet [Site-pages.es6=Get information about the site's pages]
 *  This example gets the pages of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {external:String} name The of the page.
 * @property {external:String} type The type of the page: `"static"` or `"template"`.
 * @property {external:String} [url] The URL of the page. If the page is a `static` page the `url` property is the page's SEO URL.
 * @property {external:String} [applicationId] If the page is an app page, the `applicationId` property is the app's ID.
 * @property {external:String} [prefix] If the page is a router or dynamic page, the `prefix` property is the page's prefix.
 * @property {external:Boolean} [isHomePage] If the page is the Home page, `isHomePage` is `true`. Otherwise, it does not exist.
 * @see [SiteStructure](#SiteStructure)
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

/**
 * @typedef {external:Object} wix-site~Prefix
 * @summary An object that contains information about the site's prefixes.
 * @description
 *  A site's routers, dynamic pages, and app pages all have prefixes.
 * @snippet [Site-prefixes.es6=Get information about the site's prefixes]
 *  This example gets the prefixes of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {external:String} name The name of the prefix.
 * @property {external:String} type The type of the prefix: `"dynamicPages"`, `"router"`, or `"app"`.
 * @property {external:String} prefix The prefix.
 * @property {external:String} [applicationId] If the prefix is an app's prefix, the `applicationId` property is the app's ID.
 * @see [SiteStructure](#SiteStructure)
 * @see [currentPage](#currentPage)
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

/**
 * @typedef {external:Object} wix-site~StructureLightbox
 * @summary An object that contains information about a lightbox on the site.
 * @snippet [Site-currentPage_lightbox.es6=Get information about the current lightbox]
 * @snippet [Site-lightboxes.es6=Get information about the site's lightboxes]
 *  This example gets the lightboxes of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {external:String} name The name of the lightbox.
 * @see [SiteStructure](#SiteStructure)
 * @see [currentPage](#currentPage)
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

var Site = function () {
    function Site(appDefId) {
        _classCallCheck(this, Site);

        members._appDefId.set(this, appDefId);
        _lodash2.default.bindAll(this, ['routerSitemap']);
    }

    /**
     * @function routerSitemap
     * @syntax
     * function routerSitemap(routerPrefix: string): Promise<WixRouterSitemapEntry[]>
     * @summary Returns the sitemap for a router or dynamic page prefix.
     * @description
     *  The `routerSitemap()` function returns a Promise that resolves to a list of
     *  [`WixSitemapEntry`](wix-router.WixRouterSitemapEntry.html) objects. Each
     *  [`WixSitemapEntry`](wix-router.WixRouterSitemapEntry.html) includes
     *  information about a page, such as its URL, title, and name.
     *
     *  A sitemap is used by search engines to find the links to the site's pages.
     * @snippet [Site-routerSiteMap.es6=Get the sitemap for a prefix]
     * @param {external:String} routerPrefix The prefix of the router to get the sitemap for.
     * @returns {external:Promise}
     * @fulfill {wix-router.WixRouterSitemapEntry[]} A list of sitemap entries.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-site
     */


    _createClass(Site, [{
        key: 'routerSitemap',
        value: function routerSitemap(prefix) {
            var _this = this;

            return new Promise(function (resolve, reject) {
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                    command: postMessage.MessageTypes.GET_ROUTERS_SITEMAP,
                    data: { prefix: prefix },
                    appDefinitionId: members._appDefId.get(_this),
                    callback: callback
                });
            });
        }

        /**
         * @function getSiteStructure
         * @syntax
         * function wixSite.getSiteStructure(): SiteStructure
         * @summary Returns information about the site's pages, prefixes, and lightboxes.
         * @snippet [Site-getSiteStructure.es6=Get information about the site's pages, prefixes, and lightboxes]
         *  This example gets the structure of the site with the following in its pages menu:
         *  ![Site Structure](images/site_structure.png "Site Structure")
         * @returns {wix-site~SiteStructure} An object that contains information about the site's pages, prefixes, and lightboxes.
         * @see [currentPage](#currentPage)
         * @memberof wix-site
         */

    }, {
        key: 'getSiteStructure',
        value: function getSiteStructure() {
            return _siteImpl2.default.getSiteStructure({ includePageId: false });
        }

        /**
         * @member currentPage
         * @label property
         * @summary Gets information about the current page or lightbox.
         * @snippet [Site-currentPage_page.es6=Get information about the current page]
         * @snippet [Site-currentPage_lightbox.es6=Get information about the current lightbox]
         * @type {wix-site~StructurePage|wix-site~StructureLightbox}
         * @memberof wix-site
         * @see [getSiteStructure( )](#getSiteStructure)
         */

    }, {
        key: 'getAppToken',
        value: function getAppToken(appDefinitionId) {
            var isValid = (0, _validation.validate)({
                compType: 'Site',
                functionName: 'getAppToken',
                dataToValidate: { appDefinitionId: appDefinitionId }
            });
            if (!isValid) {
                return;
            }
            var appData = _platformUtils2.default.getRGI().getAppData(appDefinitionId);
            if (appData) {
                return appData.instance;
            }
            _reporter2.default.reportSdkError(_errors.generateError.error_app_does_not_exist({
                appDefId: appDefinitionId
            }));
        }

        /**
         * @member regionalSettings
         * @label property
         * @summary Gets the site's regional settings.
         * @description
         *  The retrieved regional settings corresponds to the regional settings
         *  that has been entered in the General Info section of your site's Dashboard.
         * 
         *  The regional settings are used to determine how numbers, dates, and currencies 
         *  are displayed on your site.
         * @snippet [Site-regionalSettings.es6=Get the site's regionalSettings]
         * @type {external:String}
         * @memberof wix-site
         * @readonly
         */

    }, {
        key: 'currentPage',
        get: function get() {
            return _siteImpl2.default.getCurrentPage({ includePageId: false });
        }
    }, {
        key: 'regionalSettings',
        get: function get() {
            return _platformUtils2.default.getRGI().getRegionalSettings().locale;
        }

        /**
         * @member language
         * @label property
         * @summary Gets a code representing the site's language.
         * @description
         *  The retrieved language code corresponds to the main site language 
         *  as found in the General Info section of your site's Dashboard.
         * @note
         *  If you have a multilingual site, and it is being viewed in a language
         *  that is not the main site language, the `language` property still returns
         *  the main site language. To work with the languages of a multilingual site,
         *  use the [Multilingual API](wix-window.multilingual.html).
         * @snippet [Site-language.es6=Get the site's language]
         * @type {external:String}
         * @memberof wix-site
         * @readonly
         */

    }, {
        key: 'language',
        get: function get() {
            return _platformUtils2.default.getRGI().getRegionalSettings().language;
        }

        /**
         * @member currency
         * @label property
         * @summary Gets a code representing the site's currency.
         * @description
         *  The retrieved currency code corresponds to the currency that has been
         *  entered in the General Info section of your site's Dashboard.
         * 
         *  The currency is used your site, apps (e.g. Wix Stores, Wix Bookings), and other 
         *  Wix features.
         * @snippet [Site-currency.es6=Get the site's currency]
         * @type {external:String}
         * @memberof wix-site
         * @readonly
         */

    }, {
        key: 'currency',
        get: function get() {
            return _platformUtils2.default.getRGI().getRegionalSettings().currency;
        }

        /**
         * @member timezone
         * @label property
         * @summary Gets the site's timezone.
         * @description
         *  The retrieved timezone is the timezone that has been
         *  entered in the General Info section of your site's Dashboard.
         * 
         *  The timezone is used your site, apps (e.g. Wix Stores, Wix Bookings), and other 
         *  Wix features.
         * @snippet [Site-timezone.es6=Get the site's timezone]
         * @type {external:String}
         * @memberof wix-site
         * @readonly
         */

    }, {
        key: 'timezone',
        get: function get() {
            return _platformUtils2.default.getRGI().getRegionalSettings().timezone;
        }

        /**
         * @member revision
         * @label property
         * @summary Gets the site revision ID.
         * @description
         *  The site revision ID is a unique identifier for the current revision of
         *  your site. Each time you manually save your site or publish your site
         *  following a change, a new revision is created.
         *
         * You can view and manage your site revisions in your <a href="https://support.wix.com/en/article/viewing-and-managing-your-site-history" target="_blank">Site History</a>.
         * You can use <a href="https://support.wix.com/en/article/about-site-monitoring#site-revisions" target="_blank">site monitoring</a> to
         * monitor and debug new revisions of your site.
         * @note
         *  Since publishing your site may change the revision ID, the ID when
         *  previewing your site may be different than the ID for the published site.
         *
         *  The site revision ID is guaranteed to be unique, but not meaningful.
         *  Therefore, you cannot predict future revision IDs before they are created.
         * @snippet [Site-revision_get.es6=Get the site revision ID]
         * @type {external:String}
         * @memberof wix-site
         */

    }, {
        key: 'revision',
        get: function get() {
            return _platformUtils2.default.getRGI().getSiteRevision();
        }

        /*
        getAppPublicAPI(appDefinitionId) {
            const RMI = platformUtils.getRMI();
            return RMI.getAppPublicAPI(appDefinitionId);
        }
        */

    }]);

    return Site;
}();

exports.default = Site;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _postMessage2 = __webpack_require__(15);

var _postMessage = _interopRequireWildcard(_postMessage2);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _urlUtils = __webpack_require__(52);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _validation = __webpack_require__(3);

var _utils = __webpack_require__(5);

var _multilingual = __webpack_require__(189);

var _multilingual2 = _interopRequireDefault(_multilingual);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WINDOW_COMP_ID = 'WINDOW';

/**
 * @namespace wix-window
 * @summary The wix-window module contains functionality that pertains to the
 *  current browser window.
 * @description
 *  To use the window module, import `wixWindow` from the `wix-window` module:
 *
 *    ```javascript
 *    import wixWindow from 'wix-window';
 *    ```
 *
 *  The APIs in `wix-window` can only be used in front-end code.
 */

var Lightbox = function () {
    function Lightbox(appDefId) {
        _classCallCheck(this, Lightbox);

        members._appDefId.set(this, appDefId);
    }

    /**
     * @function getContext
     * @syntax
     * function getContext(): Object
     * @summary Returns the data object that was passed to a lightbox.
     * @description
     *  The `getContext()` function returns the data object passed when the lightbox
     *  was opened using the [`openLightbox()`](wix-window.html#openLightbox) function,
     *  if any data was passed. If the lightbox was opened another way,
     *  `getContext()` returns `undefined`.
     *
     *  To pass data to the lightbox that is opened, you must open the lightbox
     *  programmatically using the [`openLightbox()`](wix-window.html#openLightbox)
     *  function. If the lightbox is opened automatically when the page loads or
     *  by a link from a page element, data will not be passed to the lightbox.
     *  Therefore, if you want to pass data to the lightbox, make sure
     *  **Automatically display lightbox on pages** is <a href="https://support.wix.com/en/article/setting-which-page-your-lightbox-appears-on" target="_blank">set</a> to **No** in the
     *  **Lightbox Settings** panel in the Editor and don't set any element's link
     *  to open the lightbox. Instead, create your own method for opening
     *  the lightbox programmatically. For example, you can add a button with an `onClick` event
     *  handler that calls the [`openLightbox()`](wix-window.html#openLightbox) function.
     * @snippet [Lightbox-getContext.es6=Get the data that was passed to the lightbox]
     * @snippet [Lightbox-scenario.es6=A scenario where information is passed between a page and a lightbox]
     *  This example demonstrates how to pass data from a page to a lightbox that
     *  it opens and from the lightbox back to the page as it closes.
     *
     *  It assumes that the page has:
     *
     *  + An open button that is used to open the lightbox.
     *  + Two text inputs where information that is to be passed to the lightbox is entered.
     *  + Two text elements where information that is passed from the lightbox is displayed.
     *
     *
     *  It assumes that the lightbox has:
     *
     *  + An close button that is used to close the lightbox.
     *  + Two text inputs where information that is to be passed to the page is entered.
     *  + Two text elements where information that is passed from the page is displayed.
     * @returns {external:Object} The data object that was passed to the lightbox.
     * @memberof wix-window.lightbox
     */


    _createClass(Lightbox, [{
        key: 'getContext',
        value: function getContext() {
            return _platformUtils2.default.getRGI().getLightboxContext();
        }

        /**
         * @function close
         * @syntax
         * function close([data: Object]): void
         * @summary Closes the lightbox.
         * @description
         *  The `close()` function closes the lightbox and returns the given data to the
         *  [`openLightbox()`](wix-window.html#openLightbox) function that was used to
         *  open the lightbox.
         *
         *  To pass data back to the page that opened the lightbox, you must close the
         *  lightbox programmatically using the `close()` function. If the lightbox is
         *  closed by the site visitor clicking the 'X' icon, close button, or lightbox
         *  overlay, data will not be passed back the the page that opened the lightbox.
         *  Therefore, if you want to make sure data is passed back to the page that
         *  opened the lightbox, <a href="https://support.wix.com/en/article/setting-how-your-lightbox-is-closed" target="_blank">disable
         *  all of the methods mentioned above</a> and create your own method for closing
         *  the lightbox programmatically. For example, you can add a button with an `onClick` event
         *  handler that calls the `close()` function.
         * @snippet [Lightbox-close.es6=Close the lightbox]
         * @snippet [Lightbox-close_options.es6=Close the lightbox and pass back data to the opening function]
         * @snippet [Lightbox-scenario.es6=A scenario where information is passed between a page and a lightbox]
         *  This example demonstrates how to pass data from a page to a lightbox that
         *  it opens and from the lightbox back to the page as it closes.
         *
         *  It assumes that the page has:
         *
         *  + An open button that is used to open the lightbox.
         *  + Two text inputs where information that is to be passed to the lightbox is entered.
         *  + Two text elements where information that is passed from the lightbox is displayed.
         *
         *
         *  It assumes that the lightbox has:
         *
         *  + An close button that is used to close the lightbox.
         *  + Two text inputs where information that is to be passed to the page is entered.
         *  + Two text elements where information that is passed from the page is displayed.
         * @param {external:Object} [data] The data to pass back to [`openLightbox()`](wix-window.html#openLightbox) function.
         * @memberof wix-window.lightbox
         */

    }, {
        key: 'close',
        value: function close(returnedData) {
            var contextId = _platformUtils2.default.getRGI().getContextId();
            var popups = _platformUtils2.default.getRMI('wix-window.lightbox.close').getSiteStructure().lightboxes;
            if (!_lodash2.default.find(popups, { id: contextId })) {
                _reporter2.default.reportSdkError('The current page is not a lightbox and therefore cannot be closed');
                return;
            }
            _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                command: _postMessage.MessageTypes.CLOSE_LIGHTBOX,
                data: {
                    id: contextId,
                    returnedData: returnedData
                },
                appDefinitionId: members._appDefId.get(this)
            });
        }
    }]);

    return Lightbox;
}();

var RenderingContext = function () {
    function RenderingContext() {
        _classCallCheck(this, RenderingContext);
    }

    _createClass(RenderingContext, [{
        key: 'renderCycle',

        /**
         * @member renderCycle
         * @label property
         * @syntax
         * get renderCycle(): Number
         * @summary **Deprecated:** Gets the current cycle in the rendering process.
         * @description
         *  **Deprecation note:** The `renderCycle` property no longer works as expected.
         *  It will always return `1`.
         * @type {external:Number}
         * @memberof wix-window.rendering
         * @readonly
         **/
        get: function get() {
            return Number(_platformUtils2.default.getQueryParameter("renderCycle")) || NaN;
        }

        /**
         * @member env
         * @label property
         * @syntax
         * get env(): String
         * @summary Gets the current environment the rendering process is running in.
         * @description
         *  When possible, the rendering process is split in two in order to
         *  improve performance. The first cycle in the process happens server-side
         *  and the second cycle happens client-side. When not possible, all rendering
         *  happens client-side.
         *
         *  The `env` property returns `"backend"` when rendering on the server
         *  and `"browser"` when rendering on the client.
         *
         *  Use the `env` property in your page's [`onReady()`]($w.html#onReady)
         *  event handler to control where your code runs during the rendering
         *  process and to prevent code that causes side effects from running twice.
         * @note
         *  Rendering never occurs server-side when previewing your site.
         * @snippet [$w-onReady-env.es6=Use the Rendering API to avoid inserting an item twice]
         *  This example demonstrates how to make sure a collection insertion in the `onReady` 
         *  event handler occurs only once.
         * @type {external:String}
         * @memberof wix-window.rendering
         * @readonly
         **/

    }, {
        key: 'env',
        get: function get() {
            return _platformUtils2.default.getEnv();
        }

        /**
         * @member warmupData
         * @label property
         * @syntax
         * get warmupData(): Boolean | Number | String | Object
         * @summary **Deprecated:** Gets data sent from server-side code to client-side code.
         * @description
         *  **Deprecation note:** The `warmupData` property can no longer be used in a reliable
         *  manner.
         * 
         *  When possible, the rendering process is split in two in order to
         *  improve performance. The first cycle in the process happens server-side
         *  and the second cycle happens client-side. When not possible, all rendering
         *  happens client-side.
         *
         *  Pass data from the server-side cycle to the client-side cycle by
         *  returning the data from the [`onReady()`]() function when it is run server-side.
         *  Then retrieve that data client-side by getting the value of the
         *  `warmupData` property.
         * @note
         *  Rendering never occurs server-side when previewing your site.
         * @type {external:Boolean|external:Number|external:String|external:Object}
         * @memberof wix-window.rendering
         * @readonly
         **/

    }, {
        key: 'warmupData',
        get: function get() {
            var uw = _platformUtils2.default.getQueryParameter("userWarmup");
            return uw && uw['wix-code'];
        }
    }]);

    return RenderingContext;
}();

var Window = function () {
    function Window(appDefId) {
        _classCallCheck(this, Window);

        members._appDefId.set(this, appDefId);
        this.portData = {
            port: null,
            callbacks: [],
            requestInPorcess: false
        };
        this._multilingual = new _multilingual2.default(appDefId);
        _lodash2.default.bindAll(this, ['scrollTo', 'getBoundingRect', 'getCurrentGeolocation', 'openLightbox', 'openModal', 'postMessage', 'getContainerPort']);
    }

    /**
     * @namespace wix-window.rendering
     * @summary The Rendering API is used to control when code is run as a page is being loaded.
     * @description
     *  When possible, the rendering process that runs when your page loads is
     *  split in two in order to improve performance. The first cycle in the process
     *  happens server-side and the second cycle happens client-side. When not
     *  possible, all rendering happens client-side.
     *
     *  Use the Rendering API to track when and where your code is running to
     *  selectively run parts of your code in certain conditions.
     *
     *  To use the Rendering API, import `wixWindow` from the `wix-window` module:
     *
     *    ```javascript
     *    import wixWindow from 'wix-window';
     *    ```
     */


    _createClass(Window, [{
        key: 'getBoundingRect',


        /**
         * @typedef {external:Object} wix-window~WindowSizeInfo
         * @summary An object returned by the `getBoundingRect()` function that contains information about the window's size, the document's size, and the current scroll position.
         * @property {external:Object} window An object with `height` and `width` key:value pairs containing the size of the viewable area of the current browser window.
         * @property {external:Object} document An object with `height` and `width` key:value pairs containing the size of the actual body of the page, which may be larger or smaller than the current window.
         * @property {external:Object} scroll An object with `x` and `y` key:value pairs containing the scroll offset of the page within the window from the top-left corner.
         * @snippet [Window-getBoundingRect.es6=Get information about the window]
         * @see [getBoundingRect( )](#getBoundingRect)
         */

        /**
         * @function getBoundingRect
         * @syntax
         * function getBoundingRect(): Promise<WindowSizeInfo>
         * @summary Returns information about the window.
         * @description
         *  The `getBoundingRect()` function returns a Promise that resolves to an object
         *  containing information about the current window's size, the document's size,
         *  and the current scroll position.
         * @returns {Promise}
         * @fulfill {wix-window~WindowSizeInfo} An object containing information about the window's size, the document's size, and the current scroll position.
         * @snippet [Window-getBoundingRect.es6=Get information about the window]
         * @memberof wix-window
         */
        value: function getBoundingRect() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                    command: _postMessage.MessageTypes.WINDOW_BOUNDING_RECT,
                    appDefinitionId: members._appDefId.get(_this),
                    callback: callback
                });
            });
        }

        /**
         * @typedef {external:Object} wix-window~ScrollToOptions
         * @summary An object used for providing options for the `scrollTo()` method.
         * @property {external:Boolean} scrollAnimation Indicates whether to scroll with an animation. Defaults to `true`.
         * @snippet [Window-scrollTo_without_animation=Scroll the page to a location without an animation]
         * @see [scrollTo( )](#scrollTo)
         */

        /**
         * @function scrollTo
         * @summary Scrolls the page to a specific location.
         * @description
         *  The `scrollTo()` function returns a Promise that resolves when the current
         *  page has been scrolled to the given location.
         *
         *  The `x` and `y` parameters determine the top-left pixel that is
         *  displayed on screen after the scroll.
         *
         *  To scroll to a specific element on the page, see the `$w.Node`
         *  [`scrollTo()`]($w.Node.html) function.
         * 
         *  Use the `options` parameter to specify the options to use when scrolling.
         * @snippet [Window-scrollTo.es6=Scroll the page to a location]
         * @snippet [Window-scrollTo_then.es6=Scroll the page to a location and log message when done]
         * @snippet [Window-scrollTo_without_animation=Scroll the page to a location without an animation]
         * @param {external:Number} x The horizontal position, in pixels, to scroll to.
         * @param {external:Number} y The vertical position, in pixels, to scroll to.
         * @param {wix-window~ScrollToOptions} [options] Scrolling options.
         * @returns {Promise}
         * @fulfill {void} When the scroll is complete.
         * @memberof wix-window
         */

    }, {
        key: 'scrollTo',
        value: function scrollTo(x, y, options) {
            var _this2 = this;

            var validtionObj = {};
            if (!_lodash2.default.isNil(x)) {
                validtionObj.x = x;
            }
            if (!_lodash2.default.isNil(y)) {
                validtionObj.y = y;
            }
            if (!_lodash2.default.isNil(options)) {
                validtionObj.options = options;
            }
            return new Promise(function (resolve, reject) {
                if (!(0, _validation.validate)({
                    compType: 'Window',
                    functionName: 'scrollTo',
                    dataToValidate: validtionObj
                })) {
                    reject({});
                    return;
                }
                var args = { x: x, y: y, scrollAnimation: _lodash2.default.get(options, 'scrollAnimation', true), requiresDom: { compId: WINDOW_COMP_ID } };
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                    command: _postMessage.MessageTypes.SCROLL_TO,
                    data: args,
                    appDefinitionId: members._appDefId.get(_this2),
                    callback: callback
                });
            });
        }

        /**
         * @function scrollBy
         * @syntax
         * function scrollBy(x: Number, y: Number): Promise<void>
         * @summary Scrolls the page by a given number of pixels.
         * @description
         *  The `scrollBy()` function returns a Promise that resolves when the current
         *  page has been scrolled by the given number of pixels,
         *
         *  The `x` and `y` parameters determine the number of horizontal and vertical
         *  pixels to scroll the current page. Negative numbers scroll up or to the
         *  left and positive numbers scroll down or to the right.
         * @snippet [Window-scrollBy.es6=Scroll the page by a given number of pixels]
         * @snippet [Window-scrollBy_then.es6=Scroll the page by a given number of pixels and log message when done]
         * @param {external:Number} x The horizontal offset, in pixels, to scroll by.
         * @param {external:Number} y The vertical offset, in pixels, to scroll by.
         * @returns {Promise}
         * @fulfill {void} When the scroll is complete.
         * @memberof wix-window
         */

    }, {
        key: 'scrollBy',
        value: function scrollBy(x, y) {
            var _this3 = this;

            if (_lodash2.default.isNil(x)) {
                x = 0;
            }
            if (_lodash2.default.isNil(y)) {
                y = 0;
            }
            return new Promise(function (resolve, reject) {
                var args = { x: x, y: y, requiresDom: { compId: WINDOW_COMP_ID } };
                if (!(0, _validation.validate)({
                    compType: 'Window',
                    functionName: 'scrollBy',
                    dataToValidate: { x: x, y: y }
                })) {
                    reject({});
                    return;
                }
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                    command: _postMessage.MessageTypes.SCROLL_BY,
                    data: args,
                    appDefinitionId: members._appDefId.get(_this3),
                    callback: callback });
            });
        }

        /**
         * @function getRouterData
         * @syntax
         * function getRouterData(): Object
         * @summary Returns the data that a router passed to the page in its response.
         * @returns {external:Object} The data returned by the router.
         * @description
         *  When you create a router and define its functionality in its [router()](wix-router.html#router)
         *  function, you can choose to send data along with the router's [response](wix-router.WixRouterResponse.html).
         *  That data is retrieved in the code of the page that was routed to using the
         *  `getRouterData()` function.
         *
         *  If you call the `getRouterData()` function from a non-router page or a router
         *  page that wasn't sent any data, the function returns `null`.
         * @memberof wix-window
         * @snippet [Window-getRouterData.es6=Get the data passed by a router]
         * @see [router( )](wix-router.html#router)
         * @see [WixRouterResponse](wix-router.WixRouterResponse.html)
         */

    }, {
        key: 'getRouterData',
        value: function getRouterData() {
            var appDefinitionId = members._appDefId.get(this);
            return self.routerData || _platformUtils2.default.getRGI().getRouterData(appDefinitionId) || null;
        }

        /**
         * @function getCurrentGeolocation
         * @syntax
         * function getCurrentGeolocation(): Promise<Object>
         * @summary Returns the current geolocation of the user.
         * @description
         *  The `getCurrentGeolocation()` function returns a Promise that resolves to an
         *  object containing the current geolocation of the user.
         *
         *  The object contains the following key:value pairs:
         *
         *  + `"timestamp"`: The geolocation timestamp representing the date and time at which the location was retrieved.
         *  + `"coords"`: An object that defines the location.
         *    + `"latitude"`: The position's latitude in decimal degrees.
         *    + `"longitude"`: The position's longitude in decimal degrees.
         *    + `"altitude"`: The position's altitude in metres, relative to sea level. This value may be null if the browser cannot provide the data.
         *    + `"accuracy"`: The accuracy in meters of the latitude and longitude properties.
         *    + `"altitudeAccuracy"`: The accuracy in meters of the altitude property. This value may be null.
         *    + `"heading"`: The direction in degrees in which the device is traveling. It indicates how far off from heading true north the device is. If `speed` is `0`, the heading is `NaN`. This value may be null if the browser cannot provide the data.
         *    + `"speed"`: The velocity in meters per second of the device. This value may be null if the browser cannot provide the data.
         *
         *
         * @note
         *  The `getCurrentGeolocation()` function has the following limitiations:
         *
         *  + On Chrome, the function only works on HTTPS sites.
         *  + On Chrome, Firefox, and Safari, the function only works if the user
         *    approves a popup.
         * @snippet [Window-getCurrentGeolocation.es6=Get the geolocation data]
         * @returns {Promise}
         * @fulfill {external:Object} The coordinates and timestamp of the current location.
         * @reject {String} The user blocked the geolocation popup.
         * @memberof wix-window
         */

    }, {
        key: 'getCurrentGeolocation',
        value: function getCurrentGeolocation() {
            var _this4 = this;

            return new Promise(function (resolve, reject) {
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                    command: _postMessage.MessageTypes.GET_CURRENT_GEOLOCATION,
                    appDefinitionId: members._appDefId.get(_this4),
                    callback: callback
                });
            });
        }

        /**
         * @function openLightbox
         * @syntax
         * function openLightbox(name: String[, data: Object]): Promise<Object>
         * @summary Opens a lightbox and optionally passes it the given data.
         * @description
         *  The `openLightbox()` function returns a Promise which is resolved when the
         *  lightbox closes. If the lightbox is closed programmatically using its
         *  [`close()`](wix-window.lightbox.html#close) function, and the
         *  [`close()`](wix-window.lightbox.html#close) function was invoked
         *  with a data parameter, then the Promise resolves to that data object.
         *
         *  If you send a data object to the lightbox, use the [`getContext()`](wix-window.lightbox.html#getContext)
         *  function in the lightbox's code to access the received data.
         *
         *  To pass data to the lightbox that is opened, you must open the lightbox
         *  programmatically using the [`openLightbox()`](wix-window.html#openLightbox)
         *  function. If the lightbox is opened automatically when the page loads or
         *  by a link from a page element, data will not be passed to the lightbox.
         *  Therefore, if you want to pass data to the lightbox, make sure
         *  **Automatically display lightbox on pages** is <a href="https://support.wix.com/en/article/setting-which-page-your-lightbox-appears-on" target="_blank">set</a> to **No** in the
         *  **Lightbox Settings** panel in the Editor and don't set any element's link
         *  to open the lightbox. Instead, create your own method for opening
         *  the lightbox programmatically. For example, you can add a button with an `onClick` event
         *  handler that calls the [`openLightbox()`](wix-window.html#openLightbox) function.
         *
         *  To pass data back to the page that opened the lightbox, you must close the
         *  lightbox programmatically using the `close()` function. If the lightbox is
         *  closed by the site visitor clicking the 'X' icon, close button, or lightbox
         *  overlay, data will not be passed back the the page that opened the lightbox.
         *  Therefore, if you want to make sure data is passed back to the page that
         *  opened the lightbox, <a href="https://support.wix.com/en/article/setting-how-your-lightbox-is-closed" target="_blank">disable
         *  all of the methods mentioned above</a> and create your own method for closing
         *  the lightbox programmatically. For example, you can add a button with an `onClick` event
         *  handler that calls the `close()` function.
         * @note
         *  Use the name of the lightbox and not the lightbox's ID when calling
         *  `openLightbox()`.
         * @snippet [Window-openLightbox.es6=Open a lightbox]
         * @snippet [Window-openLightbox_options.es6=Open a lightbox and send it data]
         * @snippet [Window-openLightbox_then.es6=Open a lightbox and receive data when it is closed]
         * @snippet [Window-openLightbox_options_then.es6=Open a lightbox, send it data, and receive data back when it is closed]
         * @snippet [Lightbox-scenario.es6=A scenario where information is passed between a page and a lightbox]
         *  This example demonstrates how to pass data from a page to a lightbox that
         *  it opens and from the lightbox back to the page as it closes.
         *
         *  It assumes that the page has:
         *
         *  + An open button that is used to open the lightbox.
         *  + Two text inputs where information that is to be passed to the lightbox is entered.
         *  + Two text elements where information that is passed from the lightbox is displayed.
         *
         *
         *  It assumes that the lightbox has:
         *
         *  + An close button that is used to close the lightbox.
         *  + Two text inputs where information that is to be passed to the page is entered.
         *  + Two text elements where information that is passed from the page is displayed.
         * @param {external:String} name The name of the lightbox to open.
         * @param {external:Object} [data] The data to pass to the lightbox.
         * @returns {external:Promise}
         * @fulfill {external:Object} The returned data from the lightbox.
         * @reject {external:Error} The error that caused the rejection.
         * @memberof wix-window
         * @see [openModal( )](#openModal)
         */

    }, {
        key: 'openLightbox',
        value: function openLightbox(name, data) {
            var _this5 = this;

            return new Promise(function (resolve, reject) {
                var isValid = (0, _validation.validate)({
                    compType: 'Lightbox',
                    functionName: 'openLightbox',
                    dataToValidate: { name: name }
                });
                if (!isValid) {
                    return reject('Lightbox title is not a valid input');
                }
                var popups = _platformUtils2.default.getRMI('wix-window.openLightbox').getSiteStructure().lightboxes;
                var popupInfo = _lodash2.default.find(popups, { name: name });

                if (!_lodash2.default.has(popupInfo, 'id')) {
                    return reject('There is no lightbox with the title "' + name + '".');
                }
                var message = { id: popupInfo.id };
                if (!_lodash2.default.isUndefined(data)) {
                    message.context = data;
                }
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                    command: _postMessage.MessageTypes.OPEN_LIGHTBOX,
                    data: message,
                    appDefinitionId: members._appDefId.get(_this5),
                    callback: callback
                });
            });
        }

        /**
         * @namespace wix-window.trackingParameters
         * @summary Objects used when calling the [`trackEvent()`](wix-window.html#trackEvent) function.
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~AddPaymentInfoEvent
         * @summary An object used when sending an AddPaymentInfo track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [option] - Describes option information on a checkout page, such as selected payment method.
         * @snippet [Window-trackEvent-AddPaymentInfo.es6=Send an AddPaymentInfo trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~AddProductImpressionEvent
         * @summary An object used when sending an AddProductImpression track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {wix-window.trackingParameters~AddProductImpressionEventContents[]} contents Product information.
         * @snippet [Window-trackEvent-AddProductImpression.es6=Send an AddProductImpression trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~AddProductImpressionEventContents
         * @summary An object used when sending an AddProductImpression track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [list] - List or collection the product is in.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @snippet [Window-trackEvent-AddProductImpression.es6=Send an AddProductImpression trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~AddToCartEvent
         * @summary An object used when sending an AddToCart track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @property {external:Number} [quantity] - Product quantity.
         * @snippet [Window-trackEvent-AddToCart.es6=Send an AddToCart trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~CheckoutStepEvent
         * @summary An object used when sending an CheckoutStep track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [step] - Checkout step number. Be sure to report
         *  consistent step values. For example, use `3` when this step follows
         *  `StartPayment` and `AddPaymentInfo` events.
         * @property {external:String} [action] - Action the visitor has taken, such as `"Select shipping"`.
         * @property {external:String} [option] - Describes option information on a checkout page, such as selected payment method.
         * @snippet [Window-trackEvent-CheckoutStep.es6=Send an CheckoutStep trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~ClickProductEvent
         * @summary An object used when sending a ClickProduct track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [list] - List or collection the product is in.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @snippet [Window-trackEvent-ClickProduct.es6=Send a ClickProduct trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~CustomEvent
         * @summary An object used when sending a CustomEvent track event.
         * @description
         *  The object contains one required property, `event`, and any number of
         *  custom properties.
         *
         *  When sending a custom event to Google Analytics, include following parameters:
         *
         *  + `eventCategory`: string: object that was interacted with
         *  + `eventAction`: string: type of interaction
         *  + `eventLabel` (optional): string: event category
         *  + `eventValue` (optional): integer: numeric value associated with the event
         * @property {external:String} event - Product ID.
         * @snippet [Window-trackEvent-CustomEvent.es6=Send a CustomEvent trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~InitiateCheckoutEvent
         * @summary An object used when sending an InitiateCheckout track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {wix-window.trackingParameters~InitiateCheckoutEventContents[]} contents Product information.
         * @snippet [Window-trackEvent-InitiateCheckout.es6=Send an InitiateCheckout trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~InitiateCheckoutEventContents
         * @summary An object used when sending an InitiateCheckout track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:Number} [quantity] - Product quantity.
         * @snippet [Window-trackEvent-InitiateCheckout.es6=Send an InitiateCheckout trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~PurchaseEvent
         * @summary An object used when sending a Purchase track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [affiliation] - Name of the store where the event occurred.
         * @property {external:Number} [revenue] - Total amount of the purchase including shipping, taxes, etc.
         * @property {external:Number} [tax] - Total tax charge.
         * @property {external:Number} [shipping] - Total shipping charge.
         * @property {external:String} [coupon] - Coupon code applied to the transaction.
         * @property {wix-window.trackingParameters~PurchaseEventContents[]} contents Product information.
         * @snippet [Window-trackEvent-Purchase.es6=Send a Purchase trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~PurchaseEventContents
         * @summary An object used when sending an Purchase track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} name - Product name.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:Number} [quantity] - Product quantity.
         * @snippet [Window-trackEvent-Purchase.es6=Send a Purchase trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~RemoveFromCartEvent
         * @summary An object used when sending a RemoveFromCart track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @property {external:Number} [quantity] - Product quantity.
         * @snippet [Window-trackEvent-RemoveFromCart.es6=Send a RemoveFromCart trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~StartPaymentEvent
         * @summary An object used when sending an StartPayment track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [option] - Describes option information on a checkout page, such as selected payment method.
         * @snippet [Window-trackEvent-StartPayment.es6=Send a StartPayment trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window.trackingParameters~ViewContentEvent
         * @summary An object used when sending a ViewContent track event.
         * @property {external:String} [origin] - Origin of the event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [list] - List or collection the product is in.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @snippet [Window-trackEvent-ViewContent.es6=Send a ViewContent trackEvent]
         * @see [trackEvent( )](wix-window.html#trackEvent)
         */

        /**
         * @function trackEvent
         * @syntax
         * function trackEvent(eventName: TrackEvent, parameters: trackingParameters): void
         * type TrackEvent = "AddPaymentInfo" | "AddProductImpression"
         * | "AddToCart" | "CheckoutStep" | "ClickProduct" | "CustomEvent"
         * | "InitiateCheckout" | "Lead" | "Purchase" | "RemoveFromCart"
         * | "StartPayment" | "ViewContent"
         * type trackingParameters = AddPaymentInfoEvent
         * | AddProductImpressionEvent | AddToCartEvent | CheckoutStepEvent
         * | ClickProductEvent | CustomEvent | InitiateCheckoutEvent
         * | PurchaseEvent | RemoveFromCartEvent | StartPaymentEvent
         * | ViewContentEvent
         * @summary Sends a tracking event to external analytics tools.
         * @description
         *  The `trackEvent()` function sends an event to analytics tools connected
         *  to your site. It can send events to Google Analytics and Facebook Pixel.
         *  To learn how to connect analytics tools to your site, see
         *  [About Tracking Tools & Analytics](https://support.wix.com/en/article/about-tracking-tools-analytics).
         *
         *  The following events and parameters are available:
         *
         *  + `"AddProductImpression"`: [parameters](wix-window.trackingParameters.html#AddProductImpressionEvent): When a user views a product. (Google Analytics only)
         *  + `"ClickProduct"`: [parameters](wix-window.trackingParameters.html#ClickProductEvent): When a user clicks on a product. (Google Analytics only)
         *  + `"ViewContent"`: [parameters](wix-window.trackingParameters.html#ViewContentEvent): When a key page is viewed.
         *  + `"AddToCart"`: [parameters](wix-window.trackingParameters.html#AddToCartEvent): When a user adds a product to the shopping cart.
         *  + `"RemoveFromCart"`: [parameters](wix-window.trackingParameters.html#RemoveFromCartEvent): When a user removes a product from the shopping cart. (Google Analytics only)
         *  + `"InitiateCheckout"`: [parameters](wix-window.trackingParameters.html#InitiateCheckoutEvent): When a user starts the checkout process.
         *  + `"StartPayment"`: [parameters](wix-window.trackingParameters.html#StartPaymentEvent): When a user starts the payment process. (Google Analytics only)
         *  + `"AddPaymentInfo"`: [parameters](wix-window.trackingParameters.html#AddPaymentInfoEvent): When a user saves payment information.
         *  + `"CheckoutStep"`: [parameters](wix-window.trackingParameters.html#CheckoutStepEvent): When a user completes a custom checkout step. (Google Analytics only)
         *  + `"Purchase"`: [parameters](wix-window.trackingParameters.html#PurchaseEvent): When the checkout process is complete.
         *  + `"Lead"`: When a user subscribes to a newsletter or submits a contact form.
         *  + `"CustomEvent"`: [parameters](wix-window.trackingParameters.html#CustomEvent): When a user performs an event not listed above.
         *
         *
         * @note
         *  The `trackEvent()` function only runs on published versions of your site.
         *  It does not work when previewing your site.
         * @snippet [Window-trackEvent-ViewContent.es6=Send a trackEvent with parameters]
         * @snippet [Window-trackEvent-Lead.es6=Send a trackEvent that doesn't take any parameters]
         * @snippet [Window-trackEvent-onReady.es6=Send a trackEvent from the onReady event handler]
         * @param {external:String} eventName The name of the event.
         * @param {wix-window.trackingParameters~AddPaymentInfoEvent | wix-window.trackingParameters~AddProductImpressionEvent | wix-window.trackingParameters~AddToCartEvent | wix-window.trackingParameters~ClickProductEvent | wix-window.trackingParameters~CustomEvent | wix-window.trackingParameters~InitiateCheckoutEvent | wix-window.trackingParameters~PurchaseEvent | wix-window.trackingParameters~RemoveFromCartEvent | wix-window.trackingParameters~ViewContentEvent} parameters The event's parameters.
         * @memberof wix-window
         */

    }, {
        key: 'trackEvent',
        value: function trackEvent(eventName, data, options) {
            if (this.rendering.env === 'backend') {
                return;
            }

            var validtionObj = { data: data, options: options };
            if (!_lodash2.default.isNil(eventName)) {
                validtionObj.eventName = eventName;
            }
            if (!(0, _validation.validate)({
                compType: 'trackEvent',
                functionName: 'trackEvent',
                dataToValidate: validtionObj,
                shouldCheckMandatoryFields: true
            })) {
                return;
            }

            var message = { eventName: eventName };
            if (!_lodash2.default.isNil(data)) {
                message.params = data;
            }
            if (!_lodash2.default.isNil(options)) {
                message.options = options;
            }
            _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                command: _postMessage.MessageTypes.TRACK_EVENT,
                data: message,
                appDefinitionId: members._appDefId.get(this)
            });
        }

        /**
         * @typedef {external:Object} wix-window~OpenModalOptions
         * @summary An object used when opening a modal window.
         * @property {external:Number} width - Width of the modal window.
         * @property {external:Number} height - Height of the modal window.
         * @snippet [Window-openModal.es6=Open a modal window]
         * @see [openModal( )](#openModal)
         */

        /**
         * @function openModal
         * @syntax
         * function openModal(url: String, options: OpenModalOptions): Promise<void>
         * @summary Opens a modal window that displays the specified web page.
         * @description
         *  A modal window displays the page specified by the `url` property over
         *  your current page. Unlike a [lightbox](wix-window.lightbox.html), which
         *  is opened using the [`openLightbox()`](#openLightbox) function, the window
         *  opened by `openModal()` is not part of your site structure.
         *
         *  Only one modal window can be open at any given time. Therefore, opening
         *  a modal window closes an already open modal window if there is one.
         * @note
         *  The specified `url` must be an HTTPS URL. To use an HTTP URL, [turn off
         *  SSL for your site](https://support.wix.com/en/article/turning-ssl-on-or-off-for-your-site).
         * @snippet [Window-openModal.es6=Open a modal window]
         * @snippet [Window-openModal_then.es6=Open a modal window and log a message when it is closed]
         * @param {external:String} url The URL of the page to show in the modal window.
         * @param {wix-window~OpenModalOptions} options The options used for the modal window.
         * @returns {external:Promise}
         * @fulfill {void} When the modal window is closed.
         * @reject {external:Error} The error that caused the rejection.
         * @memberof wix-window
         * @see [openLightbox( )](#openLightbox)
         */

    }, {
        key: 'openModal',
        value: function openModal(url, options, compId) {
            var _this6 = this;

            return new Promise(function (resolve, reject) {
                var isValid = (0, _validation.validate)({
                    compType: 'modal',
                    functionName: 'openModal',
                    dataToValidate: { url: url, options: options },
                    shouldCheckMandatoryFields: true
                });
                if (!isValid) {
                    return reject('Modal arguments are not defined correctly');
                }

                if (!urlUtils.isValidProtocol(url, _platformUtils2.default.getRGI())) {
                    return reject('Mix protocol is not allowed. Modal url protocol is http, and the page is https');
                }

                var width = options.width,
                    height = options.height,
                    theme = options.theme;

                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                    command: _postMessage.MessageTypes.OPEN_MODAL,
                    data: {
                        url: url,
                        width: width,
                        height: height,
                        theme: theme,
                        compId: compId
                    },
                    appDefinitionId: members._appDefId.get(_this6),
                    callback: callback
                });
            });
        }

        /**
         * @function postMessage
         * @syntax
         * function postMessage(message: Object[, target: String]): void
         * @summary Sends a message to the page's parent.
         * @description
         *  If a page is embedded within another site, using an [HtmlComponent]($w.HtmlComponent.html)
         *  on a Wix site or an [iframe](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe)
         *  on a non-Wix site, you can use the `postMessage()` function to send a
         *  message from the inner site to the outer site.
         *
         *  When the parent site is a Wix site, use the [`onMessage()`]($w.HtmlComponent.html#onMessage)
         *  function to receive the message on the parent page.
         *
         *  When the parent site is a non-Wix site, use the page's `window.onmessage`
         *  event handler to read the `data` property of the received `MessageEvent`
         *  to receive the message on the parent page.
         * @snippet [Window-postMessage_wix.es6=Send a message to a Wix parent site]
         * @snippet [Window-postMessage_nonwix.es6=Send a message to a non-Wix parent site]
         * @param {external:Object} message The message to send.
         * @param {external:String} [target] The target to send the message to. Must be `"parent"` or omitted. Defaults to `"parent"`.
         * @returns {external:Promise}
         * @fulfill {external:Object} The data returned from the modal window.
         * @reject {external:Error} The error that caused the rejection.
         * @memberof wix-window
         */

    }, {
        key: 'postMessage',
        value: function postMessage(payload, target) {
            var appDefinitionId = members._appDefId.get(this);
            if (!(0, _validation.validate)({
                compType: 'Window',
                functionName: 'postMessage',
                dataToValidate: { payload: payload, target: target }
            })) {
                return;
            }
            _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                command: _postMessage.MessageTypes.SEND_MESSAGE_TO_PARENT,
                data: payload,
                appDefinitionId: appDefinitionId
            });
        }
    }, {
        key: 'getContainerPort',
        value: function getContainerPort(appDefId) {
            var _this7 = this;

            return new Promise(function (resolve, reject) {
                var cb = function cb(data, error, ports) {
                    if (error) {
                        reject(error);
                        return;
                    }
                    if (ports) {
                        _this7.portData.port = ports[0];
                        resolve(ports[0]);
                    }
                };
                var appDefinitionId = appDefId || members._appDefId.get(_this7);
                if (!(0, _validation.validate)({
                    compType: 'Window',
                    functionName: 'getContainerPort',
                    dataToValidate: { appDefinitionId: appDefinitionId }
                })) {
                    return;
                }
                if (_this7.portData.port) {
                    resolve(_this7.portData.port);
                    return;
                }
                if (_this7.portData.requestInPorcess) {
                    _this7.portData.callbacks.push(cb);
                    return;
                }
                _this7.portData.requestInPorcess = true;
                var callback = function callback(data, error, ports) {
                    _this7.portData.requestInPorcess = false;
                    cb(data, error, ports);
                    _lodash2.default.forEach(_this7.portData.callbacks, function (callback) {
                        callback(data, error, ports);
                    });
                    _this7.portData.callbacks = [];
                };
                _postMessage.sendMessageToHost(_postMessage.Intent.WIX_CODE_SITE_API, {
                    command: _postMessage.MessageTypes.OPEN_MESSAGE_CHANNEL,
                    data: { appDefinitionId: appDefinitionId },
                    appDefinitionId: appDefinitionId,
                    callback: callback
                });
            });
        }

        /**
         * @namespace wix-window.multilingual
         * @summary The Multilingual API is used when working with the languages in a multilingual site.
         * @description
         *  A multilingual site is a site that is set up to display in more than one
         *  language. To learn more about enabling multilingual functionality in your
         *  site, see <a href="https://support.wix.com/en/article/about-wix-multilingual" target="_blank">About Wix Multilingual</a>.
         *
         *  To use the Multilingual API, import `wixWindow` from the `wix-window` module:
         *
         *    ```javascript
         *    import wixWindow from 'wix-window';
         *    ```
         *
         * The APIs in `wix-window.multilingual` can only be used in front-end code.
         */

    }, {
        key: 'rendering',
        get: function get() {
            return new RenderingContext();
        }

        /**
         * @namespace wix-window.lightbox
         * @summary A <a href="https://support.wix.com/en/article/about-lightboxes" target="_blank">lightbox</a> pops up on your site to grab your visitor's attention.
         * @description
         *  To use the Lightbox API, import `wixWindow` from the `wix-window` module:
         *
         *    ```javascript
         *    import wixWindow from 'wix-window';
         *    ```
         *
         * The APIs in `wix-window.lightbox` can only be used in front-end code.
         */

    }, {
        key: 'lightbox',
        get: function get() {
            var appDefinitionId = members._appDefId.get(this);
            return new Lightbox(appDefinitionId);
        }

        /**
         * @member browserLocale
         * @label property
         * @summary Gets the locale of the site visitor's browser.
         * @description
         *  A locale, also known as an IETF language tag, is an abbreviated code
         *  that defines the language, country, and other aspects of the site 
         *  visitor's browser, such as number format and date format.
         *
         *  Some common locales include:
         *
         *  + `"en-US"`: English, United States
         *  + `"en-GB"`: English, British
         *  + `"es-ES"`: Spanish, Spain
         *  + `"de-DE"`: German, Germany
         *  + `"ja-JP"`: Japanese, Japan
         *  + `"fr-CH"`: French, Switzerland
         *  + `"it-IT"`: Italian, Italy
         * @snippet [Window-browserLocale.es6=Get the locale of a visitor's browser]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         */

    }, {
        key: 'browserLocale',
        get: function get() {
            return _platformUtils2.default.getRGI().getRegionalSettings().browserLocale;
        }

        /**
         * @member viewMode
         * @label property
         * @syntax
         * get viewMode(): "Preview" | "Site" | "Editor"
         * @summary Gets which mode the site is currently being viewed in.
         * @description
         *  The `viewMode` property gets either:
         *
         *  + `"Preview"`: When previewing the site using the **Preview** button in the Editor.
         *  + `"Site"`: When viewing the published site.
         * @snippet [Window-viewMode.es6=Get a window's view mode]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         */

    }, {
        key: 'viewMode',
        get: function get() {
            if (_platformUtils2.default.getRGI().getLivePreviewMode && _platformUtils2.default.getRGI().getLivePreviewMode()) {
                return "Editor";
            }
            return (0, _utils.capitalize)(_platformUtils2.default.getQueryParameter('viewMode'));
        }

        /**
         * @member formFactor
         * @label property
         * @syntax
         * get formFactor(): "Desktop" | "Mobile" | "Tablet"
         * @summary Gets what kind of device is being used to view the page.
         * @description
         *  The `formFactor` property gets one of:
         *
         *  + `"Desktop"`: When viewed in a desktop browser.
         *  + `"Mobile"`: When viewed in a mobile browser.
         *  + `"Tablet"`: When viewed in a tablet browser.
         * @snippet [Window-formFactor.es6=Get a device's form factor]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         */

    }, {
        key: 'formFactor',
        get: function get() {
            var formFactor = _platformUtils2.default.getRGI().getDeviceType() || 'desktop';
            return (0, _utils.capitalize)(formFactor);
        }

        /**
         * @member locale
         * @label property
         * @syntax
         * get locale(): String
         * @summary Gets the locale of the current environment.
         * @description
         *  Deprecation note: The `locale` property is being deprecated. Use the
         *  [`browserLocale`](#browserLocal) property instead.
         * 
         *  A locale, also known as an IETF language tag, is an abbreviated code
         *  that defines the user's language, country, and other aspects of the user
         *  interface such as number format and date format.
         *
         *  Some common locales include:
         *
         *  + `"en-US"`: English, United States
         *  + `"en-GB"`: English, British
         *  + `"es-ES"`: Spanish, Spain
         *  + `"de-DE"`: German, Germany
         *  + `"ja-JP"`: Japanese, Japan
         *  + `"fr-CH"`: French, Switzerland
         *  + `"it-IT"`: Italian, Italy
         * @snippet [Window-locale.es6=Get an environment's locale]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         */

    }, {
        key: 'locale',
        get: function get() {
            return _platformUtils2.default.getQueryParameter("locale");
        }

        /**
         * @member referrer
         * @label property
         * @syntax
         * get referrer(): String
         * @summary Gets the HTTP referrer header field.
         * @description
         *  The `referrer` is the address of the previous web page that the user was
         *  on before arriving at the current page, typically by clicking a link.
         * @note
         *  When visitors move from page to page within your site, the `referrer` property
         *  does not contain the address of the page the visitor came from. This is because
         *  Wix sites are built as <a href="https://en.wikipedia.org/wiki/Single-page_application" target="_blank">single page applications</a>.
         *  To get the previous page a visitor was visiting within your site, you can
         *  use [`wix-storage`](wix-storage.html) to store the visitor's current page
         *  and retrieve the visitor's previous page.
         * @snippet [Window-referrer.es6=Get the referrer information]
         * @snippet [Window-referrer_workaround.es6=Get the previous page within a Wix site]
         *  This example demonstrates how to use session storage to know which page
         *  is the page a site visitor previously visited. The code below needs to be
         *  placed in the **Site** tab so that it runs on all your site's pages. The
         *  code retrieves the URL of the page a visitor previously visited from session
         *  storage. It then stores the URL of the vistor's current page in session
         *  storage. When the visitor navigates to another page, this stored URL is
         *  retrieved as the previous page URL.
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         **/

    }, {
        key: 'referrer',
        get: function get() {
            return _platformUtils2.default.getQueryParameter("referrer");
        }
    }, {
        key: 'multilingual',
        get: function get() {
            return this._multilingual;
        }

        /**
         * @member isEnabled
         * @label property
         * @syntax
         * get isEnabled(): Boolean
         * @summary Gets whether the site has been set up to be shown in multiple languages.
         * @snippet [Multilingual-isEnabled.es6=Get whether the site is set up to be shown in multiple languages]
         * @type {external:Boolean}
         * @memberof wix-window.multilingual
         **/

        /**
         * @member currentLanguage
         * @label property
         * @syntax
         * get currentLanguage(): String
         * set currentLanguage(language: String): void
         * @summary Sets or gets the site's current display language.
         * @description
         *  Setting the `currentLanguage` property changes the site's display language.
         *  The current page is reloaded in the newly set language.
         *
         *  Set the current language using a two-letter language code. The code must
         *  represent one of <a href="https://support.wix.com/en/article/managing-languages-in-a-multilingual-site" target="_blank">the languages set to show on your site</a>.
         *  You can retrieve your site's languages and corresponding language codes using
         *  the [`siteLanguages`](#siteLanguages) property.
         *
         *  Getting the `currentLanguage` property gets the two-letter language code
         *  of the site's current display language.
         * @snippet [Multilingual-currentLanguage_get.es6=Get the site's current display language]
         * @snippet [Multilingual-currentLanguage_set.es6=Set the site's current display language]
         * @snippet [Multilingual-button_toggle.es6=Create a button used to toggle between two languages]
         *  This example assumes you have a site set up to display in both English and
         *  Spanish. It also assumes you have a button with the ID **toggleLanguage**.
         *
         *  An `onClick` event handler is registered for the button. The event handler
         *  checks the site's current language and then sets the site to change to the
         *  other available language.
         * @snippet [Multilingual-dropdown.es6=Create a dropdown used to change between available languages]
         *  This example assumes you have a site set up to display in multiple languages.
         *  It also assumes you have a dropdown element with the ID **languageDropdown**.
         *
         *  When the page loads, the site's available languages are retrieved. Then,
         *  the JavaScript `map()` function is used to change the retrieved language
         *  information into the format expected by the dropdown's `options` property.
         *  Next, the JavaScript `filter()` function is used remove the current language
         *  from the list. Finally, the dropdown's `options` property is set using the
         *  formatted language list.
         *
         *  An `onChange` event handler is registered for the dropdown element. The event
         *  handler changes the site's current language based on the language chosen by
         *  the user.
         * @snippet [Multilingual-filter_dataset.es6=Filter a dataset based on the site's current display language]
         *  This example assumes you have a site set up to display in both English and
         *  Spanish. It also assumes you have a collection that contains data in both
         *  languages. The collection has a **language** field that indicates each item's
         *  language. The following code filters a dataset connected to the collection
         *  so it only contains items that correspond to the site's current language.
         * @type {external:String}
         * @memberof wix-window.multilingual
         **/

        /**
         * @typedef {external:Object} wix-window.multilingual~SiteLanguage
         * @summary An object returned by the `siteLanguages` property that contains information about the site's languages.
         * @property {external:String} name The language's full name.
         * @property {external:String} locale The language's locale code, which represents a set of language-related formatting preferences.
         * @property {external:String} languageCode The language's two-letter code.
         * @property {external:String} countryCode The language's three-letter country code.
         * @property {external:Boolean} isPrimaryLanguage Whether the language is the site's primary language.
         * @snippet [Multilingual-siteLanguages_get.es6=Get information about the site's languages]
         * @snippet [Multilingual-dropdown.es6=Create a dropdown used to change between available languages]
         *  This example assumes you have a site set up to display in multiple languages.
         *  It also assumes you have a dropdown element with the ID **languageDropdown**.
         *
         *  When the page loads, the site's available languages are retrieved. Then,
         *  the JavaScript `map()` function is used to change the retrieved language
         *  information into the format expected by the dropdown's `options` property.
         *  Next, the JavaScript `filter()` function is used remove the current language
         *  from the list. Finally, the dropdown's `options` property is set using the
         *  formatted language list.
         *
         *  An `onChange` event handler is registered for the dropdown element. The event
         *  handler changes the site's current language based on the language chosen by
         *  the user.
         * @see [siteLanguages](#siteLanguages)
         */

        /**
         * @member siteLanguages
         * @syntax
         * function siteLanguages(): SiteLanguage[]
         * @summary Gets information about the site's languages.
         * @description
         * The `siteLanguages` property returns an array of [`SiteLanguage`](#SiteLanguage)
         * objects containing information about all the languages that the site is set
         * to display in.
         * @snippet [Multilingual-siteLanguages_get.es6=Get information about the site's languages]
         * @snippet [Multilingual-dropdown.es6=Create a dropdown used to change between available languages]
         *  This example assumes you have a site set up to display in multiple languages.
         *  It also assumes you have a dropdown element with the ID **languageDropdown**.
         *
         *  When the page loads, the site's available languages are retrieved. Then,
         *  the JavaScript `map()` function is used to change the retrieved language
         *  information into the format expected by the dropdown's `options` property.
         *  Next, the JavaScript `filter()` function is used remove the current language
         *  from the list. Finally, the dropdown's `options` property is set using the
         *  formatted language list.
         *
         *  An `onChange` event handler is registered for the dropdown element. The event
         *  handler changes the site's current language based on the language chosen by
         *  the user.
         * @type {wix-window.multilingual~SiteLanguage[]}
         * @memberof wix-window.multilingual
         */

    }]);

    return Window;
}();

(0, _livePreview.setStageUnfriendlyFunctions)(Window, ['openLightbox', 'openModal', 'scrollTo', 'scrollBy']);
exports.default = Window;

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_platformUtils2.default.setExperiments(self.openExperiments); //eslint-disable-line no-unused-vars

_platformUtils2.default.initMonitoringServices(self.monitoringServices);
_monitoring2.default.initRaven();

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getScopedGlobalApis = exports.ga = exports.onReady = exports.emitter = exports.getStorage = exports.getSelector = exports.core = exports.__INTERNAL__ = exports.window = exports.location = exports.site = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _wixSelector = __webpack_require__(84);

var _wixSelector2 = _interopRequireDefault(_wixSelector);

var _core = __webpack_require__(190);

var core = _interopRequireWildcard(_core);

var _analytics = __webpack_require__(188);

var _analytics2 = _interopRequireDefault(_analytics);

var _namespaces = __webpack_require__(186);

var _namespaces2 = _interopRequireDefault(_namespaces);

var _appsExtendedNamespaces = __webpack_require__(180);

var _appsExtendedNamespaces2 = _interopRequireDefault(_appsExtendedNamespaces);

var _Emitter = __webpack_require__(178);

var _Emitter2 = _interopRequireDefault(_Emitter);

var _Storage = __webpack_require__(179);

var _Storage2 = _interopRequireDefault(_Storage);

var _readyManager = __webpack_require__(51);

var _internalAPIs = __webpack_require__(191);

var _internalAPIs2 = _interopRequireDefault(_internalAPIs);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storage = void 0;
var emitter = new _Emitter2.default();
_platformUtils2.default.setEmitter(emitter);
_platformUtils2.default.setWixSelector(new _wixSelector2.default());
var location = new _namespaces2.default.Location();
var window = new _namespaces2.default.Window();
var site = new _namespaces2.default.Site();
var __INTERNAL__ = new _internalAPIs2.default();

var getStorage = function getStorage(appId, storageValue) {
    if (!storage) {
        storage = new _Storage2.default();
    }
    return storage.createScopedStorage(appId, storageValue);
};
/**
 * @namespace $w
 * @summary The `$w` namespace contains everything you need in order to work
 *  with your site's components. It contains all of the UI elements, nodes, and
 *  events that make up your site. It also includes the [`$w()`]($w.html#w),
 *  [`onReady()`]($w.html#onReady), and [`at()`]($w.html#at) functions.
 *
 *  The APIs in `$w` can only be used in front-end code.
 *
 *  You do not need to import `$w`.
 */

/**
 * @function $w
 * @memberof $w
 * @syntax
 * function $w(selector: string): Element | Element[]
 * @summary Selects and returns elements from a page.
 * @description
 *  The `$w()` function selects single or multiple elements by ID or type.
 *
 *  To select by ID, pass a selector string with the hash symbol
 *  (`#`) followed by the ID of the item you want to select (e.g. `"#myElement"`).
 *  The function returns the selected element object.
 *
 *  To select by type, pass a selector string with the name of
 *  the type without the preceding `#` (e.g. `"Button"`). The function returns
 *  an array of the selected element objects. An array is returned even if one
 *  or no elements are selected.
 *
 *  To select using multiple selectors, pass a selector string with
 *  multiple selectors separated by commas. The selectors in the
 *  comma-separated string can be ID selectors, type selectors, or a mixture of
 *  the two. The function returns an array of the selected element objects.
 *  An array is returned even if one or no elements are selected. If two or more
 *  selectors select the same element, it's still returned only once in the array.
 * @param {external:String} selector A selector or multiple comma-separated selectors.
 * @returns {$w.Element|$w.Element[]} A single selected element or an array of selected elements.
 * @snippet [$w-select_by_name.es6=Select an element using its ID]
 * @snippet [$w-select_by_type.es6=Select elements by type]
 * @snippet [$w-select_images.es6=Select all the images on the page]
 * @snippet [$w-select_combo.es6=Select elements using multiple selectors]
 * @snippet [$w-select_and_run.es6=Hide all the page's images]
 */

/**
 * @callback $w.ReadyHandler
 * @summary Function that runs when all page elements have finished loading.
 * @returns {Promise}
 * @fulfill {void} When the `onReady` function has completed.
 */

/**
 * @function onReady
 * @syntax
   * function onReady(initFunction: ReadyHandler): void
   * callback ReadyHandler(): Promise<void>
 * @summary Sets the function that runs when all the page elements have finished loading.
 * @description
 *  Use the `onReady()` function for code you want to run before the user starts
 *  interacting with your page.
 *
 *  The following code should be placed inside the `onReady()` event handler:
 *
 *  + Initialization of element properties: Example: setting a text element's initial text value.
 *  + Function calls on elements to set their initial state: Example: disabling a button.
 *  + Dynamic event handlers that you want bound when the page loads: Example: setting an event handler to be called when the mouse pointer enters an element.
 *
 *
 *  Static event handlers, those that are wired using the Properties panel
 *  in the Editor, are not placed inside the `onReady()` event handler.
 *
 *  The `onReady()` function in the **Site** tab is called before the
 *  `onReady()` function in the **Page** tab.
 *
 *  The `onReady()` event handler may be called twice during the page rendering
 *  process, once server-side and once client-side.
 *
 * @note
 *  Because `onReady()` code may be run twice, you need to be aware that if your
 *  `onReady()` code causes a side effect, such as inserting an item into a collection,
 *  that side effect might happen twice. To avoid a side effect from happening twice,
 *  use the [`wixWindow.rendering.env`](wix-window.rendering.html#env) to determine 
 *  where your code is being executed.
 * @param {$w.ReadyHandler} initFunction The name of the function or the function expression to run when the page has finished loading.
 * @snippet [$w-onReady-anonymous-long.es6=Run code in an anonymous function when the page loads]
 * @snippet [$w-onReady-promise.es6=Wait for a Promise to resolve]
 *  This example demonstrates the technique of returning a Promise so that the
 *  page doesn't load until the Promise resolves. Here, we wait for the query to
 *  finish and populate a table before displaying the page to users.
 * @snippet [$w-onReady-full.es6=Where to place code]
 *  This example demonstrates which code should be placed inside the `onReady()`
 *  event handler.
 * @snippet [$w-onReady-env.es6=Use the Rendering API to avoid inserting an item twice]
 *  This example demonstrates how to use the `env` property of the Rendering API to
 *  make sure an item is inserted into a collection only once.
 * @see [$w( )](#w)
 * @memberof $w
 */

/**
 * @function at
 * @syntax
 * function at(context: EventContext): Function
 * @summary Gets a selector function for a specific context.
 * @description
 *  The `at()` function returns a scoped selector where the scope is based on the
 *  context property. Usually, you will use `at()` in a event handler that handles
 *  events fired on an element contained in a repeater to get a [selector with
 *  repeated item scope]($w.Repeater.html#repeated-item-scope). The returned function
 *  selects the elements from the same repeater item where the event was fired.
 *
 *  For example, suppose we have a repeater where each item contains an image and
 *  a text element. Here, when an image is clicked, the value of the text element in
 *  the same repeated item is changed to "Selected". All the other text elements
 *  in the other repeated items are not affected.
 *
 *  ```javascript
 *  $w.onReady( function () {
 *    $w("#myRepeatedImage").onClick( (event, $w) => {
 *      let $item = $w.at(event.context)
 *      $item("#myRepeatedText").text = "Selected";
 *    } );
 *  } );
 *  ```
 * @param {$w.Event~EventContext} context An event context.
 * @returns {$w.$w} A selector function for the given context.
 * @memberof $w
 */

var getSelector = function getSelector(controllerId, logName) {
    var $w = _platformUtils2.default.getWixSelector().scoped$W(controllerId, logName);
    _lodash2.default.assign($w, emitter.createScopedEmitter(controllerId));
    $w.onReady = function (callback) {
        (0, _readyManager.onReady)(callback, logName);
    };
    $w.onRender = function (callback) {
        (0, _readyManager.onRender)(callback, logName);
    };
    return $w;
};

var getScopedGlobalApis = function getScopedGlobalApis(appDefId) {
    var apis = {
        location: new _appsExtendedNamespaces2.default.Location(appDefId),
        window: new _appsExtendedNamespaces2.default.Window(appDefId),
        site: new _appsExtendedNamespaces2.default.Site(appDefId),
        events: new _appsExtendedNamespaces2.default.Events(appDefId)
    };

    _lodash2.default.forEach(core.moduleStore.getNamespaces(), function (namespace) {
        var scopedNamespace = core.moduleStore.get(namespace).scopedNamespace;
        if (scopedNamespace) {
            var Module = core.moduleStore.get(namespace).Module;
            apis[scopedNamespace] = new Module(appDefId);
        }
    });

    return apis;
};

self['wix-location'] = location;
self['wix-window'] = window;
self['wix-site'] = site;

exports.site = site;
exports.location = location;
exports.window = window;
exports.__INTERNAL__ = __INTERNAL__;
exports.core = core;
exports.getSelector = getSelector;
exports.getStorage = getStorage;
exports.emitter = emitter;
exports.onReady = _readyManager.onReady;
exports.ga = _analytics2.default;
exports.getScopedGlobalApis = getScopedGlobalApis;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _tinyEmitter = __webpack_require__(219);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var scopeEvent = function scopeEvent(controllerId, event) {
  return controllerId + '_' + event;
};

var Emitter = function () {
  function Emitter() {
    _classCallCheck(this, Emitter);

    this.emitter = new _tinyEmitter2.default();
  }

  _createClass(Emitter, [{
    key: 'createScopedEmitter',
    value: function createScopedEmitter(controllerId) {
      var _this = this;

      // adds a controller id to the name of the event.
      var boundFunc = function boundFunc(func) {
        return _defineProperty({}, func, _this[func].bind(_this, controllerId));
      };

      return ['on', 'off', 'once', 'fireEvent'].reduce(function (acc, funcName) {
        return _lodash2.default.assign(acc, boundFunc(funcName));
      }, {});
    }
  }, {
    key: 'on',
    value: function on(controllerId, event, callback, context) {
      var _this2 = this;

      var scopedEvent = scopeEvent(controllerId, event);
      this.emitter.on(scopedEvent, callback, context);
      return function () {
        return _this2.emitter.off(scopedEvent, callback);
      };
    }
  }, {
    key: 'once',
    value: function once(controllerId, event, callback, context) {
      var _this3 = this;

      var scopedEvent = scopeEvent(controllerId, event);
      this.emitter.once(scopedEvent, callback, context);
      return function () {
        return _this3.emitter.off(scopedEvent, callback);
      };
    }
  }, {
    key: 'off',
    value: function off(controllerId, event, callback) {
      this.emitter.off(scopeEvent(controllerId, event), callback);
    }
  }, {
    key: 'fireEvent',
    value: function fireEvent(controllerId, event) {
      var _emitter;

      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      (_emitter = this.emitter).emit.apply(_emitter, [scopeEvent(controllerId, event)].concat(args));
    }
  }]);

  return Emitter;
}();

exports.default = Emitter;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _errors = __webpack_require__(9);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPES = {
    LOCAL: 'local',
    SESSION: 'session',
    MEMORY: 'memory'
};

var getParsedStoredAppData = function getParsedStoredAppData(type, appId, storageObject) {
    return JSON.parse(_lodash2.default.get(storageObject, [type + 'Storage', appId], '{}'));
};

var updateBrowserStorage = function updateBrowserStorage(type, appId, appDataToStore) {
    postMessage.sendMessageToHost(postMessage.Intent.BROWSER_API, {
        command: postMessage.MessageTypes.SET_TO_STORAGE,
        appDefinitionId: appId,
        data: {
            type: type + 'Storage',
            key: appId,
            value: appDataToStore
        } });
};

/**
 * @namespace wix-storage
 * @summary The wix-storage module contains functionality for the persistent
 *  storage of key/value data in the user's browser.
 * @description
 *  There are three types of storage:
 *
 *  + **Local:** Data in local storage never expires, even if the user closes
 *    your page. When the user reopens the page later, the data can still be
 *    retrieved.
 *
 *  + **Session:** Data in session storage is available while the user's web
 *    session is active. The session ends when the user closes the browser tab
 *    or window. When the session ends, all the data in session storage is lost.
 *    Reloading or restoring the page does not affect session storage data.
 *
 *
 *  To use the Storage API, import the needed storage type(s) from the
 *  `wix-storage` module:
 *
 *    ```javascript
 *    import {local, session} from 'wix-storage';
 *
 *    // Or one of:
 *
 *
 *    import {local} from 'wix-storage';
 *    import {session} from 'wix-storage';
 *    ```
 *
 *  The APIs in `wix-storage` can only be used in front-end code.
 *
 *  Some older browsers may not fully support `wix-storage`. See
 *  <a href="https://developer.mozilla.org/en-US/docs/Web/API/Storage#Browser_compatibility" target=_blank>Browser
 *  compatibility</a> for more information.
 */

/**
 * @member local
 * @syntax import {local} from 'wix-storage';
 * @summary Used for local storage of data.
 * @description Use the methods in [`Storage`](wix-storage.Storage.html) to manage `local` data.
 * @snippet [Storage-setItem_local.es6=Store an item in local storage]
 * @snippet [Storage-getItem_local.es6=Retrieve an item from local storage]
 * @snippet [Storage-removeItem_local.es6=Remove an item from local storage]
 * @snippet [Storage-clear_local.es6=Remove all items from local storage]
 * @type wix-storage.Storage
 * @memberof wix-storage
 */

/**
 * @member session
 * @syntax import {session} from 'wix-storage';
 * @summary Used for session storage of data.
 * @description Use the methods in [`Storage`](wix-storage.Storage.html) to manage `session` data.
 * @snippet [Storage-setItem_session.es6=Store an item in session storage]
 * @snippet [Storage-getItem_session.es6=Retrieve an item from session storage]
 * @snippet [Storage-removeItem_session.es6=Remove an item from session storage]
 * @snippet [Storage-clear_session.es6=Remove all items from session storage]
 * @type wix-storage.Storage
 * @memberof wix-storage
 */

/**
 * @class Storage
 * @summary Used for storing local or session key/value data in the user's browser.
 * @description
 *  To learn more about local and session storage, see [`wix-storage`](wix-storage.html).
 *
 *  To use the Storage API, import the needed storage type(s) from the
 *  `wix-storage` module:
 *
 *    ```javascript
 *    import {local, session} from 'wix-storage';
 *
 *    // Or one of:
 *
 *    import {local} from 'wix-storage';
 *    import {session} from 'wix-storage';
 *    ```
 *
 * @memberof wix-storage
 */
var methods = {

    /**
     * @function setItem
     * @syntax
     * function setItem(key: string, value: string): void
     * @summary Stores an item in local or session storage.
     * @param {external:String} key The key of item to set.
     * @param {external:String} value The value of the item to set.
     * @memberof wix-storage.Storage
     * @snippet [Storage-setItem_local.es6=Store an item in local storage]
     * @snippet [Storage-setItem_session.es6=Store an item in session storage]
     * @see [getItem( )](#getItem)
     */
    setItem: function setItem(type, appId, storageObject, key, value) {
        var newData = _defineProperty({}, String(key), String(value));
        var appDataToStore = JSON.stringify(_lodash2.default.assign({}, getParsedStoredAppData(type, appId, storageObject), newData));

        var maxDataSize = type === 'memory' ? 1000000 : 50000;
        if (appDataToStore.length > maxDataSize) {
            throw new _monitoring2.default.MonitoringErrorToIgnore(_errors.errors.ERROR_STORAGE_MAX_SIZE);
        }
        _lodash2.default.set(storageObject, [type + 'Storage', appId], appDataToStore);
        updateBrowserStorage(type, appId, appDataToStore);
    },

    /**
     * @function getItem
     * @syntax
     * function getItem(key: string): string
     * @summary Gets an item from local or session storage.
     * @param {external:String} key The key of the item to get.
     * @returns {external:String} The retrieved item value.
     * @memberof wix-storage.Storage
     * @snippet [Storage-getItem_local.es6=Retrieve an item from local storage]
     * @snippet [Storage-getItem_session.es6=Retrieve an item from session storage]
     * @see [setItem( )](#setItem)
     */
    getItem: function getItem(type, appId, storageObject, key) {
        var storedAppData = getParsedStoredAppData(type, appId, storageObject);
        return _lodash2.default.get(storedAppData, String(key), null);
    },

    /**
     * @function removeItem
     * @syntax
     * function removeItem(key: string): void
     * @summary Removes an item from local or session storage.
     * @param {external:String} key The key of the item to remove.
     * @memberof wix-storage.Storage
     * @snippet [Storage-removeItem_local.es6=Remove an item from local storage]
     * @snippet [Storage-removeItem_session.es6=Remove an item from session storage]
     * @see [clear( )](#clear)
     */
    removeItem: function removeItem(type, appId, storageObject, key) {
        var storedAppData = getParsedStoredAppData(type, appId, storageObject);
        var appDataToStore = JSON.stringify(_lodash2.default.omit(storedAppData, key));

        _lodash2.default.set(storageObject, [type + 'Storage', appId], appDataToStore);
        updateBrowserStorage(type, appId, appDataToStore);
    },

    /**
     * @function clear
     * @syntax
     * function clear(): void
     * @summary Removes **all** items from local or session storage.
     * @memberof wix-storage.Storage
     * @snippet [Storage-clear_local.es6=Remove all items from local storage]
     * @snippet [Storage-clear_session.es6=Remove all items from session storage]
     * @see [remove( )](#remove)
     */
    clear: function clear(type, appId, storageObject) {
        var appDataToStore = '{}';
        _lodash2.default.set(storageObject, [type + 'Storage', appId], appDataToStore);
        updateBrowserStorage(type, appId, appDataToStore);
    }
};

var createBoundMethod = function createBoundMethod(storageType, appId, storageObject, methodName) {
    return _defineProperty({}, methodName, methods[methodName].bind(null, storageType, appId, storageObject));
};

var buildAPIObject = function buildAPIObject(storageType, appId, storageObject) {
    var methodNames = ['setItem', 'getItem', 'removeItem', 'clear'];
    return methodNames.reduce(function (acc, methodName) {
        return _lodash2.default.assign(acc, createBoundMethod(storageType, appId, storageObject, methodName));
    }, {});
};

var setStorageObject = function setStorageObject(storageObject, storageData) {
    var browserParsedStoredData = JSON.parse(storageData);
    _lodash2.default.set(storageObject, TYPES.LOCAL + 'Storage', _lodash2.default.get(browserParsedStoredData, TYPES.LOCAL));
    _lodash2.default.set(storageObject, TYPES.SESSION + 'Storage', _lodash2.default.get(browserParsedStoredData, TYPES.SESSION));
    _lodash2.default.set(storageObject, TYPES.MEMORY + 'Storage', _lodash2.default.get(browserParsedStoredData, TYPES.MEMORY));
};

var Storage = function () {
    function Storage() {
        _classCallCheck(this, Storage);

        this._storageObject = {};
        setStorageObject(this._storageObject, _platformUtils2.default.getQueryParameter('storage'));
    }

    _createClass(Storage, [{
        key: 'createScopedStorage',
        value: function createScopedStorage(appId, storageValue) {
            var _this = this;

            setStorageObject(this._storageObject, storageValue);
            postMessage.registerEventListener(postMessage.MessageTypes.STORAGE_UPDATE, function (evtData) {
                setStorageObject(_this._storageObject, evtData.storageValue);
            });
            return {
                local: buildAPIObject(TYPES.LOCAL, appId, this._storageObject),
                session: buildAPIObject(TYPES.SESSION, appId, this._storageObject),
                memory: buildAPIObject(TYPES.MEMORY, appId, this._storageObject)
            };
        }
    }]);

    return Storage;
}();

exports.default = Storage;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _appsExtendedLocation = __webpack_require__(182);

var _appsExtendedLocation2 = _interopRequireDefault(_appsExtendedLocation);

var _appsExtendedSite = __webpack_require__(183);

var _appsExtendedSite2 = _interopRequireDefault(_appsExtendedSite);

var _appsExtendedWindow = __webpack_require__(184);

var _appsExtendedWindow2 = _interopRequireDefault(_appsExtendedWindow);

var _appsExtendedEvents = __webpack_require__(181);

var _appsExtendedEvents2 = _interopRequireDefault(_appsExtendedEvents);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appsExtendedNamespaces = {
    Location: _appsExtendedLocation2.default,
    Site: _appsExtendedSite2.default,
    Window: _appsExtendedWindow2.default,
    Events: _appsExtendedEvents2.default
};

exports.default = _lodash2.default.mapValues(appsExtendedNamespaces, function (namespace) {
    return _monitoring2.default.monitorNamespace(namespace);
});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _events = __webpack_require__(187);

var _events2 = _interopRequireDefault(_events);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WIXCODE_APP_DEFINITION = '675bbcef-18d8-41f5-800e-131ec9e08762';

var Events = function (_BaseEvents) {
    _inherits(Events, _BaseEvents);

    function Events(appDefId) {
        _classCallCheck(this, Events);

        var _this = _possibleConstructorReturn(this, (Events.__proto__ || Object.getPrototypeOf(Events)).call(this, appDefId));

        _initialiseProps.call(_this);

        _lodash2.default.bindAll(_this, ['setStaticEventHandlers']);
        return _this;
    }

    return Events;
}(_events2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.setStaticEventHandlers = function (eventHandlers, contextId) {
        var appDefId = members._appDefId.get(_this2);
        if (members._appDefId.get(_this2) === WIXCODE_APP_DEFINITION) {
            if (_platformUtils2.default.isExperimentOpen('sv_moveWixCodeToViewerApp')) {
                _platformUtils2.default.setStaticEventHandlers(eventHandlers, contextId);
            }
        } else {
            var errorMessage = 'app - ' + appDefId + ', should not use events - its for wixCode app only.';
            _reporter2.default.reportSdkError(errorMessage);
        }
    };
};

exports.default = Events;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _location = __webpack_require__(169);

var _location2 = _interopRequireDefault(_location);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _validation = __webpack_require__(3);

var _errors = __webpack_require__(9);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isExternalLink = function isExternalLink(linkData) {
    return _lodash2.default.get(linkData, 'type') === 'ExternalLink';
};

var Location = function (_BaseLocation) {
    _inherits(Location, _BaseLocation);

    function Location(appDefId) {
        _classCallCheck(this, Location);

        var _this = _possibleConstructorReturn(this, (Location.__proto__ || Object.getPrototypeOf(Location)).call(this, appDefId));

        _lodash2.default.bindAll(_this, ['navigateTo']);
        return _this;
    }

    _createClass(Location, [{
        key: 'getExternalUrl',
        value: function getExternalUrl(linkData) {
            if (isExternalLink(linkData)) {
                return linkData.url;
            }
        }
    }, {
        key: 'navigateTo',
        value: function navigateTo(linkData) {
            if (!(0, _validation.validate)({ compType: 'Location', functionName: 'navigateTo', dataToValidate: { linkData: linkData } })) {
                return;
            }
            if (isExternalLink(linkData)) {
                _reporter2.default.reportSdkError(_errors.generateError.error_navigating_to_external_url({ externalUrl: linkData.url }));
                return;
            }

            if (linkData.hasOwnProperty('pageId')) {
                linkData.pageId = linkData.pageId === '#' ? linkData.pageId : linkData.pageId.replace('#', '');
            }

            if (linkData.hasOwnProperty('target')) {
                delete linkData.target;
            }

            postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                command: postMessage.MessageTypes.NAVIGATE_TO,
                appDefinitionId: members._appDefId.get(this),
                data: linkData
            });
        }
    }]);

    return Location;
}(_location2.default);

exports.default = Location;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _validation = __webpack_require__(3);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _utils = __webpack_require__(5);

var _site = __webpack_require__(170);

var _site2 = _interopRequireDefault(_site);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _siteImpl = __webpack_require__(168);

var _siteImpl2 = _interopRequireDefault(_siteImpl);

var _errors = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Site = function (_BaseSite) {
    _inherits(Site, _BaseSite);

    function Site(appDefId) {
        _classCallCheck(this, Site);

        var _this = _possibleConstructorReturn(this, (Site.__proto__ || Object.getPrototypeOf(Site)).call(this, appDefId));

        _lodash2.default.bindAll(_this, ['setPageMetaData', 'onInstanceChanged', 'isAppSectionInstalled', 'notifyEventToEditorApp']);
        return _this;
    }

    _createClass(Site, [{
        key: 'getSiteStructure',
        value: function getSiteStructure() {
            return _siteImpl2.default.getSiteStructure({ includePageId: true });
        }
    }, {
        key: 'getSectionUrl',
        value: function getSectionUrl(sectionIdentifier) {
            var appDefId = members._appDefId.get(this);
            var sectionId = _lodash2.default.get(sectionIdentifier, 'sectionId');
            var isValid = (0, _validation.validate)({
                compType: 'sectionUrl',
                functionName: 'getSectionUrl',
                dataToValidate: { sectionId: sectionId }
            });
            if (!isValid) {
                return null;
            }

            var pages = _platformUtils2.default.getRMI().getSiteStructure().pages;
            var appPages = _lodash2.default.filter(pages, { applicationId: appDefId }, {});
            var page = _lodash2.default.find(appPages, { tpaPageId: sectionId }) || appPages[0];

            if (!page) {
                var errorMessage = 'Page with app "' + appDefId + '" was not found.';
                _reporter2.default.reportSdkError(errorMessage);
                return { error: { message: errorMessage } };
            }

            var baseUrl = _platformUtils2.default.getRGI().getNavigationInfo().baseUrl;
            var contactLink = { url: '' + baseUrl + page.url, relativeUrl: '' + page.url };

            return contactLink;
        }
    }, {
        key: 'getCurrentPageInfo',
        value: function getCurrentPageInfo() {
            var RMI = _platformUtils2.default.getRMI();
            var currentPageId = _platformUtils2.default.getRGI().getNavigationInfo().currentPageId;
            var pages = RMI.getSiteStructure().pages;
            var currentPage = _lodash2.default.find(pages, { id: currentPageId });

            var title = _lodash2.default.get(RMI.getPageData(), 'currentNavigationInfo.title');
            var currentPageInfo = {
                isHomePage: currentPage.isMainPage || false,
                title: title,
                url: currentPage.url
            };

            return currentPageInfo;
        }
    }, {
        key: 'setPageMetaData',
        value: function setPageMetaData(metaData, compId) {
            var _this2 = this;

            var isAllowed = function isAllowed(compId) {
                var RMI = _platformUtils2.default.getRMI();

                var componentData = RMI.getData(compId);
                if (!componentData) {
                    return false;
                }

                var isSection = componentData.type === 'TPA';
                var isMultiSection = componentData.type === 'TPAMultiSection';

                return isSection || isMultiSection;
            };

            return new Promise(function (resolve, reject) {
                if (!isAllowed(compId)) {
                    return reject('Setting a page meta data is possible only from TPA Sections and MultiSections');
                }

                var title = metaData.title,
                    description = metaData.description,
                    jsonLd = metaData.jsonLd,
                    metaTags = metaData.metaTags;

                var appDefId = members._appDefId.get(_this2);
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };

                postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                    command: postMessage.MessageTypes.SET_PAGE_METADATA,
                    data: {
                        compId: compId,
                        appDefId: appDefId,
                        title: title,
                        description: description,
                        jsonLd: jsonLd,
                        metaTags: metaTags
                    },
                    appDefinitionId: appDefId,
                    callback: callback
                });
            });
        }
    }, {
        key: 'onInstanceChanged',
        value: function onInstanceChanged(callback) {
            var RGI = _platformUtils2.default.getRGI();
            var appDefinitionId = members._appDefId.get(this);
            RGI.addOnInstanceChangedCallback(appDefinitionId, callback);
        }
    }, {
        key: 'isAppSectionInstalled',
        value: function isAppSectionInstalled(sectionIdentifier) {
            var validationObj = _extends({ sectionIdentifier: sectionIdentifier }, sectionIdentifier);
            var isValid = (0, _validation.validate)({
                compType: 'sectionIdentifier',
                functionName: 'isAppSectionInstalled',
                dataToValidate: validationObj
            });
            if (!isValid) {
                return null;
            }

            var appDefId = _lodash2.default.get(sectionIdentifier, 'appDefinitionId') || members._appDefId.get(this);
            var sectionId = _lodash2.default.get(sectionIdentifier, 'sectionId');
            var pages = _platformUtils2.default.getRMI().getSiteStructure().pages;

            var page = _lodash2.default.find(pages, { applicationId: appDefId, tpaPageId: sectionId });
            return !_lodash2.default.isUndefined(page);
        }
    }, {
        key: 'getPublicAPI',
        value: function getPublicAPI(appDefinitionId) {
            return new Promise(function (resolve, reject) {
                var RMI = _platformUtils2.default.getRMI();
                var api = RMI.getAppPublicAPI(appDefinitionId);
                if (_lodash2.default.isEmpty(api)) {
                    reject('Error - getPublicAPI of ' + appDefinitionId + ' does not exist or app did not expose a public api');
                } else {
                    resolve(api);
                }
            });
        }
    }, {
        key: 'notifyEventToEditorApp',
        value: function notifyEventToEditorApp(appDefinitionId, eventData) {
            if ((0, _utils.capitalize)(_platformUtils2.default.getQueryParameter('viewMode')) !== 'Preview') {
                _reporter2.default.reportSdkError(_errors.generateError.error_function_exist_only_in_preview({ functionName: 'notifyEventToEditorApp' }));
                return;
            }
            if ((0, _validation.validate)({ compType: 'Site', functionName: 'notifyEventToEditorApp', dataToValidate: { eventData: eventData } })) {
                var appDefinitionIdToSend = appDefinitionId || members._appDefId.get(this);
                postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                    command: postMessage.MessageTypes.NOTIFY_EVENT_TO_EDITOR_APP,
                    data: {
                        eventData: eventData,
                        appDefinitionId: appDefinitionIdToSend
                    },
                    appDefinitionId: appDefinitionIdToSend
                });
            }
        }
    }, {
        key: 'currentPage',
        get: function get() {
            return _siteImpl2.default.getCurrentPage({ includePageId: true });
        }
    }]);

    return Site;
}(_site2.default);

exports.default = Site;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _urlUtils = __webpack_require__(52);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _validation = __webpack_require__(3);

var _window = __webpack_require__(171);

var _window2 = _interopRequireDefault(_window);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _errors = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POPULAR_DESKTOP_HEIGHT = 1067;
var POPULAR_TABLET_HEIGHT = 1024;
var POPULAR_MOBILE_HEIGHT = 900;
var SCREEN_HEIGHT = {
    'Desktop': POPULAR_DESKTOP_HEIGHT,
    'Tablet': POPULAR_TABLET_HEIGHT,
    'Mobile': POPULAR_MOBILE_HEIGHT
};

var Window = function (_BaseWindow) {
    _inherits(Window, _BaseWindow);

    function Window(appDefId) {
        _classCallCheck(this, Window);

        var _this = _possibleConstructorReturn(this, (Window.__proto__ || Object.getPrototypeOf(Window)).call(this, appDefId));

        _lodash2.default.bindAll(_this, ['openPopup', 'openPersistentPopup', 'getComponentViewportState']);
        return _this;
    }

    _createClass(Window, [{
        key: 'openPopup',
        value: function openPopup(url, options, compId) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var appDefId = members._appDefId.get(_this2);
                var isValid = (0, _validation.validate)({
                    compType: 'popup',
                    functionName: 'openPopup',
                    dataToValidate: { url: url, options: options },
                    shouldCheckMandatoryFields: true
                });
                if (!isValid) {
                    return reject('Popup arguments are not defined correctly');
                }

                if (!urlUtils.isValidProtocol(url, _platformUtils2.default.getRGI())) {
                    var errorMessage = 'Mix protocol is not allowed. Popup url protocol is http, and the page is https';
                    _reporter2.default.reportSdkError(errorMessage);
                    return reject(errorMessage);
                }

                var width = options.width,
                    height = options.height,
                    position = options.position,
                    theme = options.theme;

                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                    command: postMessage.MessageTypes.OPEN_POPUP,
                    data: {
                        url: url,
                        width: width,
                        height: height,
                        position: position,
                        theme: theme,
                        compId: compId,
                        appDefId: appDefId,
                        requiresDom: { compId: compId },
                        params: { requireDom: compId }
                    },
                    appDefinitionId: members._appDefId.get(_this2),
                    callback: callback
                });
            });
        }
    }, {
        key: 'openPersistentPopup',
        value: function openPersistentPopup(url, options, compId) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var appDefId = members._appDefId.get(_this3);
                var isValid = (0, _validation.validate)({
                    compType: 'popup',
                    functionName: 'openPersistentPopup',
                    dataToValidate: { url: url, options: options },
                    shouldCheckMandatoryFields: true
                });

                if (!isValid) {
                    return reject('Popup arguments are not defined correctly');
                }

                if (!urlUtils.isValidProtocol(url, _platformUtils2.default.getRGI())) {
                    var errorMessage = 'Mix protocol is not allowed. Popup url protocol is http, and the page is https';
                    _reporter2.default.reportSdkError(errorMessage);
                    return reject(errorMessage);
                }

                var width = options.width,
                    height = options.height,
                    position = options.position,
                    theme = options.theme;

                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                    command: postMessage.MessageTypes.OPEN_PERSISTENT_POPUP,
                    data: {
                        url: url,
                        width: width,
                        height: height,
                        position: position,
                        theme: theme,
                        compId: compId,
                        appDefId: appDefId,
                        requiresDom: { compId: compId },
                        params: { requireDom: compId }
                    },
                    appDefinitionId: members._appDefId.get(_this3),
                    callback: callback
                });
            });
        }
    }, {
        key: 'getComponentViewportState',
        value: function getComponentViewportState(compId) {
            var _this4 = this;

            var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;

            var comp = _platformUtils2.default.getRMI().getComp(compId);
            if (!comp) {
                var errorMessage = _errors.generateError.error_item_not_found({
                    propertyName: 'compId',
                    wrongValue: compId,
                    functionName: 'getComponentViewportState'
                });
                _reporter2.default.reportSdkError(errorMessage);
                return Promise.reject(errorMessage);
            }
            var appDefId = members._appDefId.get(this);

            var _platformUtils$getRGI = _platformUtils2.default.getRGI().getAppData(appDefId),
                applicationId = _platformUtils$getRGI.applicationId;

            if (_lodash2.default.get(comp, 'data.applicationId') !== applicationId.toString()) {
                var _errorMessage = _errors.generateError.error_compId_does_not_exist_for_app({
                    compId: compId,
                    functionName: 'getComponentViewportState',
                    appDefId: appDefId
                });
                _reporter2.default.reportSdkError(_errorMessage);
                return Promise.reject(_errorMessage);
            }

            if (this.rendering.env === 'backend') {
                var aboveFoldScreenHeight = SCREEN_HEIGHT[this.formFactor] * factor;
                return Promise.resolve({ in: _lodash2.default.get(comp, 'layout.y', 0) < aboveFoldScreenHeight });
            }

            return new Promise(function (resolve, reject) {
                var callback = function callback(data, error) {
                    return error ? reject(error) : resolve(data);
                };
                postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                    command: postMessage.MessageTypes.GET_COMPONENT_VIEWPORT_STATE,
                    appDefinitionId: members._appDefId.get(_this4),
                    data: {
                        compId: compId,
                        requiresDom: { compId: compId },
                        params: { requireDom: compId }
                    },
                    callback: callback
                });
            });
        }
    }, {
        key: 'isMobileFriendly',
        get: function get() {
            return _platformUtils2.default.getRGI().getIsMobileFriendly();
        }
    }]);

    return Window;
}(_window2.default);

exports.default = Window;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextColorMixin = exports.styleService = exports.BorderWidthMixin = exports.BorderRadiusMixin = exports.BorderColorMixin = exports.ForegroundColorMixin = exports.BackgroundColorMixin = exports.StyleMixin = exports.ViewportMixin = exports.ValueMixin = exports.ValidatableMixin = exports.TextInputMixin = exports.RequiredMixin = exports.ReadOnlyMixin = exports.PlayableMixin = exports.LinkableMixin = exports.LabelMixin = exports.HiddenMixin = exports.HiddenCollapsedMixin = exports.FocusMixin = exports.DisabledMixin = exports.ContainableMixin = exports.CollapsedMixin = exports.ClickableMixin = exports.CheckedMixin = exports.mixin = undefined;

var _CheckedMixin = __webpack_require__(72);

var _CheckedMixin2 = _interopRequireDefault(_CheckedMixin);

var _ClickableMixin = __webpack_require__(10);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _CollapsedMixin = __webpack_require__(73);

var _CollapsedMixin2 = _interopRequireDefault(_CollapsedMixin);

var _ContainableMixin = __webpack_require__(12);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _DisabledMixin = __webpack_require__(18);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _FocusMixin = __webpack_require__(22);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _HiddenCollapsedMixin = __webpack_require__(4);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _HiddenMixin = __webpack_require__(74);

var _HiddenMixin2 = _interopRequireDefault(_HiddenMixin);

var _LabelMixin = __webpack_require__(75);

var _LabelMixin2 = _interopRequireDefault(_LabelMixin);

var _LinkableMixin = __webpack_require__(36);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _PlayableMixin = __webpack_require__(37);

var _PlayableMixin2 = _interopRequireDefault(_PlayableMixin);

var _ReadOnlyMixin = __webpack_require__(38);

var _ReadOnlyMixin2 = _interopRequireDefault(_ReadOnlyMixin);

var _RequiredMixin = __webpack_require__(23);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

var _TextInputMixin = __webpack_require__(47);

var _TextInputMixin2 = _interopRequireDefault(_TextInputMixin);

var _ValidatableMixin = __webpack_require__(76);

var _ValidatableMixin2 = _interopRequireDefault(_ValidatableMixin);

var _ValueMixin = __webpack_require__(77);

var _ValueMixin2 = _interopRequireDefault(_ValueMixin);

var _ViewportMixin = __webpack_require__(48);

var _ViewportMixin2 = _interopRequireDefault(_ViewportMixin);

var _StyleMixin = __webpack_require__(14);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _BackgroundColorMixin = __webpack_require__(78);

var _BackgroundColorMixin2 = _interopRequireDefault(_BackgroundColorMixin);

var _ForegroundColorMixin = __webpack_require__(82);

var _ForegroundColorMixin2 = _interopRequireDefault(_ForegroundColorMixin);

var _BorderColorMixin = __webpack_require__(79);

var _BorderColorMixin2 = _interopRequireDefault(_BorderColorMixin);

var _BorderRadiusMixin = __webpack_require__(80);

var _BorderRadiusMixin2 = _interopRequireDefault(_BorderRadiusMixin);

var _BorderWidthMixin = __webpack_require__(81);

var _BorderWidthMixin2 = _interopRequireDefault(_BorderWidthMixin);

var _styleService = __webpack_require__(26);

var _styleService2 = _interopRequireDefault(_styleService);

var _TextColorMixin = __webpack_require__(83);

var _TextColorMixin2 = _interopRequireDefault(_TextColorMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mixin(receiver, supplier) {
    var propsNames = Object.getOwnPropertyNames(supplier);
    propsNames.forEach(function (property) {
        if (supplier.hasOwnProperty(property) && property !== 'constructor') {
            Object.defineProperty(receiver, property, Object.getOwnPropertyDescriptor(supplier, property));
        }
    });

    return receiver;
}

exports.mixin = mixin;
exports.CheckedMixin = _CheckedMixin2.default;
exports.ClickableMixin = _ClickableMixin2.default;
exports.CollapsedMixin = _CollapsedMixin2.default;
exports.ContainableMixin = _ContainableMixin2.default;
exports.DisabledMixin = _DisabledMixin2.default;
exports.FocusMixin = _FocusMixin2.default;
exports.HiddenCollapsedMixin = _HiddenCollapsedMixin2.default;
exports.HiddenMixin = _HiddenMixin2.default;
exports.LabelMixin = _LabelMixin2.default;
exports.LinkableMixin = _LinkableMixin2.default;
exports.PlayableMixin = _PlayableMixin2.default;
exports.ReadOnlyMixin = _ReadOnlyMixin2.default;
exports.RequiredMixin = _RequiredMixin2.default;
exports.TextInputMixin = _TextInputMixin2.default;
exports.ValidatableMixin = _ValidatableMixin2.default;
exports.ValueMixin = _ValueMixin2.default;
exports.ViewportMixin = _ViewportMixin2.default;
exports.StyleMixin = _StyleMixin2.default;
exports.BackgroundColorMixin = _BackgroundColorMixin2.default;
exports.ForegroundColorMixin = _ForegroundColorMixin2.default;
exports.BorderColorMixin = _BorderColorMixin2.default;
exports.BorderRadiusMixin = _BorderRadiusMixin2.default;
exports.BorderWidthMixin = _BorderWidthMixin2.default;
exports.styleService = _styleService2.default;
exports.TextColorMixin = _TextColorMixin2.default;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _location = __webpack_require__(169);

var _location2 = _interopRequireDefault(_location);

var _site = __webpack_require__(170);

var _site2 = _interopRequireDefault(_site);

var _window = __webpack_require__(171);

var _window2 = _interopRequireDefault(_window);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var namespaces = {
    Location: _location2.default,
    Site: _site2.default,
    Window: _window2.default
};

exports.default = _lodash2.default.mapValues(namespaces, function (namespace) {
    return _monitoring2.default.monitorNamespace(namespace);
});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace wix-events
 */

var Events = function Events(appDefId) {
    _classCallCheck(this, Events);

    members._appDefId.set(this, appDefId);
};

exports.default = Events;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ga;

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function ga() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
        command: postMessage.MessageTypes.GOOGLE_ANALYTICS,
        data: args
    });
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Multilingual = function () {
    function Multilingual(appDefId) {
        _classCallCheck(this, Multilingual);

        members._appDefId.set(this, appDefId);
    }

    _createClass(Multilingual, [{
        key: 'isEnabled',
        get: function get() {
            return _platformUtils2.default.getRGI().getIsMultilingualEnabled();
        }
    }, {
        key: 'currentLanguage',
        get: function get() {
            return _platformUtils2.default.getRGI().getCurrentLanguageCode();
        },
        set: function set(languageCode) {
            var _this = this;

            var languageCodes = this.siteLanguages.map(function (language) {
                return language.languageCode;
            });
            var isValidLanguageCode = _lodash2.default.includes(languageCodes, languageCode);

            return new Promise(function (resolve, reject) {
                if (isValidLanguageCode) {
                    var callback = function callback(data, error) {
                        return error ? reject(error) : resolve(data);
                    };
                    postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
                        command: postMessage.MessageTypes.ML_SET_LANGUAGECODE,
                        data: { languageCode: languageCode },
                        appDefinitionId: members._appDefId.get(_this),
                        callback: callback
                    });
                } else {
                    _reporter2.default.reportSdkError('Error: language code "' + languageCode + '" is invalid');
                    reject("invalid language code");
                }
            });
        }
    }, {
        key: 'siteLanguages',
        get: function get() {
            return _platformUtils2.default.getRGI().getSiteLanguages();
        }
    }]);

    return Multilingual;
}();

exports.default = Multilingual;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.livePreview = exports.setAsyncFunctions = exports.mediaUtils = exports.moduleStore = exports.module = exports.members = exports.monitoring = exports.errors = exports.reporter = exports.platformUtils = exports.extendCompSchema = exports.componentInitializeService = exports.validationsService = exports.validation = exports.mixins = exports.postMessage = exports.ui = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _mixins = __webpack_require__(185);

var mixins = _interopRequireWildcard(_mixins);

var _privateMembers = __webpack_require__(1);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(3);

var validation = _interopRequireWildcard(_validation);

var _compSchemas = __webpack_require__(70);

var _valueSanitzationAlgorithm = __webpack_require__(32);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _validationsService = __webpack_require__(11);

var _compInitializeService = __webpack_require__(50);

var _compInitializeService2 = _interopRequireDefault(_compInitializeService);

var _valueValidation = __webpack_require__(68);

var _validatableWithSyncInitialize = __webpack_require__(35);

var _validatableWithSyncInitialize2 = _interopRequireDefault(_validatableWithSyncInitialize);

var _valueValidatableInitialize = __webpack_require__(20);

var _errors = __webpack_require__(9);

var _ui = __webpack_require__(46);

var _ui2 = _interopRequireDefault(_ui);

var _Element = __webpack_require__(8);

var _Element2 = _interopRequireDefault(_Element);

var _Node = __webpack_require__(33);

var _Node2 = _interopRequireDefault(_Node);

var _Button = __webpack_require__(71);

var _Button2 = _interopRequireDefault(_Button);

var _FormElement = __webpack_require__(16);

var _FormElement2 = _interopRequireDefault(_FormElement);

var _Background = __webpack_require__(21);

var _Background2 = _interopRequireDefault(_Background);

var _postMessage = __webpack_require__(15);

var postMessage = _interopRequireWildcard(_postMessage);

var _reporter = __webpack_require__(7);

var _reporter2 = _interopRequireDefault(_reporter);

var _utils = __webpack_require__(5);

var _Utils = __webpack_require__(17);

var Utils = _interopRequireWildcard(_Utils);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

var _backgroundMediaUtils = __webpack_require__(44);

var _backgroundMediaUtils2 = _interopRequireDefault(_backgroundMediaUtils);

var _videoUtils = __webpack_require__(69);

var _videoUtils2 = _interopRequireDefault(_videoUtils);

var _imageUtils = __webpack_require__(24);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _vectorImageUtils = __webpack_require__(45);

var _vectorImageUtils2 = _interopRequireDefault(_vectorImageUtils);

var _asyncDecorator = __webpack_require__(29);

var _livePreview = __webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModuleStore = function () {
    function ModuleStore() {
        _classCallCheck(this, ModuleStore);

        this.store = {};
    }

    _createClass(ModuleStore, [{
        key: 'set',
        value: function set(namespace, scopedNamespace, Module) {
            Module = _monitoring2.default.monitorNamespace(Module);
            var module = new Module();
            self[namespace] = module;
            self.wix[scopedNamespace] = module;
            this.store[namespace] = { Module: Module, scopedNamespace: scopedNamespace };
        }
    }, {
        key: 'get',
        value: function get(namespace) {
            return this.store[namespace];
        }
    }, {
        key: 'getNamespaces',
        value: function getNamespaces() {
            return _lodash2.default.keys(this.store);
        }
    }]);

    return ModuleStore;
}();

var moduleStore = new ModuleStore();

var _module = {
    register: function register(namespaceName, scopedNamespaceName, Module) {
        if (_lodash2.default.has(self, namespaceName)) {
            _reporter2.default.reportSdkError(_errors.generateError.error_namespace_already_exists({ namespace: namespaceName }));
        } else {
            moduleStore.set(namespaceName, scopedNamespaceName, Module);
        }
    }
};

var mediaUtils = { backgroundMediaUtils: _backgroundMediaUtils2.default, imageUtils: _imageUtils2.default, vectorImageUtils: _vectorImageUtils2.default, videoUtils: _videoUtils2.default };
var monitoring = { monitorClass: _monitoring2.default.monitorClass };
var errors = { generateError: _errors.generateError, formatPlatformizedHttpError: _errors.formatPlatformizedHttpError, extendGenerateError: _errors.extendGenerateError };

var validationsService = {
    valueSanitzationAlgorithm: _valueSanitzationAlgorithm2.default,
    runValidationsAfterChange: _validationsService.runValidationsAfterChange,
    runValidations: _validationsService.runValidations,
    runValidationsAndSync: _validationsService.runValidationsAndSync,
    runValidationsAndSyncAfterChange: _validationsService.runValidationsAndSyncAfterChange,
    hideValidityIndication: _validationsService.hideValidityIndication,
    extendValueMethodToInputType: _validationsService.extendValueMethodToInputType,
    extendGetValidatorByType: _valueValidation.extendGetValidatorByType,
    validators: _valueValidation.validators,
    addErrorToValidateDataAndKeepMessage: _valueValidation.addErrorToValidateDataAndKeepMessage,
    VALIDITY_KEYS: _valueValidation.VALIDITY_KEYS
};

var componentInitializeService = {
    extendComponentsInitialize: _compInitializeService2.default.extendComponentsInitialize,
    extendComponentsRemoval: _compInitializeService2.default.extendComponentsRemoval,
    validatableWithSyncInitialize: _validatableWithSyncInitialize2.default,
    valueValidatableInitialize: _valueValidatableInitialize.valueValidatableInitialize,
    valueValidatableClearance: _valueValidatableInitialize.valueValidatableClearance
};

var ui = { Background: _Background2.default, Element: _Element2.default, FormElement: _FormElement2.default, Node: _Node2.default, Button: _Button2.default };

ui.register = function (viewerType, sdkType, module) {
    if (!_ui2.default.registerComponent(sdkType, module)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_component_already_exists({ component: sdkType }));
        return false;
    }
    (0, _utils.setType)(viewerType, sdkType);
    return true;
};

ui.Utils = Utils;

var livePreview = { setStageUnfriendlyFunctions: _livePreview.setStageUnfriendlyFunctions };

exports.ui = ui;
exports.postMessage = postMessage;
exports.mixins = mixins;
exports.validation = validation;
exports.validationsService = validationsService;
exports.componentInitializeService = componentInitializeService;
exports.extendCompSchema = _compSchemas.extendCompSchema;
exports.platformUtils = _platformUtils2.default;
exports.reporter = _reporter2.default;
exports.errors = errors;
exports.monitoring = monitoring;
exports.members = members;
exports.module = _module;
exports.moduleStore = moduleStore;
exports.mediaUtils = mediaUtils;
exports.setAsyncFunctions = _asyncDecorator.setAsyncFunctions;
exports.livePreview = livePreview;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _platformUtils = __webpack_require__(6);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _postMessage = __webpack_require__(15);

var pm = _interopRequireWildcard(_postMessage);

var _validationsService = __webpack_require__(11);

var _compInitializeService = __webpack_require__(50);

var _compInitializeService2 = _interopRequireDefault(_compInitializeService);

var _readyManager = __webpack_require__(51);

var _appStudioUtils = __webpack_require__(43);

var _appStudioUtils2 = _interopRequireDefault(_appStudioUtils);

var _monitoring = __webpack_require__(13);

var _monitoring2 = _interopRequireDefault(_monitoring);

var _nativeComponentUtils = __webpack_require__(67);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function validateGlobalsParameters(platformUtils) {
    if (!platformUtils) {
        throw new Error('invalid parameter value for platformUtils: ' + platformUtils);
    }

    if (!platformUtils.RGI) {
        throw new Error('invalid parameter value for remoteGlobalsInterface: ' + platformUtils.RGI);
    }
}

function validateParameters(platformUtils) {
    if (!platformUtils) {
        throw new Error('invalid parameter value for platformUtils: ' + platformUtils);
    }

    if (!platformUtils.RMI) {
        throw new Error('invalid parameter value for remoteModelInterface: ' + platformUtils.RMI);
    }
}

function validateUtilitiesParameters(utilities) {
    if (!utilities) {
        throw new Error('invalid parameter value for utils: ' + utilities);
    }

    if (!utilities.richTextUtils) {
        throw new Error('invalid parameter value for richTextUtils: ' + utilities.richTextUtils);
    }

    if (!utilities.uriUtils) {
        throw new Error('invalid parameter value for uriUtils: ' + utilities.uriUtils);
    }

    if (!utilities.linkUtils) {
        throw new Error('invalid parameter value for linkUtils: ' + utilities.linkUtils);
    }

    if (!utilities.backgroundUtils) {
        throw new Error('invalid parameter value for backgroundUtils: ' + utilities.backgroundUtils);
    }

    if (!utilities.repeaterUtils) {
        throw new Error('invalid parameter value for repeaterUtils: ' + utilities.repeaterUtils);
    }

    if (!utilities.videoUrlsUtils) {
        throw new Error('invalid parameter value for videoUrlsUtils: ' + utilities.videoUrlsUtils);
    }

    if (!utilities.typeUtils) {
        throw new Error('invalid parameter value for typeUtils: ' + utilities.typeUtils);
    }

    if (!utilities.widgetUtils) {
        throw new Error('invalid parameter value for widgetUtils: ' + utilities.widgetUtils);
    }

    if (!utilities.mediaSrcHandler) {
        throw new Error('invalid parameter value for mediaSrcHandler: ' + utilities.mediaSrcHandler);
    }

    if (!utilities.pubSubService) {
        throw new Error('invalid parameter value for pubSubService: ' + utilities.pubSubService);
    }

    if (!utilities.messageService) {
        throw new Error('invalid parameter value for messageService: ' + utilities.messageService);
    }
}

function updateHandler(contextId) {
    return function delegateCommandToViewer(_ref) {
        var type = _ref.type,
            compId = _ref.compId,
            data = _ref.data,
            appDefinitionId = _ref.appDefinitionId,
            controllerId = _ref.controllerId,
            callback = _ref.callback;

        switch (type) {
            case 'executeBatch':
            case 'registerEvent':
                pm.sendMessageToHost(pm.Intent.WIX_CODE, { command: type, compId: compId, contextId: contextId, data: data, appDefinitionId: appDefinitionId, controllerId: controllerId, callback: callback });
                break;
            case 'behavior':
                pm.sendMessageToHost(pm.Intent.WIX_CODE, { command: 'executeBehavior', compId: compId, contextId: contextId, data: data, appDefinitionId: appDefinitionId, controllerId: controllerId, callback: callback });
                break;
            default:
                pm.sendMessageToHost(pm.Intent.WIX_CODE, { command: type + 'Changed', compId: compId, contextId: contextId, data: data, appDefinitionId: appDefinitionId, controllerId: controllerId, callback: callback });
                break;
        }
    };
}

var InternalAPIs = function () {
    function InternalAPIs() {
        _classCallCheck(this, InternalAPIs);
    }

    _createClass(InternalAPIs, [{
        key: 'dumpModel',
        value: function dumpModel() {
            return {
                RMI: _platformUtils2.default.getRMI('dumpModel').toJson(),
                RGI: _platformUtils2.default.getRGI().toJson()
            };
        }
    }, {
        key: 'initGlobals',
        value: function initGlobals(platformUtilities) {
            validateGlobalsParameters(platformUtilities);
            _platformUtils2.default.initGlobals(platformUtilities);
            _monitoring2.default.setUserContext();
        }
    }, {
        key: 'initUtilities',
        value: function initUtilities(utilities) {
            validateUtilitiesParameters(utilities);
            _platformUtils2.default.initUtilities(utilities);
        }
    }, {
        key: 'initModel',
        value: function initModel() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            validateParameters.apply(undefined, args);
            var platformUtilities = args[0];

            var contextId = _platformUtils2.default.getRGI().getContextId();
            var RMI = platformUtilities.RMI;
            var componentsHooks = platformUtilities.componentsHooks;
            var HOOKS = RMI.getHooks();
            RMI.registerHook(HOOKS.data, 'wysiwyg.viewer.components.Repeater', componentsHooks.repeaters.updateRepeaterItems);
            RMI.registerHook(HOOKS.all, null, componentsHooks.repeaters.syncRepeaterItemData);
            _platformUtils2.default.getWixSelector().initialize({ currentRMI: RMI, contextId: contextId });
            _platformUtils2.default.init(platformUtilities, updateHandler(contextId));

            (0, _validationsService.initValidationsService)();
            _compInitializeService2.default.componentsInitialize(RMI, contextId, RMI.getComponents());
        }
    }, {
        key: 'setStaticEventHandlers',
        value: function setStaticEventHandlers(eventHandlers, contextId) {
            _platformUtils2.default.setStaticEventHandlers(eventHandlers, contextId);
        }
    }, {
        key: 'getEventHandler',
        value: function getEventHandler(name) {
            return _platformUtils2.default.getStaticEventHandler(name, true);
        }
    }, {
        key: 'onMessage',
        value: function onMessage(event) {
            pm.onMessage(event);
        }
    }, {
        key: 'initEnv',
        value: function initEnv(queryParameters) {
            _platformUtils2.default.setQueryParameters(queryParameters);
        }
    }, {
        key: 'addEnvParams',
        value: function addEnvParams(params) {
            _platformUtils2.default.addQueryParameters(params);
        }
    }, {
        key: 'triggerOnReady',
        value: function triggerOnReady(success) {
            (0, _readyManager.triggerOnReady)(success);
        }
    }, {
        key: 'triggerOnRender',
        value: function triggerOnRender(success) {
            (0, _readyManager.triggerOnRender)(success);
        }
    }, {
        key: 'setWarmupData',
        value: function setWarmupData() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var _Object$assign = Object.assign.apply(Object, [{}].concat(args)),
                controllerId = _Object$assign.controllerId,
                data = _Object$assign.data,
                appDefinitionId = _Object$assign.appDefinitionId;

            if (controllerId) {
                pm.sendMessageToHost(pm.Intent.WIX_CODE_WARMUP, {
                    command: pm.MessageTypes.SET_WARMUP_DATA,
                    data: { controllerId: controllerId, data: data },
                    controllerId: controllerId,
                    appDefinitionId: appDefinitionId
                });
            } else {
                var _controllerId = args[0];
                var _data = args[1];
                pm.sendMessageToHost(pm.Intent.WIX_CODE_WARMUP, {
                    command: pm.MessageTypes.SET_WARMUP_DATA,
                    data: { controllerId: _controllerId, data: _data },
                    controllerId: _controllerId
                });
            }
        }
    }, {
        key: 'getWarmupData',
        value: function getWarmupData(controllerId) {
            var uw = _platformUtils2.default.getQueryParameter("userWarmup");
            return uw && uw[controllerId];
        }
    }, {
        key: 'addAppStudioOnPropsChangedIfNeeded',
        value: function addAppStudioOnPropsChangedIfNeeded() {
            _appStudioUtils2.default.addAppStudioGlobalsIfNeeded();
        }
    }, {
        key: 'addAppStudioGlobalsIfNeeded',
        value: function addAppStudioGlobalsIfNeeded() {
            _appStudioUtils2.default.addAppStudioGlobalsIfNeeded();
        }
    }, {
        key: 'updateControllerData',
        value: function updateControllerData(controllerId, data) {
            var currentRMI = _platformUtils2.default.getRMI();
            var contextId = _platformUtils2.default.getRGI().getContextId();
            (0, _nativeComponentUtils.updateControllerData)(contextId, currentRMI, controllerId, data);
        }
    }, {
        key: 'setBiServices',
        value: function setBiServices(biServices) {
            _platformUtils2.default.setBiReporter(biServices);
        }
    }, {
        key: 'clearReadyManager',
        value: function clearReadyManager() {
            (0, _readyManager.clearReadyManager)();
        }
    }]);

    return InternalAPIs;
}();

exports.default = InternalAPIs;

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 220 */,
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(176);
module.exports = __webpack_require__(177);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// build/wix.min.js